webpackJsonp([24],{

/***/ "+Gv0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+opI":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("hcE8");
var hide = __webpack_require__("wkr2");
var has = __webpack_require__("l/2K");
var setGlobal = __webpack_require__("C/Wh");
var nativeFunctionToString = __webpack_require__("0Q51");
var InternalStateModule = __webpack_require__("I1z2");
var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(nativeFunctionToString).split('toString');

__webpack_require__("izte")('inspectSource', function (it) {
  return nativeFunctionToString.call(it);
});

(module.exports = function (O, key, value, unsafe) {
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    setGlobal(key, value);
  } else if (!unsafe) {
    delete O[key];
    hide(O, key, value);
  } else if (O[key]) {
    O[key] = value;
  } else {
    hide(O, key, value);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
});


/***/ }),

/***/ "/09a":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var internalObjectKeys = __webpack_require__("AMIE");
var enumBugKeys = __webpack_require__("YveC");

module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "/1Jj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bankAuthPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__ = __webpack_require__("pNAd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__ = __webpack_require__("nAuI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_picker_style_css__ = __webpack_require__("QeGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_picker__ = __webpack_require__("lOFV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_icon_style_css__ = __webpack_require__("h2Na");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_icon_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_icon_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_icon__ = __webpack_require__("YK8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib_toast_style_css__ = __webpack_require__("gj9y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast__ = __webpack_require__("qZDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib_list_style_css__ = __webpack_require__("WcGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib_list_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib_list_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib_list__ = __webpack_require__("V/++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tips__ = __webpack_require__("EjGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Btn__ = __webpack_require__("yU3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_less__ = __webpack_require__("RiGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_less__);












var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ListItem = __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib_list___default.a.Item;

var popupQueue = [];

var _ref2 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref3 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref4 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref5 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref6 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref7 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref8 = _jsx('div', {
  className: 'bankCardLine'
});

var _ref9 = _jsx('div', {
  className: 'bankCardLine'
});

var BankAuth = function (_PureComponent) {
  _inherits(BankAuth, _PureComponent);

  function BankAuth(props) {
    var _this2 = this;

    _classCallCheck(this, BankAuth);

    var _this = _possibleConstructorReturn(this, (BankAuth.__proto__ || Object.getPrototypeOf(BankAuth)).call(this, props));

    _this._inputChange = function (key) {
      return function (value) {
        if (Object.keys(_this.state.cardInfo).includes(key)) {
          var cardInfo = Object.assign({}, _this.state.cardInfo);
          if (key === 'showName' || key === 'name') {
            cardInfo['showName'] = value.replace(/[^\u4e00-\u9fa5]/g, '');
            cardInfo['name'] = value.replace(/[^\u4e00-\u9fa5]/g, '');
          } else {
            cardInfo[key] = value;
          }
          _this.setState({
            cardInfo: cardInfo
          });
        } else {
          _this.setState(_defineProperty({}, key, value));
        }
      };
    };

    _this._inputClear = function (key) {
      return function () {
        if (Object.keys(_this.state.cardInfo).includes(key)) {
          var cardInfo = Object.assign({}, _this.state.cardInfo);
          cardInfo[key] = '';
          _this.setState({
            cardInfo: cardInfo
          });
        } else {
          _this.setState(_defineProperty({}, key, ''));
        }
      };
    };

    _this.getverification = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
      var cardInfo, lang, settimer;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cardInfo = _this.state.cardInfo;
              lang = _this.props.lang;

              if (!(!/^1\d{10}$/.test(cardInfo.phone) || cardInfo.phone.length !== 11)) {
                _context.next = 5;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.eleven_phone, 1);
              return _context.abrupt('return', false);

            case 5:

              _this.setState({ timer: true });
              _this.verbtn.style.color = '#b2b0bc';
              settimer = setInterval(function () {
                _this.setState(function (preState) {
                  return {
                    seconds: preState.seconds - 1
                  };
                }, function () {
                  if (_this.state.seconds === -1) {
                    clearInterval(settimer);
                    _this.setState({ seconds: 59, timer: false });
                    _this.verbtn.style.color = '#0073df';
                  }
                });
              }, 1000);
              _context.next = 10;
              return _this.props.getCode(cardInfo.phone);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this._submit = function () {
      var _this$state = _this.state,
          code = _this$state.code,
          cardInfo = _this$state.cardInfo,
          timer = _this$state.timer;
      var lang = _this.props.lang;

      if (!cardInfo.name) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.error_name, 1);
        return false;
      }

      if (!cardInfo.certno) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.error_certno, 1);
        return false;
      }

      if (cardInfo.account === '') {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.no_bankcard, 1);
        return false;
      }

      if (!cardInfo.phone || cardInfo.phone.length !== 11) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.eleven_phone, 1);
        return false;
      }

      if (!code) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.no_verification, 1);
        return false;
      }
      if (code.length < 6) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.error_verification, 1);
        return false;
      }
      if (!timer) {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib_toast___default.a.info(lang.applySubmit.overtime_verification, 1);
        return false;
      }

      _this.props.submit(code, cardInfo);
    };

    _this._pickerConfirm = function (npsg) {
      return function (value) {
        var _this$props = _this.props,
            psgList = _this$props.psgList,
            switchPsg = _this$props.switchPsg;

        var v = Array.isArray(value) ? value[0] : value;
        var psg = npsg || psgList.filter(function (item) {
          return item.ticketNo === v;
        })[0];
        switchPsg(psg, function () {
          _this.setState({
            pickerValue: v,
            cardInfo: {
              showName: psg.psgName,
              name: psg.psgName,
              certno: psg.certificateIdDis,
              account: _this.state.cardInfo.account,
              phone: _this.state.cardInfo.phone,
              ticketNo: psg.ticketNo
            }
          });
        });
      };
    };

    _this._onCancel = function () {
      _this.props.destroy();
    };

    var isDomestic = _this.props.isDomestic;

    _this.state = Object.assign({}, {
      pickerData: _this.props.psgList.map(function (item) {
        return {
          label: item.psgName,
          value: item.ticketNo
        };
      }),
      pickerValue: isDomestic ? _this.props.psgList[0].ticketNo : '',
      code: '',
      seconds: 59,
      timer: false,
      cardInfo: {
        showName: isDomestic ? _this.props.psgList[0].psgName : '',
        name: isDomestic ? _this.props.psgList[0].psgName : '', // 持卡人
        certno: isDomestic ? _this.props.psgList[0].certificateIdDis : '', // 证件号
        account: '', // 银行卡号
        phone: '', // 手机
        province: '', // 省
        city: '', // 城市
        address: '', // 开户地址,
        bank: '', // 开户银行
        ticketNo: _this.props.psgList[0].ticketNo // 客票号
      }
    });
    return _this;
  }

  // 编辑卡号


  // 获取验证码


  _createClass(BankAuth, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var isDomestic = this.props.isDomestic;
      var _state = this.state,
          pickerData = _state.pickerData,
          pickerValue = _state.pickerValue,
          code = _state.code,
          cardInfo = _state.cardInfo,
          seconds = _state.seconds,
          timer = _state.timer;
      var lang = this.props.lang;

      return _jsx('div', {
        className: 'bankPopup'
      }, void 0, _jsx('div', {
        id: 'cet',
        className: 'content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_icon___default.a, {
        type: 'cross',
        onClick: this._onCancel,
        role: 'button',
        'aria-label': '\u5173\u95ED'
      }), _jsx('p', {}, void 0, lang.refundMoth), _jsx('div', {
        className: 'bankAuth'
      }, void 0, _jsx('div', {
        className: 'reminder'
      }, void 0, _jsx('span', {
        className: 'reminder_hint'
      }, void 0, lang.inpIdCard)), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.cardholder), _jsx('div', {
        className: 'bankCardMsg_right cardNo'
      }, void 0, isDomestic ? _jsx(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_picker___default.a, {
        cols: 1,
        data: pickerData,
        value: [pickerValue],
        okText: '\u786E\u5B9A',
        onOk: this._pickerConfirm()
      }, void 0, _jsx(ListItem, {
        arrow: 'horizontal'
      }, void 0, lang.choosePerson)) : _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'string',
        value: cardInfo.showName,
        placeholder: lang.inpMessage,
        onChange: this._inputChange('name'),
        clear: true
      }))), _ref2), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.updateDetail55), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, isDomestic ? _jsx('span', {
        className: 'cardholder'
      }, void 0, cardInfo.certno) : _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'string',
        value: cardInfo.certno,
        placeholder: lang.inpMessage2,
        maxLength: 39,
        onChange: this._inputChange('certno'),
        clear: true
      }))), _ref3), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.cardNum), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'number',
        value: cardInfo.account.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 '),
        placeholder: lang.inpIdCard2,
        maxLength: 39,
        onChange: this._inputChange('account'),
        clear: this._inputClear('account')
      }))), _ref4, _jsx('div', {
        className: 'originalBankWarn'
      }, void 0, lang.cardtip)), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.refundMoth1), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'string',
        value: cardInfo.province,
        placeholder: lang.refundMoth2,
        onChange: this._inputChange('province'),
        clear: this._inputClear('province')
      }))), _ref5, _jsx('div', {
        className: 'originalBankWarn'
      }, void 0, lang.refundMoth3)), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.refundMoth4), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'string',
        value: cardInfo.city,
        placeholder: lang.refundMoth5,
        onChange: this._inputChange('city'),
        clear: this._inputClear('city')
      }))), _ref6, _jsx('div', {
        className: 'originalBankWarn'
      }, void 0, lang.refundMoth6)), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.refundMoth4567), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'string',
        value: cardInfo.address,
        placeholder: lang.refundMoth7,
        onChange: this._inputChange('address'),
        clear: this._inputClear('address')
      }))), _ref7, _jsx('div', {
        className: 'originalBankWarn'
      }, void 0, lang.refundMoth8)), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg_left'
      }, void 0, lang.refundMoth9), _jsx('div', {
        className: 'bankCardMsg_right'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'number',
        value: cardInfo.phone.replace(/\s/g, ''),
        maxLength: 11,
        clear: true,
        placeholder: lang.refundMoth0,
        onChange: this._inputChange('phone')
      }))), _ref8), _jsx('div', {
        className: 'bankCardLi'
      }, void 0, _jsx('div', {
        className: 'bankCardMsg'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, {
        type: 'number',
        style: { marginLeft: '21px', width: '310px' },
        value: code,
        maxLength: 6,
        onChange: this._inputChange('code'),
        placeholder: lang.refundMoth11,
        clear: true
      }), _jsx('div', {
        className: 'acquierVerification'
      }, void 0, timer && _jsx('span', {}, void 0, ' (', seconds, 's) '), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        'button',
        {
          disabled: timer ? 'disabled' : '',
          onClick: this.getverification,
          ref: function ref(verbtn) {
            return _this3.verbtn = verbtn;
          }
        },
        lang.checkCode
      ))), _ref9), _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14_Btn__["default"], {
        onClick: this._submit,
        text: lang.submit
      })))));
    }
  }]);

  return BankAuth;
}(__WEBPACK_IMPORTED_MODULE_12_react__["PureComponent"]);

BankAuth.defaultProps = {
  isDomestic: true,
  psgList: [],
  switchPsg: function switchPsg() {},
  getCode: function getCode() {},
  submit: function submit() {},
  destroy: function destroy() {}
};


function bankAuthPopup() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('cet');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  function close() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(BankAuth, Object.assign({}, param, { destroy: close })), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('cet').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  popupQueue.push({
    close: close
  });

  return popupQueue[popupQueue.length - 1];
}

bankAuthPopup.clear = function () {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(function (progess) {
      progess.close();
    });
    popupQueue = [];
  }
};

/***/ }),

/***/ "/GnY":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "/mOS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("i9tX");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var iterate = __webpack_require__("UHV6");

module.exports = function (COLLECTION) {
  $export({ target: COLLECTION, stat: true }, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, boundFunction;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      boundFunction = bind(mapFn, arguments[2], 2);
      iterate(source, function (nextItem) {
        A.push(boundFunction(nextItem, n++));
      });
    } else {
      iterate(source, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "/rHU":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():t()}(0,function(){var e,t={};function r(e){if(!e)return!1;var t=Object.prototype.toString.call(e);return"[object Function]"==t||"[object AsyncFunction]"==t}function n(){return Date.now&&r(Date.now)?Date.now():(new Date).getTime()}t.DEFAULT_SEND_TYPE="image",function(){var e={"function":!0,object:!0},t=e[typeof window]&&window||this;var r=t.JSON,n=t.JSON3,i=!1,a=function o(r,n){r||(r=t.Object()),n||(n=t.Object());var i=r.Number||t.Number,a=r.String||t.String,s=r.Object||t.Object,l=r.Date||t.Date,u=r.SyntaxError||t.SyntaxError,c=r.TypeError||t.TypeError,p=r.Math||t.Math,d=r.JSON||t.JSON;if("object"==typeof d&&d)return n.stringify=d.stringify,n.parse=d.parse,n.runInContext=o,n;var f,g=s.prototype,_=g.toString,h=g.hasOwnProperty;function m(e,t){try{e()}catch(r){t&&t()}}var v=new l(-0xc782b5b800cec);function y(e){if(null!=y[e])return y[e];var t;if("bug-string-char-index"==e)t="a"!="a"[0];else if("json"==e)t=y("json-stringify")&&y("date-serialization")&&y("json-parse");else if("date-serialization"==e){if(t=y("json-stringify")&&v){var r=n.stringify;m(function(){t='"-271821-04-20T00:00:00.000Z"'==r(new l(-864e13))&&'"+275760-09-13T00:00:00.000Z"'==r(new l(864e13))&&'"-000001-01-01T00:00:00.000Z"'==r(new l(-621987552e5))&&'"1969-12-31T23:59:59.999Z"'==r(new l(-1))})}}else{var o,s='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if("json-stringify"==e){var u="function"==typeof(r=n.stringify);u&&((o=function(){return 1}).toJSON=o,m(function(){u="0"===r(0)&&"0"===r(new i)&&'""'==r(new a)&&r(_)===f&&r(f)===f&&r()===f&&"1"===r(o)&&"[1]"==r([o])&&"[null]"==r([f])&&"null"==r(null)&&"[null,null,null]"==r([f,_,null])&&r({a:[o,!0,!1,null,"\0\b\n\f\r\t"]})==s&&"1"===r(null,o)&&"[\n 1,\n 2\n]"==r([1,2],null,1)},function(){u=!1})),t=u}if("json-parse"==e){var c,p=n.parse;"function"==typeof p&&m(function(){0!==p("0")||p(!1)||(o=p(s),(c=5==o.a.length&&1===o.a[0])&&(m(function(){c=!p('"\t"')}),c&&m(function(){c=1!==p("01")}),c&&m(function(){c=1!==p("1.")})))},function(){c=!1}),t=c}}return y[e]=!!t}if(m(function(){v=-109252==v.getUTCFullYear()&&0===v.getUTCMonth()&&1===v.getUTCDate()&&10==v.getUTCHours()&&37==v.getUTCMinutes()&&6==v.getUTCSeconds()&&708==v.getUTCMilliseconds()}),y["bug-string-char-index"]=y["date-serialization"]=y.json=y["json-stringify"]=y["json-parse"]=null,!y("json")){var b=y("bug-string-char-index"),w=function(t,r){var n,i,a,o=0;for(a in(n=function(){this.valueOf=0}).prototype.valueOf=0,i=new n)h.call(i,a)&&o++;return n=i=null,o?w=function(e,t){var r,n,i="[object Function]"==_.call(e);for(r in e)i&&"prototype"==r||!h.call(e,r)||(n="constructor"===r)||t(r);(n||h.call(e,r="constructor"))&&t(r)}:(i=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"],w=function(t,r){var n,a,o="[object Function]"==_.call(t),s=!o&&"function"!=typeof t.constructor&&e[typeof t.hasOwnProperty]&&t.hasOwnProperty||h;for(n in t)o&&"prototype"==n||!s.call(t,n)||r(n);for(a=i.length;n=i[--a];)s.call(t,n)&&r(n)}),w(t,r)};if(!y("json-stringify")&&!y("date-serialization")){var S={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"},k=function(e,t){return("000000"+(t||0)).slice(-e)},P=function(e){var t,r,n,i,a,o,s,l,u;if(v)t=function(e){r=e.getUTCFullYear(),n=e.getUTCMonth(),i=e.getUTCDate(),o=e.getUTCHours(),s=e.getUTCMinutes(),l=e.getUTCSeconds(),u=e.getUTCMilliseconds()};else{var c=p.floor,d=[0,31,59,90,120,151,181,212,243,273,304,334],f=function(e,t){return d[t]+365*(e-1970)+c((e-1969+(t=+(t>1)))/4)-c((e-1901+t)/100)+c((e-1601+t)/400)};t=function(e){for(i=c(e/864e5),r=c(i/365.2425)+1970-1;f(r+1,0)<=i;r++);for(n=c((i-f(r,0))/30.42);f(r,n+1)<=i;n++);i=1+i-f(r,n),o=c((a=(e%864e5+864e5)%864e5)/36e5)%24,s=c(a/6e4)%60,l=c(a/1e3)%60,u=a%1e3}}return(P=function(e){return e>-1/0&&e<1/0?(t(e),e=(r<=0||r>=1e4?(r<0?"-":"+")+k(6,r<0?-r:r):k(4,r))+"-"+k(2,n+1)+"-"+k(2,i)+"T"+k(2,o)+":"+k(2,s)+":"+k(2,l)+"."+k(3,u)+"Z",r=n=i=o=s=l=u=null):e=null,e})(e)};if(y("json-stringify")&&!y("date-serialization")){function C(e){return P(this)}var O=n.stringify;n.stringify=function(e,t,r){var n=l.prototype.toJSON;l.prototype.toJSON=C;var i=O(e,t,r);return l.prototype.toJSON=n,i}}else{var j=function(e){var t=e.charCodeAt(0),r=S[t];return r||"\\u00"+k(2,t.toString(16))},N=/[\x00-\x1f\x22\x5c]/g,T=function(e){return N.lastIndex=0,'"'+(N.test(e)?e.replace(N,j):e)+'"'},I=function(e,t,r,n,i,a,o){var s,u,p,d,g,h,v,y,b;if(m(function(){s=t[e]}),"object"==typeof s&&s&&(s.getUTCFullYear&&"[object Date]"==_.call(s)&&s.toJSON===l.prototype.toJSON?s=P(s):"function"==typeof s.toJSON&&(s=s.toJSON(e))),r&&(s=r.call(t,e,s)),s==f)return s===f?s:"null";switch("object"==(u=typeof s)&&(p=_.call(s)),p||u){case"boolean":case"[object Boolean]":return""+s;case"number":case"[object Number]":return s>-1/0&&s<1/0?""+s:"null";case"string":case"[object String]":return T(""+s)}if("object"==typeof s){for(v=o.length;v--;)if(o[v]===s)throw c();if(o.push(s),d=[],y=a,a+=i,"[object Array]"==p){for(h=0,v=s.length;h<v;h++)g=I(h,s,r,n,i,a,o),d.push(g===f?"null":g);b=d.length?i?"[\n"+a+d.join(",\n"+a)+"\n"+y+"]":"["+d.join(",")+"]":"[]"}else w(n||s,function(e){var t=I(e,s,r,n,i,a,o);t!==f&&d.push(T(e)+":"+(i?" ":"")+t)}),b=d.length?i?"{\n"+a+d.join(",\n"+a)+"\n"+y+"}":"{"+d.join(",")+"}":"{}";return o.pop(),b}};n.stringify=function(t,r,n){var i,a,o,s;if(e[typeof r]&&r)if("[object Function]"==(s=_.call(r)))a=r;else if("[object Array]"==s){o={};for(var l,u=0,c=r.length;u<c;)l=r[u++],"[object String]"!=(s=_.call(l))&&"[object Number]"!=s||(o[l]=1)}if(n)if("[object Number]"==(s=_.call(n))){if((n-=n%1)>0)for(n>10&&(n=10),i="";i.length<n;)i+=" "}else"[object String]"==s&&(i=n.length<=10?n:n.slice(0,10));return I("",((l={})[""]=t,l),a,o,i,"",[])}}}if(!y("json-parse")){var A,D,$=a.fromCharCode,x={92:"\\",34:'"',47:"/",98:"\b",116:"\t",110:"\n",102:"\f",114:"\r"},E=function(){throw A=D=null,u()},L=function(){for(var e,t,r,n,i,a=D,o=a.length;A<o;)switch(i=a.charCodeAt(A)){case 9:case 10:case 13:case 32:A++;break;case 123:case 125:case 91:case 93:case 58:case 44:return e=b?a.charAt(A):a[A],A++,e;case 34:for(e="@",A++;A<o;)if((i=a.charCodeAt(A))<32)E();else if(92==i)switch(i=a.charCodeAt(++A)){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:e+=x[i],A++;break;case 117:for(t=++A,r=A+4;A<r;A++)(i=a.charCodeAt(A))>=48&&i<=57||i>=97&&i<=102||i>=65&&i<=70||E();e+=$("0x"+a.slice(t,A));break;default:E()}else{if(34==i)break;for(i=a.charCodeAt(A),t=A;i>=32&&92!=i&&34!=i;)i=a.charCodeAt(++A);e+=a.slice(t,A)}if(34==a.charCodeAt(A))return A++,e;E();default:if(t=A,45==i&&(n=!0,i=a.charCodeAt(++A)),i>=48&&i<=57){for(48==i&&(i=a.charCodeAt(A+1))>=48&&i<=57&&E(),n=!1;A<o&&(i=a.charCodeAt(A))>=48&&i<=57;A++);if(46==a.charCodeAt(A)){for(r=++A;r<o&&!((i=a.charCodeAt(r))<48||i>57);r++);r==A&&E(),A=r}if(101==(i=a.charCodeAt(A))||69==i){for(43!=(i=a.charCodeAt(++A))&&45!=i||A++,r=A;r<o&&!((i=a.charCodeAt(r))<48||i>57);r++);r==A&&E(),A=r}return+a.slice(t,A)}n&&E();var s=a.slice(A,A+4);if("true"==s)return A+=4,!0;if("fals"==s&&101==a.charCodeAt(A+4))return A+=5,!1;if("null"==s)return A+=4,null;E()}return"$"},U=function(e){var t,r;if("$"==e&&E(),"string"==typeof e){if("@"==(b?e.charAt(0):e[0]))return e.slice(1);if("["==e){for(t=[];"]"!=(e=L());)r?","==e?"]"==(e=L())&&E():E():r=!0,","==e&&E(),t.push(U(e));return t}if("{"==e){for(t={};"}"!=(e=L());)r?","==e?"}"==(e=L())&&E():E():r=!0,","!=e&&"string"==typeof e&&"@"==(b?e.charAt(0):e[0])&&":"==L()||E(),t[e.slice(1)]=U(L());return t}E()}return e},R=function(e,t,r){var n=B(e,t,r);n===f?delete e[t]:e[t]=n},B=function(e,t,r){var n,i=e[t];if("object"==typeof i&&i)if("[object Array]"==_.call(i))for(n=i.length;n--;)R(_,w,i);else w(i,function(e){R(i,e,r)});return r.call(e,t,i)};n.parse=function(e,t){var r,n;return A=0,D=""+e,r=U(L()),"$"!=L()&&E(),A=D=null,t&&"[object Function]"==_.call(t)?B(((n={})[""]=r,n),"",t):r}}}return n.runInContext=o,n}(t,t.JSON3={noConflict:function(){return i||(i=!0,t.JSON=r,t.JSON3=n,r=n=null),a}});t.JSON?(t.JSON.parse=a.parse,t.JSON.stringify=a.stringify):t.JSON={parse:a.parse,stringify:a.stringify}}.call(window),function(e){if(e.atob)try{e.atob(" ")}catch(a){e.atob=(t=e.atob,(r=function(e){return t(String(e).replace(/[\t\n\f\r ]+/g,""))}).original=t,r)}else{var t,r,n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i=/^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;e.btoa=function(e){e=String(e);for(var t,r,i,a,o="",s=0,l=e.length%3;s<e.length;){if((r=e.charCodeAt(s++))>255||(i=e.charCodeAt(s++))>255||(a=e.charCodeAt(s++))>255)return"";o+=n.charAt((t=r<<16|i<<8|a)>>18&63)+n.charAt(t>>12&63)+n.charAt(t>>6&63)+n.charAt(63&t)}return l?o.slice(0,l-3)+"===".substring(l):o},e.atob=function(e){if(e=String(e).replace(/[\t\n\f\r ]+/g,""),!i.test(e))return"";e+="==".slice(2-(3&e.length));for(var t,r,a,o="",s=0;s<e.length;)t=n.indexOf(e.charAt(s++))<<18|n.indexOf(e.charAt(s++))<<12|(r=n.indexOf(e.charAt(s++)))<<6|(a=n.indexOf(e.charAt(s++))),o+=64===r?String.fromCharCode(t>>16&255):64===a?String.fromCharCode(t>>16&255,t>>8&255):String.fromCharCode(t>>16&255,t>>8&255,255&t);return o}}}(window);var i={setup:function(t){e=t},log:function(){(e||console&&console.log||function(){}).apply(null,arguments)}},a={get:function(e){return window.localStorage.getItem(e)},parse:function(e){var t;try{t=JSON.parse(a.get(e))||null}catch(r){i.log(r)}return t},set:function(e,t){try{window.localStorage.setItem(e,t)}catch(r){i.log(r)}},remove:function(e){window.localStorage.removeItem(e)},isSupport:function(){var e=!0;try{var t="__local_store_support__",r="testIsSupportStorage";a.set(t,r),a.get(t)!==r&&(e=!1),a.remove(t)}catch(n){e=!1}return e}};function s(e){return null!=e&&"[object Object]"==Object.prototype.toString.call(e)}var l=function(){var e=(new Date).getTime();return function(t){return Math.ceil((e=(9301*e+49297)%233280)/233280*t)}}();function u(){if("function"==typeof Uint32Array){var e="";if("undefined"!=typeof crypto?e=crypto:"undefined"!=typeof msCrypto&&(e=msCrypto),s(e)&&e.getRandomValues){var t=new Uint32Array(1);return e.getRandomValues(t)[0]/Math.pow(2,32)}}return l(1e19)/1e19}function c(e){var t=null;try{t=JSON.parse(e)}catch(r){}return t}function p(e,t){this.lockGetPrefix=e||"lock-get-prefix",this.lockSetPrefix=t||"lock-set-prefix"}function d(e){return"function"==typeof e||!(!e||"object"!=typeof e)&&d(e.listener)}function f(){this._events={}}function g(e){var t=e;try{t=decodeURIComponent(e)}catch(r){t=e}return t}function _(e){e=e||"";for(var t=function(){function e(){}return"function"!=typeof Object.create?(e.prototype=null,new e):Object.create(null)}(),r=e.substring(1).split("&"),n=0;n<r.length;n++){var i=r[n].indexOf("=");if(-1!==i){var a=r[n].substring(0,i),o=r[n].substring(i+1);a=g(a),o=g(o),"__proto__"!==a&&"constructor"!==a&&"prototype"!==a&&(t[a]=o)}}return t}function h(e){return"[object String]"==Object.prototype.toString.call(e)}function v(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}function y(e){var t=function(e){this._fields={Username:4,Password:5,Port:7,Protocol:2,Host:6,Path:8,URL:0,QueryString:9,Fragment:10},this._values={},this._regex=/^((\w+):\/\/)?((\w+):?(\w+)?@)?([^\/\?:]+):?(\d+)?(\/?[^\?#]+)?\??([^#]+)?#?(\w*)/,void 0!==e&&this._parse(e)};return t.prototype.setUrl=function(e){this._parse(e)},t.prototype._initValues=function(){for(var e in this._fields)this._values[e]=""},t.prototype.addQueryString=function(e){if("object"!=typeof e)return!1;var t=this._values.QueryString||"";for(var r in e)t=new RegExp(r+"[^&]+").test(t)?t.replace(new RegExp(r+"[^&]+"),r+"="+e[r]):"&"===t.slice(-1)?t+r+"="+e[r]:""===t?r+"="+e[r]:t+"&"+r+"="+e[r];this._values.QueryString=t},t.prototype.getUrl=function(){var e="";return e+=this._values.Origin,e+=this._values.Port?":"+this._values.Port:"",e+=this._values.Path,e+=this._values.QueryString?"?"+this._values.QueryString:"",e+=this._values.Fragment?"#"+this._values.Fragment:""},t.prototype._parse=function(e){this._initValues();var t=this._regex.exec(e);t||i.log("URLParser::_parse -> Invalid URL");var r=e.split("#"),n=r[0],a=r.slice(1).join("#");for(var o in t=this._regex.exec(n),this._fields)"undefined"!=typeof t[this._fields[o]]&&(this._values[o]=t[this._fields[o]]);this._values.Hostname=this._values.Host.replace(/:\d+$/,""),this._values.Origin=this._values.Protocol+"://"+this._values.Hostname,this._values.Fragment=a},new t(e)}function b(e){var t,r={};if("function"==typeof window.URL&&function(){try{return"http://modernizr.com/"===new URL("http://modernizr.com/").href}catch(e){return!1}}())(r=new URL(e)).searchParams||(r.searchParams=(t=_(r.search),{get:function(e){return t[e]}}));else{h(e)||(e=String(e)),e=v(e);if(!1===/^https?:\/\/.+/.test(e))return void i.log("Invalid URL");var n=y(e);r.hash=n._values.Fragment,r.host=n._values.Host?n._values.Host+(n._values.Port?":"+n._values.Port:""):"",r.href=n._values.URL,r.password=n._values.Password,r.pathname=n._values.Path,r.port=n._values.Port,r.search=n._values.QueryString?"?"+n._values.QueryString:"",r.username=n._values.Username,r.hostname=n._values.Hostname,r.protocol=n._values.Protocol?n._values.Protocol+":":"",r.origin=n._values.Origin?n._values.Origin+(n._values.Port?":"+n._values.Port:""):"",r.searchParams=function(){var e=_("?"+n._values.QueryString);return{get:function(t){return e[t]}}}()}return r}p.prototype.get=function(e,t,r,i){if(!e)throw new Error("key is must");t=t||1e4,r=r||1e3,i=i||function(){};var o=this.lockGetPrefix+e,s=a.get(o),l=String(u());if(s&&(s=c(s)||{randomNum:0,expireTime:0}).expireTime>n())return i(null);a.set(o,JSON.stringify({randomNum:l,expireTime:n()+t})),setTimeout(function(){(s=c(a.get(o))||{randomNum:0,expireTime:0})&&s.randomNum===l?(i(a.get(e)),a.remove(e),a.remove(o)):i(null)},r)},p.prototype.set=function(e,t,r,i,o){if(!e||!t)throw new Error("key and val is must");r=r||1e4,i=i||1e3,o=o||function(){};var s=this.lockSetPrefix+e,l=a.get(s),p=String(u());if(l&&(l=c(l)||{randomNum:0,expireTime:0}).expireTime>n())return o({status:"fail",reason:"This key is locked"});a.set(s,JSON.stringify({randomNum:p,expireTime:n()+r})),setTimeout(function(){(l=c(a.get(s))||{randomNum:0,expireTime:0}).randomNum===p?a.set(e,t)&&o({status:"success"}):o({status:"fail",reason:"This key is locked"})},i)},f.prototype.on=function(e,t){if(!e||!t)return!1;if(!d(t))throw new Error("listener must be a function");this._events[e]=this._events[e]||[];var r="object"==typeof t;return this._events[e].push(r?t:{listener:t,once:!1}),this},f.prototype.prepend=function(e,t){if(!e||!t)return!1;if(!d(t))throw new Error("listener must be a function");this._events[e]=this._events[e]||[];var r="object"==typeof t;return this._events[e].unshift(r?t:{listener:t,once:!1}),this},f.prototype.prependOnce=function(e,t){return this.prepend(e,{listener:t,once:!0})},f.prototype.once=function(e,t){return this.on(e,{listener:t,once:!0})},f.prototype.off=function(e,t){var r=this._events[e];if(!r)return!1;if("number"==typeof t)r.splice(t,1);else if("function"==typeof t)for(var n=0,i=r.length;n<i;n++)r[n]&&r[n].listener===t&&r.splice(n,1);return this},f.prototype.emit=function(e,t){var r=this._events[e];if(!r)return!1;for(var n=0;n<r.length;n++){var i=r[n];i&&(i.listener.call(this,t||{}),i.once&&this.off(e,n))}return this},f.prototype.removeAllListeners=function(e){e&&this._events[e]?this._events[e]=[]:this._events={}},f.prototype.listeners=function(e){return e&&"string"==typeof e?this._events[e]:this._events};var w,S=(w=function(){for(var e=1*new Date,t=0;e==1*new Date;)t++;return e.toString(16)+t.toString(16)},function(){var e=String(screen.height*screen.width);e=e&&/\d{5,}/.test(e)?e.toString(16):String(31242*u()).replace(".","").slice(0,8);var t=w()+"-"+u().toString(16).replace(".","")+"-"+function(){var e,t,r=navigator.userAgent,n=[],i=0;function a(e,t){var r,i=0;for(r=0;r<t.length;r++)i|=n[r]<<8*r;return e^i}for(e=0;e<r.length;e++)t=r.charCodeAt(e),n.unshift(255&t),n.length>=4&&(i=a(i,n),n=[]);return n.length>0&&(i=a(i,n)),i.toString(16)}()+"-"+e+"-"+w();return t||(String(u())+String(u())+String(u())).slice(2,15)});function k(e){return!(!e||1!==e.nodeType)}function P(e){return void 0===e}function C(e){return Array.isArray&&r(C)?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)}function O(e){return new j(e)}var j=function(e){this.ele=e},N=function(e,t){for(var r=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&r.push(e);return r};function T(e,t,r,n){function i(e){return e&&(e.preventDefault=i.preventDefault,e.stopPropagation=i.stopPropagation,e._getPath=i._getPath),e}i._getPath=function(){return this.path||this.composedPath&&this.composedPath()||O(this.target).getParents()},i.preventDefault=function(){this.returnValue=!1},i.stopPropagation=function(){this.cancelBubble=!0};(function(e,t,r){if(n===undefined&&"click"===t&&(n=!0),e&&e.addEventListener)e.addEventListener(t,function(e){e._getPath=i._getPath,r.call(this,e)},n);else{var a="on"+t,o=e[a];e[a]=function(e,t,r,n){return function(a){if(!(a=a||i(window.event)))return undefined;a.target=a.srcElement;var o,s,l=!0;return"function"==typeof r&&(o=r(a)),s=t.call(e,a),"beforeunload"!==n?(!1!==o&&!1!==s||(l=!1),l):void 0}}(e,r,o,t)}}).apply(null,arguments)}function I(e){var t="pushState"in window.history?"popstate":"hashchange";T(window,t,e)}function A(e){if(e)return"undefined"!=typeof window.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest?new XMLHttpRequest:"undefined"!=typeof XDomainRequest?new XDomainRequest:null;if("undefined"!=typeof window.XMLHttpRequest)return new XMLHttpRequest;if(window.ActiveXObject)try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(t){try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(t){i.log(t)}}}function D(e,t,r){if("object"==typeof e&&"number"==typeof e.length&&e.length>0)if(Array.prototype.forEach&&e.forEach)e.forEach(t,r);else for(var n=0;n<e.length;n++)t.call(r,e[n],n,e);else if("[object Object]"===Object.prototype.toString.call(e))for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.call(r,e[i],i,e)}function $(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];if("[object Object]"===Object.prototype.toString.call(r))for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&void 0!==r[n]&&(e[n]=r[n])}return e}function x(e){function t(e){if(!e)return"";try{return JSON.parse(e)}catch(t){return{}}}e.timeout=e.timeout||2e4,e.credentials="undefined"==typeof e.credentials||e.credentials;var r=A(e.cors);if(!r)return!1;e.type||(e.type=e.data?"POST":"GET");var n,a=(e=$({success:function(){},error:function(){}},e)).success,o=e.error;e.success=function(e){a(e),n&&(clearTimeout(n),n=null)},e.error=function(e){o(e),n&&(clearTimeout(n),n=null)},n=setTimeout(function(){!function(){try{r&&"object"==typeof r&&r.abort&&r.abort()}catch(t){i.log(t)}n&&(clearTimeout(n),n=null,e.error&&e.error(),r.onreadystatechange=null,r.onload=null,r.onerror=null)}()},e.timeout),"undefined"!=typeof XDomainRequest&&r instanceof XDomainRequest&&(r.onload=function(){e.success&&e.success(t(r.responseText)),r.onreadystatechange=null,r.onload=null,r.onerror=null},r.onerror=function(){e.error&&e.error(t(r.responseText),r.status),r.onreadystatechange=null,r.onerror=null,r.onload=null}),r.onreadystatechange=function(){try{4==r.readyState&&(r.status>=200&&r.status<300||304==r.status?e.success(t(r.responseText)):e.error(t(r.responseText),r.status),r.onreadystatechange=null,r.onload=null)}catch(n){r.onreadystatechange=null,r.onload=null}},r.open(e.type,e.url,!0);try{e.credentials&&(r.withCredentials=!0),s(e.header)&&D(e.header,function(e,t){r.setRequestHeader&&r.setRequestHeader(t,e)}),e.data&&(e.cors||r.setRequestHeader&&r.setRequestHeader("X-Requested-With","XMLHttpRequest"),"application/json"===e.contentType?r.setRequestHeader&&r.setRequestHeader("Content-type","application/json; charset=UTF-8"):r.setRequestHeader&&r.setRequestHeader("Content-type","application/x-www-form-urlencoded"))}catch(l){i.log(l)}r.send(e.data||null)}function E(e,t){var r=[];return null==e?r:Array.prototype.map&&e.map===Array.prototype.map?e.map(t):(D(e,function(e,n,i){r.push(t(e,n,i))}),r)}function L(e){var t=[];try{t=E(atob(e).split(""),function(e){return"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2)})}catch(r){t=[]}try{return decodeURIComponent(t.join(""))}catch(r){return t.join("")}}function U(e){var t="";try{t=btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,function(e,t){return String.fromCharCode("0x"+t)}))}catch(r){t=e}return t}j.prototype={addClass:function(e){return-1===(" "+this.ele.className+" ").indexOf(" "+e+" ")&&(this.ele.className=this.ele.className+(""===this.ele.className?"":" ")+e),this},removeClass:function(e){var t=" "+this.ele.className+" ";return-1!==t.indexOf(" "+e+" ")&&(this.ele.className=t.replace(" "+e+" "," ").slice(1,-1)),this},hasClass:function(e){return-1!==(" "+this.ele.className+" ").indexOf(" "+e+" ")},attr:function(e,t){return"string"==typeof e&&P(t)?this.ele.getAttribute(e):("string"==typeof e&&(t=String(t),this.ele.setAttribute(e,t)),this)},offset:function(){var e=this.ele.getBoundingClientRect();if(e.width||e.height){var t=this.ele.ownerDocument.documentElement;return{top:e.top+window.pageYOffset-t.clientTop,left:e.left+window.pageXOffset-t.clientLeft}}return{top:0,left:0}},getSize:function(){if(!window.getComputedStyle)return{width:this.ele.offsetWidth,height:this.ele.offsetHeight};try{var e=this.ele.getBoundingClientRect();return{width:e.width,height:e.height}}catch(t){return{width:0,height:0}}},getStyle:function(e){return this.ele.currentStyle?this.ele.currentStyle[e]:this.ele.ownerDocument.defaultView.getComputedStyle(this.ele,null).getPropertyValue(e)},wrap:function(e){var t=document.createElement(e);return this.ele.parentNode.insertBefore(t,this.ele),t.appendChild(this.ele),O(t)},getCssStyle:function(e){var t=this.ele.style.getPropertyValue(e);if(t)return t;var r=null;if("function"==typeof window.getMatchedCSSRules&&(r=window.getMatchedCSSRules(this.ele)),!r||!C(r))return null;for(var n=r.length-1;n>=0;n--){if(t=r[n].style.getPropertyValue(e))return t}},sibling:function(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e},next:function(){return this.sibling(this.ele,"nextSibling")},prev:function(){return this.sibling(this.ele,"previousSibling")},siblings:function(){return N((this.ele.parentNode||{}).firstChild,this.ele)},children:function(){return N(this.ele.firstChild)},parent:function(){var e=this.ele.parentNode;return O(e=e&&11!==e.nodeType?e:null)},previousElementSibling:function(){var e=this.ele;if("previousElementSibling"in document.documentElement)return O(e.previousElementSibling);for(;e=e.previousSibling;)if(1===e.nodeType)return O(e);return O(null)},getSameTypeSiblings:function(){for(var e=this.ele,t=e.parentNode,r=e.tagName.toLowerCase(),n=[],i=0;i<t.children.length;i++){var a=t.children[i];1===a.nodeType&&a.tagName.toLowerCase()===r&&n.push(t.children[i])}return n},getParents:function(){try{var e=this.ele;if(!k(e))return[];var t=[e];if(null===e||null===e.parentElement)return[];for(;null!==e.parentElement;)e=e.parentElement,t.push(e);return t}catch(r){return[]}}};var R={get:function(e){for(var t=e+"=",r=document.cookie.split(";"),n=0;n<r.length;n++){for(var i=r[n];" "==i.charAt(0);)i=i.substring(1,i.length);if(0==i.indexOf(t))return g(i.substring(t.length,i.length))}return null},set:function(e,t,r,n,i,a){var o=a,s="",l="",u="";if(0!==(r=null==r?73e3:r)){var c=new Date;"s"===String(r).slice(-1)?c.setTime(c.getTime()+1e3*Number(String(r).slice(0,-1))):c.setTime(c.getTime()+24*r*60*60*1e3),s="; expires="+c.toGMTString()}function p(e){return!!e&&e.replace(/\r\n/g,"")}n&&""!==n&&(u="; SameSite="+n),i&&(l="; secure");var d="",f="",g="";e&&(d=p(e)),t&&(f=p(t)),o&&(g=p(o)),d&&f&&(document.cookie=d+"="+encodeURIComponent(f)+s+"; path=/"+g+u+l)},remove:function(e,t){this.set(e,"1",-1,t)},isSupport:function(e,t,r,n,i){e=e||"cookie_support_test",t=t||"1";var a=this;return navigator.cookieEnabled&&(a.set(e,t,r,n,i),a.get(e)===t&&(a.remove(e),!0))}};function B(e){return D(Array.prototype.slice.call(arguments,1),function(t){for(var r in t)void 0!==t[r]&&void 0===e[r]&&(e[r]=t[r])}),e}function H(e){var t=e;try{t=decodeURI(e)}catch(r){t=e}return t}function J(e){return"[object Date]"==Object.prototype.toString.call(e)}function M(e){function t(e){return e<10?"0"+e:e}return e.getFullYear()+"-"+t(e.getMonth()+1)+"-"+t(e.getDate())+" "+t(e.getHours())+":"+t(e.getMinutes())+":"+t(e.getSeconds())+"."+t(e.getMilliseconds())}function q(e){return D(Array.prototype.slice.call(arguments,1),function(t){for(var r in t)void 0!==t[r]&&(s(t[r])&&s(e[r])?$(e[r],t[r]):e[r]=t[r])}),e}function F(e,t,r){var n=Object.prototype.hasOwnProperty;if(e.filter)return e.filter(t);for(var i=[],a=0;a<e.length;a++)if(n.call(e,a)){var o=e[a];t.call(r,o,a,e)&&i.push(o)}return i}function K(e,t,r){t=t||"domain_test";var n=function(e){return"string"==typeof e&&e.match(/^[a-zA-Z0-9\u4e00-\u9fa5\-\.]+$/)?e:""}(e=e||location.hostname),i=n.split(".");if(C(i)&&i.length>=2&&!/^(\d+\.)+\d+$/.test(n))for(var a="."+i.splice(i.length-1,1);i.length>0;)if(a="."+i.splice(i.length-1,1)+a,R.set(t,"true",0,null,r,"; domain="+a),-1!==document.cookie.indexOf(t+"=true"))return R.set(t,"true","-1s",null,r,"; domain="+a),a;return""}function V(e){if(!h(e))return null;var t,r=e.split(">");return(t=function n(e){var t,a=r.shift();if(!a)return e;try{t=function(e,t){var r;if("body"===(e=v(e)))return document.getElementsByTagName("body")[0];if(0===e.indexOf("#"))e=e.slice(1),r=document.getElementById(e);else if(e.indexOf(":nth-of-type")>-1){var n=e.split(":nth-of-type");if(!n[0]||!n[1])return null;var i=n[0],a=n[1].match(/\(([0-9]+)\)/);if(!a||!a[1])return null;var o=Number(a[1]);if(!(k(t)&&t.children&&t.children.length>0))return null;for(var s=t.children,l=0;l<s.length;l++)if(k(s[l])&&s[l].tagName.toLowerCase()===i&&0==--o){r=s[l];break}if(o>0)return null}return r||null}(a,e)}catch(o){i.log(o)}return t&&k(t)?n(t):null}())&&k(t)?t:null}function z(e,t){var r="",n="";return e.textContent?r=v(e.textContent):e.innerText&&(r=v(e.innerText)),r&&(r=r.replace(/[\r\n]/g," ").replace(/[ ]+/g," ").substring(0,255)),n=r||"","input"!==t&&"INPUT"!==t||(n=e.value||""),n}function W(e,t){t&&"string"==typeof t||(t="hostname\u89e3\u6790\u5f02\u5e38");var r=null;try{r=b(e).hostname}catch(n){i.log("getHostname\u4f20\u5165\u7684url\u53c2\u6570\u4e0d\u5408\u6cd5\uff01")}return r||t}function X(){try{var e=navigator.appVersion.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);return e&&e[1]?Number.parseInt(e[1],10):""}catch(t){return""}}function Z(e,t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]"),e=g(e);var r=new RegExp("[\\?&]"+t+"=([^&#]*)").exec(e);return null===r||r&&"string"!=typeof r[1]&&r[1].length?"":g(r[1])}function Y(e){var t={},r=e.split("?")[1]||"";return r&&(t=_("?"+r)),t}function G(){return"undefined"!=typeof window.matchMedia||"undefined"!=typeof window.msMatchMedia}function Q(){var e,t={},r=navigator.userAgent.toLowerCase();return(e=r.match(/ qq\/([\d.]+)/))?t.qqBuildinBrowser=Number(e[1].split(".")[0]):(e=r.match(/mqqbrowser\/([\d.]+)/))?t.qqBrowser=Number(e[1].split(".")[0]):(e=r.match(/opera.([\d.]+)/))?t.opera=Number(e[1].split(".")[0]):(e=r.match(/msie ([\d.]+)/))?t.ie=Number(e[1].split(".")[0]):(e=r.match(/edge.([\d.]+)/))?t.edge=Number(e[1].split(".")[0]):(e=r.match(/firefox\/([\d.]+)/))?t.firefox=Number(e[1].split(".")[0]):(e=r.match(/chrome\/([\d.]+)/))?t.chrome=Number(e[1].split(".")[0]):(e=r.match(/version\/([\d.]+).*safari/))?t.safari=Number(e[1].match(/^\d*.\d*/)):(e=r.match(/trident\/([\d.]+)/))&&(t.ie=11),t}function ee(e){return h(e)?H(e=v(e)):H(location.href)}function te(e){return h(e)?H(e=v(e)):H(location.pathname)}function re(e,t){return e.hasAttribute?e.hasAttribute(t):e.attributes?!(!e.attributes[t]||!e.attributes[t].specified):void 0}function ne(e,t){if("string"==typeof t)return re(e,t);if(C(t)){for(var r=!1,n=0;n<t.length;n++){if(re(e,t[n])){r=!0;break}}return r}}function ie(e){if("string"!=typeof e)return 0;var t=0;if(0==e.length)return t;for(var r=0;r<e.length;r++)t=(t<<5)-t+e.charCodeAt(r),t&=t;return t}function ae(e){var t=9007199254740992,r=-9007199254740992,n=0;if(e.length>0)for(var i=e.split(""),a=0;a<i.length;a++){var o=i[a].charCodeAt(),s=31*n+o;if(s>t)for(n=r+n;(s=31*n+o)<r;)n=n/2+o;if(s<r)for(n=t+n;(s=31*n+o)>t;)n=n/2+o;n=31*n+o}return n}function oe(e,t){var r=e.indexOf;if(r)return r.call(e,t);for(var n=0;n<e.length;n++)if(t===e[n])return n;return-1}var se=Object.prototype.hasOwnProperty;function le(e){return!(!e||!se.call(e,"callee"))}function ue(e){return"[object Boolean]"==Object.prototype.toString.call(e)}function ce(e){if(s(e)){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))return!1;return!0}return!1}function pe(e){if("string"!=typeof e)return!1;return!1!==/^https?:\/\/.+/.test(e)||(i.log("Invalid URL"),!1)}function de(){return!!navigator.userAgent.match(/iPhone|iPad|iPod/i)}function fe(e){try{JSON.parse(e)}catch(t){return!1}return!0}function ge(e){return"[object Number]"==Object.prototype.toString.call(e)&&/[\d\.]+/.test(String(e))}function _e(e){if(!s(e)||!h(e.callbackName))return i.log("JSONP \u8bf7\u6c42\u7f3a\u5c11 callbackName"),!1;e.success=r(e.success)?e.success:function(){},e.error=r(e.error)?e.error:function(){},e.data=e.data||"";var t=document.createElement("script"),n=document.getElementsByTagName("head")[0],a=null,o=!1;n.appendChild(t);ge(e.timeout)&&(a=setTimeout(function(){if(o)return!1;e.error("timeout"),window[e.callbackName]=function(){i.log("call jsonp error")},a=null,n.removeChild(t),o=!0},Math.min(e.timeout,3e4))),window[e.callbackName]=function(){clearTimeout(a),a=null,e.success.apply(null,arguments),window[e.callbackName]=function(){i.log("call jsonp error")},n.removeChild(t)};var l=encodeURIComponent(e.callbackName),u="";if(e.url.indexOf("?")>-1?e.url+="&callbackName="+l:e.url+="?callbackName="+l,s(e.data)){var c=[];D(e.data,function(e,t){c.push(encodeURIComponent(t)+"="+encodeURIComponent(e))}),(u=c.join("&"))&&(e.url+="&"+u)}t.onerror=function(r){if(o)return!1;window[e.callbackName]=function(){i.log("call jsonp error")},clearTimeout(a),a=null,n.removeChild(t),e.error(r),o=!0},t.src=e.url}function he(e){({visibleHandler:r(e.visible)?e.visible:function(){},hiddenHandler:r(e.hidden)?e.hidden:function(){},visibilityChange:null,hidden:null,isSupport:function(){return"undefined"!=typeof document[this.hidden]},init:function(){"undefined"!=typeof document.hidden?(this.hidden="hidden",this.visibilityChange="visibilitychange"):"undefined"!=typeof document.mozHidden?(this.hidden="mozHidden",this.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.msHidden?(this.hidden="msHidden",this.visibilityChange="msvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(this.hidden="webkitHidden",this.visibilityChange="webkitvisibilitychange"),this.listen()},listen:function(){if(this.isSupport()){var e=this;T(document,this.visibilityChange,function(){document[e.hidden]?e.hiddenHandler():e.visibleHandler()},1)}else T(window,"focus",this.visibleHandler),T(window,"blur",this.hiddenHandler)}}).init()}function me(e){e=$({success:function(){},error:function(){},appendCall:function(e){document.getElementsByTagName("head")[0].appendChild(e)}},e);var t=null;"css"===e.type&&((t=document.createElement("link")).rel="stylesheet",t.href=e.url),"js"===e.type&&((t=document.createElement("script")).async="async",t.setAttribute("charset","UTF-8"),t.src=e.url,t.type="text/javascript"),t.onload=t.onreadystatechange=function(){this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(e.success(),t.onload=t.onreadystatechange=null)},t.onerror=function(){e.error(),t.onerror=null},e.appendCall(t)}function ve(e,t){t="number"==typeof t?t:13;for(var r=(e=String(e)).split(""),n=0;n<r.length;n++){r[n].charCodeAt(0)<126&&(r[n]=String.fromCharCode((r[n].charCodeAt(0)+t)%126))}return r.join("")}function ye(e){return ve(e=String(e),113)}function be(e){s(e)&&D(e,function(t,r){s(t)?be(e[r]):J(t)&&(e[r]=M(t))})}var we={isSupport:function(){var e=!0,t="testIsSupportStorage";try{sessionStorage&&sessionStorage.setItem?(sessionStorage.setItem("__session_storage_support__",t),sessionStorage.removeItem("__session_storage_support__",t),e=!0):e=!1}catch(r){e=!1}return e}};function Se(e){var t=document.createElement("style");t.type="text/css";try{t.appendChild(document.createTextNode(e))}catch(i){t.styleSheet.cssText=e}var r=document.getElementsByTagName("head")[0],n=document.getElementsByTagName("script")[0];r?r.children.length?r.insertBefore(t,r.children[0]):r.appendChild(t):n.parentNode.insertBefore(t,n)}function ke(e){var t=[];return null==e?t:(D(e,function(e){t[t.length]=e}),t)}function Pe(e){for(var t,r=[],n={},i=0;i<e.length;i++)(t=e[i])in n||(n[t]=!0,r.push(t));return r}var Ce={"+":"-","/":"_","=":"."},Oe={"-":"+",_:"/",".":"="};function je(e,t,r){return r=r||0,e.substr(r,t.length)===t}function Ne(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e}var Te={__proto__:null,noPrototypePollution:Ne,ConcurrentStorage:p,EventEmitter:f,URL:b,UUID:S,addEvent:T,addHashEvent:I,ajax:x,base64Decode:L,base64Encode:U,bindReady:function(e,t){t=t||window;var r=!1,n=!0,a=t.document,o=a.documentElement,s=a.addEventListener,l=s?"addEventListener":"attachEvent",u=s?"removeEventListener":"detachEvent",c=s?"":"on",p=function(n){"readystatechange"==n.type&&"complete"!=a.readyState||(("load"==n.type?t:a)[u](c+n.type,p,!1),!r&&(r=!0)&&e.call(t,n.type||n))},d=function(){try{o.doScroll("left")}catch(e){return void setTimeout(d,50)}p("poll")};if("complete"==a.readyState)e.call(t,"lazy");else{if(!s&&o.doScroll){try{n=!t.frameElement}catch(f){i.log(f)}n&&d()}a[l](c+"DOMContentLoaded",p,!1),a[l](c+"readystatechange",p,!1),t[l](c+"load",p,!1)}},cookie:R,coverExtend:B,decodeURI:H,decodeURIComponent:g,dfmapping:function(e){var t="t6KJCZa5pDdQ9khoEM3Tj70fbP2eLSyc4BrsYugARqFIw1mzlGNVXOHiWvxUn8",r=t.length-1,n={},i=0;for(i=0;i<t.length;i++)n[t.charAt(i)]=t.charAt(r-i);var a="";for(i=0;i<e.length;i++)e.charAt(i)in n?a+=n[e.charAt(i)]:a+=e.charAt(i);return a},each:D,encodeDates:function La(e){return D(e,function(t,r){J(t)?e[r]=M(t):s(t)&&(e[r]=La(t))}),e},extend:$,extend2Lev:q,filter:F,formatDate:M,formatJsonString:function(e){try{return JSON.stringify(e,null,"  ")}catch(t){return JSON.stringify(e)}},getCookieTopLevelDomain:K,getDomBySelector:V,getElementContent:z,getHostname:W,getIOSVersion:X,getQueryParam:Z,getQueryParamsFromUrl:Y,getRandom:u,getRandomBasic:l,getScreenOrientation:function(){var e=screen.msOrientation||screen.mozOrientation||(screen.orientation||{}).type,t="\u672a\u53d6\u5230\u503c";if(e)t=e.indexOf("landscape")>-1?"landscape":"portrait";else if(G()){var r=window.matchMedia||window.msMatchMedia;r("(orientation: landscape)").matches?t="landscape":r("(orientation: portrait)").matches&&(t="portrait")}return t},getUA:Q,getURL:ee,getURLPath:te,getURLSearchParams:_,hasAttribute:re,hasAttributes:ne,hashCode:ie,hashCode53:ae,indexOf:oe,inherit:function(e,t){return e.prototype=new t,e.prototype.constructor=e,e.superclass=t.prototype,e},isArguments:le,isArray:C,isBoolean:ue,isDate:J,isElement:k,isEmptyObject:ce,isFunction:r,isHttpUrl:pe,isIOS:de,isJSONString:fe,isNumber:ge,isObject:s,isString:h,isSupportBeaconSend:function(){var e=!1;if("object"!=typeof navigator||"function"!=typeof navigator.sendBeacon)return e;var t=Q(),r=navigator.userAgent.toLowerCase();if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){var n=(r.match(/os [\d._]*/gi)+"").replace(/[^0-9|_.]/gi,"").replace(/_/gi,".").split(".");"undefined"==typeof t.safari&&(t.safari=n[0]),n[0]&&(t.qqBuildinBrowser||t.qqBrowser)?e=!1:n[0]&&n[0]<13?(t.chrome>41||t.firefox>30||t.opera>25||t.safari>12)&&(e=!0):(t.chrome>41||t.firefox>30||t.opera>25||t.safari>11.3)&&(e=!0)}else(t.chrome>38||t.edge>13||t.firefox>30||t.opera>25||t.safari>11)&&(e=!0);return e},isSupportCors:function(){return"undefined"!=typeof window.XMLHttpRequest&&("withCredentials"in new XMLHttpRequest||"undefined"!=typeof XDomainRequest)},isUndefined:P,jsonp:_e,listenPageState:he,loadScript:me,localStorage:a,logger:i,map:E,mediaQueriesSupported:G,now:n,removeScriptProtocol:function(e){if("string"!=typeof e)return"";for(var t=/^\s*javascript/i;t.test(e);)e=e.replace(t,"");return e},rot13defs:ye,rot13obfs:ve,ry:O,safeJSONParse:c,searchObjDate:be,sessionStorage:we,setCssStyle:Se,strToUnicode:function(e){if("string"!=typeof e)return i.log("\u8f6c\u6362unicode\u9519\u8bef",e),e;for(var t="",r=0;r<e.length;r++)t+="\\"+e.charCodeAt(r).toString(16);return t},throttle:function(e,t,r){var i,a,o,s=null,l=0;r||(r={});var u=function(){l=!1===r.leading?0:n(),s=null,o=e.apply(i,a),s||(i=a=null)};return function(){var c=n();l||!1!==r.leading||(l=c);var p=t-(c-l);return i=this,a=arguments,p<=0||p>t?(s&&(clearTimeout(s),s=null),l=c,o=e.apply(i,a),s||(i=a=null)):s||!1===r.trailing||(s=setTimeout(u,p)),o}},toArray:function(e){return e?e.toArray?e.toArray():C(e)||le(e)?Array.prototype.slice.call(e):ke(e):[]},trim:v,unique:Pe,urlParse:y,urlSafeBase64:{encode:function(e){return e.replace(/[+\/=]/g,function(e){return Ce[e]})},decode:function(e){return e.replace(/[-_.]/g,function(e){return Oe[e]})},trim:function(e){return e.replace(/[.=]{1,2}$/,"")},isBase64:function(e){return/^[A-Za-z0-9+\/]*[=]{0,2}$/.test(e)},isUrlSafeBase64:function(e){return/^[A-Za-z0-9_-]*[.]{0,2}$/.test(e)}},values:ke,xhr:A,startsWith:je},Ie=[],Ae={appendWriter:function(e){Ie.push(e)},msg:function(){var e={module:"",level:"log",brand:"web-sdk",content:null};return e.content=Array.prototype.slice.call(arguments),{module:function(t){return h(t)&&(e.module=t),this},level:function(t){return h(t)&&(e.level=t),this},brand:function(t){return h(t)&&(e.brand=t),this},log:function(){if(e.content&&e.content.length)for(var t=0;t<Ie.length;t++)if("function"==typeof Ie[t])try{Ie[t].call(null,e)}catch(r){}return this}}}};function De(){Ae.msg.apply(Ae,arguments).log()}function $e(){Ae.msg.apply(Ae,arguments).level("warn").log()}function xe(){Ae.msg.apply(Ae,arguments).level("error").log()}var Ee={},Le={preset_properties:{search_keyword_baidu:!1,latest_utm:!0,latest_traffic_source_type:!0,latest_search_keyword:!0,latest_referrer:!0,latest_referrer_host:!1,latest_landing_page:!1,latest_wx_ad_click_id:undefined,url:!0,title:!0},encrypt_cookie:!1,enc_cookie:!1,img_use_crossorigin:!1,name:"sa",max_referrer_string_length:200,max_string_length:1024,max_id_length:255,max_key_length:100,cross_subdomain:!0,show_log:!1,is_debug:!1,source_channel:[],sdk_id:"",auto_init:!0,is_track_single_page:!1,is_single_page:!1,batch_send:!1,custom_server_url:"",source_type:{},callback_timeout:200,datasend_timeout:8e3,is_track_device_id:!1,ignore_oom:!0,app_js_bridge:!1,white_list:{}};Le.white_list[location.host]=b(location.href).hostname;var Ue="utm_source utm_medium utm_campaign utm_content utm_term",Re="1.27.11",Be="sensorsdata_domain_test",He={EMAIL:"$identity_email",MOBILE:"$identity_mobile",LOGIN:"$identity_login_id"};function Je(e){var t=Ee.current_domain;switch(typeof t){case"function":var r=t();return""===r||""===v(r)?"url\u89e3\u6790\u5931\u8d25":-1!==r.indexOf(".")?r:"url\u89e3\u6790\u5931\u8d25";case"string":return""===t||""===v(t)?"url\u89e3\u6790\u5931\u8d25":-1!==t.indexOf(".")?t:"url\u89e3\u6790\u5931\u8d25";default:var n=K(null,Be,Ee.is_secure_cookie);return""===e?"url\u89e3\u6790\u5931\u8d25":""===n?"url\u89e3\u6790\u5931\u8d25":n}}var Me={get:function(e){return R.get(e)},set:function(e,t,r,n){var i="";if(n=P(n)?Ee.cross_subdomain:n){var a=Je(location.href);"url\u89e3\u6790\u5931\u8d25"===a&&(a=""),i=a?"; domain="+a:""}return R.set(e,t,r,Ee.set_cookie_samesite,Ee.is_secure_cookie,i)},remove:function(e,t){return t=P(t)?Ee.cross_subdomain:t,R.remove(e,t)},isSupport:function(e,t){return e=e||"sajssdk_2015_cookie_access_test",t=t||"1",R.isSupport(e,t,0,null,Ee.is_secure_cookie)}};function qe(e,r){var n="";if(!1===Ee.cross_subdomain){try{if(r)n=b(r).hostname;else{var i=location.host;P(t.para.white_list[i])||(n=t.para.white_list[i])}}catch(a){xe(a)}n="string"==typeof n&&""!==n?"sajssdk_2015_"+Ee.sdk_id+e+"_"+n.replace(/\./g,"_"):"sajssdk_2015_root_"+Ee.sdk_id+e}else n="sajssdk_2015_cross_"+Ee.sdk_id+e;return n}function Fe(){return Me.isSupport()?null!==Me.get("sensorsdata_is_new_user")||null!==Me.get(qe("new_user")):null!==Ke.get(Ke.getNewUserFlagMemoryKey("new_user"))}Me.getNewUser=Fe;var Ke={data:{},get:function(e){var t=this.data[e];return t===undefined?null:t._expirationTimestamp_!==undefined?(new Date).getTime()>t._expirationTimestamp_?null:t.value:t},set:function(e,t,r){if(r){var n=new Date;t={value:t,_expirationTimestamp_:"s"===String(r).slice(-1)?n.getTime()+1e3*Number(String(r).slice(0,-1)):n.getTime()+24*r*60*60*1e3}}this.data[e]=t},getNewUserFlagMemoryKey:function(e){return"sajssdk_2015_"+Ee.sdk_id+e}},Ve={checkIsAddSign:function(e){"track"===e.type&&(Fe()?e.properties.$is_first_day=!0:e.properties.$is_first_day=!1)},is_first_visit_time:!1,is_page_first_visited:!1,checkIsFirstTime:function(e){"track"===e.type&&"$pageview"===e.event&&(this.is_first_visit_time?(e.properties.$is_first_time=!0,this.is_first_visit_time=!1):e.properties.$is_first_time=!1)},setDeviceId:function(){},storeInitCheck:function(){if(t.is_first_visitor){var e=new Date,r={h:23-e.getHours(),m:59-e.getMinutes(),s:59-e.getSeconds()};Me.isSupport()?Me.set(qe("new_user"),"1",3600*r.h+60*r.m+r.s+"s"):Ke.set(Ke.getNewUserFlagMemoryKey("new_user"),"1",3600*r.h+60*r.m+r.s+"s"),this.is_first_visit_time=!0,this.is_page_first_visited=!0}else Fe()||(this.checkIsAddSign=function(e){"track"===e.type&&(e.properties.$is_first_day=!1)}),this.checkIsFirstTime=function(e){"track"===e.type&&"$pageview"===e.event&&(e.properties.$is_first_time=!1)}}};function ze(e,t,r){var n=!(!s(Ee.heatmap)||!Ee.heatmap.useCapture);return s(Ee.heatmap)&&P(Ee.heatmap.useCapture)&&"click"===t&&(n=!0),T(e,t,r,n)}var We=function(){this._events=[],this.pendingEvents=[]};function Xe(){var e=document.referrer;if(!e)return!1;try{var t=b(e).hostname;return t&&"baidu.com"===t.substring(t.length-"baidu.com".length)}catch(r){return!1}}We.prototype={emit:function(e){var t=[].slice.call(arguments,1);D(this._events,function(r){r.type===e&&r.callback.apply(r.context,t)}),this.pendingEvents.push({type:e,data:t}),this.pendingEvents.length>20&&this.pendingEvents.shift()},on:function(e,t,n,i){r(t)&&(this._events.push({type:e,callback:t,context:n||this}),i=!1!==i,this.pendingEvents.length>0&&i&&D(this.pendingEvents,function(r){r.type===e&&t.apply(n,r.data)}))},tempAdd:function(e,t){if(t&&e)return this.emit(e,t)},isReady:function(){}};var Ze={data:{},id:function(){return this.data.id?this.data.id:(this.data.id=Ge(),this.data.id)},type:function(){return this.data.type?this.data.type:(this.data.type=Ye(),this.data.type)}};function Ye(){var e=Y(document.referrer);if(ce(e)||!e.eqid){var t=Y(location.href);return e.ck||t.utm_source?"baidu_sem_keyword_id":"baidu_other_keyword_id"}return"baidu_seo_keyword_id"}function Ge(){var e=Y(document.referrer);return ce(e)||!e.eqid?S().replace(/-/g,""):e.eqid}function Qe(e,t){return h(e=e||document.referrer)?(0!==(e=H(e=v(e))).indexOf("https://www.baidu.com/")||t||(e=e.split("?")[0]),h(e=e.slice(0,Ee.max_referrer_string_length))?e:""):"\u53d6\u503c\u5f02\u5e38_referrer\u5f02\u5e38_"+String(e)}function et(e){if(""===(e=e||document.referrer))return!0;var t=K(null,Be,Ee.is_secure_cookie),r=W(e);return-1===(r="."+r).indexOf(t)&&""!==t}function tt(e,t){e=e||document.referrer;var r=Ee.source_type.keyword;if(document&&h(e)){if(0===e.indexOf("http")){var n=rt(e),i=Y(e);if(ce(i))return Ee.preset_properties.search_keyword_baidu&&Xe()?void 0:"\u672a\u53d6\u5230\u503c";var a=null;for(var o in r)if(n===o&&s(i))if(C(a=r[o]))for(o=0;o<a.length;o++){var l=i[a[o]];if(l)return t?{active:l}:l}else if(i[a])return t?{active:i[a]}:i[a];return Ee.preset_properties.search_keyword_baidu&&Xe()?void 0:"\u672a\u53d6\u5230\u503c"}return""===e?"\u672a\u53d6\u5230\u503c_\u76f4\u63a5\u6253\u5f00":"\u672a\u53d6\u5230\u503c_\u975ehttp\u7684url"}return"\u53d6\u503c\u5f02\u5e38_referrer\u5f02\u5e38_"+String(e)}function rt(e){var t=W(e);if(!t||"hostname\u89e3\u6790\u5f02\u5e38"===t)return"";var r={baidu:[/^.*\.baidu\.com$/],bing:[/^.*\.bing\.com$/],google:[/^www\.google\.com$/,/^www\.google\.com\.[a-z]{2}$/,/^www\.google\.[a-z]{2}$/],sm:[/^m\.sm\.cn$/],so:[/^.+\.so\.com$/],sogou:[/^.*\.sogou\.com$/],yahoo:[/^.*\.yahoo\.com$/]};for(var n in r)for(var i=r[n],a=0,o=i.length;a<o;a++)if(i[a].test(t))return n;return"\u672a\u77e5\u641c\u7d22\u5f15\u64ce"}var nt={distinct_id:function(){},jssdkDebug:function(){},_sendDebug:function(e){},apph5:function(e){var t="app_h5\u6253\u901a\u5931\u8d25-",r={1:t+"use_app_track\u4e3afalse",2:t+"Android\u6216\u8005iOS\uff0c\u6ca1\u6709\u66b4\u9732\u76f8\u5e94\u65b9\u6cd5",3.1:t+"Android\u6821\u9a8cserver_url\u5931\u8d25",3.2:t+"iOS\u6821\u9a8cserver_url\u5931\u8d25",4.1:t+"H5 \u6821\u9a8c iOS server_url \u5931\u8d25",4.2:t+"H5 \u6821\u9a8c Android server_url \u5931\u8d25"},n=e.output,i=e.step,a=e.data||"";"all"!==n&&"console"!==n||De(r[i]),("all"===n||"code"===n)&&s(Ee.is_debug)&&Ee.is_debug.apph5&&(a.type&&"profile"===a.type.slice(0,7)||(a.properties._jssdk_debug_info="apph5-"+String(i)))},defineMode:function(e){var t={1:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"App SDK \u4e0e Web JS SDK \u6ca1\u6709\u8fdb\u884c\u6253\u901a\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u6280\u672f\u4eba\u5458\u4fee\u6b63 App SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"",link_url:""},2:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"App SDK \u4e0e Web JS SDK \u6ca1\u6709\u8fdb\u884c\u6253\u901a\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u6280\u672f\u4eba\u5458\u4fee\u6b63 Web JS SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"",link_url:""},3:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"Web JS SDK \u6ca1\u6709\u5f00\u542f\u5168\u57cb\u70b9\u914d\u7f6e\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u5de5\u4f5c\u4eba\u5458\u4fee\u6b63 SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"",link_url:""},4:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"Web JS SDK \u914d\u7f6e\u7684\u6570\u636e\u6821\u9a8c\u5730\u5740\u4e0e App SDK \u914d\u7f6e\u7684\u6570\u636e\u6821\u9a8c\u5730\u5740\u4e0d\u4e00\u81f4\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u5de5\u4f5c\u4eba\u5458\u4fee\u6b63 SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"",link_url:""}};return!(!e||!t[e])&&t[e]},protocol:{protocolIsSame:function(e,t){try{if(b(e).protocol!==b(t).protocol)return!1}catch(r){return $e("\u4e0d\u652f\u6301 _.URL \u65b9\u6cd5"),!1}return!0},serverUrl:function(){h(Ee.server_url)&&""!==Ee.server_url&&!this.protocolIsSame(Ee.server_url,location.href)&&$e("SDK \u68c0\u6d4b\u5230\u60a8\u7684\u6570\u636e\u53d1\u9001\u5730\u5740\u548c\u5f53\u524d\u9875\u9762\u5730\u5740\u7684\u534f\u8bae\u4e0d\u4e00\u81f4\uff0c\u5efa\u8bae\u60a8\u4fee\u6539\u6210\u4e00\u81f4\u7684\u534f\u8bae\u3002\n\u56e0\u4e3a\uff1a1\u3001https \u4e0b\u9762\u53d1\u9001 http \u7684\u56fe\u7247\u8bf7\u6c42\u4f1a\u5931\u8d25\u30022\u3001http \u9875\u9762\u4f7f\u7528 https + ajax \u65b9\u5f0f\u53d1\u6570\u636e\uff0c\u5728 ie9 \u53ca\u4ee5\u4e0b\u4f1a\u4e22\u5931\u6570\u636e\u3002")},ajax:function(e){if(e===Ee.server_url)return!1;h(e)&&""!==e&&!this.protocolIsSame(e,location.href)&&$e("SDK \u68c0\u6d4b\u5230\u60a8\u7684\u6570\u636e\u53d1\u9001\u5730\u5740\u548c\u5f53\u524d\u9875\u9762\u5730\u5740\u7684\u534f\u8bae\u4e0d\u4e00\u81f4\uff0c\u5efa\u8bae\u60a8\u4fee\u6539\u6210\u4e00\u81f4\u7684\u534f\u8bae\u3002\u56e0\u4e3a http \u9875\u9762\u4f7f\u7528 https + ajax \u65b9\u5f0f\u53d1\u6570\u636e\uff0c\u5728 ie9 \u53ca\u4ee5\u4e0b\u4f1a\u4e22\u5931\u6570\u636e\u3002")}}},it={initPage:function(){var e=Qe(),t=ee(),r=Je(t);r||nt.jssdkDebug("url_domain\u5f02\u5e38_"+t+"_"+r),this.pageProp={referrer:e,referrer_host:e?W(e):"",url:t,url_host:W(t,"url_host\u53d6\u503c\u5f02\u5e38"),url_domain:r}},pageProp:{},campaignParams:function(){return t.kit.getUtmData()},campaignParamsStandard:function(e,t){e=e||"",t=t||"";var r=it.campaignParams(),n={},i={};return D(r,function(r,a,o){-1!==(" "+Ue+" ").indexOf(" "+a+" ")?n[e+a]=o[a]:i[t+a]=o[a]}),{$utms:n,otherUtms:i}},properties:function(){var e=window.innerHeight||document.documentElement.clientHeight||document.body&&document.body.clientHeight||0,t=window.innerWidth||document.documentElement.clientWidth||document.body&&document.body.clientWidth||0;return{$timezone_offset:(new Date).getTimezoneOffset(),$screen_height:Number(screen.height)||0,$screen_width:Number(screen.width)||0,$viewport_height:e,$viewport_width:t,$lib:"js",$lib_version:Re}},currentProps:{},register:function(e){$(it.currentProps,e)}};function at(){function e(e,t){for(var r=0;r<e.length;r++)if(-1!==t.split("?")[0].indexOf(e[r]))return!0}var t="("+Ee.source_type.utm.join("|")+")\\=[^&]+",r=Ee.source_type.search,n=Ee.source_type.social,i=document.referrer||"",a=it.pageProp.url;if(a){var o=a.match(new RegExp(t));return o&&o[0]?"\u4ed8\u8d39\u5e7f\u544a\u6d41\u91cf":e(r,i)?"\u81ea\u7136\u641c\u7d22\u6d41\u91cf":e(n,i)?"\u793e\u4ea4\u7f51\u7ad9\u6d41\u91cf":""===i?"\u76f4\u63a5\u6d41\u91cf":"\u5f15\u8350\u6d41\u91cf"}return"\u83b7\u53d6url\u5f02\u5e38"}function ot(e){var t=Z(e,"gdt_vid"),r=Z(e,"hash_key"),n=Z(e,"callbacks"),i={click_id:"",hash_key:"",callbacks:""};return h(t)&&t.length&&(i.click_id=16==t.length||18==t.length?t:"\u53c2\u6570\u89e3\u6790\u4e0d\u5408\u6cd5",h(r)&&r.length&&(i.hash_key=r),h(n)&&n.length&&(i.callbacks=n)),i}function st(e){var t=e.properties,n=JSON.parse(JSON.stringify(e));s(t)&&D(t,function(e,i){if(r(e))try{t[i]=e(n),r(t[i])&&($e("\u60a8\u7684\u5c5e\u6027- "+i+" \u683c\u5f0f\u4e0d\u6ee1\u8db3\u8981\u6c42\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664"),delete t[i])}catch(a){delete t[i],$e("\u60a8\u7684\u5c5e\u6027- "+i+" \u629b\u51fa\u4e86\u5f02\u5e38\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664")}})}function lt(e){if(s(e)&&e.$option){var t=e.$option;return delete e.$option,t}return{}}function ut(e){var t={};return D(e,function(e,r){null!=e&&(t[r]=e)}),t}function ct(e){if(!k(e.target))return!1;var t=e.target,r=h(t.tagName)?t.tagName.toLowerCase():"unknown",n={};return n.$element_type=r,n.$element_name=t.getAttribute("name"),n.$element_id=t.getAttribute("id"),n.$element_class_name=h(t.className)?t.className:null,n.$element_target_url=t.getAttribute("href"),n.$element_content=pt(t,r),(n=ut(n)).$url=ee(),n.$url_path=te(),n.$title=document.title,n}function pt(e,t){return h(t)&&"input"===t.toLowerCase()?(n=e,i=Ee.heatmap&&r(Ee.heatmap.collect_input)&&Ee.heatmap.collect_input(n),("button"===n.type||"submit"===n.type||i)&&n.value||""):z(e,t);var n,i}function dt(e){return nt.protocol.ajax(e.url),x(e)}function ft(e,t){if("string"==typeof e&&(e=v(e))&&("://"===e.slice(0,3)?e=location.protocol.slice(0,-1)+e:"//"===e.slice(0,2)?e=location.protocol+e:"http"!==e.slice(0,4)&&(e="")),C(e)&&e.length)for(var r=0;r<e.length;r++)/sa\.gif[^\/]*$/.test(e[r])||(e[r]=e[r].replace(/\/sa$/,"/sa.gif").replace(/(\/sa)(\?[^\/]+)$/,"/sa.gif$2"));else/sa\.gif[^\/]*$/.test(e)||"string"!=typeof e||(e=e.replace(/\/sa$/,"/sa.gif").replace(/(\/sa)(\?[^\/]+)$/,"/sa.gif$2"));return t&&"string"==typeof t&&(e=t),e}function gt(e){h(e)||(e=JSON.stringify(e));var t=U(e),r="crc="+ie(t);return"data="+encodeURIComponent(t)+"&ext="+encodeURIComponent(r)}var _t={},ht=new f;function mt(e,t){var r=[];"string"==typeof e&&e in _t.EVENT_LIST&&(r=_t.EVENT_LIST[e],_t[r[0]].on(r[1],t))}_t.spa=ht,_t.sdk=new f,_t.data=new f,_t.initSystemEvent=function(){var e,t,n,i,a;e=function(e){ht.emit("switch",e)},n=location.href,i=window.history.pushState,a=window.history.replaceState,r(window.history.pushState)&&(window.history.pushState=function(){i.apply(window.history,arguments),e(n),n=location.href}),r(window.history.replaceState)&&(window.history.replaceState=function(){a.apply(window.history,arguments),e(n),n=location.href}),t=window.document.documentMode?"hashchange":i?"popstate":"hashchange",T(window,t,function(){e(n),n=location.href})},_t.EVENT_LIST={spaSwitch:["spa","switch"],sdkBeforeInit:["sdk","beforeInit"],sdkInitPara:["sdk","initPara"],sdkAfterInitPara:["sdk","afterInitPara"],sdkInitAPI:["sdk","initAPI"],sdkAfterInitAPI:["sdk","afterInitAPI"],sdkAfterInit:["sdk","afterInit"],sdkReady:["sdk","ready"],dataSendSuccess:["data","sendSuccess"],dataSendFail:["data","sendFail"]};var vt=function(e){this.callback=e.callback,this.server_url=e.server_url,this.data=e.data,this.origin_data=e.origin_data};vt.prototype.start=function(){var e=this,t=new Date;dt({url:this.server_url,type:"POST",data:e.data,credentials:!1,timeout:Ee.datasend_timeout,cors:!0,success:function(r,n){_t.data.emit("sendSuccess",{status:String(n),resText:r,type:"ajax_single",timeout_config:Ee.datasend_timeout,request_timeout:new Date-t,data:e.origin_data}),e.end()},error:function(r,n){_t.data.emit("sendFail",{status:String(n),resText:r,type:"ajax_single",timeout_config:Ee.datasend_timeout,request_timeout:new Date-t,data:e.origin_data}),e.end()}})},vt.prototype.end=function(){if(this.callback){if(De("warning: sdk callback is deprecated."),!r(this.callback))return void De("error: sdk callback must be function.");this.callback()}};function yt(){this.sendTimeStamp=0,this.timer=null,this.serverUrl="",this.hasTabStorage=!1}yt.prototype={batchInterval:function(){""===this.serverUrl&&this.getServerUrl(),this.hasTabStorage||(this.generateTabStorage(),this.hasTabStorage=!0);var e=this;e.timer=setTimeout(function(){e.updateExpireTime(),e.recycle(),e.send(),clearTimeout(e.timer),e.batchInterval()},Ee.batch_send.send_interval)},getServerUrl:function(){if(!(h(Ee.server_url)&&""!==Ee.server_url||C(Ee.server_url)&&Ee.server_url.length))return xe("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01");this.serverUrl=C(Ee.server_url)?Ee.server_url[0]:Ee.server_url},send:function(){if(this.sendTimeStamp&&n()-this.sendTimeStamp<Ee.batch_send.send_interval)return!1;var e=a.get(this.tabKey);if(e){this.sendTimeStamp=n();var r=Pe((e=c(e)||this.generateTabStorageVal()).data);if(r.length){for(var i=[],o=0;o<r.length;o++){var s=t.store.readObjectVal(r[o]);s&&(s._flush_time=(new Date).getTime(),i.push(s))}i.length&&this.request(i,e.data)}}},updateExpireTime:function(){var e=a.get(this.tabKey);e&&((e=c(e)||this.generateTabStorageVal()).expireTime=n()+2*Ee.batch_send.send_interval,e.serverUrl=this.serverUrl,a.set(this.tabKey,JSON.stringify(e)))},request:function(e,t){var r=this,n=new Date;dt({url:this.serverUrl,type:"POST",data:"data_list="+encodeURIComponent(U(JSON.stringify(e))),credentials:!1,timeout:Ee.batch_send.datasend_timeout,cors:!0,success:function(i,a){_t.data.emit("sendSuccess",{status:String(a),resText:i,type:"ajax_batch",timeout_config:Ee.batch_send.datasend_timeout,request_timeout:new Date-n,data:e}),r.remove(t),r.sendTimeStamp=0},error:function(t,i){_t.data.emit("sendFail",{status:String(i),resText:t,type:"ajax_batch",timeout_config:Ee.batch_send.datasend_timeout,request_timeout:new Date-n,data:e}),r.sendTimeStamp=0}})},remove:function(e){var t=a.get(this.tabKey);if(t){for(var r=(c(t)||this.generateTabStorageVal()).data,n=0;n<e.length;n++){var i=oe(r,e[n]);i>-1&&r.splice(i,1),a.remove(e[n])}r=Pe(r),a.set(this.tabKey,JSON.stringify(this.generateTabStorageVal(r)))}},add:function(e){var r="sawebjssdk-"+String(u()),i=a.get(this.tabKey);null===i?(this.tabKey="tab-sawebjssdk-"+String(u()),i=this.generateTabStorageVal()):i=c(i)||this.generateTabStorageVal(),i.data.push(r),i.expireTime=n()+2*Ee.batch_send.send_interval,a.set(this.tabKey,JSON.stringify(i)),t.store.saveObjectVal(r,e),"track_signup"!==e.type&&"$pageview"!==e.event||this.sendImmediately()},generateTabStorage:function(){this.tabKey="tab-sawebjssdk-"+String(u()),a.set(this.tabKey,JSON.stringify(this.generateTabStorageVal()))},generateTabStorageVal:function(e){return{data:e=e||[],expireTime:n()+2*Ee.batch_send.send_interval,serverUrl:this.serverUrl}},sendImmediately:function(){this.send()},recycle:function(){for(var e={},t=0;t<localStorage.length;t++){var r=localStorage.key(t),i=this;if(0===r.indexOf("tab-sawebjssdk-")){for(var o=c(a.get(r))||this.generateTabStorageVal(),s=0;s<o.data.length;s++)e[o.data[s]]=!0;if(r!==i.tabKey&&n()>o.expireTime&&this.serverUrl===o.serverUrl)new p("sajssdk-lock-get-").get(r,1e4,1e3,function(e){if(e){null===a.get(i.tabKey)&&i.generateTabStorage();var t=c(e)||i.generateTabStorageVal(),r=c(a.get(i.tabKey))||i.generateTabStorageVal();r.data=Pe(r.data.concat(t.data)),a.set(i.tabKey,JSON.stringify(r))}})}else if(0===r.indexOf("sajssdk-lock-get-")){var l=c(a.get(r))||{expireTime:0};n()-l.expireTime>1e4&&a.remove(r)}}for(var u=0;u<localStorage.length;u++){var d=localStorage.key(u);0!==d.indexOf("sawebjssdk-")||e[d]||a.remove(d)}}};var bt=function(e){this.callback=e.callback,this.server_url=e.server_url,this.data=e.data};bt.prototype.start=function(){var e=this;"object"==typeof navigator&&"function"==typeof navigator.sendBeacon&&navigator.sendBeacon(this.server_url,this.data),setTimeout(function(){e.end()},40)},bt.prototype.end=function(){if(this.callback){if(De("warning: sdk callback is deprecated."),!r(this.callback))return void De("error: sdk callback must be function.");this.callback()}};var wt=function(e){this.callback=e.callback,this.img=document.createElement("img"),this.img.width=1,this.img.height=1,Ee.img_use_crossorigin&&(this.img.crossOrigin="anonymous"),this.server_url=e.data};wt.prototype.start=function(){var e=this;Ee.ignore_oom&&(this.img.onload=function(){this.onload=null,this.onerror=null,this.onabort=null,e.end()},this.img.onerror=function(){this.onload=null,this.onerror=null,this.onabort=null,e.end()},this.img.onabort=function(){this.onload=null,this.onerror=null,this.onabort=null,e.end()}),this.img.src=this.server_url},wt.prototype.lastClear=function(){Q().ie!==undefined?this.img.src="about:blank":this.img.src=""},wt.prototype.end=function(){if(this.callback){if(De("warning: sdk callback is deprecated."),!r(this.callback))return void De("error: sdk callback must be function.");this.callback()}self.lastClear&&self.lastClear()};var St={__proto__:null,addEvent:ze,EventEmitterSa:We,cookie:Me,info:it,getReferrer:Qe,getCurrentDomain:Je,isBaiduTraffic:Xe,getReferrerEqid:Ge,getReferrerEqidType:Ye,getBaiduKeyword:Ze,isReferralTraffic:et,getKeywordFromReferrer:tt,getReferSearchEngine:rt,getSourceFromReferrer:at,getWxAdIdFromUrl:ot,parseSuperProperties:st,searchConfigData:lt,strip_empty_properties:ut,getEleInfo:ct,getElementContent:pt,ajax:dt,optimizeServerUrl:ft,encodeTrackData:gt,AjaxSend:vt,BatchSend:yt,BeaconSend:bt,ImageSend:wt},kt=new We,Pt={requests:[],_sessionState:{},_state:{distinct_id:"",first_id:"",props:{},identities:{}},getProps:function(){return this._state.props||{}},getSessionProps:function(){},getOriginDistinctId:function(){return this._state._distinct_id||this._state.distinct_id},getOriginUnionId:function(e){var t={},r=(e=e||this._state)._first_id||e.first_id,n=e._distinct_id||e.distinct_id;return r&&n?(t.login_id=n,t.anonymous_id=r):t.anonymous_id=n,t},getIdentities:function(){var e=JSON.parse(JSON.stringify(this._state.identities));return e.$identity_anonymous_id=this.getAnonymousId(),e},getAnonymousId:function(){return Pt._state._first_id||Pt._state.first_id||Pt._state._distinct_id||Pt._state.distinct_id},getDistinctId:function(){var e=this.getUnionId();return e.login_id||e.anonymous_id},getUnionId:function(e){var t=this.getOriginUnionId(e);return t.login_id&&this._state.history_login_id&&this._state.history_login_id.name&&this._state.history_login_id.name!==He.LOGIN&&(t.login_id=this._state.history_login_id.name+"+"+t.login_id),t},getFirstId:function(){return this._state._first_id||this._state.first_id},initSessionState:function(){},setOnce:function(e,t){e in this._state||this.set(e,t)},set:function(e,t){this._state=this._state||{};var r=this._state.distinct_id;this._state[e]=t,"first_id"===e?delete this._state._first_id:"distinct_id"===e&&delete this._state._distinct_id,this.save(),"distinct_id"===e&&r&&kt.tempAdd("changeDistinctId",t)},change:function(e,t){this._state["_"+e]=t},setSessionProps:function(){t.log("initSessionState \u65b9\u6cd5\u5df2\u7ecf\u5f03\u7528\uff0c\u8bf7\u4e0d\u8981\u4f7f\u7528\u8be5\u529f\u80fd\uff0c\u5982\u6709\u9700\u6c42\u8054\u7cfb\u6280\u672f\u987e\u95ee")},setSessionPropsOnce:function(){t.log("initSessionState \u65b9\u6cd5\u5df2\u7ecf\u5f03\u7528\uff0c\u8bf7\u4e0d\u8981\u4f7f\u7528\u8be5\u529f\u80fd\uff0c\u5982\u6709\u9700\u6c42\u8054\u7cfb\u6280\u672f\u987e\u95ee")},setProps:function(e,r){var n={};for(var i in n=r?e:$(this._state.props||{},e))"string"==typeof n[i]&&(n[i]=n[i].slice(0,t.para.max_referrer_string_length));this.set("props",n)},setPropsOnce:function(e){var t=this._state.props||{};B(t,e),this.set("props",t)},clearAllProps:function(e){var t;if(C(e)&&e.length>0)for(t=0;t<e.length;t++)h(e[t])&&-1===e[t].indexOf("latest_")&&s(this._state.props)&&e[t]in this._state.props&&delete this._state.props[e[t]];else if(s(this._state.props))for(t in this._state.props)1!==t.indexOf("latest_")&&delete this._state.props[t];this.sessionSave({}),this.save()},sessionSave:function(){t.log("initSessionState \u65b9\u6cd5\u5df2\u7ecf\u5f03\u7528\uff0c\u8bf7\u4e0d\u8981\u4f7f\u7528\u8be5\u529f\u80fd\uff0c\u5982\u6709\u9700\u6c42\u8054\u7cfb\u6280\u672f\u987e\u95ee")},save:function(){var e=JSON.parse(JSON.stringify(this._state));delete e._first_id,delete e._distinct_id,e.identities&&(e.identities=U(JSON.stringify(e.identities)));var r=JSON.stringify(e);t.para.encrypt_cookie&&(r=t.kit.userEncrypt(r)),Me.set(this.getCookieName(),r,360,t.para.cross_subdomain)},getCookieName:function(){var e="";if(!1===t.para.cross_subdomain){try{var r=location.host;P(t.para.white_list[r])||(e=t.para.white_list[r])}catch(n){$e(n)}e="string"==typeof e&&""!==e?"sa_jssdk_2015_"+t.para.sdk_id+e.replace(/\./g,"_"):"sa_jssdk_2015_root"+t.para.sdk_id}else e="sensorsdata2015jssdkcross"+t.para.sdk_id;return e},init:function(){this.initSessionState();var e,r,n=S();Me.isSupport()&&(e=Me.get(this.getCookieName()),r=c(e=t.kit.userDecryptIfNeeded(e))),Me.isSupport()&&null!==e&&fe(e)&&s(r)&&(!s(r)||r.distinct_id)?(Pt._state=$(function(e){var t;e.identities&&(0===e.identities.indexOf("\n/")?e.identities=c(ye(e.identities)):e.identities=c(L(e.identities)));var r=Pt.getOriginUnionId(e);e.identities&&s(e.identities)&&!ce(e.identities)||(e.identities={},e.identities.$identity_cookie_id=S()),e.history_login_id=e.history_login_id||{};var n=e.history_login_id.name;if(r.login_id)if(n&&e.identities.hasOwnProperty(n)){if(e.identities[n]!==r.login_id){for(t in e.identities[n]=r.login_id,e.identities)e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&t!==n&&delete e.identities[t];e.history_login_id.value=r.login_id}}else{var i=n||He.LOGIN;for(t in e.identities[i]=r.login_id,e.identities)e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&t!==i&&delete e.identities[t];e.history_login_id={name:i,value:r.login_id}}else{if(e.identities.hasOwnProperty("$identity_login_id")||e.identities.hasOwnProperty(n))for(t in e.identities)e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&"$identity_anonymous_id"!==t&&delete e.identities[t];e.history_login_id={name:"",value:""}}return e}(r)),Pt.save()):(t.is_first_visitor=!0,function(e){Pt.set("distinct_id",e),Pt.set("identities",{$identity_cookie_id:e}),Pt.set("history_login_id",{name:"",value:""})}(n)),Ve.setDeviceId(n,this),Ve.storeInitCheck()},saveObjectVal:function(e,r){h(r)||(r=JSON.stringify(r)),1==t.para.encrypt_cookie&&(r=t.kit.userEncrypt(r)),a.set(e,r)},readObjectVal:function(e){var r=a.get(e);return r?c(r=t.kit.userDecryptIfNeeded(r)):null}},Ct={string:function(e){$e(e+" must be string")},emptyString:function(e){$e(e+"'s is empty")},regexTest:function(e){$e(e+" is invalid")},idLength:function(e){$e(e+" length is longer than "+Ee.max_id_length)},keyLength:function(e){$e(e+" length is longer than "+Ee.max_key_length)},stringLength:function(e){$e(e+" length is longer than "+Ee.max_string_length)},voidZero:function(e){$e(e+"'s is undefined")},reservedLoginId:function(e){$e(e+" is invalid")},reservedBind:function(e){$e(e+" is invalid")},reservedUnbind:function(e){$e(e+" is invalid")}},Ot={regName:/^((?!^distinct_id$|^original_id$|^time$|^properties$|^id$|^first_id$|^second_id$|^users$|^events$|^event$|^user_id$|^date$|^datetime$|^user_tag.*|^user_group.*)[a-zA-Z_$][a-zA-Z\d_$]*)$/i,loginIDReservedNames:["$identity_anonymous_id","$identity_cookie_id"],bindReservedNames:["$identity_login_id","$identity_anonymous_id","$identity_cookie_id"],unbindReservedNames:["$identity_anonymous_id",He.LOGIN],string:function(e){return!!h(e)},emptyString:function(e){return!(!h(e)||0===v(e).length)},regexTest:function(e){return!(!h(e)||!this.regName.test(e))},idLength:function(e){return!(!h(e)||e.length>Ee.max_id_length)},keyLength:function(e){return!(!h(e)||e.length>Ee.max_key_length)},stringLength:function(e){return!(!h(e)||e.length>Ee.max_string_length)},voidZero:function(e){return void 0!==e},reservedLoginId:function(e){return!(oe(this.loginIDReservedNames,e)>-1)},reservedUnbind:function(e){return!(oe(this.unbindReservedNames,e)>-1)},reservedBind:function(e){var t=Pt._state.history_login_id;return(!t||!t.name||t.name!==e)&&!(oe(this.bindReservedNames,e)>-1)}},jt={distinct_id:{rules:["string","emptyString","idLength"],onComplete:function(e,t,n){return!e&&("emptyString"===n&&(t="Id"),r(Ct[n])&&Ct[n](t),"idLength"===n)||e}},event:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,n){return e||("emptyString"===n&&(t="eventName"),r(Ct[n])&&Ct[n](t)),!0}},propertyKey:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,n){return e||("emptyString"===n&&(t="Property key"),r(Ct[n])&&Ct[n](t)),!0}},propertyValue:{rules:["voidZero"],onComplete:function(e,t,n){return e||("Property Value",r(Ct[n])&&Ct[n]("Property Value")),!0}},properties:function(e){return s(e)?D(e,function(e,t){Nt({propertyKey:t});Nt({propertyValue:e},function(e,n,i){return e||(n=t+"'s Value",r(Ct[i])&&Ct[i](n)),!0})}):Ot.voidZero(e)&&$e("properties\u53ef\u4ee5\u6ca1\u6709\uff0c\u4f46\u6709\u7684\u8bdd\u5fc5\u987b\u662f\u5bf9\u8c61"),!0},propertiesMust:function(e){return e!==undefined&&s(e)&&!ce(e)?this.properties.call(this,e):$e("properties\u5fc5\u987b\u662f\u5bf9\u8c61"),!0},item_type:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,n){return e||("emptyString"===n&&(t="item_type"),r(Ct[n])&&Ct[n](t)),!0}},item_id:{rules:["string","emptyString","stringLength"],onComplete:function(e,t,n){return e||("emptyString"===n&&(t="item_id"),r(Ct[n])&&Ct[n](t)),!0}},loginIdKey:{rules:["string","emptyString","keyLength","regexTest","reservedLoginId"],onComplete:function(e,t,n){return!e&&("emptyString"===n&&(t="login_id_key"),r(Ct[n])&&Ct[n](t),"keyLength"===n)||e}},bindKey:{rules:["string","emptyString","keyLength","regexTest","reservedBind"],onComplete:function(e,t,n){return!e&&("emptyString"===n&&(t="Key"),r(Ct[n])&&Ct[n](t),"keyLength"===n)||e}},unbindKey:{rules:["string","emptyString","keyLength","regexTest","reservedUnbind"],onComplete:function(e,t,n){return!e&&("emptyString"===n&&(t="Key"),r(Ct[n])&&Ct[n](t),"keyLength"===n)||e}},bindValue:{rules:["string","emptyString","idLength"],onComplete:function(e,t,n){return!e&&("emptyString"===n&&(t="Value"),r(Ct[n])&&Ct[n](t),"idLength"===n)||e}},check:function(e,t,n){var i=this[e];if(r(i))return i.call(this,t);if(!i)return!1;for(var a=0;a<i.rules.length;a++){var o=i.rules[a],s=Ot[o](t),l=r(n)?n(s,t,o):i.onComplete(s,t,o);if(!s)return l}return!0}};function Nt(e,t){for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)&&!jt.check(r,e[r],t))return!1;return!0}function Tt(e){var t=["$element_selector","$element_path"],r=["sensorsdata_app_visual_properties"];s(e)&&D(e,function(n,i){if(s(n))Tt(e[i]);else if(h(n)){if(oe(r,i)>-1)return;e[i]=(a=n,ge(o=oe(t,i)>-1?1024:Ee.max_string_length)&&a.length>o?($e("\u5b57\u7b26\u4e32\u957f\u5ea6\u8d85\u8fc7\u9650\u5236\uff0c\u5df2\u7ecf\u505a\u622a\u53d6--"+a),a.slice(0,o)):a)}var a,o})}var It={initUrl:function(){var e,r,n={server_url:{project:"",host:""},page_url:{host:"",pathname:""}};if(!pe(t.para.server_url))return xe("----vcollect---server_url\u5fc5\u987b\u4e3a\u6709\u6548 URL \u5b57\u7b26\u4e32"),!1;try{e=b(t.para.server_url),n.server_url.project=e.searchParams.get("project")||"default",n.server_url.host=e.host}catch(i){return xe("----vcollect---server_url\u89e3\u6790\u5f02\u5e38",i),!1}try{r=b(location.href),n.page_url.host=r.hostname,n.page_url.pathname=r.pathname}catch(i){return xe("----vcollect---\u9875\u9762\u5730\u5740\u89e3\u6790\u5f02\u5e38",i),!1}return n},isDiv:function(e){if(e.element_path&&"div"!==v(e.element_path.split(">").pop()).slice(0,3))return!1;return!0},configIsMatchNew:function(e,t){if(h(e.$element_selector)&&h(t.element_selector)){if("element_selector"===t.element_field&&"equal"===t["function"])return e.$element_selector===t.element_selector;if("element_selector"===t.element_field&&"contain"===t["function"])return e.$element_selector.indexOf(t.element_selector)>-1}if(h(e.$element_path)&&h(t.element_path)){if("element_path"===t.element_field&&"equal"===t["function"])return e.$element_path===t.element_path;if("element_path"===t.element_field&&"contain"===t["function"])return e.$element_path.indexOf(t.element_path)>-1}return!1},configIsMatch:function(e,t){return(!t.limit_element_content||t.element_content===e.$element_content)&&((!t.limit_element_position||t.element_position===String(e.$element_position))&&(t.element_field&&t["function"]?It.configIsMatchNew(e,t):It.configIsMatchOldVersion(e,t)))},configIsMatchOldVersion:function(e,t){if(!t.element_path)return!1;if(e.$element_position!==undefined){if(t.element_path!==e.$element_path)return!1}else if(It.isDiv({element_path:t.element_path})){if(e.$element_path.indexOf(t.element_path)<0)return!1}else if(t.element_path!==e.$element_path)return!1;return!0},filterConfig:function(e,t,r){var n=[];if(!r){var i=It.initUrl();if(!i)return[];r=i.page_url}return"$WebClick"===e.event&&D(t,function(t){s(t)&&("webclick"===t.event_type||"appclick"===t.event_type)&&s(t.event)&&t.event.url_host===r.host&&t.event.url_path===r.pathname&&It.configIsMatch(e.properties,t.event)&&n.push(t)}),n},getPropElInLi:function(e,r){if(!(e&&k(e)&&h(r)))return null;if("li"!==e.tagName.toLowerCase())return null;var n=t.heatmap.getDomSelector(e);if(n){var i=V(n+r);return i||null}return $e("----custom---\u83b7\u53d6\u540c\u7ea7\u5c5e\u6027\u5143\u7d20\u5931\u8d25\uff0cselector\u4fe1\u606f\u5f02\u5e38",n,r),null},getProp:function(e,r){if(!s(e))return!1;if(!(h(e.name)&&e.name.length>0))return $e("----vcustom----\u5c5e\u6027\u540d\u4e0d\u5408\u6cd5,\u5c5e\u6027\u629b\u5f03",e.name),!1;var n,i,a={};if("content"===e.method){var o;if(h(e.element_selector)&&e.element_selector.length>0)o=V(e.element_selector);else{if(!r||!h(e.list_selector))return $e("----vcustom----\u5c5e\u6027\u914d\u7f6e\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;var l=V(r.properties.$element_selector);if(!l)return $e("----vcustom----\u70b9\u51fb\u5143\u7d20\u83b7\u53d6\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;var u=t.heatmap.getClosestLi(l);o=It.getPropElInLi(u,e.list_selector)}if(!o||!k(o))return $e("----vcustom----\u5c5e\u6027\u5143\u7d20\u83b7\u53d6\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;if("input"===o.tagName.toLowerCase())n=o.value||"";else if("select"===o.tagName.toLowerCase()){var c=o.selectedIndex;ge(c)&&k(o[c])&&(n=pt(o[c],"select"))}else n=pt(o,o.tagName.toLowerCase());if(e.regular){try{i=new RegExp(e.regular).exec(n)}catch(p){return $e("----vcustom----\u6b63\u5219\u5904\u7406\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1}if(null===i)return $e("----vcustom----\u5c5e\u6027\u89c4\u5219\u5904\u7406\uff0c\u672a\u5339\u914d\u5230\u7ed3\u679c,\u5c5e\u6027\u629b\u5f03",e.name),!1;if(!C(i)||!h(i[0]))return $e("----vcustom----\u6b63\u5219\u5904\u7406\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name,i),!1;n=i[0]}if("STRING"===e.type)a[e.name]=n;else if("NUMBER"===e.type){if(n.length<1)return $e("----vcustom----\u672a\u83b7\u53d6\u5230\u6570\u5b57\u5185\u5bb9\uff0c\u5c5e\u6027\u629b\u5f03",e.name,n),!1;if(isNaN(Number(n)))return $e("----vcustom----\u6570\u5b57\u7c7b\u578b\u5c5e\u6027\u8f6c\u6362\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name,n),!1;a[e.name]=Number(n)}return a}return xe("----vcustom----\u5c5e\u6027\u4e0d\u652f\u6301\u6b64\u83b7\u53d6\u65b9\u5f0f",e.name,e.method),!1},getAssignConfigs:function(e,t){var r=It.initUrl();if(!r||!r.page_url)return[];if(!s(t))return[];var n=[];return t.events=t.events||t.eventList,C(t.events)&&t.events.length>0?(D(t.events,function(t){s(t)&&s(t.event)&&t.event.url_host===r.page_url.host&&t.event.url_path===r.page_url.pathname&&e(t)&&n.push(t)}),n):[]}},At={events:[],customProp:{events:[],getAssignConfigs:It.getAssignConfigs,filterConfig:It.filterConfig,getProp:It.getProp,initUrl:It.initUrl,updateEvents:function(e){C(e)&&(this.events=e)},init:function(){this.initAppGetPropsBridge()},geth5Props:function(e){var r={},n=[],i=this;if(!this.events.length)return{};if("$WebClick"===e.event){var a=this.filterConfig(e,this.events);if(!a.length)return{};D(a,function(t){s(t)&&(C(t.properties)&&t.properties.length>0&&D(t.properties,function(t){if(s(t))if(!1===t.h5)C(r.sensorsdata_app_visual_properties)||(r.sensorsdata_app_visual_properties=[]),r.sensorsdata_app_visual_properties.push(t);else{var n=i.getProp(t,e);s(n)&&(r=$(r,n))}}),h(t.event_name)&&n.push(t.event_name))}),t.bridge.hasVisualModeBridge()&&(r.sensorsdata_web_visual_eventName=n)}return r.sensorsdata_app_visual_properties&&(r.sensorsdata_app_visual_properties=U(JSON.stringify(r.sensorsdata_app_visual_properties))),r},initAppGetPropsBridge:function(){var e=this,r=new t.SDKJSBridge("getJSVisualProperties");return r.onAppNotify(function(n){var i={};try{n=JSON.parse(L(n))}catch(l){xe("getJSVisualProperties data parse error!")}if(s(n)){var a=n.sensorsdata_js_visual_properties,o=e.initUrl();o&&(o=o.page_url,C(a)&&a.length>0&&D(a,function(t){if(s(t)&&t.url_host===o.host&&t.url_path===o.pathname&&t.h5){var r=e.getProp(t);s(r)&&(i=$(i,r))}}))}return"android"===t.bridge.bridge_info.platform&&r.notifyApp({data:i},n.message_id),i}),r}},getAssignConfigs:It.getAssignConfigs,initUrl:It.initUrl,init:function(){if(this.initUrl()){var e=this.getConfigFromApp();e&&this.updateConfigs(e),this.customProp.init(),this.initAppUpdateConfigBridge()}},initAppUpdateConfigBridge:function(){var e=this;return new t.SDKJSBridge("updateH5VisualConfig").onAppNotify(function(t){if(t){try{t=JSON.parse(L(t))}catch(r){return void xe("updateH5VisualConfig result parse error\uff01")}e.updateConfigs(t)}})},getConfigFromApp:function(){var e=new t.SDKJSBridge("sensorsdata_get_app_visual_config").notifyApp();if(e)try{e=JSON.parse(L(e))}catch(r){e=null,xe("getAppVisualConfig result parse error\uff01")}return e},updateConfigs:function(e){this.events=this.filterConfigs(e),this.customProp.updateEvents(this.events)},filterConfigs:function(e){return this.getAssignConfigs(function(e){return!(!s(e)||!1===e.h5)},e)}},Dt={events:[],init:function(e){this.filterWebClickEvents(e)},filterWebClickEvents:function(e){this.events=xt.getAssignConfigs(function(e){return!(!s(e)||!0!==e.event.unlimited_div||"webclick"!==e.event_type)},e)},isTargetEle:function(e){var r=t.heatmap.getEleDetail(e);if(!s(r)||!h(r.$element_path))return!1;for(var n=0;n<this.events.length;n++)if(s(this.events[n])&&s(this.events[n].event)&&xt.configIsMatch(r,this.events[n].event))return!0;return!1}},$t={events:[],configSwitch:!1,collectAble:function(){return this.configSwitch&&s(t.para.heatmap)&&t.para.heatmap.get_vtrack_config},updateEvents:function(e){this.events=xt.getAssignConfigs(function(e){return!!(s(e)&&C(e.properties)&&e.properties.length>0)},e),this.events.length?this.configSwitch=!0:this.configSwitch=!1},getVtrackProps:function(e){var t={};return this.collectAble()?("$WebClick"===e.event&&(t=this.clickCustomPropMaker(e,this.events)),t):{}},clickCustomPropMaker:function(e,t,r){var n=this;r=r||this.filterConfig(e,t,xt.url_info.page_url);var i={};return r.length?(D(r,function(t){C(t.properties)&&t.properties.length>0&&D(t.properties,function(t){var r=n.getProp(t,e);s(r)&&$(i,r)})}),i):{}},getProp:It.getProp,getPropElInLi:It.getPropElInLi,filterConfig:It.filterConfig},xt={unlimitedDiv:Dt,config:{},storageEnable:!0,storage_name:"webjssdkvtrackcollect",para:{session_time:18e5,timeout:5e3,update_interval:18e5},url_info:{},timer:null,update_time:null,customProp:$t,initUrl:function(){var e=It.initUrl();if(e){var r;try{(r=new y(t.para.server_url))._values.Path="/config/visualized/Web.conf",e.api_url=r.getUrl()}catch(n){return xe("----vtrackcollect---API\u5730\u5740\u89e3\u6790\u5f02\u5e38",n),!1}this.url_info=e}return e},init:function(){if(!s(t.para.heatmap)||!t.para.heatmap.get_vtrack_config)return!1;if(a.isSupport()||(this.storageEnable=!1),!this.initUrl())return xe("----vtrackcustom----\u521d\u59cb\u5316\u5931\u8d25\uff0curl\u4fe1\u606f\u89e3\u6790\u5931\u8d25"),!1;if(this.storageEnable){var e=Pt.readObjectVal(this.storage_name);if(s(e)&&s(e.data))if(this.serverUrlIsSame(e.serverUrl)){this.config=e.data,this.update_time=e.updateTime,this.updateConfig(e.data);var r=(new Date).getTime()-this.update_time;if(ge(r)&&r>0&&r<this.para.session_time){var n=this.para.update_interval-r;this.setNextFetch(n)}else this.getConfigFromServer()}else this.getConfigFromServer();else this.getConfigFromServer()}else this.getConfigFromServer();this.pageStateListenner()},serverUrlIsSame:function(e){return!!s(e)&&(e.host===this.url_info.server_url.host&&e.project===this.url_info.server_url.project)},getConfigFromServer:function(){var e=this;this.sendRequest(function(t,r){e.update_time=(new Date).getTime();var n={};200===t?r&&s(r)&&"Web"===r.os&&(n=r,e.updateConfig(n)):205===t?e.updateConfig(n):304===t?n=e.config:(xe("----vtrackcustom----\u6570\u636e\u5f02\u5e38",t),e.updateConfig(n)),e.updateStorage(n),e.setNextFetch()},function(t){e.update_time=(new Date).getTime(),xe("----vtrackcustom----\u914d\u7f6e\u62c9\u53d6\u5931\u8d25",t),e.setNextFetch()})},setNextFetch:function(e){var t=this;this.timer&&(clearTimeout(this.timer),this.timer=null),e=e||this.para.update_interval,this.timer=setTimeout(function(){t.getConfigFromServer()},e)},pageStateListenner:function(){var e=this;he({visible:function(){var t=(new Date).getTime()-e.update_time;if(ge(t)&&t>0&&t<e.para.update_interval){var r=e.para.update_interval-t;e.setNextFetch(r)}else e.getConfigFromServer()},hidden:function(){e.timer&&(clearTimeout(e.timer),e.timer=null)}})},updateConfig:function(e){if(!s(e))return!1;this.config=e,this.customProp.updateEvents(e),this.unlimitedDiv.init(e)},updateStorage:function(e){if(!this.storageEnable)return!1;if(!s(e))return!1;var t;if(this.url_info.server_url)t=this.url_info.server_url;else{var r=xt.initUrl();if(!r)return!1;t=r.server_url}var n={updateTime:(new Date).getTime(),data:e,serverUrl:t};Pt.saveObjectVal(this.storage_name,n)},sendRequest:function(e,t){var r={app_id:this.url_info.page_url.host};this.config.version&&(r.v=this.config.version),_e({url:this.url_info.api_url,callbackName:"saJSSDKVtrackCollectConfig",data:r,timeout:this.para.timeout,success:function(t,r){e(t,r)},error:function(e){t(e)}})},getAssignConfigs:It.getAssignConfigs,configIsMatch:It.configIsMatch};var Et={stage:null,init:function(e){this.stage=e},interceptor:{basicProps:{priority:0,entry:function(e,t){try{var r=t.sensors,n={};s(e)&&s(e.identities)&&!ce(e.identities)?$(n,e.identities):$(n,Pt.getIdentities());var i={identities:n,distinct_id:Pt.getDistinctId(),lib:{$lib:"js",$lib_method:"code",$lib_version:String(r.lib_version)},properties:{}};return s(e)&&s(e.properties)&&!ce(e.properties)&&(e.properties.$lib_detail&&(i.lib.$lib_detail=e.properties.$lib_detail,delete e.properties.$lib_detail),e.properties.$lib_method&&(i.lib.$lib_method=e.properties.$lib_method,delete e.properties.$lib_method)),q(i,Pt.getUnionId(),e),s(e.properties)&&!ce(e.properties)&&$(i.properties,e.properties),"$UnbindID"===i.event&&(i.login_id&&delete i.login_id,i.anonymous_id&&delete i.anonymous_id),e.type&&"profile"===e.type.slice(0,7)||(r.para.properties_priority&&3===r.para.properties_priority?i.properties=$({},it.properties(),Pt.getSessionProps(),it.currentProps,Pt.getProps(),i.properties):i.properties=$({},it.properties(),Pt.getProps(),Pt.getSessionProps(),it.currentProps,i.properties),r.para.preset_properties.latest_referrer&&!h(i.properties.$latest_referrer)&&(i.properties.$latest_referrer="\u53d6\u503c\u5f02\u5e38"),r.para.preset_properties.latest_search_keyword&&!h(i.properties.$latest_search_keyword)&&(r.para.preset_properties.search_keyword_baidu&&h(i.properties.$search_keyword_id)&&ge(i.properties.$search_keyword_id_hash)&&h(i.properties.$search_keyword_id_type)||(i.properties.$latest_search_keyword="\u53d6\u503c\u5f02\u5e38")),r.para.preset_properties.latest_traffic_source_type&&!h(i.properties.$latest_traffic_source_type)&&(i.properties.$latest_traffic_source_type="\u53d6\u503c\u5f02\u5e38"),r.para.preset_properties.latest_landing_page&&!h(i.properties.$latest_landing_page)&&(i.properties.$latest_landing_page="\u53d6\u503c\u5f02\u5e38"),"not_collect"===r.para.preset_properties.latest_wx_ad_click_id?(delete i.properties._latest_wx_ad_click_id,delete i.properties._latest_wx_ad_hash_key,delete i.properties._latest_wx_ad_callbacks):r.para.preset_properties.latest_wx_ad_click_id&&!h(i.properties._latest_wx_ad_click_id)&&(i.properties._latest_wx_ad_click_id="\u53d6\u503c\u5f02\u5e38",i.properties._latest_wx_ad_hash_key="\u53d6\u503c\u5f02\u5e38",i.properties._latest_wx_ad_callbacks="\u53d6\u503c\u5f02\u5e38"),h(i.properties._latest_wx_ad_click_id)&&(i.properties.$url=ee())),i.properties.$time&&J(i.properties.$time)?(i.time=1*i.properties.$time,delete i.properties.$time):i.time=1*new Date,function(e){if(r.bridge&&"success"===r.bridge.bridge_info.verify_success){var t=At.customProp.geth5Props(JSON.parse(JSON.stringify(e)));s(t)&&!ce(t)&&(e.properties=$(e.properties,t))}var n=xt.customProp.getVtrackProps(JSON.parse(JSON.stringify(e)));s(n)&&!ce(n)&&(e.properties=$(e.properties,n))}(i),st(i),Ve.checkIsAddSign(i),Ve.checkIsFirstTime(i),function(e){var t=!e.type||"profile"!==e.type.slice(0,7);s(e.properties)&&t&&("$referrer"in e.properties&&(e.properties.$referrer_host=""===e.properties.$referrer?"":W(e.properties.$referrer,"\u53d6\u503c\u5f02\u5e38")),Ee.preset_properties.latest_referrer&&Ee.preset_properties.latest_referrer_host&&(e.properties.$latest_referrer_host=""===e.properties.$latest_referrer?"":W(e.properties.$latest_referrer,"\u53d6\u503c\u5f02\u5e38")))}(i),function(e){var t=!e.type||"profile"!==e.type.slice(0,7),r=Ee.preset_properties&&t;r&&Ee.preset_properties.url&&P(e.properties.$url)&&(e.properties.$url=ee()),r&&Ee.preset_properties.title&&P(e.properties.$title)&&(e.properties.$title=document.title)}(i),i}catch(a){return{_debug_web_msg:String(a)}}}},formatData:{priority:0,entry:function(e){var t,n,i=e.properties;be(e),s(i)?(function(e,t){s(e)&&D(e,function(n,i){if(C(n)){var a=[];D(n,function(e){if(h(e))a.push(e);else if(P(e))a.push("null");else try{a.push(JSON.stringify(e))}catch(t){$e("\u60a8\u7684\u6570\u636e-",i,n,"\u6570\u7ec4\u91cc\u503c\u6709\u9519\u8bef,\u5df2\u5c06\u5176\u5220\u9664")}}),e[i]=a}var o=oe(t||[],i)>-1;if(s(n)&&"$option"!==i&&!o)try{e[i]=JSON.stringify(n)}catch(l){delete e[i],$e("\u60a8\u7684\u6570\u636e-",i,n,"\u6570\u636e\u503c\u6709\u9519\u8bef\uff0c\u5df2\u5c06\u5176\u5220\u9664")}else h(n)||ge(n)||J(n)||ue(n)||C(n)||r(n)||"$option"===i||o||($e("\u60a8\u7684\u6570\u636e-",i,n,"-\u683c\u5f0f\u4e0d\u6ee1\u8db3\u8981\u6c42\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664"),delete e[i])})}(i),s(t=i)&&D(["distinct_id","user_id","id","date","datetime","event","events","first_id","original_id","device_id","properties","second_id","time","users"],function(e,r){e in t&&(oe(n||[],e)>-1||(r<3?(delete t[e],$e("\u60a8\u7684\u5c5e\u6027- "+e+"\u662f\u4fdd\u7559\u5b57\u6bb5\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664")):$e("\u60a8\u7684\u5c5e\u6027- "+e+"\u662f\u4fdd\u7559\u5b57\u6bb5\uff0c\u8bf7\u907f\u514d\u5176\u4f5c\u4e3a\u5c5e\u6027\u540d")))}),function(e){"undefined"!=typeof e.properties.$project&&(e.project=e.properties.$project,delete e.properties.$project),"undefined"!=typeof e.properties.$token&&(e.token=e.properties.$token,delete e.properties.$token)}(e),function(e,t){D(e,function(r,n){-1===oe(t||[],n)&&Nt({propertyKey:n},function(t,r,i){return t||"keyLength"===i||delete e[n],!0})})}(i),Tt(i)):"properties"in e&&(e.properties={}),function(e){"item_type"in e&&Nt({item_type:e.item_type},function(t){return t||delete e.item_type,!0}),"item_id"in e&&Nt({item_id:e.item_id},function(t,r,n){return t||"string"!==n||delete e.item_id,!0})}(e)}},finalAdjustData:{priority:0,entry:function(e,t){var r=t.sensors;return e._track_id=Number(String(u()).slice(2,5)+String(u()).slice(2,4)+String((new Date).getTime()).slice(-4)),e._flush_time=(new Date).getTime(),r.events.tempAdd("send",e),e}}}};var Lt={};function Ut(e,t,r,n){var i=null;if((e=e||{}).ele&&(i=e.ele),e.event&&(i=e.target?e.target:e.event.target),r=r||{},!i||"object"!=typeof i)return!1;if(!i.href||/^javascript/.test(i.href)||i.target||i.download||i.onclick)return n(t,r),!1;function a(e){e.stopPropagation(),e.preventDefault();var a=!1;function o(){a||(a=!0,location.href=i.href)}setTimeout(o,1e3),n(t,r,o)}e.event&&a(e.event),e.ele&&ze(e.ele,"click",function(e){a(e)})}function Rt(){var e=location.protocol;return"http:"===e||"https:"===e?e:"http:"}Lt.check=Nt,Lt.sendItem=function(e){var r={lib:{$lib:"js",$lib_method:"code",$lib_version:String(t.lib_version)},time:1*new Date};$(r,e),function(e){Et.stage.process("formatData",e)}(r),t.kit.sendData(r)},Lt.send=function(e,r){var n=t.kit.buildData(e);t.kit.sendData(n,r)};var Bt={stage:null,init:function(e){this.stage=e}};var Ht={label:!1,li:!1,a:!0,button:!0},Jt={otherTags:[],initUnlimitedTags:function(){D(Jt.otherTags,function(e){e in Ht&&(Ht[e]=!0)})},isUnlimitedTag:function(e){if(!e||1!==e.nodeType)return!1;var r=e.nodeName.toLowerCase();return Ht[r]||ne(e,t.para.heatmap.track_attr)},getTargetElement:function(e,r){var n=this,i=e;if("object"!=typeof i)return null;if("string"!=typeof i.tagName)return null;var a=i.tagName.toLowerCase();if("body"===a.toLowerCase()||"html"===a.toLowerCase())return null;if(!i||!i.parentNode||!i.parentNode.children)return null;var o=i.parentNode,s=n.otherTags;if("a"===a||"button"===a||"input"===a||"textarea"===a)return i;if(oe(s,a)>-1)return i;if("area"===a&&"map"===o.tagName.toLowerCase()&&O(o).prev().tagName&&"img"===O(o).prev().tagName.toLowerCase())return O(o).prev();if("div"===a&&t.para.heatmap.collect_tags.div&&n.isDivLevelValid(i)&&((t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div&&t.para.heatmap.collect_tags.div.max_level||1)>1||n.isCollectableDiv(i)))return i;if(n.isStyleTag(a)&&t.para.heatmap.collect_tags.div){var l=n.getCollectableParent(i);if(l&&n.isDivLevelValid(l))return l}return n.hasElement({event:r&&r.originalEvent||r,element:e},function(e){return n.isUnlimitedTag(e)})||null},getDivLevels:function(e,t){var r=Jt.getElementPath(e,!0,t).split(" > "),n=0;return D(r,function(e){"div"===e&&n++}),n},isDivLevelValid:function(e){for(var r=t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div&&t.para.heatmap.collect_tags.div.max_level||1,n=e.getElementsByTagName("div"),i=n.length-1;i>=0;i--)if(Jt.getDivLevels(n[i],e)>r)return!1;return!0},getElementPath:function(e,t,r){for(var n=[];e.parentNode&&k(e);){if(!h(e.tagName))return"unknown";if(e.id&&!t&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.id)){n.unshift(e.tagName.toLowerCase()+"#"+e.id);break}if(r&&e===r){n.unshift(e.tagName.toLowerCase());break}if(e===document.body){n.unshift("body");break}n.unshift(e.tagName.toLowerCase()),e=e.parentNode}return n.join(" > ")},getClosestLi:function(e){return function(e,t){for(;e&&e!==document&&1===e.nodeType;e=e.parentNode)if(e.tagName&&h(e.tagName)&&e.tagName.toLowerCase()===t)return e;return null}(e,"li")},getElementPosition:function(e,r,n){var i=t.heatmap.getClosestLi(e);if(!i||!k(e)||!h(e.tagName))return null;var a=e.tagName.toLowerCase(),o=i.getElementsByTagName(a),s=o.length,l=[];if(s>1){for(var u=0;u<s;u++){t.heatmap.getElementPath(o[u],n)===r&&l.push(o[u])}if(l.length>1)return oe(l,e)}return function(e){if(!e.parentNode)return"";if(1===O(e).getSameTypeSiblings().length)return 0;for(var t=0,r=e;O(r).previousElementSibling().ele;r=O(r).previousElementSibling().ele,t++);return t}(i)},setNotice:function(e){t.is_heatmap_render_mode=!0,t.para.heatmap||(t.errorMsg="\u60a8 SDK \u6ca1\u6709\u914d\u7f6e\u5f00\u542f\u70b9\u51fb\u56fe \uff01"),e&&"http:"===e.slice(0,5)&&"https:"===location.protocol&&(t.errorMsg="\u60a8\u7684\u5f53\u524d\u9875\u9762\u662f https \u7684\u5730\u5740\uff0c\u795e\u7b56\u5206\u6790\u73af\u5883\u4e5f\u5fc5\u987b\u662f https \uff01"),t.para.heatmap_url||(t.para.heatmap_url=Rt()+"//static.sensorsdata.cn/sdk/"+t.lib_version+"/heatmap.min.js")},getDomIndex:function(e){if(!e.parentNode)return-1;for(var t=0,r=e.tagName,n=e.parentNode.children,i=0;i<n.length;i++)if(n[i].tagName===r){if(e===n[i])return t;t++}return-1},selector:function(e,r){if(!e||!k(e)||!h(e.tagName))return"";var n=e.parentNode&&9==e.parentNode.nodeType?-1:this.getDomIndex(e);return e.getAttribute&&e.getAttribute("id")&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute("id"))&&(!t.para.heatmap||t.para.heatmap&&"not_use_id"!==t.para.heatmap.element_selector)&&!r?"#"+e.getAttribute("id"):e.tagName.toLowerCase()+(~n?":nth-of-type("+(n+1)+")":"")},getDomSelector:function(e,r,n){if(!(e&&e.parentNode&&e.parentNode.children&&h(e.tagName)))return"unknown";r=r&&r.join?r:[];var i=e.nodeName.toLowerCase();return e&&"body"!==i&&1==e.nodeType?(r.unshift(this.selector(e,n)),e.getAttribute&&e.getAttribute("id")&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute("id"))&&t.para.heatmap&&"not_use_id"!==t.para.heatmap.element_selector&&!n?r.join(" > "):this.getDomSelector(e.parentNode,r,n)):(r.unshift("body"),r.join(" > "))},na:function(){var e=document.documentElement.scrollLeft||window.pageXOffset;return parseInt(isNaN(e)?0:e,10)},i:function(){var e=0;try{e=o.documentElement&&o.documentElement.scrollTop||m.pageYOffset,e=isNaN(e)?0:e}catch(t){e=0}return parseInt(e,10)},getBrowserWidth:function(){var e=window.innerWidth||document.body.clientWidth;return isNaN(e)?0:parseInt(e,10)},getBrowserHeight:function(){var e=window.innerHeight||document.body.clientHeight;return isNaN(e)?0:parseInt(e,10)},getScrollWidth:function(){var e=parseInt(document.body.scrollWidth,10);return isNaN(e)?0:e},getEleDetail:function(e){var r=this.getDomSelector(e),n=ct({target:e});n.$element_selector=r||"",n.$element_path=t.heatmap.getElementPath(e,t.para.heatmap&&"not_use_id"===t.para.heatmap.element_selector);var i=t.heatmap.getElementPosition(e,n.$element_path,t.para.heatmap&&"not_use_id"===t.para.heatmap.element_selector);return ge(i)&&(n.$element_position=i),n},getPointerEventProp:function(e,t){if(!e)return{};function r(){return{scrollLeft:document.body.scrollLeft||document.documentElement.scrollLeft||0,scrollTop:document.body.scrollTop||document.documentElement.scrollTop||0}}function n(e){if(document.documentElement.getBoundingClientRect){var t=e.getBoundingClientRect();return{targetEleX:t.left+r().scrollLeft||0,targetEleY:t.top+r().scrollTop||0}}}function i(e){return Number(Number(e).toFixed(3))}return function(e){var a=e.pageX||e.clientX+r().scrollLeft||e.offsetX+n(t).targetEleX||0,o=e.pageY||e.clientY+r().scrollTop||e.offsetY+n(t).targetEleY||0;return{$page_x:i(a),$page_y:i(o)}}(e)},start:function(e,n,i,a,o){if(s(t.para.heatmap)&&r(t.para.heatmap.collect_element)&&!t.para.heatmap.collect_element(n))return!1;var l,u=Jt.getBasicEleInfo(e,n,i,a,o);l=u,Bt.stage.process("webClickEvent",l)},getBasicEleInfo:function(e,n,i,a,o){var l=s(a)?a:{},u=r(o)?o:r(a)?a:undefined,c=this.getEleDetail(n);if(t.para.heatmap&&t.para.heatmap.custom_property){var p=t.para.heatmap.custom_property(n);s(p)&&(c=$(c,p))}return{event:e,target:n,props:c=$(c,this.getPointerEventProp(e,n),l),tagName:i,callback:u}},hasElement:function(e,t){var r;if(e.event){var n=e.event;r=n.path||n._getPath&&n._getPath()}else e.element&&(r=O(e.element).getParents());if(r&&C(r)&&r.length>0)for(var i=0;i<r.length;i++)if("object"==typeof r[i]&&1===r[i].nodeType&&t(r[i]))return r[i]},isStyleTag:function(e,r){return!(oe(["a","div","input","button","textarea"],e)>-1)&&(!r||t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div?!!(s(t.para.heatmap)&&s(t.para.heatmap.collect_tags)&&s(t.para.heatmap.collect_tags.div)&&C(t.para.heatmap.collect_tags.div.ignore_tags)&&oe(t.para.heatmap.collect_tags.div.ignore_tags,e)>-1):oe(["mark","/mark","strong","b","em","i","u","abbr","ins","del","s","sup"],e)>-1)},isCollectableDiv:function(e,r){try{if(0===e.children.length)return!0;for(var n=0;n<e.children.length;n++)if(1===e.children[n].nodeType){var i=h(e.children[n].tagName)?e.children[n].tagName.toLowerCase():"unknown",a=t.para&&t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div&&t.para.heatmap.collect_tags.div.max_level;if(!("div"===i&&a>1||this.isStyleTag(i,r)))return!1;if(!this.isCollectableDiv(e.children[n],r))return!1}return!0}catch(o){xe("isCollectableDiv:"+o)}return!1},getCollectableParent:function(e,r){try{var n=e.parentNode,i=n?n.tagName.toLowerCase():"";if("body"===i)return!1;var a=t.para&&t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div&&t.para.heatmap.collect_tags.div.max_level;if(i&&"div"===i&&(a>1||this.isCollectableDiv(n,r)))return n;if(n&&this.isStyleTag(i,r))return this.getCollectableParent(n,r)}catch(o){xe("getCollectableParent:"+o)}return!1},listenUrlChange:function(e){e(),t.ee.spa.on("switch",function(){e()})},initScrollmap:function(){if(!s(t.para.heatmap)||"default"!==t.para.heatmap.scroll_notice_map)return!1;var e=!0;t.para.scrollmap&&r(t.para.scrollmap.collect_url)&&this.listenUrlChange(function(){e=!!t.para.scrollmap.collect_url()});var n=function(e){var t={};return t.timeout=e.timeout||1e3,t.func=e.func,t.hasInit=!1,t.inter=null,t.main=function(e,t){this.func(e,t),this.inter=null},t.go=function(e){var r={};this.inter||(r.$viewport_position=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop||0,r.$viewport_position=Math.round(r.$viewport_position)||0,e?t.main(r,!0):this.inter=setTimeout(function(){t.main(r)},this.timeout))},t}({timeout:1e3,func:function(e,r){var n,i=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop||0,a=new Date,o=a-this.current_time;(o>t.para.heatmap.scroll_delay_time&&i-e.$viewport_position!=0||r)&&(e.$url=ee(),e.$title=document.title,e.$url_path=te(),e.event_duration=Math.min(t.para.heatmap.scroll_event_duration,parseInt(o)/1e3),e.event_duration=e.event_duration<0?0:e.event_duration,n=e,Bt.stage.process("webStayEvent",n)),this.current_time=a}});n.current_time=new Date,ze(window,"scroll",function(){if(!e)return!1;n.go()}),ze(window,"beforeunload",function(){if(!e)return!1;n.go("notime")})},initHeatmap:function(){var e=this,n=!0;if(!s(t.para.heatmap)||"default"!==t.para.heatmap.clickmap)return!1;r(t.para.heatmap.collect_url)&&this.listenUrlChange(function(){n=!!t.para.heatmap.collect_url()}),"all"===t.para.heatmap.collect_elements?t.para.heatmap.collect_elements="all":t.para.heatmap.collect_elements="interact","all"===t.para.heatmap.collect_elements?ze(document,"click",function(t){if(!n)return!1;var r=t||window.event;if(!r)return!1;var i=r.target||r.srcElement;if("object"!=typeof i)return!1;if("string"!=typeof i.tagName)return!1;var a=i.tagName.toLowerCase();if("body"===a||"html"===a)return!1;if(!i||!i.parentNode||!i.parentNode.children)return!1;var o=h(i.parentNode.tagName)?i.parentNode.tagName.toLowerCase():"unknown";"a"===o||"button"===o?e.start(r,i.parentNode,o):e.start(r,i,a)}):ze(document,"click",function(r){if(!n)return!1;var i=r||window.event;if(!i)return!1;var a=i.target||i.srcElement,o=t.heatmap.getTargetElement(a,r);if(!k(o)&&!h(a.tagName))return!1;k(o)&&h(o.tagName)?e.start(i,o,o.tagName.toLowerCase()):k(a)&&"div"===a.tagName.toLowerCase()&&s(t.para.heatmap)&&t.para.heatmap.get_vtrack_config&&Dt.events.length>0&&Dt.isTargetEle(a)&&e.start(i,a,a.tagName.toLowerCase(),{$lib_method:"vtrack"})})}};function Mt(){var e=it.campaignParams(),r={};return D(e,function(e,n,i){-1!==(" "+t.source_channel_standard+" ").indexOf(" "+n+" ")?r["$"+n]=i[n]:r[n]=i[n]}),r}function qt(e,r,n){if(t.is_first_visitor&&n){var i={};t.para.preset_properties.search_keyword_baidu&&et(document.referrer)&&Xe()&&(i.$search_keyword_id=Ze.id(),i.$search_keyword_id_type=Ze.type(),i.$search_keyword_id_hash=ae(i.$search_keyword_id));var a=document.characterSet||document.charset,o=Qe(null,r);e($({$first_visit_time:new Date,$first_referrer:o,$first_referrer_host:o?W(o,"\u53d6\u503c\u5f02\u5e38"):"",$first_browser_language:h(navigator.language)?navigator.language.toLowerCase():"\u53d6\u503c\u5f02\u5e38",$first_browser_charset:h(a)?a.toUpperCase():"\u53d6\u503c\u5f02\u5e38",$first_traffic_source_type:at(),$first_search_keyword:tt(),$timezone_offset:(new Date).getTimezoneOffset()},Mt(),i)),t.is_first_visitor=!1}}var Ft={autoTrackIsUsed:!1,isReady:function(e){r(e)?e():t.log("error: isReady callback must be function")},getUtm:function(){return it.campaignParams()},getStayTime:function(){return(new Date-t._t)/1e3},setProfileLocal:function(e){if(!a.isSupport())return t.setProfile(e),!1;if(!s(e)||ce(e))return!1;var r=Pt.readObjectVal("sensorsdata_2015_jssdk_profile"),n=!1;if(s(r)&&!ce(r)){for(var i in e)!(i in r&&r[i]!==e[i])&&i in r||(r[i]=e[i],n=!0);n&&(Pt.saveObjectVal("sensorsdata_2015_jssdk_profile",r),t.setProfile(e))}else Pt.saveObjectVal("sensorsdata_2015_jssdk_profile",e),t.setProfile(e)},setInitReferrer:function(){var e=Qe();t.setOnceProfile({_init_referrer:e,_init_referrer_host:it.pageProp.referrer_host})},setSessionReferrer:function(){var e=Qe();Pt.setSessionPropsOnce({_session_referrer:e,_session_referrer_host:it.pageProp.referrer_host})},setDefaultAttr:function(){it.register({_current_url:location.href,_referrer:Qe(),_referring_host:it.pageProp.referrer_host})},trackHeatMap:function(e,r,n){if("object"==typeof e&&e.tagName&&k(e.parentNode)){var i=e.tagName.toLowerCase(),a=e.parentNode.tagName.toLowerCase(),o=t.para.heatmap&&t.para.heatmap.track_attr?t.para.heatmap.track_attr:["data-sensors-click"];"button"===i||"a"===i||"a"===a||"button"===a||"input"===i||"textarea"===i||ne(e,o)||Jt.start(null,e,i,r,n)}},trackAllHeatMap:function(e,t,r){if("object"==typeof e&&e.tagName){var n=e.tagName.toLowerCase();Jt.start(null,e,n,t,r)}},autoTrackSinglePage:function(e,r){var n;n=this.autoTrackIsUsed?it.pageProp.url:it.pageProp.referrer;var i=!(e=s(e)?e:{}).not_set_profile;function a(e,r){t.track("$pageview",$({$referrer:n,$url:ee(),$url_path:te(),$title:document.title},e,Mt()),r),n=ee()}e.not_set_profile&&delete e.not_set_profile,a(e,r),this.autoTrackSinglePage=a,qt(t.setOnceProfile,!1,i)},autoTrackWithoutProfile:function(e,t){e=s(e)?e:{},this.autoTrack($(e,{not_set_profile:!0}),t)},autoTrack:function(e,r){e=s(e)?e:{};var n=Mt(),i=!e.not_set_profile;e.not_set_profile&&delete e.not_set_profile;var a=location.href;t.para.is_single_page&&I(function(){var i=Qe(a,!0);t.track("$pageview",$({$referrer:i,$url:ee(),$url_path:te(),$title:document.title},n,e),r),a=ee()}),t.track("$pageview",$({$referrer:Qe(null,!0),$url:ee(),$url_path:te(),$title:document.title},n,e),r),qt(t.setOnceProfile,!0,i),this.autoTrackIsUsed=!0},getAnonymousID:function(){return ce(Pt._state)?"SDK is not initialized.":Pt.getAnonymousId()},setPlugin:function(e){if(!s(e))return!1;D(e,function(e,n){r(e)&&(s(window.SensorsDataWebJSSDKPlugin)&&window.SensorsDataWebJSSDKPlugin[n]?e(window.SensorsDataWebJSSDKPlugin[n]):s(t.modules)&&t.modules[n]?e(t.modules[n]):$e(n+"is not found,please check sensorsdata documents."))})},useModulePlugin:function(){t.use.apply(t,arguments)},useAppPlugin:function(){this.setPlugin.apply(this,arguments)}};function Kt(e,t){var r=e.id,n=e.callback,i=e.name,a=Pt.getFirstId(),o=Pt.getOriginDistinctId();if(!Nt({distinct_id:r}))return xe("login id is invalid"),!1;if(r===Pt.getOriginDistinctId()&&!a)return xe("login id is equal to distinct_id"),!1;if(s(Pt._state.identities)&&Pt._state.identities.hasOwnProperty(i)&&r===Pt._state.first_id)return!1;if(Pt._state.history_login_id.name!==i||r!==Pt._state.history_login_id.value){Pt._state.identities[i]=r,Pt.set("history_login_id",{name:i,value:r}),a||Pt.set("first_id",o),t(r,"$SignUp",{},n);var l={$identity_cookie_id:Pt._state.identities.$identity_cookie_id};return l[i]=r,Vt(l),!0}return!1}function Vt(e){var t={};for(var r in e)t[r]=e[r];Pt._state.identities=t,Pt.save()}var zt=1;function Wt(e,n){if(h(e)||s(e)){var i;if(s(e)){var a=t.modules&&t.modules[e.plugin_name];a&&a!==e&&$e(e.name+" is conflict with builtin plugin, and sdk uses builtin plugin."),i=a||e}return h(e)&&(s(t.modules)&&s(t.modules[e])?i=t.modules[e]:s(window.SensorsDataWebJSSDKPlugin)&&s(window.SensorsDataWebJSSDKPlugin[e])?i=window.SensorsDataWebJSSDKPlugin[e]:window.sensorsDataAnalytic201505&&window.sensorsDataAnalytic201505.modules[e]&&(i=window.sensorsDataAnalytic201505.modules[e])),i&&r(i.init)?i.plugin_is_init?i:(i.plugin_name||$e("warning: invalid plugin, plugin_name required."),i.plugin_version?i.plugin_version!==t.lib_version&&$e("warning: plugin version not match SDK version. plugin may not work correctly. "):$e("warning: invalid plugin, plugin version required."),!i.plugin_is_init&&i.init(t,n),i.plugin_is_init=!0,t.modules=t.modules||{},t.modules[i.plugin_name||"unnamed_"+zt++]=i,i):($e((e.plugin_name||e)+" is not found or it's not a standard plugin. Please check sensorsdata official documents."),i)}xe("use's first arguments must be string or object.")}function Xt(e,t,r,n){var i=Pt.getFirstId()||Pt.getDistinctId();Pt.set("distinct_id",e),Lt.send({original_id:i,distinct_id:Pt.getDistinctId(),type:"track_signup",event:t,properties:r},n)}function Zt(e){Nt({properties:e})?Pt.setProps(e):xe("register\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function Yt(e,t){"number"==typeof e&&(e=String(e)),!Kt({id:e,callback:t,name:He.LOGIN},Xt)&&r(t)&&t()}var Gt={__proto__:null,setInitVar:function(){t._t=t._t||1*new Date,t.is_first_visitor=!1,t.source_channel_standard=Ue},initPara:function(e){$(Ee,e||t.para||{}),t.para=Ee;var r,n={};if(s(t.para.is_track_latest))for(var i in t.para.is_track_latest)n["latest_"+i]=t.para.is_track_latest[i];for(r in t.para.preset_properties=$({},Le.preset_properties,n,t.para.preset_properties||{}),Le)void 0===t.para[r]&&(t.para[r]=Le[r]);"string"!=typeof t.para.web_url||"://"!==t.para.web_url.slice(0,3)&&"//"!==t.para.web_url.slice(0,2)||("://"===t.para.web_url.slice(0,3)?t.para.web_url=location.protocol.slice(0,-1)+t.para.web_url:t.para.web_url=location.protocol+t.para.web_url),nt.protocol.serverUrl(),t.bridge&&t.bridge.initPara();var a=["utm_source","utm_medium","utm_campaign","utm_content","utm_term"],o=["www.baidu.","m.baidu.","m.sm.cn","so.com","sogou.com","youdao.com","google.","yahoo.com/","bing.com/","ask.com/"],l=["weibo.com","renren.com","kaixin001.com","douban.com","qzone.qq.com","zhihu.com","tieba.baidu.com","weixin.qq.com"],u={baidu:["wd","word","kw","keyword"],google:"q",bing:"q",yahoo:"p",sogou:["query","keyword"],so:"q",sm:"q"};"object"==typeof t.para.source_type&&(t.para.source_type.utm=C(t.para.source_type.utm)?t.para.source_type.utm.concat(a):a,t.para.source_type.search=C(t.para.source_type.search)?t.para.source_type.search.concat(o):o,t.para.source_type.social=C(t.para.source_type.social)?t.para.source_type.social.concat(l):l,t.para.source_type.keyword=s(t.para.source_type.keyword)?$(u,t.para.source_type.keyword):u);var c=["mark","/mark","strong","b","em","i","u","abbr","ins","del","s","sup"];if(t.para.heatmap&&!s(t.para.heatmap)&&(t.para.heatmap={}),s(t.para.heatmap)){t.para.heatmap.clickmap=t.para.heatmap.clickmap||"default",t.para.heatmap.scroll_notice_map=t.para.heatmap.scroll_notice_map||"default",t.para.heatmap.scroll_delay_time=t.para.heatmap.scroll_delay_time||4e3,t.para.heatmap.scroll_event_duration=t.para.heatmap.scroll_event_duration||18e3,t.para.heatmap.renderRefreshTime=t.para.heatmap.renderRefreshTime||1e3,t.para.heatmap.loadTimeout=t.para.heatmap.loadTimeout||1e3,t.para.heatmap.request_timeout=t.para.heatmap.request_timeout||1e4,!0!==t.para.heatmap.get_vtrack_config&&(t.para.heatmap.get_vtrack_config=!1);var p=C(t.para.heatmap.track_attr)?F(t.para.heatmap.track_attr,function(e){return e&&"string"==typeof e}):[];p.push("data-sensors-click"),t.para.heatmap.track_attr=p,s(t.para.heatmap.collect_tags)?!0===t.para.heatmap.collect_tags.div?t.para.heatmap.collect_tags.div={ignore_tags:c,max_level:1}:s(t.para.heatmap.collect_tags.div)?(t.para.heatmap.collect_tags.div.ignore_tags?C(t.para.heatmap.collect_tags.div.ignore_tags)||($e("ignore_tags \u53c2\u6570\u5fc5\u987b\u662f\u6570\u7ec4\u683c\u5f0f"),t.para.heatmap.collect_tags.div.ignore_tags=c):t.para.heatmap.collect_tags.div.ignore_tags=c,t.para.heatmap.collect_tags.div.max_level&&-1===oe([1,2,3],t.para.heatmap.collect_tags.div.max_level)&&(t.para.heatmap.collect_tags.div.max_level=1)):t.para.heatmap.collect_tags.div=!1:t.para.heatmap.collect_tags={div:!1}}t.para.server_url=ft(t.para.server_url,t.para.custom_server_url),!0===t.para.noCache?t.para.noCache="?"+(new Date).getTime():t.para.noCache="",t.para.callback_timeout>t.para.datasend_timeout&&(t.para.datasend_timeout=t.para.callback_timeout),t.para.heatmap&&t.para.heatmap.collect_tags&&s(t.para.heatmap.collect_tags)&&D(t.para.heatmap.collect_tags,function(e,r){"div"!==r&&e&&t.heatmap.otherTags.push(r)}),t.para.heatmap&&"default"===t.para.heatmap.clickmap&&t.heatmap.initUnlimitedTags()},quick:function(){var e=Array.prototype.slice.call(arguments),r=e[0],n=e.slice(1);if("string"==typeof r&&Ft[r])return Ft[r].apply(Ft,n);"function"==typeof r?r.apply(t,n):$e("quick\u65b9\u6cd5\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u529f\u80fd"+e[0])},use:Wt,track:function(e,t,r){Nt({event:e,properties:t})&&Lt.send({type:"track",event:e,properties:t},r)},bind:function(e,t){if(!Nt({bindKey:e,bindValue:t}))return!1;Pt._state.identities[e]=t,Pt.save(),Lt.send({type:"track_id_bind",event:"$BindID",properties:{}})},unbind:function(e,t){var r=function(e,t){if(!Nt({unbindKey:e,bindValue:t}))return!1;if(s(Pt._state.identities)&&Pt._state.identities.hasOwnProperty(e)&&Pt._state.identities[e]===t){var r=Pt.getUnionId().login_id;r&&e+"+"+t===r&&(Pt._state.distinct_id=Pt._state.first_id,Pt._state.first_id="",Pt.set("history_login_id",{name:"",value:""})),"$identity_cookie_id"!==e&&(delete Pt._state.identities[e],Pt.save())}var n={};return n[e]=t,n}(e,t);r&&Lt.send({identities:r,type:"track_id_unbind",event:"$UnbindID",properties:{}})},trackLink:function(e,r,n){"object"==typeof e&&e.tagName?Ut({ele:e},r,n,t.track):"object"==typeof e&&e.target&&e.event&&Ut(e,r,n,t.track)},trackLinks:function(e,r,n){return n=n||{},!(!e||"object"!=typeof e)&&!(!e.href||/^javascript/.test(e.href)||e.target)&&void ze(e,"click",function(i){i.preventDefault();var a=!1;function o(){a||(a=!0,location.href=e.href)}setTimeout(o,1e3),t.track(r,n,o)})},setItem:function(e,t,r){Nt({item_type:e,item_id:t,properties:r})&&Lt.sendItem({type:"item_set",item_type:e,item_id:t,properties:r||{}})},deleteItem:function(e,t){Nt({item_type:e,item_id:t})&&Lt.sendItem({type:"item_delete",item_type:e,item_id:t})},setProfile:function(e,t){Nt({propertiesMust:e})&&Lt.send({type:"profile_set",properties:e},t)},setOnceProfile:function(e,t){Nt({propertiesMust:e})&&Lt.send({type:"profile_set_once",properties:e},t)},appendProfile:function(e,t){Nt({propertiesMust:e})&&(D(e,function(t,r){h(t)&&Ne(r)?e[r]=[t]:C(t)&&Ne(r)?e[r]=t:(delete e[r],$e("appendProfile\u5c5e\u6027\u7684\u503c\u5fc5\u987b\u662f\u5b57\u7b26\u4e32\u6216\u8005\u6570\u7ec4"))}),ce(e)||Lt.send({type:"profile_append",properties:e},t))},incrementProfile:function(e,t){var r=e;h(e)&&((e={})[r]=1),Nt({propertiesMust:e})&&(function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)&&!/-*\d+/.test(String(e[t])))return!1;return!0}(e)?Lt.send({type:"profile_increment",properties:e},t):xe("profile_increment\u7684\u503c\u53ea\u80fd\u662f\u6570\u5b57"))},deleteProfile:function(e){Lt.send({type:"profile_delete"},e),Pt.set("distinct_id",S()),Pt.set("first_id","")},unsetProfile:function(e,t){var r=e,n={};h(e)&&(e=[]).push(r),C(e)?(D(e,function(e){h(e)?n[e]=!0:$e("profile_unset\u7ed9\u7684\u6570\u7ec4\u91cc\u9762\u7684\u503c\u5fc5\u987b\u65f6string,\u5df2\u7ecf\u8fc7\u6ee4\u6389",e)}),Lt.send({type:"profile_unset",properties:n},t)):xe("profile_unset\u7684\u53c2\u6570\u5fc5\u987b\u662f\u6570\u7ec4")},identify:function(e){"number"==typeof e&&(e=String(e));var t=Pt.getFirstId();if(void 0===e){var r=S();t?Pt.set("first_id",r):Pt.set("distinct_id",r)}else Nt({distinct_id:e})&&(t?Pt.set("first_id",e):Pt.set("distinct_id",e))},resetAnonymousIdentity:function(e){if(Pt.getFirstId())return xe("resetAnonymousIdentity must be used in a logout state \uff01"),!1;if("number"==typeof e&&(e=String(e)),void 0===e){var t=S();Pt._state.identities.$identity_cookie_id=t,Pt.set("distinct_id",t)}else Nt({distinct_id:e})&&(Pt._state.identities.$identity_cookie_id=e,Pt.set("distinct_id",e))},trackSignup:function(e,t,r,n){"number"==typeof e&&(e=String(e)),Nt({distinct_id:e,event:t,properties:r})&&Xt(e,t,r,n)},registerPage:function(e){Nt({properties:e})?$(it.currentProps,e):xe("register\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")},clearAllRegister:function(e){Pt.clearAllProps(e)},clearPageRegister:function(e){var t;if(C(e)&&e.length>0)for(t=0;t<e.length;t++)h(e[t])&&e[t]in it.currentProps&&delete it.currentProps[e[t]];else if(!0===e)for(t in it.currentProps)delete it.currentProps[t]},register:Zt,registerOnce:function(e){Nt({properties:e})?Pt.setPropsOnce(e):xe("registerOnce\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")},registerSession:function(e){t.log("registerSession \u65b9\u6cd5\u5df2\u7ecf\u5f03\u7528\uff0c\u6709\u95ee\u9898\u8054\u7cfb\u6280\u672f\u987e\u95ee"),Nt({properties:e})?Pt.setSessionProps(e):xe("registerSession\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")},registerSessionOnce:function(e){t.log("registerSessionOnce \u65b9\u6cd5\u5df2\u7ecf\u5f03\u7528\uff0c\u6709\u95ee\u9898\u8054\u7cfb\u6280\u672f\u987e\u95ee"),Nt({properties:e})?Pt.setSessionPropsOnce(e):xe("registerSessionOnce\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")},login:Yt,loginWithKey:function(e,t){return $e("loginWithKey is deprecated !!!"),"number"==typeof t&&(t=String(t)),"number"==typeof e&&(e=String(e)),!!Nt({loginIdKey:e})&&(He.LOGIN===e?(Yt(t),!1):void Kt({id:t,callback:null,name:e},Xt))},logout:function(e){var t=Pt.getFirstId();if(t)if(Pt.set("first_id",""),!0===e){var r=S();Pt.set("distinct_id",r)}else Pt.set("distinct_id",t);Vt({$identity_cookie_id:Pt._state.identities.$identity_cookie_id}),Pt.set("history_login_id",{name:"",value:""})},getPresetProperties:function(){var e,r,n={$is_first_day:Fe(),$is_first_time:Ve.is_page_first_visited,$referrer:it.pageProp.referrer||"",$referrer_host:it.pageProp.referrer?W(it.pageProp.referrer):"",$url:ee(),$url_path:te(),$title:document.title||"",_distinct_id:Pt.getDistinctId(),identities:Pt.getIdentities()},i=$({},it.properties(),Pt.getProps(),(e=it.campaignParams(),r={},D(e,function(e,n,i){-1!==(" "+t.source_channel_standard+" ").indexOf(" "+n+" ")?r["$"+n]=i[n]:r[n]=i[n]}),r),n);return t.para.preset_properties.latest_referrer&&t.para.preset_properties.latest_referrer_host&&(i.$latest_referrer_host=""===i.$latest_referrer?"":W(i.$latest_referrer)),i},readyState:{state:0,historyState:[],stateType:{1:"1-init\u672a\u5f00\u59cb",2:"2-init\u5f00\u59cb",3:"3-store\u5b8c\u6210"},getState:function(){return this.historyState.join("\n")},setState:function(e){String(e)in this.stateType&&(this.state=e),this.historyState.push(this.stateType[e])}},debug:nt,on:mt,log:De};i.setup(De);var Qt=$({},Te,St);var er={bridge_info:{touch_app_bridge:!1,verify_success:!1,platform:"",support_two_way_call:!1},is_verify_success:!1,initPara:function(){var e={is_send:!1!==t.para.use_app_track_is_send&&"only"!==t.para.use_app_track,white_list:[],is_mui:"mui"===t.para.use_app_track};"object"==typeof t.para.app_js_bridge?t.para.app_js_bridge=$({},e,t.para.app_js_bridge):!0!==t.para.use_app_track&&!0!==t.para.app_js_bridge&&"only"!==t.para.use_app_track&&"mui"!==t.para.use_app_track||(t.para.app_js_bridge=$({},e)),!1===t.para.app_js_bridge.is_send&&$e("\u8bbe\u7f6e\u4e86 is_send:false,\u5982\u679c\u6253\u901a\u5931\u8d25\uff0c\u6570\u636e\u5c06\u88ab\u4e22\u5f03!")},app_js_bridge_v1:function(){var e=null,r=null;window.sensorsdata_app_js_bridge_call_js=function(t){!function(t){fe(e=t)&&(e=JSON.parse(e)),r&&(r(e),r=null,e=null)}(t)},t.getAppStatus=function(t){if(function(){if(/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream){var e=document.createElement("iframe");e.setAttribute("src","sensorsanalytics://getAppInfo"),document.documentElement.appendChild(e),e.parentNode.removeChild(e),e=null}}(),"object"==typeof window.SensorsData_APP_JS_Bridge&&window.SensorsData_APP_JS_Bridge.sensorsdata_call_app&&fe(e=window.SensorsData_APP_JS_Bridge.sensorsdata_call_app())&&(e=JSON.parse(e)),!t)return e;null===e?r=t:(t(e),e=null)}},hasVisualModeBridge:function(){var e=window.SensorsData_App_Visual_Bridge,t="sensorsdata_visualized_mode";return s(e)&&e[t]&&(!0===e[t]||e[t]())},validateAppUrl:function(e){function r(e){var t={hostname:"",project:""};try{e=b(e),t.hostname=e.hostname,t.project=e.searchParams.get("project")||"default"}catch(r){xe("validateAppUrl:"+r)}return t}var n=r(e),i=r(t.para.server_url);if(n.hostname===i.hostname&&n.project===i.project)return!0;if(C(t.para.app_js_bridge.white_list))for(var a=0;a<t.para.app_js_bridge.white_list.length;a++){var o=r(t.para.app_js_bridge.white_list[a]);if(o.hostname===n.hostname&&o.project===n.project)return!0}return!1}};function tr(e){var t=this;this.type=e,this.resultCbs={},this.timeoutCbs={},this.timerId=null,this.appCallJsCallback=null,window.sensorsdata_app_call_js||(window.sensorsdata_app_call_js=function(e,t){if(e in window.sensorsdata_app_call_js.modules)return window.sensorsdata_app_call_js.modules[e](t)}),window.sensorsdata_app_call_js.modules=window.sensorsdata_app_call_js.modules||{},window.sensorsdata_app_call_js.modules[this.type]=function(e){try{var r=L(e)||e;try{r=JSON.parse(r)}catch(a){}var n=r&&r.message_id;if(n&&t.resultCbs[n]){if(e=r,t.timeoutCbs[n]&&t.timeoutCbs[n].isTimeout)return void(t.resultCbs[n].callbacks.length=0);if(t.resultCbs[n])for(var i in t.resultCbs[n].result=e,clearTimeout(t.timerId),t.timeoutCbs[n].callbacks.length=0,t.resultCbs[n].callbacks)t.resultCbs[n].callbacks[i].call(null,e),t.resultCbs[n].callbacks.splice(i,1);return}return t.appCallJsCallback&&t.appCallJsCallback.call(null,e)}catch(o){xe("app \u56de\u8c03 js \u5f02\u5e38",e)}}}function rr(e){try{if(t.bridge.activeBridge&&r(t.bridge.activeBridge.handleCommand))return t.bridge.activeBridge.handleCommand(e)}catch(n){xe("Error: handle command exception:"+n)}return xe("\u6570\u636e\u53d1\u5f80App\u5931\u8d25\uff0cApp\u6ca1\u6709\u66b4\u9732bridge,type:"+e.callType),!1}function nr(e){this.bridge=new tr(e.type)}function ir(e){var t=null;try{var r=JSON.parse(window.name);t=r[e]?g(r[e]):null}catch(n){t=null}return null===t&&(t=Z(location.href,e)||null),t}tr.prototype.call=function(e,t){var r=this,n=(new Date).getTime().toString(16)+String(u()).replace(".","").slice(1,8);this.resultCbs[n]=r.resultCbs[n]||{result:null,callbacks:[]},this.timeoutCbs[n]=r.timeoutCbs[n]||{isTimeout:!1,callbacks:[]},(e=e.data?e:{data:e}).data.message_id=n;var i=$({callType:this.type},e);return t&&(this.timerId=setTimeout(function(){for(var e in r.timeoutCbs[n].isTimeout=!0,r.timeoutCbs[n].callbacks)r.timeoutCbs[n].callbacks[e].call(null),r.timeoutCbs[n].callbacks.splice(e,1)},t)),rr(i),{onResult:function(e){return r.resultCbs[n].result?(e(r.resultCbs[n].result),this):(!r.timeoutCbs[n].isTimeout&&r.resultCbs[n].callbacks.push(e),this)},onTimeout:function(e){return r.timeoutCbs[n].isTimeout?(e(),this):(!r.resultCbs[n].result&&r.timeoutCbs[n].callbacks.push(e),this)}}},tr.prototype.onAppNotify=function(e){this.appCallJsCallback=e},tr.prototype.notifyApp=function(e,t){var r=$({callType:this.type},e);return t&&(r.message_id=t),rr(r)},nr.prototype={double:function(){},getAppData:function(){},hasAppBridge:function(){return t.bridge.bridge_info.support_two_way_call},init:function(){},jsCallApp:function(){},requestToApp:function(e){this.bridge.call(e,e.timeout.time).onResult(function(t){r(e.callback)&&e.callback(t)}).onTimeout(function(){r(e.timeout.callback)&&e.timeout.callback()})}};var ar={isSeachHasKeyword:function(){return""!==Z(location.href,"sa-request-id")&&("string"==typeof sessionStorage.getItem("sensors-visual-mode")&&sessionStorage.removeItem("sensors-visual-mode"),!0)},hasKeywordHandle:function(){var e=location.href,t=Z(e,"sa-request-id")||null,r=Z(e,"sa-request-type")||null,n=Z(e,"sa-request-url")||null;if(Jt.setNotice(n),we.isSupport())if(null!==n&&sessionStorage.setItem("sensors_heatmap_url",n),sessionStorage.setItem("sensors_heatmap_id",t),null!==r)"1"===r||"2"===r||"3"===r?sessionStorage.setItem("sensors_heatmap_type",r):r=null;else{var i=sessionStorage.getItem("sensors_heatmap_type");r=null!==i?i:null}this.isReady(t,r)},isReady:function(e,r,n){t.para.heatmap_url&&t.para.heatmap?me({success:function(){setTimeout(function(){"undefined"!=typeof sa_jssdk_heatmap_render&&(sa_jssdk_heatmap_render(t,e,r,n),"object"==typeof console&&"function"==typeof console.log&&(t.heatmap_version&&t.heatmap_version===t.lib_version||$e("heatmap.js\u4e0esensorsdata.js\u7248\u672c\u53f7\u4e0d\u4e00\u81f4\uff0c\u53ef\u80fd\u5b58\u5728\u98ce\u9669!")))},0)},error:function(){},type:"js",url:t.para.heatmap_url}):$e("\u6ca1\u6709\u914d\u7f6e heatmap \u5f00\u542f\u70b9\u51fb\u56fe\uff0c\u6216\u8005\u6ca1\u6709\u6307\u5b9a heatmap_url \u7684\u8def\u5f84")},isStorageHasKeyword:function(){return we.isSupport()&&"string"==typeof sessionStorage.getItem("sensors_heatmap_id")},storageHasKeywordHandle:function(){Jt.setNotice(),ar.isReady(sessionStorage.getItem("sensors_heatmap_id"),sessionStorage.getItem("sensors_heatmap_type"),location.href)},isWindowNameHasKeyword:function(){try{var e=JSON.parse(window.name),t=h(e["sa-heatmap-src"])?g(e["sa-heatmap-src"]):null;return e["sa-request-id"]&&h(e["sa-request-id"])&&t===location.href}catch(r){return!1}},windowNameHasKeywordHandle:function(){var e=JSON.parse(window.name);function t(t){var r=e[t];return h(r)?g(r):null}var r=t("sa-request-id"),n=t("sa-request-type"),i=t("sa-request-url"),o=t("sa-request-language");Jt.setNotice(i),a.isSupport()&&h(o)&&a.set("web_sdk_heatmap_language",o),we.isSupport()&&(null!==i&&sessionStorage.setItem("sensors_heatmap_url",i),sessionStorage.setItem("sensors_heatmap_id",r),null!==n?"1"===n||"2"===n||"3"===n?sessionStorage.setItem("sensors_heatmap_type",n):n=null:n=null!==sessionStorage.getItem("sensors_heatmap_type")?sessionStorage.getItem("sensors_heatmap_type"):null),ar.isReady(r,n)}},or={isStorageHasKeyword:function(){return we.isSupport()&&"string"==typeof sessionStorage.getItem("sensors-visual-mode")},isSearchHasKeyword:function(){return(!0===ir("sa-visual-mode")||"true"===ir("sa-visual-mode"))&&("string"==typeof sessionStorage.getItem("sensors_heatmap_id")&&sessionStorage.removeItem("sensors_heatmap_id"),!0)},loadVtrack:function(){me({success:function(){},error:function(){},type:"js",url:t.para.vtrack_url?t.para.vtrack_url:Rt()+"//static.sensorsdata.cn/sdk/"+t.lib_version+"/vtrack.min.js"})},messageListener:function(e){if(!e||!e.data||"sa-fe"!==e.data.source)return!1;if("v-track-mode"===e.data.type){if(e.data.data&&e.data.data.isVtrack)if(we.isSupport()&&sessionStorage.setItem("sensors-visual-mode","true"),e.data.data.userURL&&location.href.match(/sa-visual-mode=true/)){var t=e.data.data.userURL;h(t)&&(je(t,"http://")||je(t,"https://"))&&(window.location.href=encodeURI(t),setTimeout(function(){window.location.reload(!0)},1e3))}else or.loadVtrack();window.removeEventListener("message",or.messageListener,!1)}},removeMessageHandle:function(){window.removeEventListener&&window.removeEventListener("message",or.messageListener,!1)},verifyVtrackMode:function(){window.addEventListener&&window.addEventListener("message",or.messageListener,!1),or.postMessage()},postMessage:function(){try{window.parent&&window.parent.postMessage&&window.parent.postMessage({source:"sa-web-sdk",type:"v-is-vtrack",data:{sdkversion:Re}},"*")}catch(e){xe("\u6d4f\u89c8\u5668\u7248\u672c\u8fc7\u4f4e\uff0c\u4e0d\u652f\u6301 postMessage API")}},notifyUser:function(){var e=function(t){if(!t||!t.data||"sa-fe"!==t.data.source)return!1;"v-track-mode"===t.data.type&&(t.data.data&&t.data.data.isVtrack&&alert("\u5f53\u524d\u7248\u672c\u4e0d\u652f\u6301\uff0c\u8bf7\u5347\u7ea7\u90e8\u7f72\u795e\u7b56\u6570\u636e\u6cbb\u7406"),window.removeEventListener("message",e,!1))};window.addEventListener&&window.addEventListener("message",e,!1),or.postMessage()}};function sr(e){var r=t.bridge.bridge_info;function n(){var e=[];r.touch_app_bridge||e.push(nt.defineMode("1")),s(t.para.app_js_bridge)||(e.push(nt.defineMode("2")),r.verify_success=!1),s(t.para.heatmap)&&"default"==t.para.heatmap.clickmap||e.push(nt.defineMode("3")),"fail"===r.verify_success&&e.push(nt.defineMode("4")),new t.SDKJSBridge("app_alert").notifyApp({data:e})}if(t.bridge.hasVisualModeBridge())if(s(t.para.heatmap)&&"default"==t.para.heatmap.clickmap)if(s(t.para.app_js_bridge)&&"success"===r.verify_success)if(e)window.sa_jssdk_app_define_mode(t,e);else{var i=location.protocol;me({success:function(){setTimeout(function(){"undefined"!=typeof sa_jssdk_app_define_mode&&window.sa_jssdk_app_define_mode(t,e)},0)},error:function(){},type:"js",url:(i=oe(["http:","https:"],i)>-1?i:"https:")+"//static.sensorsdata.cn/sdk/"+t.lib_version+"/vapph5define.min.js"})}else n();else n()}function lr(){var e;t.readyState.setState(3),new t.SDKJSBridge("visualized").onAppNotify(function(){"undefined"!=typeof sa_jssdk_app_define_mode?sr(!0):sr(!1)}),sr(!1),t.bridge.app_js_bridge_v1(),it.initPage(),t.para.is_track_single_page&&ht.on("switch",function(n){var i=function(i){if(i=i||{},n!==location.href){it.pageProp.referrer=ee(n);var a=$({$url:ee(),$referrer:ee(n)},i);r(e)?e(a):t.quick&&t.quick("autoTrack",a)}};if("boolean"==typeof t.para.is_track_single_page)i();else if("function"==typeof t.para.is_track_single_page){var a=t.para.is_track_single_page();s(a)?i(a):!0===a&&i()}}),Pt.init(),function(){var e=it.pageProp.url_domain,t={};""===e&&(e="url\u89e3\u6790\u5931\u8d25");var r=tt(document.referrer,!0);if(Ee.preset_properties.search_keyword_baidu?et(document.referrer)&&(!Xe()||s(r)&&r.active?Pt._state&&Pt._state.props&&(Pt._state.props.$search_keyword_id&&delete Pt._state.props.$search_keyword_id,Pt._state.props.$search_keyword_id_type&&delete Pt._state.props.$search_keyword_id_type,Pt._state.props.$search_keyword_id_hash&&delete Pt._state.props.$search_keyword_id_hash):(t.$search_keyword_id=Ze.id(),t.$search_keyword_id_type=Ze.type(),t.$search_keyword_id_hash=ae(t.$search_keyword_id))):Pt._state&&Pt._state.props&&(Pt._state.props.$search_keyword_id&&delete Pt._state.props.$search_keyword_id,Pt._state.props.$search_keyword_id_type&&delete Pt._state.props.$search_keyword_id_type,Pt._state.props.$search_keyword_id_hash&&delete Pt._state.props.$search_keyword_id_hash),Pt.save(),D(Ee.preset_properties,function(r,n){if(-1===n.indexOf("latest_"))return!1;if(n=n.slice(7),r){if("wx_ad_click_id"===n&&"not_collect"===r)return!1;if("utm"!==n&&"url\u89e3\u6790\u5931\u8d25"===e)"wx_ad_click_id"===n?(t._latest_wx_ad_click_id="url\u7684domain\u89e3\u6790\u5931\u8d25",t._latest_wx_ad_hash_key="url\u7684domain\u89e3\u6790\u5931\u8d25",t._latest_wx_ad_callbacks="url\u7684domain\u89e3\u6790\u5931\u8d25"):t["$latest_"+n]="url\u7684domain\u89e3\u6790\u5931\u8d25";else if(et(document.referrer))switch(n){case"traffic_source_type":t.$latest_traffic_source_type=at();break;case"referrer":t.$latest_referrer=it.pageProp.referrer;break;case"search_keyword":tt()?t.$latest_search_keyword=tt():s(Pt._state)&&s(Pt._state.props)&&Pt._state.props.$latest_search_keyword&&delete Pt._state.props.$latest_search_keyword;break;case"landing_page":t.$latest_landing_page=ee();break;case"wx_ad_click_id":var i=ot(location.href);t._latest_wx_ad_click_id=i.click_id,t._latest_wx_ad_hash_key=i.hash_key,t._latest_wx_ad_callbacks=i.callbacks}}else if("utm"===n&&Pt._state&&Pt._state.props)for(var a in Pt._state.props)(0===a.indexOf("$latest_utm")||0===a.indexOf("_latest_")&&a.indexOf("_latest_wx_ad_")<0)&&delete Pt._state.props[a];else Pt._state&&Pt._state.props&&"$latest_"+n in Pt._state.props?delete Pt._state.props["$latest_"+n]:"wx_ad_click_id"==n&&Pt._state&&Pt._state.props&&!1===r&&D(["_latest_wx_ad_click_id","_latest_wx_ad_hash_key","_latest_wx_ad_callbacks"],function(e){e in Pt._state.props&&delete Pt._state.props[e]})}),Ee.preset_properties.latest_utm){var n=it.campaignParamsStandard("$latest_","_latest_"),i=n.$utms,a=n.otherUtms;ce(i)||$(t,i),ce(a)||$(t,a)}Zt(t)}(),xt.init(),"success"===t.bridge.bridge_info.verify_success&&At.init(),t.readyState.setState(4),t._q&&C(t._q)&&t._q.length>0&&D(t._q,function(e){t[e[0]].apply(t,Array.prototype.slice.call(e[1]))}),s(t.para.heatmap)&&(Jt.initHeatmap(),Jt.initScrollmap())}function ur(){ar.isWindowNameHasKeyword()?ar.windowNameHasKeywordHandle():ar.isSeachHasKeyword()?ar.hasKeywordHandle():window.parent!==self&&or.isSearchHasKeyword()?or.verifyVtrackMode():ar.isStorageHasKeyword()?ar.storageHasKeywordHandle():window.parent!==self&&or.isStorageHasKeyword()?or.verifyVtrackMode():(lr(),or.notifyUser())}var cr=["setItem","deleteItem","getAppStatus","track","quick","register","registerPage","registerOnce","trackSignup","setProfile","setOnceProfile","appendProfile","incrementProfile","deleteProfile","unsetProfile","identify","resetAnonymousIdentity","login","logout","trackLink","clearAllRegister","clearPageRegister","bind","unbind","loginWithKey"];function pr(){D(cr,function(e){var n=t[e];t[e]=function(){if(t.readyState.state<3)return C(t._q)||(t._q=[]),$e("calling sdk api before init is deprecated."),t._q.push([e,arguments]),!1;if(!r(t.getDisabled)||!t.getDisabled()){if(t.readyState.getState())return n.apply(t,arguments);xe("\u8bf7\u5148\u521d\u59cb\u5316\u795e\u7b56JS SDK")}}})}var dr={track:function(e,t,r){},quick:function(e,t,r,n){},register:function(e){},registerPage:function(e){},registerOnce:function(e){},clearAllRegister:function(e){},trackSignup:function(e,t,r,n){},setProfile:function(e,t){},setOnceProfile:function(e,t){},appendProfile:function(e,t){},incrementProfile:function(e,t){},deleteProfile:function(e){},unsetProfile:function(e,t){},identify:function(e,t){},resetAnonymousIdentity:function(e){},login:function(e,t){},logout:function(e){},trackLink:function(e,t,r){},deleteItem:function(e,t){},setItem:function(e,t,r){},getAppStatus:function(e){},clearPageRegister:function(e){},bind:function(e,t){},unbind:function(e,t){},registerPropertyPlugin:function(e){}};function fr(e,t){this.cancel=function(){e=!0},this.getCanceled=function(){return e||!1},this.stop=function(){t=!0},this.getStopped=function(){return t||!1}}function gr(e,t,r){var n=null;try{n=JSON.parse(JSON.stringify(e||null))}catch(i){}this.getOriginalData=function(){return n},this.getPosition=function(){return t},this.cancellationToken=new fr,this.sensors=r}function _r(e){if(!s(e))throw"error: Stage constructor requires arguments.";this.processDef=e,this.registeredInterceptors={}}_r.prototype.process=function(e,r){if(e&&e in this.processDef){var n=this.registeredInterceptors[e];if(n&&C(n)&&n.length>0)for(var i={current:0,total:n.length},a=new gr(r,i,t),o=0;o<n.length;o++)try{if(i.current=o+1,r=n[o].call(null,r,a)||r,a.cancellationToken.getCanceled())break;if(a.cancellationToken.getStopped())return}catch(s){xe("interceptor error:"+s)}return this.processDef[e]&&this.processDef[e]in this.processDef&&(r=this.process(this.processDef[e],r)),r}xe("process ["+e+"] is not supported")},_r.prototype.registerStageImplementation=function(e){e&&e.init&&r(e.init)&&(e.init(this),e.interceptor&&this.registerInterceptor(e.interceptor))},_r.prototype.registerInterceptor=function(e){if(e)for(var t in e){var n=e[t];if(n&&s(n)&&r(n.entry)){ge(n.priority)||(n.priority=Number.MAX_VALUE),this.registeredInterceptors[t]||(this.registeredInterceptors[t]=[]);var i=this.registeredInterceptors[t];n.entry.priority=n.priority,i.push(n.entry),i.sort(function(e,t){return e.priority-t.priority})}}};var hr=new _r({basicProps:"extendProps",extendProps:"formatData",formatData:"finalAdjustData",finalAdjustData:null}),mr=new _r({send:null}),vr=new _r({getUtmData:null,callSchema:null}),yr=new _r({webClickEvent:null,webStayEvent:null});function br(e){e&&e.buildDataStage&&hr.registerStageImplementation(e.buildDataStage),e&&e.businessStage&&vr.registerStageImplementation(e.businessStage),e&&e.sendDataStage&&mr.registerStageImplementation(e.sendDataStage),e&&e.viewStage&&yr.registerStageImplementation(e.viewStage)}var wr={buildDataStage:function(e){e&&hr.registerInterceptor(e)},businessStage:function(e){e&&vr.registerInterceptor(e)},sendDataStage:function(e){e&&mr.registerInterceptor(e)},viewStage:function(e){e&&yr.registerInterceptor(e)}};function Sr(e,t){wr[e]&&wr[e](t)}var kr={stage:null,init:function(e){this.stage=e}};var Pr={stage:null,init:function(e){this.stage=e},interceptor:{send:{entry:function(e){return e}}}};var Cr={};function Or(e){e.kit=Cr,e.saEvent=Lt,this.buildDataStage=Et,this.sendDataStage=Pr,this.businessStage=kr}function jr(e){e.heatmap=Jt,this.viewStage=Bt}Cr.buildData=function(e){return t=e,Et.stage.process("basicProps",t);var t},Cr.sendData=function(e,r){var n=lt(e.properties);!function(e){Pr.stage.process("send",e)}({origin_data:e,server_url:t.para.server_url,data:e,config:n||{},callback:r}),t.log(e)},Cr.encodeTrackData=function(e){return gt(e)},Cr.getUtmData=function(){return kr.stage&&kr.stage.process("getUtmData")};var Nr={webClickEvent:{entry:function(e,t){var r=t.sensors;"a"===e.tagName&&r.para.heatmap&&!0===r.para.heatmap.isTrackLink?r.trackLink({event:e.event,target:e.target},"$WebClick",e.props):r.track("$WebClick",e.props,e.callback)}},webStayEvent:{entry:function(e,t){t.sensors.track("$WebStay",e)}}};function Tr(e){r(e.properties)?!e.isMatchedWithFilter||r(e.isMatchedWithFilter)?Sr("buildDataStage",{finalAdjustData:{priority:100,entry:function(t){try{if(r(e.isMatchedWithFilter))return e.isMatchedWithFilter(t)&&e.properties(t);e.properties(t)}catch(n){xe("execute registerPropertyPlugin callback error:"+n)}}}}):xe("registerPropertyPlugin arguments error, isMatchedWithFilter must be function"):xe("registerPropertyPlugin arguments error, properties must be function")}var Ir=window.sensors_data_pre_config,Ar=!!Qt.isObject(Ir)&&Ir.is_compliance_enabled;function Dr(e){e&&(t.events=kt,t.bridge=er,t.SDKJSBridge=tr,t.JSBridge=nr,t.store=Pt,t.unlimitedDiv=Dt,t.customProp=$t,t.vtrackcollect=xt,t.vapph5collect=At,t.detectMode=ur,t.registerFeature=br,t.registerInterceptor=Sr,t.commonWays=Ft,br(new Or(t)),br(new jr(t)),Sr("viewStage",Nr));var r=e?Gt:dr;for(var n in r)t[n]=r[n];t.logger=Ae,t.log=De,t._=Qt,t.on=mt,t.ee=_t,t.use=Wt,t.lib_version=Re,t.registerPropertyPlugin=Tr}t.init=function(e){if(_t.sdk.emit("beforeInit"),t.readyState&&t.readyState.state&&t.readyState.state>=2)return!1;var r,n;Ar&&(Dr(!0),pr()),_t.initSystemEvent(),t.setInitVar(),t.readyState.setState(2),t.initPara(e),_t.sdk.emit("initPara"),_t.sdk.emit("afterInitPara"),_t.sdk.emit("initAPI"),_t.sdk.emit("afterInitAPI"),t.detectMode(),r="",n=" { cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); }",t.heatmap&&C(t.heatmap.otherTags)&&D(t.heatmap.otherTags,function(e){r+=e+n}),de()&&X()&&X()<13&&(t.para.heatmap&&t.para.heatmap.collect_tags&&t.para.heatmap.collect_tags.div&&Se("div, [data-sensors-click]"+n),t.para.heatmap&&t.para.heatmap.track_attr&&Se("["+t.para.heatmap.track_attr.join("], [")+"]"+n),""!==r&&Se(r)),_t.sdk.emit("afterInit"),_t.sdk.emit("ready")},Ar?Dr(!1):(Dr(!0),pr());var $r="1.27.11";var xr,Er,Lr,Ur=(function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(xr={init:function(e){var t=e._.isString,r=e._.rot13defs,n=e._.dfmapping,i="data:enc;";e.ee.sdk.on("afterInitPara",function(){e.kit.userEncrypt=function(e){return"dfm-enc-"+n(e)},e.kit.userDecrypt=function(e){return 0===e.indexOf(i)?(e=e.substring(i.length),e=r(e)):0===e.indexOf("dfm-enc-")&&(e=e.substring("dfm-enc-".length),e=n(e)),e},e.kit.userDecryptIfNeeded=function(r){return!t(r)||0!==r.indexOf(i)&&0!==r.indexOf("dfm-enc-")||(r=e.kit.userDecrypt(r)),r}})},plugin_name:"UserEncryptDefault"},Er,Lr),xr.plugin_version=$r,xr),Rr="1.27.11";var Br=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Rr,e}({sd:null,init:function(e){if(this.sd)return!1;if(this.sd=e,!this.sd||!this.sd._)return!1;var t=this.sd._.cookie.get("sensors_amp_id"),r=this.sd.store._state.distinct_id;if(t&&t.length>0){var n="amp-"===t.slice(0,4);if(t!==r){if(!n)return!1;this.sd.store._state.first_id?(this.sd.identify(t,!0),this.sd.saEvent.send({original_id:t,distinct_id:r,type:"track_signup",event:"$SignUp",properties:{}},null),this.setAmpId(r)):this.sd.identify(t,!0)}}else this.setAmpId(r);this.addListener()},addListener:function(){var e=this;this.sd.events.on("changeDistinctId",function(t){e.setAmpId(t)}),this.sd.events.isReady()},setAmpId:function(e){this.sd._.cookie.set("sensors_amp_id",e)}},"Amp","sdkReady"),Hr=window.SensorsData_App_Visual_Bridge,Jr=Hr&&Hr.sensorsdata_visualized_mode,Mr=Hr&&Hr.sensorsdata_visualized_alert_info,qr=Hr&&Hr.sensorsdata_hover_web_nodes;function Fr(e){return Jr.call(Hr)&&qr&&qr.call(Hr,JSON.stringify(e))}var Kr,Vr,zr,Wr,Xr,Zr,Yr={isVerify:function(){return Jr&&(!0===Jr||Jr.call(Hr))},commands:{app_alert:function(e){return Mr&&Mr.call(Hr,JSON.stringify(e))},visualized_track:Fr,page_info:Fr,sensorsdata_get_app_visual_config:function(e,t){return t&&"function"==typeof t[e.callType]&&t[e.callType]()}}},Gr="1.27.11";var Qr={init:function(e){Xr=(Wr=e)&&Wr._,Zr=Wr&&Wr.log||console&&console.log||function(){},function(){if(Kr=window.SensorsData_APP_New_H5_Bridge,Vr=Kr&&Kr.sensorsdata_track,zr=Vr&&Kr.sensorsdata_get_server_url&&Kr.sensorsdata_get_server_url(),Zr("---test---fail---",!Wr,Wr.bridge.activeBridge,!zr),!Wr||Wr.bridge.activeBridge||!zr)return;Wr.bridge.activeBridge=Qr,Wr.para.app_js_bridge&&!Wr.para.app_js_bridge.is_mui&&(Wr.bridge.is_verify_success=zr&&Wr.bridge.validateAppUrl(zr),Zr("---test---bridge-verify-",Wr.bridge.is_verify_success));if(Wr.bridge.bridge_info={touch_app_bridge:!0,platform:"android",verify_success:Wr.bridge.is_verify_success?"success":"fail",support_two_way_call:!!Kr.sensorsdata_js_call_app},!Wr.para.app_js_bridge)return void Zr("---test---app_js_bridge is not configured, data will not be sent by android bridge.");Wr.registerInterceptor("sendDataStage",{send:{priority:60,entry:en}})}()},handleCommand:function(e){var t=e.callType;if(t in Yr.commands)return Yr.commands[t](e,Kr);Kr&&Xr.isFunction(Kr.sensorsdata_js_call_app)&&Kr.sensorsdata_js_call_app(JSON.stringify(e))}};function en(e,t){if(Zr("---test---datasend-",Wr.bridge.is_verify_success),Wr.para.app_js_bridge.is_mui||"item_set"===e.data.type||"item_delete"===e.data.type)return e;var r=e.callback;return Wr.bridge.is_verify_success?(Zr("---test---bridge-verify-success---",e.data),Vr&&Vr.call(Kr,JSON.stringify(Xr.extend({server_url:Wr.para.server_url},e.data))),Xr.isFunction(r)&&r(),t.cancellationToken.cancel(),e):(Zr("---test---bridge-verify-fail-----",Wr.bridge.is_verify_success),Wr.para.app_js_bridge.is_send?(Wr.debug.apph5({data:e.data,step:"4.2",output:"all"}),e):(Xr.isFunction(r)&&r(),t.cancellationToken.cancel(),e))}var tn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Gr,e}(Qr,"AndroidBridge","sdkAfterInitPara"),rn=window.SensorsData_App_Visual_Bridge,nn=rn&&rn.sensorsdata_visualized_mode,an=rn&&rn.sensorsdata_visualized_alert_info,on=rn&&rn.sensorsdata_hover_web_nodes;function sn(e){return nn.call(rn)&&on&&on.call(rn,JSON.stringify(e))}var ln,un,cn,pn,dn,fn,gn,_n={isVerify:function(){return nn&&(!0===nn||nn.call(rn))},commands:{app_alert:function(e){return an&&an.call(rn,JSON.stringify(e))},visualized_track:sn,page_info:sn,sensorsdata_get_app_visual_config:function(e,t){return t&&"function"==typeof t[e.callType]&&t[e.callType]()}}},hn="1.27.11";var mn={init:function(e){fn=(dn=e)&&dn._,gn=dn&&dn.log||console&&console.log||function(){},function(){if(gn("ObsoleteBridge---test---init---"),ln=window.SensorsData_APP_JS_Bridge,un=ln&&ln.sensorsdata_track,cn=ln&&ln.sensorsdata_verify,pn=ln&&ln.sensorsdata_visual_verify,gn("ObsoleteBridge-",dn.bridge.activeBridge,cn,un,pn),!dn||dn.bridge.activeBridge||!(cn||un||pn))return;dn.bridge.activeBridge=mn;var e=cn||un;pn&&(e=!!pn.call(ln,JSON.stringify({server_url:dn.para.server_url})),gn("ObsoleteBridge---called-return",e));if(dn.bridge.bridge_info={touch_app_bridge:!0,platform:"android",verify_success:e?"success":"fail"},!dn.para.app_js_bridge)return void gn("app_js_bridge is not configured, data will not be sent by android obsolete bridge.");dn.registerInterceptor("sendDataStage",{send:{priority:80,entry:vn}}),gn("Android obsolete bridge inits succeed.")}()},handleCommand:function(e){gn("ObsoleteBridge---handleCommadn");var t=e.callType;if(t in _n.commands)return gn("ObsoleteBridge---",t,_n.commands),_n.commands[t](e,ln);if(ln&&fn.isFunction(ln.sensorsdata_js_call_app))return gn("ObsoleteBridge---handleCommadn-abridge"),ln.sensorsdata_js_call_app(JSON.stringify(e))}};function vn(e,t){if(gn("ObsoleteBridge---senddata"),dn.para.app_js_bridge.is_mui||"item_set"===e.data.type||"item_delete"===e.data.type)return e;var r=e.callback;if(cn){var n=cn&&cn.call(ln,JSON.stringify(fn.extend({server_url:dn.para.server_url},e.data)));return gn("ObsoleteBridge---anVerify-success",n),n?(fn.isFunction(r)&&r(),t.cancellationToken.cancel(),e):dn.para.app_js_bridge.is_send?(dn.debug.apph5({data:e.data,step:"3.1",output:"all"}),e):(fn.isFunction(r)&&r(),t.cancellationToken.cancel(),e)}return gn("ObsoleteBridge---is-send-old-way",dn.para.app_js_bridge.is_send),un&&un.call(ln,JSON.stringify(fn.extend({server_url:dn.para.server_url},e.data))),fn.isFunction(r)&&r(),t.cancellationToken.cancel(),e}var yn,bn,wn,Sn,kn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=hn,e}(mn,"AndroidObsoleteBridge","sdkAfterInitPara"),Pn="1.27.11";var Cn,On={event_list:[],latest_event_initial_time:null,max_save_time:2592e6,init:function(e,t){if(bn||!e)return!1;Sn=(t=t||{}).cookie_name||"sensorsdata2015jssdkchannel",bn=e;var r=this;!function(){if(yn=bn._,wn=bn.store,!yn.localStorage.isSupport())return!1;r.eventList.init(),r.addLatestChannelUrl(),r.addIsChannelCallbackEvent()}()},addIsChannelCallbackEvent:function(){bn.registerPage({$is_channel_callback_event:function(e){if(yn.isObject(e)&&e.event&&"$WebClick"!==e.event&&"$pageview"!==e.event&&"$WebStay"!==e.event&&"$SignUp"!==e.event)return!On.eventList.hasEvent(e.event)&&(On.eventList.add(e.event),!0)}})},addLatestChannelUrl:function(){var e=this.getUrlDomain(),t=this.cookie.getChannel();if("url\u89e3\u6790\u5931\u8d25"===e)this.registerAndSave({_sa_channel_landing_url:"",_sa_channel_landing_url_error:"url\u7684domain\u89e3\u6790\u5931\u8d25"});else if(yn.isReferralTraffic(document.referrer)){var r=yn.getQueryParam(location.href,"sat_cf");yn.isString(r)&&r.length>0?(this.registerAndSave({_sa_channel_landing_url:location.href}),On.channelLinkHandler()):this.registerAndSave({_sa_channel_landing_url:""})}else t?bn.registerPage(t):bn.registerPage({_sa_channel_landing_url:"",_sa_channel_landing_url_error:"\u53d6\u503c\u5f02\u5e38"})},registerAndSave:function(e){bn.registerPage(e),this.cookie.saveChannel(e)},cookie:{getChannel:function(){var e=bn.kit.userDecryptIfNeeded(yn.cookie.get(Sn));return e=yn.safeJSONParse(e),!(!yn.isObject(e)||!e.prop)&&e.prop},saveChannel:function(e){var t={prop:e},r=JSON.stringify(t);bn.para.encrypt_cookie&&(r=bn.kit.userEncrypt(r)),yn.cookie.set(Sn,r)}},channelLinkHandler:function(){this.eventList.reset(),bn.track("$ChannelLinkReaching")},getUrlDomain:function(){var e=yn.info.pageProp.url_domain;return""===e&&(e="url\u89e3\u6790\u5931\u8d25"),e},eventList:{init:function(){var e=this.get(),t=(new Date).getTime();if(e&&yn.isNumber(e.latest_event_initial_time)&&yn.isArray(e.eventList)){var r=t-e.latest_event_initial_time;r>0&&r<On.max_save_time?(On.event_list=e.eventList,On.latest_event_initial_time=e.latest_event_initial_time):this.reset()}else this.reset()},get:function(){var e={};try{e=wn.readObjectVal("sawebjssdkchannel")}catch(t){bn.log(t)}return e},add:function(e){On.event_list.push(e),this.save()},save:function(){var e={latest_event_initial_time:On.latest_event_initial_time,eventList:On.event_list};wn.saveObjectVal("sawebjssdkchannel",e)},reset:function(){On.event_list=[],On.latest_event_initial_time=(new Date).getTime(),this.save()},hasEvent:function(e){var t=!1;return yn.each(On.event_list,function(r){r===e&&(t=!0)}),t}}},jn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Pn,e}(On,"SensorsChannel","sdkAfterInitAPI"),Nn="1.27.11";/micromessenger\/([\d.]+)/i.test(navigator.userAgent||"");var Tn=function(){var e={};return"undefined"!=typeof document.hidden?(e.hidden="hidden",e.visibilityChange="visibilitychange"):"undefined"!=typeof document.msHidden?(e.hidden="msHidden",e.visibilityChange="msvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e};function In(){return void 0!==Cn&&document[Cn]}Cn=Tn().hidden;var An,Dn,$n,xn,En,Ln={android:/Android/i,iOS:/iPhone|iPad|iPod/i,harmony:/OpenHarmony/i},Un=function(){for(var e in Ln)if(navigator.userAgent.match(Ln[e]))return e;return""}(),Rn=function(e){return null!=e&&"[object Object]"==Object.prototype.toString.call(e)},Bn=function(e,t,r){e.log("\u5c1d\u8bd5\u5524\u8d77 android app");var n=t;e.log("\u5524\u8d77APP\u7684\u5730\u5740\uff1a"+n),window.location=n,e.timer=setTimeout(function(){var t=In();if(e.log("hide:"+Cn+":"+document[Cn]),t)return e.log("The page is hidden, stop navigating to download page"),!1;e.log("App\u53ef\u80fd\u672a\u5b89\u88c5\uff0c\u8df3\u8f6c\u5230\u4e0b\u8f7d\u5730\u5740"),window.location=r},e.timeout)},Hn={plugin_name:["deeplink","Deeplink"],key:null,timer:null,sd:null,data:null,timeout:2500,apiURL:"{origin}/sdk/deeplink/param?key={key}&system_type=JS&project={project}",init:function(e){if(this.sd)return this.logger("deeplink\u5df2\u7ecf\u521d\u59cb\u5316"),!1;arguments[0]?Rn(arguments[0])&&"number"==typeof arguments[0].timeout?this.sd=window.sensorsDataAnalytic201505:this.sd=e:this.sd=window.sensorsDataAnalytic201505;var t={};if(arguments.length>0&&(1===arguments.length&&Rn(arguments[0])?t=arguments[0]:arguments.length>=2&&Rn(arguments[1])&&(t=arguments[1])),!Ln.hasOwnProperty(Un))return this.logger("\u4e0d\u652f\u6301\u5f53\u524d\u7cfb\u7edf\uff0c\u76ee\u524d\u53ea\u652f\u6301Android\u548ciOS"),!1;if(Rn(t)&&this.sd._.isNumber(t.timeout)&&t.timeout>=2500&&(this.timeout=t.timeout),!this.sd.para.server_url)return this.logger("\u795e\u7b56JS SDK\u914d\u7f6e\u9879server_url\u672a\u6b63\u786e\u914d\u7f6e"),!1;var r=function(e){var t=e._.URL(e.para.server_url);return{origin:t.origin,project:t.searchParams.get("project")||"default"}}(this.sd);this.apiURL=this.apiURL.replace("{origin}",r.origin).replace("{project}",r.project);var n=this.sd._.getQueryParam(window.location.href,"deeplink");if(!n)return this.logger("\u5f53\u524d\u9875\u9762\u7f3a\u5c11deeplink\u53c2\u6570"),!1;n=window.decodeURIComponent(n);var i=n.match(/\/sd\/(\w+)\/(\w+)$/);if(!i)return this.logger("\u5f53\u524d\u9875\u9762\u7684deeplink\u53c2\u6570\u65e0\u6548"),!1;this.key=i[2],this.apiURL=this.apiURL.replace("{key}",window.encodeURIComponent(i[2])),this.sd._.ajax({url:this.apiURL,type:"GET",cors:!0,credentials:!1,success:function(e){if(e.errorMsg)return Hn.logger("API\u62a5\u9519\uff1a"+e.errorMsg),!1;Hn.data=e,Hn.logger("API\u67e5\u8be2\u6210\u529f\uff0c\u6570\u636e\uff1a"+JSON.stringify(e,null,"  ")),this.data.app_key&&(this.data.android_info&&this.data.android_info.url_schemes&&(this.data.android_info.url_schemes+="://sensorsdata/sd/"+this.data.app_key+"/"+this.key),this.data.ios_info&&this.data.ios_info.url_schemes&&(this.data.ios_info.url_schemes+="://sensorsdata/sd/"+this.data.app_key+"/"+this.key),this.data.harmony_info&&this.data.harmony_info.url_schemes&&(this.data.harmony_info.url_schemes+="://sensorsdata/sd/"+this.data.app_key+"/"+this.key))}.bind(this),error:function(){Hn.logger("API\u67e5\u8be2\u51fa\u9519")}}),this.addListeners()},openDeepLink:function(){if(this.logger("openDeeplink()"),!this.data)return this.logger("\u6ca1\u6709Deep link\u6570\u636e!"),!1;if("iOS"===Un){this.logger("\u5f53\u524d\u7cfb\u7edf\u662fiOS");var e=this.sd&&this.sd._&&this.sd._.getIOSVersion()>=9&&this.data.ios_info.ios_wake_url?this.data.ios_info.ios_wake_url:this.data.ios_info.url_schemes;this.logger("\u5524\u8d77APP\u7684\u5730\u5740\uff1a"+e),r=this,n=e,i=this.data.ios_info.download_url,r.log("\u5c1d\u8bd5\u5524\u8d77 iOS app:"+n),window.location.href=n,r.timer=setTimeout(function(){if(In())return r.log("The page is hidden, stop navigating to download page"),!1;r.log("App\u53ef\u80fd\u672a\u5b89\u88c5\uff0c\u8df3\u8f6c\u5230\u4e0b\u8f7d\u5730\u5740"),window.location.href=i},r.timeout),r.log("new timer:"+r.timer)}else if("android"===Un)this.logger("\u5f53\u524d\u7cfb\u7edf\u662f android"),Bn(this,this.data.android_info.url_schemes,this.data.android_info.download_url);else if("harmony"===Un){var t=this.data.harmony_info.app_linking_url||this.data.harmony_info.url_schemes;this.logger("\u5f53\u524d\u7cfb\u7edf\u662f HarmonyOS"),Bn(this,t,this.data.harmony_info.download_url)}var r,n,i},logger:function(e){this.sd&&this.sd.log(e)},addListeners:function(){var e=Tn().visibilityChange,t=this;e&&document.addEventListener(e,function(){clearTimeout(t.timer),t.logger("visibilitychange, clear timeout:"+t.timer)},!1),window.addEventListener("pagehide",function(){t.logger("page hide, clear timeout:"+t.timer),clearTimeout(t.timer)},!1)}},Jn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Nn,e}(Hn,null,"sdkReady"),Mn="1.27.11";var qn={init:function(e){xn=($n=e)&&$n._,En=$n&&$n.log||console&&console.log||function(){},function(){if(An=window.SensorsData_iOS_JS_Bridge&&window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url,Dn=function(){return window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker},!$n||$n.bridge.activeBridge||!Dn()||!Dn().postMessage)return;$n.bridge.activeBridge=qn,$n.para.app_js_bridge&&!$n.para.app_js_bridge.is_mui&&($n.bridge.is_verify_success=An&&$n.bridge.validateAppUrl(An));if($n.bridge.bridge_info={touch_app_bridge:!0,platform:"ios",verify_success:$n.bridge.is_verify_success?"success":"fail",support_two_way_call:!0},!$n.para.app_js_bridge)return void En("app_js_bridge is not configured, data will not be sent by iOS bridge.");$n.registerInterceptor("sendDataStage",{send:{priority:70,entry:Fn}}),En("IOS bridge inits succeed.")}()},handleCommand:function(e){var t=e.callType;if(("page_info"===t||"visualized_track"===t)&&!$n.bridge.hasVisualModeBridge())return null;if("sensorsdata_get_app_visual_config"===t)return xn.isObject(window.SensorsData_APP_New_H5_Bridge)&&window.SensorsData_APP_New_H5_Bridge[t];return Dn()&&Dn().postMessage(JSON.stringify(e))}};function Fn(e,t){if($n.para.app_js_bridge.is_mui||"item_set"===e.data.type||"item_delete"===e.data.type)return e;var r=e.callback;return $n.bridge.is_verify_success?(Dn()&&Dn().postMessage(JSON.stringify({callType:"app_h5_track",data:xn.extend({server_url:$n.para.server_url},e.data)})),xn.isFunction(r)&&r(),t.cancellationToken.cancel(),e):$n.para.app_js_bridge.is_send?($n.debug.apph5({data:e.data,step:"4.1",output:"all"}),e):(xn.isFunction(r)&&r(),t.cancellationToken.cancel(),e)}var Kn,Vn,zn,Wn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Mn,e}(qn,"IOSBridge","sdkAfterInitPara"),Xn="1.27.11";var Zn={init:function(e){Vn=(Kn=e)&&Kn._,zn=Kn&&Kn.log||console&&console.log||function(){},function(){if(!Kn||Kn.bridge.activeBridge||!/sensors-verify/.test(navigator.userAgent)&&!/sa-sdk-ios/.test(navigator.userAgent)||window.MSStream)return;if(Kn.bridge.activeBridge=Zn,Kn.bridge.bridge_info={touch_app_bridge:!0,platform:"ios",verify_success:Yn()?"success":"fail"},!Kn.para.app_js_bridge)return void zn("app_js_bridge is not configured, data will not be sent by iOS obsolete bridge.");Kn.registerInterceptor("sendDataStage",{send:{priority:90,entry:Gn}}),zn("IOS obsolete bridge inits succeed.")}()}};function Yn(){if(/sensors-verify/.test(navigator.userAgent)){var e=navigator.userAgent.match(/sensors-verify\/([^\s]+)/);if(e&&e[0]&&"string"==typeof e[1]&&2===e[1].split("?").length){e=e[1].split("?");var t=null,r=null;try{t=Vn.URL(Kn.para.server_url).hostname,r=Vn.URL(Kn.para.server_url).searchParams.get("project")||"default"}catch(n){Kn.log(n)}return!(!t||t!==e[0]||!r||r!==e[1])}return!1}return!!/sa-sdk-ios/.test(navigator.userAgent)}function Gn(e,t){if(Kn.para.app_js_bridge.is_mui||"item_set"===e.data.type||"item_delete"===e.data.type)return e;var r,n,i=e.callback;if(Kn.bridge.bridge_info.verify_success){var a=document.createElement("iframe"),o=(r=e.data,n=(n=JSON.stringify(Vn.extend({server_url:Kn.para.server_url},r))).replace(/\r\n/g,""),"sensorsanalytics://trackEvent?event="+(n=encodeURIComponent(n)));return a.setAttribute("src",o),document.documentElement.appendChild(a),a.parentNode.removeChild(a),a=null,Vn.isFunction(i)&&i(),t.cancellationToken.cancel(),!0}return Kn.para.app_js_bridge.is_send?(Kn.debug.apph5({data:e.data,step:"3.2",output:"all"}),e):(Vn.isFunction(i)&&i(),t.cancellationToken.cancel(),e)}var Qn=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Xn,e}(Zn,"IOSObsoleteBridge","sdkAfterInitPara"),ei="1.27.11";var ti=432e3;function ri(){this.sd=null,this.start_time=+new Date,this.page_show_status=!0,this.page_hidden_status=!1,this._={},this.timer=null,this.current_page_url=document.referrer,this.url=location.href,this.title=document.title||"",this.option={},this.heartbeat_interval_time=5e3,this.heartbeat_interval_timer=null,this.page_id=null,this.storage_name="sawebjssdkpageleave",this.max_duration=ti}ri.prototype.init=function(e,t){if(e){if(this.sd=e,this._=this.sd._,t){this.option=t;var r=t.heartbeat_interval_time;r&&(this._.isNumber(r)||this._.isNumber(1*r))&&1*r>0&&(this.heartbeat_interval_time=1e3*r);var n=t.max_duration;n&&(this._.isNumber(n)||this._.isNumber(1*n))&&1*n>0&&(this.max_duration=n)}this.page_id=Number(String(this._.getRandom()).slice(2,5)+String(this._.getRandom()).slice(2,4)+String((new Date).getTime()).slice(-4)),this.addEventListener(),!0===document.hidden?this.page_show_status=!1:this.addHeartBeatInterval(),this.log("PageLeave\u521d\u59cb\u5316\u5b8c\u6bd5")}else this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165")},ri.prototype.log=function(e){this.sd&&this.sd.log(e)},ri.prototype.refreshPageEndTimer=function(){var e=this;this.timer&&(clearTimeout(this.timer),this.timer=null),this.timer=setTimeout(function(){e.page_hidden_status=!1},5e3)},ri.prototype.hiddenStatusHandler=function(){clearTimeout(this.timer),this.timer=null,this.page_hidden_status=!1},ri.prototype.pageStartHandler=function(){this.start_time=+new Date,!0==!document.hidden?this.page_show_status=!0:this.page_show_status=!1,this.url=location.href,this.title=document.title},ri.prototype.pageEndHandler=function(){if(!0!==this.page_hidden_status){var e=this.getPageLeaveProperties();!1===this.page_show_status&&delete e.event_duration,this.page_show_status=!1,this.page_hidden_status=!0,this.isCollectUrl(this.url)&&this.sd.track("$WebPageLeave",e),this.refreshPageEndTimer(),this.delHeartBeatData()}},ri.prototype.addEventListener=function(){this.addPageStartListener(),this.addPageSwitchListener(),this.addSinglePageListener(),this.addPageEndListener()},ri.prototype.addPageStartListener=function(){var e=this;"onpageshow"in window&&this._.addEvent(window,"pageshow",function(){e.pageStartHandler(),e.hiddenStatusHandler()})},ri.prototype.isCollectUrl=function(e){return"function"!=typeof this.option.isCollectUrl||("string"!=typeof e||""===e||this.option.isCollectUrl(e))},ri.prototype.addSinglePageListener=function(){var e=this;this.sd.ee&&this.sd.ee.spa.prepend("switch",function(t){t!==location.href&&(e.url=t,e.pageEndHandler(),e.stopHeartBeatInterval(),e.current_page_url=e.url,e.pageStartHandler(),e.hiddenStatusHandler(),e.addHeartBeatInterval())})},ri.prototype.addPageEndListener=function(){var e=this;this._.each(["pagehide","beforeunload","unload"],function(t){"on"+t in window&&e._.addEvent(window,t,function(){e.pageEndHandler(),e.stopHeartBeatInterval()})})},ri.prototype.addPageSwitchListener=function(){var e=this;this._.listenPageState({visible:function(){e.pageStartHandler(),e.hiddenStatusHandler(),e.addHeartBeatInterval()},hidden:function(){e.url=location.href,e.title=document.title,e.pageEndHandler(),e.stopHeartBeatInterval()}})},ri.prototype.addHeartBeatInterval=function(){this._.localStorage.isSupport()&&this.startHeartBeatInterval()},ri.prototype.startHeartBeatInterval=function(){var e=this;this.heartbeat_interval_timer&&this.stopHeartBeatInterval();var t=!0;this.isCollectUrl(this.url)||(t=!1),this.heartbeat_interval_timer=setInterval(function(){t&&e.saveHeartBeatData()},this.heartbeat_interval_time),t&&this.saveHeartBeatData("is_first_heartbeat"),this.reissueHeartBeatData()},ri.prototype.stopHeartBeatInterval=function(){clearInterval(this.heartbeat_interval_timer),this.heartbeat_interval_timer=null},ri.prototype.saveHeartBeatData=function(e){var t=this.getPageLeaveProperties(),r=new Date;t.$time=r,"is_first_heartbeat"===e&&(t.event_duration=3.14);var n=this.sd.kit.buildData({type:"track",event:"$WebPageLeave",properties:t});n.heartbeat_interval_time=this.heartbeat_interval_time,this.sd.store.saveObjectVal(this.storage_name+"-"+this.page_id,n)},ri.prototype.delHeartBeatData=function(e){this._.localStorage.isSupport()&&this._.localStorage.remove(e||this.storage_name+"-"+this.page_id)},ri.prototype.reissueHeartBeatData=function(){for(var e=window.localStorage.length-1;e>=0;e--){var t=window.localStorage.key(e);if(t&&t!==this.storage_name+"-"+this.page_id&&0===t.indexOf(this.storage_name+"-")){var r=this.sd.store.readObjectVal(t);this._.isObject(r)&&1*new Date-r.time>r.heartbeat_interval_time+5e3&&(delete r.heartbeat_interval_time,r._flush_time=(new Date).getTime(),this.sd.kit.sendData(r),this.delHeartBeatData(t))}}},ri.prototype.getPageLeaveProperties=function(){var e=(+new Date-this.start_time)/1e3;(isNaN(e)||e<0||e>this.max_duration)&&(e=0),e=Number(e.toFixed(3));var t=this._.getReferrer(this.current_page_url),r=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body&&document.body.scrollTop||0;r=Math.round(r)||0;var n={$title:this.title,$url:this._.getURL(this.url),$url_path:this._.getURLPath(this._.URL(this.url).pathname),$referrer_host:t?this._.getHostname(t):"",$referrer:t,$viewport_position:r};return 0!==e&&(n.event_duration=e),n=this._.extend(n,this.option.custom_props)};var ni=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=ei,e}(new ri,"PageLeave","sdkReady"),ii="1.27.11";var ai=!1,oi=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=ii,e}({init:function(e,t){function r(){var n=0,i=window.performance||window.webkitPerformance||window.msPerformance||window.mozPerformance,a={$url:e._.getURL(),$title:document.title,$url_path:e._.getURLPath(),$referrer:e._.getReferrer(null,!0)};if(i?(n=function(t){var r=0;return e._.isFunction(t.getEntriesByType)&&(r=((t.getEntriesByType("navigation")||[{}])[0]||{}).domContentLoadedEventEnd||0),r}(i)||function(t){var r=0;if(t.timing){var n=t.timing;0!==n.fetchStart&&e._.isNumber(n.fetchStart)&&0!==n.domContentLoadedEventEnd&&e._.isNumber(n.domContentLoadedEventEnd)?r=n.domContentLoadedEventEnd-n.fetchStart:e.log("performance \u6570\u636e\u83b7\u53d6\u5f02\u5e38")}return r}(i),function(t,r){if(t.getEntries&&"function"==typeof t.getEntries){for(var n=t.getEntries(),i=null,a=0;a<n.length;a++)"transferSize"in n[a]&&(i+=n[a].transferSize);e._.isNumber(i)&&i>=0&&i<10737418240&&(r.$page_resource_size=Number((i/1024).toFixed(3)))}}(i,a)):e.log("\u6d4f\u89c8\u5668\u672a\u652f\u6301 performance API."),n>0){var o=e._.isObject(t)&&t.max_duration||1800;n=Number((n/1e3).toFixed(3)),(!e._.isNumber(o)||o<=0||n<=o)&&(a.event_duration=n)}ai||(e.track("$WebPageLoad",a),ai=!0),window.removeEventListener?window.removeEventListener("load",r):window.detachEvent&&window.detachEvent("onload",r)}"complete"==document.readyState?r():window.addEventListener?window.addEventListener("load",r):window.attachEvent&&window.attachEvent("onload",r)}},"PageLoad","sdkReady");function si(){this.sd=null,this.log=window.console&&window.console.log||function(){},this.customRegister=[]}si.prototype.init=function(e){if(e){this.sd=e,this._=e._,this.log=e.log;var t=this;e.registerInterceptor("buildDataStage",{extendProps:{priority:0,entry:function(e){return function(e,t){if("track"!==e.type)return e;var r=t.sd,n=r._,i=r.saEvent.check,a=n.extend2Lev({properties:{}},e),o=t.customRegister,s=a.properties,l=a.event,u={};return n.each(o,function(e){if(n.isObject(e))n.indexOf(e.events,l)>-1&&i({properties:e.properties})&&(u=n.extend(u,e.properties));else if(n.isFunction(e)){var t=e({event:l,properties:s,data:a});n.isObject(t)&&!n.isEmptyObject(t)&&i({properties:t})&&(u=n.extend(u,t))}}),e.properties=n.extend(s,u),e}(e,t)}}})}else this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165")},si.prototype.register=function(e){this.sd?this._.isObject(e)&&this._.isArray(e.events)&&e.events.length>0&&this._.isObject(e.properties)&&!this._.isEmptyObject(e.properties)?this.customRegister.push(e):this.log("RegisterProperties: register \u53c2\u6570\u9519\u8bef"):this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165")},si.prototype.hookRegister=function(e){this.sd?this._.isFunction(e)?this.customRegister.push(e):this.log("RegisterProperties: hookRegister \u53c2\u6570\u9519\u8bef"):this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165")};var li="1.27.11";si.prototype.plugin_name="RegisterProperties";var ui=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=li,e}(new si),ci="1.27.11";var pi,di,fi=window.console&&window.console.log||function(){};function gi(e){try{if("$pageview"!==e.event&&(!e.type||"profile"!==e.type.slice(0,7))){var t=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||0,r=document.documentElement.scrollHeight||0,n={$page_height:Math.max(t,r)||0};e.properties=pi._.extend(e.properties||{},n)}}catch(i){fi("\u9875\u9762\u9ad8\u5ea6\u83b7\u53d6\u5f02\u5e38\u3002")}return di.call(pi.kit,e)}var _i=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=ci,e}({init:function(e){fi=(pi=e)&&pi.log||fi,e&&e.kit&&e.kit.buildData?(di=pi.kit.buildData,pi.kit.buildData=gi,fi("RegisterPropertyPageHeight \u63d2\u4ef6\u521d\u59cb\u5316\u5b8c\u6210")):fi("RegisterPropertyPageHeight \u63d2\u4ef6\u521d\u59cb\u5316\u5931\u8d25,\u5f53\u524d\u4e3bsdk\u4e0d\u652f\u6301 RegisterPropertyPageHeight \u63d2\u4ef6\uff0c\u8bf7\u5347\u7ea7\u4e3bsdk")}},"RegisterPropertyPageHeight","sdkReady"),hi="1.27.11";var mi,vi={getPart:function(e){var t=this.option.length;if(t)for(var r=0;r<t;r++)if(e.indexOf(this.option[r].part_url)>-1)return!0;return!1},getPartHash:function(e){var t=this.option.length;if(t)for(var r=0;r<t;r++)if(e.indexOf(this.option[r].part_url)>-1)return this.option[r].after_hash;return!1},getCurrenId:function(){var e=this.store.getDistinctId()||"",t=this.store.getFirstId()||"";return this._.urlSafeBase64&&this._.urlSafeBase64.encode?e=e?this._.urlSafeBase64.trim(this._.urlSafeBase64.encode(this._.base64Encode(e))):"":this._.rot13obfs&&(e=e?this._.rot13obfs(e):""),encodeURIComponent(t?"f"+e:"d"+e)},rewriteUrl:function(e,t){var r=this,n=/([^?#]+)(\?[^#]*)?(#.*)?/.exec(e),i="";if(n){var a,o=n[1]||"",s=n[2]||"",l=n[3]||"",u="_sasdk="+this.getCurrenId(),c=function(e){var t=e.split("&"),n=[];return r._.each(t,function(e){e.indexOf("_sasdk=")>-1?n.push(u):n.push(e)}),n.join("&")};if(this.getPartHash(e))a=l.indexOf("_sasdk"),i=l.indexOf("?")>-1?a>-1?o+s+"#"+l.substring(1,a)+c(l.substring(a,l.length)):o+s+l+"&"+u:o+s+"#"+l.substring(1)+"?"+u;else a=s.indexOf("_sasdk"),i=/^\?(\w)+/.test(s)?a>-1?o+"?"+c(s.substring(1))+l:o+s+"&"+u+l:o+"?"+u+l;return t&&(t.href=i),i}},getUrlId:function(){var e=location.href.match(/_sasdk=([aufd][^\?\#\&\=]+)/);if(this._.isArray(e)&&e[1]){var t=decodeURIComponent(e[1]);return!t||"f"!==t.substring(0,1)&&"d"!==t.substring(0,1)||(this._.urlSafeBase64&&this._.urlSafeBase64.isUrlSafeBase64&&this._.urlSafeBase64.isUrlSafeBase64(t)?t=t.substring(0,1)+this._.base64Decode(this._.urlSafeBase64.decode(t.substring(1))):this._.rot13defs&&(t=t.substring(0,1)+this._.rot13defs(t.substring(1)))),t}return""},setRefferId:function(e){var t=this.store.getDistinctId(),r=this.getUrlId();if(r&&""!==r){var n="a"===r.substring(0,1)||"d"===r.substring(0,1);(r=r.substring(1))!==t&&(n?(this.sd.identify(r,!0),this.store.getFirstId()&&this.sd.saEvent.send({original_id:r,distinct_id:t,type:"track_signup",event:"$SignUp",properties:{}},null)):this.store.getFirstId()&&!e.re_login||this.sd.login(r))}},addListen:function(){var e=this,t=function(t){var r,n,i=t.target,a=i.tagName.toLowerCase(),o=i.parentNode;if("a"===a&&i.href||o&&o.tagName&&"a"===o.tagName.toLowerCase()&&o.href){"a"===a&&i.href?(r=i.href,n=i):(r=o.href,n=o);var s=e._.URL(r).protocol;"http:"!==s&&"https:"!==s||e.getPart(r)&&e.rewriteUrl(r,n)}};e._.addEvent(document,"mousedown",t),window.PointerEvent&&"maxTouchPoints"in window.navigator&&window.navigator.maxTouchPoints>=0&&e._.addEvent(document,"pointerdown",t)},init:function(e,t){this.sd=e,this._=e._,this.store=e.store,this.para=e.para,this._.isObject(t)&&this._.isArray(t.linker)&&t.linker.length>0?(this.setRefferId(t),this.addListen(),this.option=t.linker,this.option=function(t){for(var r=t.length,n=[],i=0;i<r;i++)/[A-Za-z0-9]+\./.test(t[i].part_url)&&"[object Boolean]"==Object.prototype.toString.call(t[i].after_hash)?n.push(t[i]):e.log("linker \u914d\u7f6e\u7684\u7b2c "+(i+1)+" \u9879\u683c\u5f0f\u4e0d\u6b63\u786e\uff0c\u8bf7\u68c0\u67e5\u53c2\u6570\u683c\u5f0f\uff01");return n}(this.option)):e.log("\u8bf7\u914d\u7f6e\u6253\u901a\u57df\u540d\u53c2\u6570\uff01")}},yi=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=hi,e}(vi,"SiteLinker","sdkReady"),bi="utm_source utm_medium utm_campaign utm_content utm_term",wi="1.27.11";var Si=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=wi,e}({init:function(e){e&&!mi&&(mi=e).registerInterceptor("businessStage",{getUtmData:{priority:0,entry:function(){return function(){var e=bi.split(" "),t="",r={};mi._.isArray(mi.para.source_channel)&&mi.para.source_channel.length>0&&(e=e.concat(mi.para.source_channel),e=mi._.unique(e));return mi._.each(e,function(e){(t=mi._.getQueryParam(location.href,e)).length&&(r[e]=t)}),r}()}}})}},"Utm","sdkAfterInitPara"),ki="1.27.11";var Pi=!1,Ci=null;function Oi(){Pi=!0}function ji(){Pi=!1}function Ni(){return Pi}var Ti,Ii,Ai=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=ki,e}({init:function(e){(Ci=e).disableSDK=Oi,Ci.enableSDK=ji,Ci.getDisabled=Ni}},"DisableSDK","sdkInitAPI"),Di="1.27.11";function $i(e,t){if(!0===Ti.para.debug_mode){var r=e.data;e.callback;!function(e){var t=e,r="";r=-1!==Ti.para.debug_mode_url.indexOf("?")?Ti.para.debug_mode_url+"&"+Ti.kit.encodeTrackData(e):Ti.para.debug_mode_url+"?"+Ti.kit.encodeTrackData(e),Ii.ajax({url:r,type:"GET",cors:!0,header:{"Dry-Run":String(Ti.para.debug_mode_upload)},success:function(e){!0===Ii.isEmptyObject(e)?alert("debug\u6570\u636e\u53d1\u9001\u6210\u529f"+t):alert("debug\u5931\u8d25 \u9519\u8bef\u539f\u56e0"+JSON.stringify(e))}})}(JSON.stringify(r)),t.cancellationToken.stop()}return e}function xi(){Ti.on("sdkInitPara",function(){!0===Ti.para.debug_mode&&(Ti.para.debug_mode_upload=Ti.para.debug_mode_upload||!1,Ii.isString(Ti.para.debug_mode_url)||(Ii.isString(Ti.para.server_url)?Ti.para.debug_mode_url=Ti.para.server_url.replace("sa.gif","debug"):Ii.isArray(Ti.para.server_url)&&Ii.isString(Ti.para.server_url[0])?Ti.para.debug_mode_url=Ti.para.server_url[0].replace("sa.gif","debug"):Ti.para.debug_mode=!1))}),Ti.on("sdkAfterInitPara",function(){Ti.registerInterceptor("sendDataStage",{send:{priority:30,entry:$i}})})}var Ei,Li,Ui=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Di,e}({plugin_name:"DebugSender",init:function(e){Ii=(Ti=e)._,xi()}}),Ri="1.27.11";function Bi(e,t){if(Li.isObject(Ei.para.jsapp)&&!Ei.para.jsapp.isOnline&&"function"==typeof Ei.para.jsapp.setData){var r=e;delete r.callback,r=JSON.stringify(r),Ei.para.jsapp.setData(r),t.cancellationToken.stop()}return e}function Hi(e){if(!0===e&&Li.isObject(Ei.para.jsapp)&&"function"==typeof Ei.para.jsapp.getData){Ei.para.jsapp.isOnline=!0;var t=Ei.para.jsapp.getData();Li.isArray(t)&&t.length>0&&Li.each(t,function(e){Li.isJSONString(e)&&Ei.kit.sendData(JSON.parse(e))})}else Ei.para.jsapp.isOnline=!1}var Ji,Mi,qi=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Ri,e}({plugin_name:"JsappSender",init:function(e){Li=(Ei=e)._,Ei.on("sdkAfterInitAPI",function(){Li.isObject(Ei.commonWays)&&(Ei.commonWays.setOnlineState=Hi),Ei.registerInterceptor("sendDataStage",{send:{priority:40,entry:Bi}})})}}),Fi="1.27.11";var Ki=null;function Vi(e,t){return!Ji.para.app_js_bridge&&Ji.para.batch_send&&Mi.localStorage.isSupport()&&localStorage.length<Ji.para.batch_send.storage_length&&(Ki.add(e.data),t.cancellationToken.stop()),e}function zi(){Ji.on("sdkInitPara",function(){var e;e={datasend_timeout:6e3,send_interval:6e3,storage_length:200},Mi.localStorage.isSupport()&&Mi.isSupportCors()&&"object"==typeof localStorage?!0===Ji.para.batch_send?Ji.para.batch_send=Mi.extend({},e):"object"==typeof Ji.para.batch_send&&(Ji.para.batch_send=Mi.extend({},e,Ji.para.batch_send)):Ji.para.batch_send=!1}),Ji.on("sdkAfterInitPara",function(){!Ji.para.app_js_bridge&&Ji.para.batch_send&&Mi.localStorage.isSupport()&&(Ki||(Ki=new Mi.BatchSend),Ki.batchInterval(),Ji.registerInterceptor("sendDataStage",{send:{priority:100,entry:Vi}}))})}var Wi,Xi,Zi=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Fi,e}({plugin_name:"BatchSender",init:function(e){Mi=(Ji=e)._,zi()}}),Yi="1.27.11";function Gi(e){new Xi.BeaconSend(e).start()}function Qi(e,t){var r=null,n=null;if(Xi.isObject(e.config)&&(r=e.config.send_type,n=Xi.optimizeServerUrl(e.config.server_url)),("beacon"===r||!r&&"beacon"===Wi.para.send_type)&&Xi.isSupportBeaconSend()){var i=n||e.server_url;e.server_url=i,e.data=Wi.kit.encodeTrackData(e.data),Xi.isArray(i)&&i.length?Xi.each(i,function(t){e.callback=null,e.server_url=t,Gi(e)}):"string"==typeof i&&""!==i?Gi(e):Wi.log("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01"),t.cancellationToken.stop()}return e}function ea(){Wi.on("sdkInitPara",function(){"beacon"!==Wi.para.send_type||Xi.isSupportBeaconSend()||(Wi.para.send_type=Wi.DEFAULT_SEND_TYPE)}),Wi.on("sdkAfterInitPara",function(){Wi.registerInterceptor("sendDataStage",{send:{priority:110,entry:Qi}})})}var ta,ra,na=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Yi,e}({plugin_name:"BeaconSender",init:function(e){Xi=(Wi=e)._,ea()}}),ia="1.27.11";function aa(e){new ra.AjaxSend(e).start()}function oa(e,t){var r=null,n=null;if(ra.isObject(e.config)&&(r=e.config.send_type,n=ra.optimizeServerUrl(e.config.server_url)),("ajax"===r||!r&&"ajax"===ta.para.send_type)&&ra.isSupportCors()){var i=n||e.server_url;e.server_url=i,e.data=ta.kit.encodeTrackData(e.data),ra.isArray(i)&&i.length?ra.each(i,function(t){e.callback=null,e.server_url=t,aa(e)}):"string"==typeof i&&""!==i?aa(e):ta.log("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01"),t.cancellationToken.stop()}return e}function sa(){ta.on("sdkInitPara",function(){"ajax"!==ta.para.send_type||ra.isSupportCors()||(ta.para.send_type=ta.DEFAULT_SEND_TYPE)}),ta.on("sdkAfterInitPara",function(){ta.registerInterceptor("sendDataStage",{send:{priority:120,entry:oa}})})}var la,ua,ca=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=ia,e}({plugin_name:"AjaxSender",init:function(e){ra=(ta=e)._,sa()}}),pa="1.27.11";function da(e,t){var r=la.kit.encodeTrackData(t);return-1!==e.indexOf("?")?e+"&"+r:e+"?"+r}function fa(e){new ua.ImageSend(e).start()}function ga(e,t){var r=null;ua.isObject(e.config)&&(r=ua.optimizeServerUrl(e.config.server_url));var n=r||e.server_url,i=e.data;e.server_url=n,ua.isArray(n)&&n.length?ua.each(n,function(t){t&&(e.data=da(t,i),e.callback=null,e.server_url=t,fa(e))}):"string"==typeof n&&""!==n?(e.data=da(n,i),fa(e)):la.logger&&la.logger.msg("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01").level("warn").log(),t.cancellationToken.stop()}function _a(){la.on("sdkInitPara",function(){"image"!==la.para.send_type&&"ajax"!==la.para.send_type&&"beacon"!==la.para.send_type&&(la.para.send_type="image")}),la.on("sdkAfterInitPara",function(){la.registerInterceptor("sendDataStage",{send:{priority:130,entry:ga}})})}var ha=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=pa,e}({plugin_name:"ImageSender",init:function(e){ua=(la=e)._,_a()}});var ma=null,va=null,ya=[],ba=function(e,t,r){return function(e,t,r){if(t&&(e.plugin_name=t),r&&e.init){var n=e.init;e.init=function(i,a){if(function(e,t,r){function n(t,n){e.logger?e.logger.msg.apply(e.logger,n).module(r+""||"").level(t).log():e.log&&e.log.apply(e,n)}t.log=function(){n("log",arguments)},t.warn=function(){n("warn",arguments)},t.error=function(){n("error",arguments)}}(i,e,t),i.readyState&&i.readyState.state>=3||!i.on)return o();function o(){n.call(e,i,a)}i.on(r,o)}}}(e,t,r),e.plugin_version=Re,e}({init:function(e){e&&(va=(ma=e)._,ma.logger&&ma.logger.appendWriter(wa),ma.on&&ma.on("sdkAfterInitPara",function(){for(var e=0;e<ya.length;e++)Sa(ya[e]);ya=null}),ma.on&&ma.on("sdkInitAPI",function(){ma.enableLocalLog=Oa,ma.disableLocalLog=ja}))}},"ConsoleLogger");function wa(e){null!==ya?ya.push(e):Sa(e)}function Sa(e){try{if("log"===e.level&&ka())return void Pa(e);if("warn"===e.level&&function(){if(Na())return!0;return ka()||va.isObject(ma.para.show_log)&&"warn"===ma.para.show_log.level}())return void Pa(e);if("error"===e.level&&function(){if(Na())return!0;if(va.isObject(ma.para.show_log))return"none"!==ma.para.show_log.level;return!0}())return void Pa(e)}catch(t){}}function ka(){return!!Na()||(!0===ma.para.show_log||va.isObject(ma.para.show_log)&&"log"===ma.para.show_log.level)}function Pa(e){var t=e.content,r=va.isObject(t[0])?va.formatJsonString(t[0]):t[0],n=function(e){var t="",r="",n=ma.para.show_log;va.isObject(n)&&!1===n.show_brand||(t+=e.brand);va.isObject(n)&&!1===n.show_level||(t+=(t.length>0?"-":"")+e.level);t.length>0&&(t="["+t+"]");va.isObject(n)&&!1===n.show_module||(r=e.module);return t+r}(e);t[0]=n+(n.length>0?": ":"")+r;try{console&&(va.isFunction(console[e.level])?console[e.level].apply(console,t):va.isObject(console[e.level])&&console[e.level](t[0]))}catch(i){}}var Ca="sensorsdata_jssdk_debug";function Oa(){va.sessionStorage.isSupport()&&sessionStorage.setItem(Ca,"true")}function ja(){va.sessionStorage.isSupport()&&sessionStorage.removeItem(Ca)}function Na(){return va.sessionStorage.isSupport()&&"true"===sessionStorage.getItem(Ca)}t.modules=t.modules||{};for(var Ta=[ba,Br,tn,kn,jn,Jn,Wn,Qn,ni,oi,ui,_i,yi,Si,Ai,Ui,qi,Zi,na,ca,ha],Ia=[ba,Ur,Si,Ai,qi,Ui,tn,Wn,kn,Qn,Zi,na,ca,ha],Aa=0;Aa<Ta.length;Aa++){var Da=Ta[Aa];t._.isString(Da.plugin_name)?t.modules[Da.plugin_name]=Da:t._.isArray(Da.plugin_name)&&t._.each(Da.plugin_name,function(e){t.modules[e]=Da})}for(Aa=0;Aa<Ia.length;Aa++)t.use(Ia[Aa]);var $a=t;try{"string"==typeof window.sensorsDataAnalytic201505?(t.para=window[sensorsDataAnalytic201505].para,t._q=window[sensorsDataAnalytic201505]._q,window[sensorsDataAnalytic201505]=t,window.sensorsDataAnalytic201505=t,t.init()):"undefined"==typeof window.sensorsDataAnalytic201505?window.sensorsDataAnalytic201505=t:$a=window.sensorsDataAnalytic201505}catch(Ea){xe(Ea)}var xa=$a;return xa.DEFAULT_SEND_TYPE="image",xa});

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("jF/i");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "01Lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopPwd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__ = __webpack_require__("h2Na");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__ = __webpack_require__("YK8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_routes_feeQuery_routes_detail_components_Radio__ = __webpack_require__("0GZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__("bwUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Btn__ = __webpack_require__("yU3I");



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var popPwdQueue = [];

var PopPwdComponent = function (_Component) {
  _inherits(PopPwdComponent, _Component);

  function PopPwdComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopPwdComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopPwdComponent.__proto__ || Object.getPrototypeOf(PopPwdComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: '',
      inCoudesOne: true,
      inCoudesTwo: false
    }, _this.onChange = function (e) {
      _this.setState({ value: e.target.value });
    }, _this.readingF = function (key) {
      return function () {
        if (key == 'inCoudesOne' && !_this.state[key]) {
          _this.setState(_defineProperty({}, key, !_this.state[key]));
          _this.setState({ inCoudesTwo: _this.state[key] });
        }
        if (key == 'inCoudesTwo' && !_this.state[key]) {
          _this.setState(_defineProperty({}, key, !_this.state[key]));
          _this.setState({ inCoudesOne: _this.state[key] });
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopPwdComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onCancel = _props.onCancel,
          onConfirm = _props.onConfirm,
          destroy = _props.destroy,
          renderHtml = _props.renderHtml,
          nameList = _props.nameList,
          lang = _props.lang;
      var _state = this.state,
          value = _state.value,
          inCoudesOne = _state.inCoudesOne,
          inCoudesTwo = _state.inCoudesTwo;

      return _jsx('section', {
        className: 'pop-pwd'
      }, void 0, _jsx('div', {
        id: 'popp',
        className: 'pop-pwd-content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default.a, {
        type: 'cross',
        onClick: function onClick(e) {
          return onCancel(destroy);
        },
        role: 'button',
        'aria-label': '\u5173\u95ED'
      }), _jsx('p', {}, void 0, this.props.title), !renderHtml && _jsx('div', {}, void 0, _jsx('input', {
        id: 'mileage-pwd',
        onChange: this.onChange,
        type: 'password',
        placeholder: lang.memberShip6
      }), _jsx('div', {
        className: 'pop-pwd-btns'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_Btn__["default"], {
        text: lang.confirm,
        onClick: function onClick(e) {
          return onConfirm(destroy, value);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_Btn__["default"], {
        text: lang.Cancel,
        onClick: function onClick(e) {
          return onCancel(destroy);
        }
      }))), renderHtml && _jsx('div', {}, void 0, _jsx('div', {
        className: 'radioT'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__routes_routes_feeQuery_routes_detail_components_Radio__["a" /* default */], {
        className: 'reading',
        label: '',
        name: 'inCoudesOne',
        checked: inCoudesOne,
        clickEvent: this.readingF('inCoudesOne')
      }), _jsx('div', {}, void 0, nameList[0])), _jsx('div', {
        className: 'radioP'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__routes_routes_feeQuery_routes_detail_components_Radio__["a" /* default */], {
        className: 'reading',
        label: '',
        name: 'inCoudesTwo',
        checked: inCoudesTwo,
        clickEvent: this.readingF('inCoudesTwo')
      }), _jsx('div', {}, void 0, nameList[1]))), renderHtml && _jsx('div', {
        className: 'tipColor'
      }, void 0, _jsx('p', {}, void 0, lang.reminder2), lang.memberShip7), renderHtml && _jsx('div', {
        className: 'pop-pwd-btns'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_Btn__["default"], {
        text: lang.reInput,
        onClick: function onClick(e) {
          return onCancel(destroy);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_Btn__["default"], {
        text: lang.confirm,
        onClick: function onClick(e) {
          return onConfirm(destroy, [inCoudesOne, inCoudesTwo]);
        }
      }))));
    }
  }]);

  return PopPwdComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

PopPwdComponent.props = {
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  destroy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onConfirm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderHtml: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  nameList: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  lang: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
PopPwdComponent.defaultProps = {
  title: '',
  destroy: function destroy() {},
  onConfirm: function onConfirm(destroy, value) {
    destroy && destroy();
  },
  onCancel: function onCancel(destroy) {
    destroy && destroy();
  }
};


function PopPwd() {
  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('popp');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  var destroy = function destroy() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(PopPwdComponent, Object.assign({}, prop, { destroy: destroy })), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('popp').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

PopPwd.clear = function () {
  if (popPwdQueue && popPwdQueue.length) {
    popPwdQueue.forEach(function (progess) {
      progess();
    });
    popPwdQueue = [];
  }
};

/***/ }),

/***/ "04KZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/create-react-class/index.js from dll-reference vendor_library
var create_react_classfrom_dll_reference_vendor_library = __webpack_require__("DT0+");
var create_react_classfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(create_react_classfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// CONCATENATED MODULE: ./node_modules/rc-util/es/KeyCode.js
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ var es_KeyCode = (KeyCode);
// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules
var Animate = __webpack_require__("8aSS");

// EXTERNAL MODULE: delegated ./node_modules/object-assign/index.js from dll-reference vendor_library
var object_assignfrom_dll_reference_vendor_library = __webpack_require__("BEQ0");
var object_assignfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(object_assignfrom_dll_reference_vendor_library);

// CONCATENATED MODULE: ./node_modules/rc-dialog/es/LazyRenderBox.js








var LazyRenderBox_LazyRenderBox = function (_React$Component) {
    inherits_default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        classCallCheck_default()(this, LazyRenderBox);

        return possibleConstructorReturn_default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
    }

    createClass_default()(LazyRenderBox, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return !!nextProps.hiddenClassName || !!nextProps.visible;
        }
    }, {
        key: 'render',
        value: function render() {
            var className = this.props.className;
            if (!!this.props.hiddenClassName && !this.props.visible) {
                className += ' ' + this.props.hiddenClassName;
            }
            var props = object_assignfrom_dll_reference_vendor_library_default()({}, this.props);
            delete props.hiddenClassName;
            delete props.visible;
            props.className = className;
            return reactfrom_dll_reference_vendor_library_default.a.createElement("div", extends_default()({}, props));
        }
    }]);

    return LazyRenderBox;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

/* harmony default export */ var es_LazyRenderBox = (LazyRenderBox_LazyRenderBox);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/getScrollBarSize.js
var getScrollBarSize = __webpack_require__("7j3q");
var getScrollBarSize_default = /*#__PURE__*/__webpack_require__.n(getScrollBarSize);

// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog.js












var uuid = 0;
var openCount = 0;

function noop() {}
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog_Dialog = function (_React$Component) {
    inherits_default()(Dialog, _React$Component);

    function Dialog() {
        classCallCheck_default()(this, Dialog);

        var _this = possibleConstructorReturn_default()(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));

        _this.onAnimateLeave = function () {
                                    if (_this.refs.wrap) {
                _this.refs.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.removeScrollingEffect();
            _this.props.afterClose();
        };
        _this.onMaskClick = function (e) {
                        if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === es_KeyCode.ESC) {
                _this.close(e);
            }
                        if (props.visible) {
                if (e.keyCode === es_KeyCode.TAB) {
                    var activeElement = document.activeElement;
                    var dialogRoot = _this.refs.wrap;
                    var sentinel = _this.refs.sentinel;
                    if (e.shiftKey) {
                        if (activeElement === dialogRoot) {
                            sentinel.focus();
                        }
                    } else if (activeElement === _this.refs.sentinel) {
                        dialogRoot.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = reactfrom_dll_reference_vendor_library_default.a.createElement("div", { className: prefixCls + '-footer', ref: "footer" }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = reactfrom_dll_reference_vendor_library_default.a.createElement("div", { className: prefixCls + '-header', ref: "header" }, reactfrom_dll_reference_vendor_library_default.a.createElement("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = reactfrom_dll_reference_vendor_library_default.a.createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, reactfrom_dll_reference_vendor_library_default.a.createElement("span", { className: prefixCls + '-close-x' }));
            }
            var style = object_assignfrom_dll_reference_vendor_library_default()({}, props.style, dest);
            var transitionName = _this.getTransitionName();
            var dialogElement = reactfrom_dll_reference_vendor_library_default.a.createElement(es_LazyRenderBox, { key: "dialog-element", role: "document", ref: "dialog", style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, reactfrom_dll_reference_vendor_library_default.a.createElement("div", { className: prefixCls + '-content' }, closer, header, reactfrom_dll_reference_vendor_library_default.a.createElement("div", extends_default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: "body" }, props.bodyProps), props.children), footer), reactfrom_dll_reference_vendor_library_default.a.createElement("div", { tabIndex: 0, ref: "sentinel", style: { width: 0, height: 0, overflow: 'hidden' } }, "sentinel"));
            return reactfrom_dll_reference_vendor_library_default.a.createElement(Animate["a" /* default */], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, dialogElement);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return object_assignfrom_dll_reference_vendor_library_default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return object_assignfrom_dll_reference_vendor_library_default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = reactfrom_dll_reference_vendor_library_default.a.createElement(es_LazyRenderBox, extends_default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = reactfrom_dll_reference_vendor_library_default.a.createElement(Animate["a" /* default */], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getElement = function (part) {
            return _this.refs[part];
        };
        _this.setScrollbar = function () {
            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
                document.body.style.paddingRight = _this.scrollbarWidth + 'px';
            }
        };
        _this.addScrollingEffect = function () {
            openCount++;
            if (openCount !== 1) {
                return;
            }
            _this.checkScrollbar();
            _this.setScrollbar();
            document.body.style.overflow = 'hidden';
                    };
        _this.removeScrollingEffect = function () {
            openCount--;
            if (openCount !== 0) {
                return;
            }
            document.body.style.overflow = '';
            _this.resetScrollbar();
                    };
        _this.close = function (e) {
            _this.props.onClose(e);
        };
        _this.checkScrollbar = function () {
            var fullWindowWidth = window.innerWidth;
            if (!fullWindowWidth) {
                var documentElementRect = document.documentElement.getBoundingClientRect();
                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }
            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
            if (_this.bodyIsOverflowing) {
                _this.scrollbarWidth = getScrollBarSize_default()();
            }
        };
        _this.resetScrollbar = function () {
            document.body.style.paddingRight = '';
        };
        _this.adjustDialog = function () {
            if (_this.refs.wrap && _this.scrollbarWidth !== undefined) {
                var modalIsOverflowing = _this.refs.wrap.scrollHeight > document.documentElement.clientHeight;
                _this.refs.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
                _this.refs.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
            }
        };
        _this.resetAdjustments = function () {
            if (_this.refs.wrap) {
                _this.refs.wrap.style.paddingLeft = _this.refs.wrap.style.paddingLeft = '';
            }
        };
        return _this;
    }

    createClass_default()(Dialog, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.inTransition = false;
            this.titleId = 'rcDialogTitle' + uuid++;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate({});
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var props = this.props;
            var mousePosition = this.props.mousePosition;
            if (props.visible) {
                                if (!prevProps.visible) {
                    this.openTime = Date.now();
                    this.lastOutSideFocusNode = document.activeElement;
                    this.addScrollingEffect();
                    this.refs.wrap.focus();
                    var dialogNode = react_domfrom_dll_reference_vendor_library_default.a.findDOMNode(this.refs.dialog);
                    if (mousePosition) {
                        var elOffset = offset(dialogNode);
                        setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                    } else {
                        setTransformOrigin(dialogNode, '');
                    }
                }
            } else if (prevProps.visible) {
                this.inTransition = true;
                if (props.mask && this.lastOutSideFocusNode) {
                    try {
                        this.lastOutSideFocusNode.focus();
                    } catch (e) {
                        this.lastOutSideFocusNode = null;
                    }
                    this.lastOutSideFocusNode = null;
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.visible || this.inTransition) {
                this.removeScrollingEffect();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                maskClosable = props.maskClosable;

            var style = this.getWrapStyle();
                                    if (props.visible) {
                style.display = null;
            }
            return reactfrom_dll_reference_vendor_library_default.a.createElement("div", null, this.getMaskElement(), reactfrom_dll_reference_vendor_library_default.a.createElement("div", extends_default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: "wrap", onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
        }
    }]);

    return Dialog;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

/* harmony default export */ var es_Dialog = (Dialog_Dialog);

Dialog_Dialog.defaultProps = {
    afterClose: noop,
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    prefixCls: 'rc-dialog',
    onClose: noop
};
// CONCATENATED MODULE: ./node_modules/rc-util/es/getContainerRenderMixin.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function defaultGetContainer() {
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
}

function getContainerRenderMixin(config) {
  var _config$autoMount = config.autoMount,
      autoMount = _config$autoMount === void 0 ? true : _config$autoMount,
      _config$autoDestroy = config.autoDestroy,
      autoDestroy = _config$autoDestroy === void 0 ? true : _config$autoDestroy,
      isVisible = config.isVisible,
      isForceRender = config.isForceRender,
      getComponent = config.getComponent,
      _config$getContainer = config.getContainer,
      getContainer = _config$getContainer === void 0 ? defaultGetContainer : _config$getContainer;
  var mixin;

  function _renderComponent(instance, componentArg, ready) {
    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
      if (!instance._container) {
        instance._container = getContainer(instance);
      }

      var component;

      if (instance.getComponent) {
        component = instance.getComponent(componentArg);
      } else {
        component = getComponent(instance, componentArg);
      }

      react_domfrom_dll_reference_vendor_library_default.a.unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
        instance._component = this;

        if (ready) {
          ready.call(this);
        }
      });
    }
  }

  if (autoMount) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentDidMount: function componentDidMount() {
        _renderComponent(this);
      },
      componentDidUpdate: function componentDidUpdate() {
        _renderComponent(this);
      }
    });
  }

  if (!autoMount || !autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      renderComponent: function renderComponent(componentArg, ready) {
        _renderComponent(this, componentArg, ready);
      }
    });
  }

  function _removeContainer(instance) {
    if (instance._container) {
      var container = instance._container;
      react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(container);
      container.parentNode.removeChild(container);
      instance._container = null;
    }
  }

  if (autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentWillUnmount: function componentWillUnmount() {
        _removeContainer(this);
      }
    });
  } else {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      removeContainer: function removeContainer() {
        _removeContainer(this);
      }
    });
  }

  return mixin;
}
// CONCATENATED MODULE: ./node_modules/rc-dialog/es/DialogWrap.js





var DialogWrap = create_react_classfrom_dll_reference_vendor_library_default()({
    displayName: 'DialogWrap',
    mixins: [getContainerRenderMixin({
        isVisible: function isVisible(instance) {
            return instance.props.visible;
        },

        autoDestroy: false,
        getComponent: function getComponent(instance, extra) {
            return reactfrom_dll_reference_vendor_library_default.a.createElement(es_Dialog, extends_default()({}, instance.props, extra, { key: "dialog" }));
        },
        getContainer: function getContainer(instance) {
            if (instance.props.getContainer) {
                return instance.props.getContainer();
            }
            var container = document.createElement('div');
            document.body.appendChild(container);
            return container;
        }
    })],
    getDefaultProps: function getDefaultProps() {
        return {
            visible: false
        };
    },
    shouldComponentUpdate: function shouldComponentUpdate(_ref) {
        var visible = _ref.visible;

        return !!(this.props.visible || visible);
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this.props.visible) {
            this.renderComponent({
                afterClose: this.removeContainer,
                onClose: function onClose() {},

                visible: false
            });
        } else {
            this.removeContainer();
        }
    },
    getElement: function getElement(part) {
        return this._component.getElement(part);
    },
    render: function render() {
        return null;
    }
});
/* harmony default export */ var es_DialogWrap = __webpack_exports__["default"] = (DialogWrap);

/***/ }),

/***/ "0GZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("tmj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Radio = function (_PureComponent) {
  _inherits(Radio, _PureComponent);

  function Radio() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || Object.getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checked: _this.props.checked
    }, _this._handleClick = function () {
      var _this$props = _this.props,
          disable = _this$props.disable,
          clickEvent = _this$props.clickEvent;
      // const { checked } = this.state;

      if (disable) {
        // this.setState({ checked: !checked });

        clickEvent();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Radio, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var checked = nextProps.checked;

      if (checked !== this.props.checked) {
        this.setState({ checked: checked });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disable = _props.disable,
          name = _props.name,
          label = _props.label,
          className = _props.className,
          style = _props.style;
      var checked = this.state.checked;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        Object.assign({ className: 'radio ' + className }, style && { style: style }),
        _jsx('input', {
          id: name,
          type: 'radio',
          checked: checked,
          onClick: this._handleClick
        }),
        _jsx('label', {
          htmlFor: name,
          'aria-label': label,
          style: !disable ? { border: '0.02rem solid #d3d3d3' } : {}
        }),
        _jsx('span', {
          style: !disable ? { color: '#d3d3d3' } : {}
        }, void 0, label)
      );
    }
  }]);

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Radio.defaultProps = {
  disable: true,
  label: '选择',
  className: '',
  style: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),

/***/ "0IZF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    select: function select(value) {
        var children = _react2['default'].Children.toArray(this.props.children);
        for (var i = 0, len = children.length; i < len; i++) {
            if (children[i].props.value === value) {
                this.selectByIndex(i);
                return;
            }
        }
        this.selectByIndex(0);
    },
    selectByIndex: function selectByIndex(index) {
        if (index < 0 || index >= _react2['default'].Children.count(this.props.children) || !this.itemHeight) {
            return;
        }
        this.scrollTo(index * this.itemHeight);
    },
    doScrollingComplete: function doScrollingComplete(top) {
        var index = top / this.itemHeight;
        var floor = Math.floor(index);
        if (index - floor > 0.5) {
            index = floor + 1;
        } else {
            index = floor;
        }
        var children = _react2['default'].Children.toArray(this.props.children);
        index = Math.min(index, children.length - 1);
        var child = children[index];
        if (child) {
            this.fireValueChange(child.props.value);
        } else if (console.warn) {
            console.warn('child not found', children, index);
        }
    }
}; /* tslint:disable:no-console */

module.exports = exports['default'];

/***/ }),

/***/ "0LGO":
/***/ (function(module, exports, __webpack_require__) {

var METADATA = __webpack_require__("17Rs")('meta');
var FREEZING = __webpack_require__("wjiB");
var isObject = __webpack_require__("HAas");
var has = __webpack_require__("l/2K");
var defineProperty = __webpack_require__("1rEs").f;
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

__webpack_require__("Eb96")[METADATA] = true;


/***/ }),

/***/ "0Q51":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("izte")('native-function-to-string', Function.toString);


/***/ }),

/***/ "0ghZ":
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__("PfJA"),
    hasUnicode = __webpack_require__("iYj9"),
    unicodeToArray = __webpack_require__("KGqH");

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "13I+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}
exports['default'] = {
    getDefaultProps: function getDefaultProps() {
        return {
            onVisibleChange: noop,
            okText: 'Ok',
            pickerValueProp: 'selectedValue',
            pickerValueChangeProp: 'onValueChange',
            dismissText: 'Dismiss',
            title: '',
            onOk: noop,
            onDismiss: noop
        };
    },
    getInitialState: function getInitialState() {
        return {
            pickerValue: 'value' in this.props ? this.props.value : null,
            visible: this.props.visible || false
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
            this.setState({
                pickerValue: nextProps.value
            });
        }
        if ('visible' in nextProps) {
            this.setVisibleState(nextProps.visible);
        }
    },
    onPickerChange: function onPickerChange(pickerValue) {
        if (this.state.pickerValue !== pickerValue) {
            this.setState({
                pickerValue: pickerValue
            });
            var _props = this.props,
                picker = _props.picker,
                pickerValueChangeProp = _props.pickerValueChangeProp;

            if (picker && picker.props[pickerValueChangeProp]) {
                picker.props[pickerValueChangeProp](pickerValue);
            }
        }
    },
    saveRef: function saveRef(picker) {
        this.picker = picker;
    },
    setVisibleState: function setVisibleState(visible) {
        this.setState({
            visible: visible
        });
        if (!visible) {
            this.setState({
                pickerValue: null
            });
        }
    },
    fireVisibleChange: function fireVisibleChange(visible) {
        if (this.state.visible !== visible) {
            if (!('visible' in this.props)) {
                this.setVisibleState(visible);
            }
            this.props.onVisibleChange(visible);
        }
    },
    getRender: function getRender() {
        var props = this.props;
        var children = props.children;
        if (!children) {
            return this.getModal();
        }
        var _props2 = this.props,
            WrapComponent = _props2.WrapComponent,
            disabled = _props2.disabled;

        var child = children;
        var newChildProps = {};
        if (!disabled) {
            newChildProps[props.triggerType] = this.onTriggerClick;
        }
        return _react2['default'].createElement(
            WrapComponent,
            { style: props.wrapStyle },
            _react2['default'].cloneElement(child, newChildProps),
            this.getModal()
        );
    },
    onTriggerClick: function onTriggerClick(e) {
        var child = this.props.children;
        var childProps = child.props || {};
        if (childProps[this.props.triggerType]) {
            childProps[this.props.triggerType](e);
        }
        this.fireVisibleChange(!this.state.visible);
    },
    onOk: function onOk() {
        this.props.onOk(this.picker && this.picker.getValue());
        this.fireVisibleChange(false);
    },
    getContent: function getContent() {
        if (this.props.picker) {
            var _React$cloneElement;

            var pickerValue = this.state.pickerValue;

            if (pickerValue === null) {
                pickerValue = this.props.value;
            }
            return _react2['default'].cloneElement(this.props.picker, (_React$cloneElement = {}, (0, _defineProperty3['default'])(_React$cloneElement, this.props.pickerValueProp, pickerValue), (0, _defineProperty3['default'])(_React$cloneElement, this.props.pickerValueChangeProp, this.onPickerChange), (0, _defineProperty3['default'])(_React$cloneElement, 'ref', this.saveRef), _React$cloneElement));
        } else {
            return this.props.content;
        }
    },
    onDismiss: function onDismiss() {
        this.props.onDismiss();
        this.fireVisibleChange(false);
    },
    hide: function hide() {
        this.fireVisibleChange(false);
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "16tV":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("tO4o"),
    keys = __webpack_require__("ktak");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "17Rs":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
};


/***/ }),

/***/ "1EI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_NAVBAR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_OLD_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_LOGINPARAM_FEEQUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SYS_CONFIG; });
/* unused harmony export GO_CHANGE_PAY */
/* unused harmony export CANCLE_CHANGE_PAY */
/* unused harmony export CHECK_LUCK_DRAW_ENTRY */
/* unused harmony export PAY_MILEAGE */
/* unused harmony export VERIFY_MILEAGE */
/* unused harmony export GET_COUNTRY_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_APP_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_PSGS_FLIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_USER_INFO; });
/* unused harmony export READ_COOIKE_USERINFO */
/* unused harmony export GET_CITY_WIDGET */
/* unused harmony export GET_PASSAGEMEMBER_LEVEL */
/* unused harmony export CREATE_NPSQNR_DETAIL */
/* unused harmony export CREATE_FDB_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_MILEAGE_SWITCH; });
/* unused harmony export GET_MENU_LIST */
/* unused harmony export GET_AD_INFO */
/* unused harmony export GET_AD_SWITCH */
/* unused harmony export GET_ALL_SWITCH */
/* unused harmony export GET_MOREQUERY_SWITCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_LANGUAGE; });
/* harmony export (immutable) */ __webpack_exports__["s"] = getLanguage;
/* harmony export (immutable) */ __webpack_exports__["D"] = setSimpleStatus;
/* harmony export (immutable) */ __webpack_exports__["l"] = changeNavbarState;
/* harmony export (immutable) */ __webpack_exports__["B"] = saveOldLocation;
/* unused harmony export editLoginParamFeeQuery */
/* harmony export (immutable) */ __webpack_exports__["y"] = getUserInfo;
/* harmony export (immutable) */ __webpack_exports__["x"] = getSysConf;
/* harmony export (immutable) */ __webpack_exports__["q"] = getAppConf;
/* unused harmony export volunteerChangePay */
/* unused harmony export h5_pay */
/* unused harmony export getExtraConfig */
/* unused harmony export wechat_pay */
/* harmony export (immutable) */ __webpack_exports__["E"] = unitePay;
/* harmony export (immutable) */ __webpack_exports__["k"] = cancleChangePay;
/* harmony export (immutable) */ __webpack_exports__["j"] = cancleChangeOOPay;
/* unused harmony export checkLuckDrawEntry */
/* unused harmony export payMileage */
/* unused harmony export verifyMileage */
/* harmony export (immutable) */ __webpack_exports__["A"] = mileageProcess;
/* harmony export (immutable) */ __webpack_exports__["r"] = getCountryData;
/* unused harmony export readCookieSetUserInfo */
/* harmony export (immutable) */ __webpack_exports__["w"] = getPassageMemberLevel;
/* harmony export (immutable) */ __webpack_exports__["m"] = createNpsQnrDetail;
/* harmony export (immutable) */ __webpack_exports__["C"] = searchNpsUrl;
/* harmony export (immutable) */ __webpack_exports__["u"] = getMileageSwitch;
/* harmony export (immutable) */ __webpack_exports__["t"] = getMenuList;
/* harmony export (immutable) */ __webpack_exports__["n"] = getAdInfo;
/* harmony export (immutable) */ __webpack_exports__["o"] = getAdSwitch;
/* harmony export (immutable) */ __webpack_exports__["v"] = getMoreQuerySwitch;
/* harmony export (immutable) */ __webpack_exports__["p"] = getAllSwitch;
/* harmony export (immutable) */ __webpack_exports__["z"] = getcustomerUrlSwitch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Routes__ = __webpack_require__("a1o4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Utils__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_reformProcess_modules_actions__ = __webpack_require__("2s00");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__ = __webpack_require__("mekh");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var CHANGE_NAVBAR_STATE = 'CHANGE_NAVBAR_STATE';
var SAVE_OLD_LOCATION = 'SAVE_OLD_LOCATION';
var EDIT_LOGINPARAM_FEEQUERY = 'EDIT_LOGINPARAM_FEEQUERY';
var GET_SYS_CONFIG = 'GET_SYS_CONFIG';
var GO_CHANGE_PAY = 'GO_CHANGE_PAY';
var CANCLE_CHANGE_PAY = 'CANCLE_CHANGE_PAY';
var CHECK_LUCK_DRAW_ENTRY = 'CHECK_LUCK_DRAW_ENTRY';
var PAY_MILEAGE = 'PAY_MILEAGE';
var VERIFY_MILEAGE = 'VERIFY_MILEAGE';
var GET_COUNTRY_DATA = 'GET_COUNTRY_DATA';
var GET_APP_CONFIG = 'GET_APP_CONFIG';
var SET_PSGS_FLIGHTS = 'SET_PSGS_FLIGHTS';
var GET_USER_INFO = 'GET_USER_INFO';
var READ_COOIKE_USERINFO = 'READ_COOIKE_USERINFO';
var GET_CITY_WIDGET = 'GET_CITY_WIDGET';
var GET_PASSAGEMEMBER_LEVEL = 'GET_PASSAGEMEMBER_LEVEL';
var CREATE_NPSQNR_DETAIL = 'CREATE_NPSQNR_DETAIL';
var CREATE_FDB_URL = 'CREATE_FDB_URL';
var GET_MILEAGE_SWITCH = 'GET_MILEAGE_SWITCH';
var GET_MENU_LIST = 'GET_MENU_LIST';
var GET_AD_INFO = 'GET_AD_INFO';
var GET_AD_SWITCH = 'GET_AD_SWITCH';
var GET_ALL_SWITCH = 'GET_ALL_SWITCH';

var GET_MOREQUERY_SWITCH = 'GET_MOREQUERY_SWITCH';
var GET_LANGUAGE = 'GET_LANGUAGE';

function getLanguage(lang) {
  return { type: GET_LANGUAGE, lang: lang };
}
// 临时勾选状态存储操作
function setSimpleStatus(psgs, flights) {
  return { type: SET_PSGS_FLIGHTS, psgs: psgs, flights: flights };
}

// 修改状态栏状态
function changeNavbarState(state) {
  return { type: CHANGE_NAVBAR_STATE, state: state };
}

// 保存旧的历史地址
function saveOldLocation(data) {
  return { type: SAVE_OLD_LOCATION, data: data };
}

// 修改退改费用url带参数查询状态
function editLoginParamFeeQuery() {
  return { type: EDIT_LOGINPARAM_FEEQUERY };
}

/**
 * @description 获取用户基本信息
 */
function getUserInfo() {
  return function (dispatch, getState) {
    var _getState = getState(),
        userInfo = _getState.App.userInfo;

    if (!userInfo.channel) dispatch({
      type: GET_USER_INFO,
      closeLoading: true,
      payload: {
        request: {
          url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].getUserInfo,
          method: 'post',
          data: {}
        }
      }
    });
  };
}

// 获取配置
function getSysConf() {
  return {
    type: GET_SYS_CONFIG,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].getConfig,
        method: 'post',
        data: {
          key: ['is_Easy_Login_Turn_On', 'is_authenticate_turn_on', 'is_recommend_turn_on', 'has_luck_draw_movable_switch_bool', 'the_flag_fastchange']
        }
      }
    }
  };
}

/**
 * @description 获取前端程序配置
 */
function getAppConf() {
  return {
    type: GET_APP_CONFIG,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].app_config_url,
        method: 'get',
        params: {
          t: new Date().getTime()
        }
      }
    }
  };
}

/**
 * @description 获取支付参数
 */
function volunteerChangePay(data) {
  return {
    type: GO_CHANGE_PAY,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].volunteerChangePay,
        method: 'post',
        data: data,
        headers: {
          'x-requested-with': 'XMLHttpRequest',
          'login-channel': navigator.userAgent.toLowerCase().includes('toutiaomicroapp') ? 'd' : 'm',
          'client-device': Object(__WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__["C" /* isCsairApp */])() ? 'app' : 'touch'
        }
      }
    }
  };
}

/**
 * @description 变更支付
 * @param {string} changeNo 变更单号
 * @param {func} fail 报错回调函数
 */
function h5_pay(changeNo, fail, load, totalPayMoney, bigOrderNo, ismu, payXSOOrderUppReq) {
  var _this = this;

  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var isAIComming, isAICommingFT, orderingSite, urlAppos, url, obj, DYurl, _ref2, _ref2$payload$data, errorInfo, token, merAppId, merId, version, language, callBackSuccessDto, isEN;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isAIComming = window.sessionStorage.getItem('isAIComming');
              isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
              orderingSite = window.sessionStorage.getItem('orderingSiteCode');
              urlAppos = window.location.href.indexOf('appos') !== -1;
              url = __WEBPACK_IMPORTED_MODULE_2_Url__["default"].payCallBackUrl + '?' + (isAIComming || isAICommingFT ? 'channel=AI&' : '') + (isAIComming ? 'from=assistant&' : '');

              if (window.location.href.indexOf(__WEBPACK_IMPORTED_MODULE_3_Routes__["default"].ticket.child.applySubmit.path) !== -1) {
                url += 'vipMember=Y&';
              }
              if (payXSOOrderUppReq) {
                url = __WEBPACK_IMPORTED_MODULE_2_Url__["default"].pageInfoDto.homeUrl + '?';
              }
              obj = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_2_Url__["default"].pageInfoDto));

              if (isAICommingFT || Object(__WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__["C" /* isCsairApp */])()) {
                obj.titleShow = 'N';
              }
              DYurl = '';

              if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
                DYurl = "https://emp.csair.com/" + 'ticketRefund/#/ticket/ReformProcess?orderNo=' + (changeNo.indexOf('ES') !== -1 && bigOrderNo ? bigOrderNo : changeNo) + '&orderType=S&channel=DY';
                obj.orderChangeDetailUrl = DYurl;
              }
              _context.next = 13;
              return dispatch(volunteerChangePay(Object.assign({
                changeNo: changeNo,
                callBackUrl: encodeURIComponent(url),
                pageInfoDto: obj
              }, bigOrderNo ? { changeUppReq: { orderId: bigOrderNo } } : {}, Object(__WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__["C" /* isCsairApp */])() && window.CSNativeObject.getOSType() === 'harmony' ? // || /Harmony/i.test(navigator.userAgent)
              { hmChannel: 'hm' } : {}, navigator.userAgent.toLowerCase().includes('toutiaomicroapp') ? { dyChannel: 'DY' } : {}, {
                orderChannel: Object(__WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__["C" /* isCsairApp */])() ? 'App' : 'Mobile'
              }, ismu ? { isCeAirline: '1' } : {}, payXSOOrderUppReq ? { payXSOOrderUppReq: payXSOOrderUppReq } : {}, orderingSite === 'appos' || urlAppos ? { orderingSite: 'appos' } : {}, {
                wxChannel: window.__wxjs_environment && window.__wxjs_environment === 'miniprogram' ? '1' : '0'
              })));

            case 13:
              _ref2 = _context.sent;
              _ref2$payload$data = _ref2.payload.data;
              errorInfo = _ref2$payload$data.errorInfo;
              token = _ref2$payload$data.token;
              merAppId = _ref2$payload$data.merAppId;
              merId = _ref2$payload$data.merId;
              version = _ref2$payload$data.version;
              language = _ref2$payload$data.language;
              callBackSuccessDto = _ref2$payload$data.callBackSuccessDto;

              if (!errorInfo) {
                _context.next = 25;
                break;
              }

              fail(errorInfo);
              return _context.abrupt('return', false);

            case 25:
              if (!callBackSuccessDto) {
                _context.next = 28;
                break;
              }

              window.location.href = "https://emp.csair.com/" + 'ticketRefund/#/ticket/ReformProcess?orderNo=' + (changeNo.indexOf('ES') !== -1 && bigOrderNo ? bigOrderNo : changeNo) + '&orderType=S';
              return _context.abrupt('return', false);

            case 28:
              isEN = window.sessionStorage.getItem('language') == 'en';

              Object(__WEBPACK_IMPORTED_MODULE_4_Utils__["submitPay"])(Object.assign({
                token: token,
                merAppId: merAppId,
                merId: merId,
                version: version,
                DYurl: DYurl
              }, isEN ? { language: 'en_US' } : { language: language }));

            case 30:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/**
 * @description 获取小程序增值开关配置
 */
function getExtraConfig() {
  return {
    type: 'GET_EXTRA_CONFIG',
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].commonSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_APPLET_CASHIER'
        }
      }
    }
  };
}

/**
 * @description 微信小程序支付
 * @param {string} changeNo
 * @param {func} fail 报错回调函数
 * @param {bool} load 获取详情单是否开启load加载框， 默认false
 */
function wechat_pay(changeNo, fail, cost) {
  var _this2 = this;

  var load = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var bigOrderNo = arguments[4];

  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var _ref4, data, time, _data$insuranceDetail, insuranceDetailList, _data$changePrice, changePrice, _data$base, base, insuranceMoney, payMoney, url, _ref5, _ref5$payload, payload, orderType, cancelPayUrl;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__routes_reformProcess_modules_actions__["f" /* getChangeDetail */])({
                changeNo: bigOrderNo ? bigOrderNo : changeNo
              }, load));

            case 2:
              _ref4 = _context2.sent;
              data = _ref4.payload.data;

              if (!data.errorInfo) {
                _context2.next = 7;
                break;
              }

              fail(data.errorInfo);
              return _context2.abrupt('return', false);

            case 7:
              if (!(wx && wx.miniProgram)) {
                _context2.next = 30;
                break;
              }

              // const time =
              //   moment(data.progressBar.dealtime)
              //     .add(40, 'minutes')
              //     .unix() - moment().unix();
              // if (time < 0) {
              //   alert('支付超时');
              //   return false;
              // }
              time = data.progressBar.payDiffTime;

              if (!data.progressBar.paymentTimeout) {
                _context2.next = 12;
                break;
              }

              alert('支付超时');
              return _context2.abrupt('return', false);

            case 12:
              _data$insuranceDetail = data.insuranceDetailList, insuranceDetailList = _data$insuranceDetail === undefined ? [] : _data$insuranceDetail, _data$changePrice = data.changePrice, changePrice = _data$changePrice === undefined ? {} : _data$changePrice, _data$base = data.base, base = _data$base === undefined ? {} : _data$base;
              insuranceMoney = insuranceDetailList.reduce(function (sum, cur) {
                return sum + cur.orderPrice;
              }, 0) || 0;
              payMoney = changePrice.totalPayMoney + insuranceMoney;
              url = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_Url__["default"].payCallBackUrl + '?orderNo=' + (bigOrderNo ? bigOrderNo : data.changeNo) + '&payMoney=' + payMoney);

              //小程序端，订单中包含保险，且支付金额不为0, 调增值的收银台

              if (!(insuranceDetailList.length && payMoney > 0)) {
                _context2.next = 27;
                break;
              }

              _context2.next = 19;
              return dispatch(getExtraConfig());

            case 19:
              _ref5 = _context2.sent;
              _ref5$payload = _ref5.payload;
              payload = _ref5$payload === undefined ? {} : _ref5$payload;

              if (!(payload.data && payload.data.isOpen && payload.data.isOpen === 'Y')) {
                _context2.next = 27;
                break;
              }

              orderType = data.changeNo.includes('S') || data.changeNo.includes('GO') ? 'S' : 'T';
              cancelPayUrl = encodeURIComponent("https://emp.csair.com/" + 'ticketRefund/#/ticket/ReformProcess?orderNo=' + (bigOrderNo ? bigOrderNo : data.changeNo) + '&orderType=' + orderType + '&channel=wxopen');

              wx.miniProgram.navigateTo({
                url: '/page/jump?action=extraPayPage&globalNo=' + base.globalNo + '&payCallbackUrl=' + url + '&isUseTooken=Y&buyerId=' + base.submitUserId + '&cancelPayUrl=' + cancelPayUrl
              });
              return _context2.abrupt('return', false);

            case 27:

              wx.miniProgram.navigateTo({
                url: '/page/jump?action=unifiedPay&external=refund&orderNo=' + (bigOrderNo ? bigOrderNo : data.changeNo) + '&amount=' + data.changePrice.totalPayMoney.toFixed(1) + '&countdown=' + time + '&successPage=' + url + '&changeType=' + (data.base.changeType === 'E' ? 'e2e' : 's')
              });
              _context2.next = 31;
              break;

            case 30:
              alert('支付异常');

            case 31:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/**
 * @description 统一支付，区分渠道调用不同支付方式
 */
function unitePay() {
  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return function (dispatch, getState) {
    // if (
    //   window.__wxjs_environment &&
    //   window.__wxjs_environment === 'miniprogram' &&
    //   !params[6] &&
    //   !params[7]
    // ) {
    //   !wx && createWechatSdk();
    //   dispatch(wechat_pay(...params));
    // } else {
    dispatch(h5_pay.apply(undefined, params));
    // }
  };
}

/**
 * @description 取消变更单
 */
function cancleChangePay(data) {
  return {
    type: CANCLE_CHANGE_PAY,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].cancleChangePayIn,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 取消OO变更单
 */
function cancleChangeOOPay(data) {
  return {
    type: CANCLE_CHANGE_PAY,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].cancleChangeOOPayIn,
        method: 'post',
        data: data
      }
    }
  };
}

// 检验抽奖器入口
function checkLuckDrawEntry(order) {
  var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: CHECK_LUCK_DRAW_ENTRY,
    closeLoading: bool,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].checkLuckDrawEntry + '?' + new Date().getTime(),
        method: 'post',
        data: order
      }
    }
  };
}

// 支付里程
function payMileage(data) {
  return {
    type: PAY_MILEAGE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].exchangePayMileage,
        method: 'post',
        data: data
      }
    }
  };
}
// 里程验证
function verifyMileage(data) {
  return {
    type: VERIFY_MILEAGE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].checkSvcFfpMemberPwd,
        method: 'post',
        data: data
      }
    }
  };
}

// 验证支付里程
function mileageProcess(changeNo, success, fail, isGo, goFail) {
  var _this3 = this;

  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var _ref7, _ref7$payload$data, payPassWord, result, _ref8, _ref8$payload$data, responseCode, responseMessage, errorCode, message;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(verifyMileage({
                passWord: Object(__WEBPACK_IMPORTED_MODULE_4_Utils__["encrypt"])(document.getElementById('mileage-pwd').value),
                changeNo: changeNo
              }));

            case 2:
              _ref7 = _context3.sent;
              _ref7$payload$data = _ref7.payload.data;
              payPassWord = _ref7$payload$data.payPassWord;
              result = _ref7$payload$data.result;

              if (!(payPassWord !== 'Y')) {
                _context3.next = 9;
                break;
              }

              if (payPassWord === 'N') {
                if (result.indexOf('N/24小时内剩余错误次数') !== -1) fail('密码错误，请重新输入');
                if (result.indexOf('N/验密错误次数超过限制') !== -1) fail('您的账号已经被锁定，请稍后重新输入');
              } else {
                fail('密码错误，请重新输入');
              }
              return _context3.abrupt('return', false);

            case 9:
              if (!isGo) {
                _context3.next = 14;
                break;
              }

              _context3.next = 12;
              return dispatch(unitePay(changeNo, goFail, false, '', '', false, false, true));

            case 12:
              _context3.next = 26;
              break;

            case 14:
              _context3.next = 16;
              return dispatch(payMileage({
                changeNo: changeNo
              }));

            case 16:
              _ref8 = _context3.sent;
              _ref8$payload$data = _ref8.payload.data;
              responseCode = _ref8$payload$data.responseCode;
              responseMessage = _ref8$payload$data.responseMessage;
              errorCode = _ref8$payload$data.errorCode;
              message = _ref8$payload$data.message;

              if (!(errorCode || responseCode !== '00')) {
                _context3.next = 25;
                break;
              }

              fail(responseMessage || message);
              return _context3.abrupt('return', false);

            case 25:
              if (responseCode === '00') {
                success();
              }

            case 26:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function getCountryData() {
  return {
    type: GET_COUNTRY_DATA,
    payload: {
      request: {
        url: '/public/country.json',
        method: 'get'
      }
    }
  };
}

function readCookieSetUserInfo() {
  return {
    type: READ_COOIKE_USERINFO,
    data: Object(__WEBPACK_IMPORTED_MODULE_6__csair_emp_helpers__["m" /* getCookieUserInfo */])()
  };
}

function getPassageMemberLevel(data) {
  return {
    type: GET_PASSAGEMEMBER_LEVEL,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].getPassageMemberLevel,
        method: 'post',
        data: data
      }
    }
  };
}

function createNpsQnrDetail(data) {
  return {
    type: CREATE_NPSQNR_DETAIL,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].createNpsQnrDetail,
        method: 'post',
        data: data
      }
    }
  };
}

function searchNpsUrl(data) {
  return {
    type: CREATE_FDB_URL,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].searchNpsUrl,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 获取里程字段开关
 */
function getMileageSwitch() {
  return {
    type: GET_MILEAGE_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_SWITHC_INTEGRAL'
        }
      }
    }
  };
}

/**
 * @description 获取服务列表开关
 */
function getMenuList() {
  return {
    type: GET_MENU_LIST,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].getMenuList,
        method: 'post',
        data: {}
      }
    }
  };
}

function getAdInfo(data) {
  return {
    type: GET_AD_INFO,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].getAdInfo,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 获取广告字段开关
 */
function getAdSwitch() {
  return {
    type: GET_AD_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'CHANGE_ADVERTISEMENT_SWITCH'
        }
      }
    }
  };
}
function getMoreQuerySwitch(val) {
  return {
    type: GET_MOREQUERY_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: val
        }
      }
    }
  };
}
function getAllSwitch(val) {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].memberAllSwitch,
        method: 'post',
        data: {
          switchKeys: val
        }
      }
    }
  };
}

function getcustomerUrlSwitch() {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_2_Url__["default"].customerUrlSwitchOn,
        method: 'post',
        data: {}
      }
    }
  };
}

/***/ }),

/***/ "1Yb9":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "1nw6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("5+O3");
var getIteratorMethod = __webpack_require__("URKv");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "1rEs":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("q0qZ");
var IE8_DOM_DEFINE = __webpack_require__("K6eN");
var anObject = __webpack_require__("5+O3");
var toPrimitive = __webpack_require__("whWw");
var nativeDefineProperty = Object.defineProperty;

exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "22B7":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "2Hvv":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "2KeS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(16);

/***/ }),

/***/ "2S96":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("odTk");
var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var speciesConstructor = __webpack_require__("Xfp1");
var iterate = __webpack_require__("UHV6");
var Set = path.Set;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  union: function union(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, Set))(set);
    iterate(iterable, aFunction(newSet.add), newSet);
    return newSet;
  }
});


/***/ }),

/***/ "2X2u":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "2gEL":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),

/***/ "2s00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_CHANGE_DETAIL */
/* unused harmony export GET_FEFUNDORDER_DETAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_SUBINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_REFUNDINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ELE_INVOICE; });
/* unused harmony export GET_RESERVE_NEW_SEAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_RESERVE_NEW_SEAT; });
/* unused harmony export QUERY_REFUNDEXTENNDDETAIL */
/* unused harmony export GET_SCHEME */
/* unused harmony export GET_FILELIST */
/* unused harmony export GET_REFUND_FEE */
/* unused harmony export RESET_SUBMIT_REASON */
/* unused harmony export DOWN_LOAD_FILE */
/* harmony export (immutable) */ __webpack_exports__["f"] = getChangeDetail;
/* harmony export (immutable) */ __webpack_exports__["g"] = getEleInvoice;
/* harmony export (immutable) */ __webpack_exports__["o"] = saveSubInfo;
/* harmony export (immutable) */ __webpack_exports__["i"] = getRefundOrderDetail;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveRefundInfo;
/* harmony export (immutable) */ __webpack_exports__["j"] = getReserveNewSeat;
/* harmony export (immutable) */ __webpack_exports__["n"] = saveReserveNewSeat;
/* unused harmony export queryRefundExtendDetail */
/* harmony export (immutable) */ __webpack_exports__["k"] = getScheme;
/* harmony export (immutable) */ __webpack_exports__["p"] = searchRefundAttachment;
/* harmony export (immutable) */ __webpack_exports__["q"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = getRefundFee;
/* harmony export (immutable) */ __webpack_exports__["l"] = resetSubmitReason;
/* harmony export (immutable) */ __webpack_exports__["e"] = downloadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var GET_CHANGE_DETAIL = 'GET_CHANGE_DETAIL';
var GET_FEFUNDORDER_DETAIL = 'GET_FEFUNDORDER_DETAIL';
var SAVE_SUBINFO = 'SAVE_SUBINFO';
var SAVE_REFUNDINFO = 'SAVE_REFUNDINFO';
var GET_ELE_INVOICE = 'GET_ELE_INVOICE';
var GET_RESERVE_NEW_SEAT = 'GET_RESERVE_NEW_SEAT';
var SAVE_RESERVE_NEW_SEAT = 'SAVE_RESERVE_NEW_SEAT';
var QUERY_REFUNDEXTENNDDETAIL = 'QUERY_REFUNDEXTENNDDETAIL';
var GET_SCHEME = 'GET_SCHEME';
var GET_FILELIST = 'GET_FILELIST';
var GET_REFUND_FEE = 'GET_REFUND_FEE';
var RESET_SUBMIT_REASON = 'RESET_SUBMIT_REASON';
var DOWN_LOAD_FILE = 'DOWNLOAD_FILE';

function getChangeDetail(data, load) {
  return {
    type: GET_CHANGE_DETAIL,
    closeLoading: load,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleChangeReqDetail,
        method: 'post',
        data: data
      }
    }
  };
}
//电子发票详情
function getEleInvoice(data) {
  return {
    type: GET_ELE_INVOICE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getPrintableTickets,
        method: 'post',
        data: data
      }
    }
  };
}

function saveSubInfo(data) {
  return { type: SAVE_SUBINFO, data: data };
}

function getRefundOrderDetail(data) {
  return {
    type: GET_FEFUNDORDER_DETAIL,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterGetRefundOrderDetail,
        method: 'post',
        data: data
      }
    }
  };
}

function saveRefundInfo(data) {
  return { type: SAVE_REFUNDINFO, data: data };
}

function getReserveNewSeat(data) {
  return {
    type: GET_RESERVE_NEW_SEAT,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].reserveNewSeat,
        method: 'post',
        data: data
      }
    }
  };
}

function saveReserveNewSeat(data) {
  return { type: SAVE_RESERVE_NEW_SEAT, data: data };
}

function queryRefundExtendDetail(data) {
  return {
    type: QUERY_REFUNDEXTENNDDETAIL,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryRefundExtendDetail,
        method: 'post',
        data: data
      }
    }
  };
}

function getScheme(data) {
  return {
    type: GET_SCHEME,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getScheme,
        method: 'post',
        data: data
      }
    }
  };
}

function searchRefundAttachment(data) {
  return {
    type: GET_FILELIST,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].searchRefundAttachment + '?refundNo=' + data.refundNo,
        method: 'post',
        data: data
      }
    }
  };
}
function uploadFile(data) {
  return {
    type: GET_FILELIST,
    payload: {
      request: {
        // url: urlConfig.uploadRCattachment,
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].updateFileList,
        method: 'post',
        data: data,
        processData: false,
        contentType: false
      }
    }
  };
}

function getRefundFee(data) {
  return {
    type: GET_REFUND_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleRefundFee,
        method: 'post',
        data: data
      }
    }
  };
}
function resetSubmitReason(data) {
  return {
    type: RESET_SUBMIT_REASON,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].resetSubmitReason,
        method: 'post',
        data: data
      }
    }
  };
}

function downloadFile(data) {
  return {
    type: DOWN_LOAD_FILE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].downloadFile,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "3Cgm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "3Nrx":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("HAas");
var setPrototypeOf = __webpack_require__("jE8y");

module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "3mz+":
/***/ (function(module, exports, __webpack_require__) {

var DOMIterables = __webpack_require__("PedI");
var ArrayIteratorMethods = __webpack_require__("a/rO");
var global = __webpack_require__("hcE8");
var hide = __webpack_require__("wkr2");
var wellKnownSymbol = __webpack_require__("jAiL");
var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      hide(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (e) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        hide(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (e) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "40wi":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("mWhC");
var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "42xy":
/***/ (function(module, exports) {

/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

module.exports = stubTrue;


/***/ }),

/***/ "43zn":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("5+O3");
var defineProperties = __webpack_require__("o/tC");
var enumBugKeys = __webpack_require__("YveC");
var html = __webpack_require__("N5RP");
var documentCreateElement = __webpack_require__("P1fK");
var IE_PROTO = __webpack_require__("siPu")('IE_PROTO');
var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

__webpack_require__("Eb96")[IE_PROTO] = true;


/***/ }),

/***/ "4VPq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcDialog = __webpack_require__("04KZ");

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _createReactClass = __webpack_require__("DT0+");

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _PopupMixin = __webpack_require__("13I+");

var _PopupMixin2 = _interopRequireDefault(_PopupMixin);

var _rcTouchable = __webpack_require__("zMcl");

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupPicker = (0, _createReactClass2['default'])({
  mixins: [_PopupMixin2['default']],
  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rmc-picker-popup',
      triggerType: 'onClick',
      WrapComponent: 'span'
    };
  },
  getModal: function getModal() {
    var props = this.props;
    if (!this.state.visible) {
      return null;
    }
    var prefixCls = props.prefixCls;

    return _react2['default'].createElement(
      _rcDialog2['default'],
      { prefixCls: '' + prefixCls, className: props.className || '', visible: true, closable: false, transitionName: props.transitionName || props.popupTransitionName, maskTransitionName: props.maskTransitionName, onClose: this.hide, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement(
            _rcTouchable2['default'],
            { activeClassName: prefixCls + '-item-active' },
            _react2['default'].createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-left', onClick: this.onDismiss },
              props.dismissText
            )
          ),
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-item ' + prefixCls + '-title' },
            props.title
          ),
          _react2['default'].createElement(
            _rcTouchable2['default'],
            { activeClassName: prefixCls + '-item-active' },
            _react2['default'].createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-right', onClick: this.onOk },
              props.okText
            )
          )
        ),
        this.getContent()
      )
    );
  },
  render: function render() {
    return this.getRender();
  }
});
exports['default'] = PopupPicker;
module.exports = exports['default'];

/***/ }),

/***/ "5+O3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("HAas");

module.exports = function (it) {
  if (!isObject(it)) throw TypeError(String(it) + ' is not an object!');
  return it;
};


/***/ }),

/***/ "5Zxu":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "5d6Q":
/***/ (function(module, exports, __webpack_require__) {

// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("BGSR")('Set');


/***/ }),

/***/ "6//X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _arrayTreeFilter = __webpack_require__("C9Ci");

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

var _MultiPicker = __webpack_require__("RmFE");

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__("fu9N");

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Cascader = function (_React$Component) {
    (0, _inherits3['default'])(Cascader, _React$Component);

    function Cascader() {
        (0, _classCallCheck3['default'])(this, Cascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).apply(this, arguments));

        _this.state = {
            value: _this.getValue(_this.props.data, _this.props.defaultValue || _this.props.value)
        };
        _this.onValueChange = function (value, index) {
            var children = (0, _arrayTreeFilter2['default'])(_this.props.data, function (c, level) {
                return level <= index && c.value === value[level];
            });
            var data = children[index];
            var i = void 0;
            for (i = index + 1; data && data.children && data.children.length && i < _this.props.cols; i++) {
                data = data.children[0];
                value[i] = data.value;
            }
            value.length = i;
            if (!('value' in _this.props)) {
                _this.setState({
                    value: value
                });
            }
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Cascader, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: this.getValue(nextProps.data, nextProps.value)
                });
            }
        }
    }, {
        key: 'getValue',
        value: function getValue(d, val) {
            var data = d || this.props.data;
            var value = val || this.props.value || this.props.defaultValue;
            if (!value || !value.length) {
                value = [];
                for (var i = 0; i < this.props.cols; i++) {
                    if (data && data.length) {
                        value[i] = data[0].value;
                        data = data[0].children;
                    }
                }
            }
            return value;
        }
    }, {
        key: 'getCols',
        value: function getCols() {
            var _props = this.props,
                data = _props.data,
                cols = _props.cols,
                pickerPrefixCls = _props.pickerPrefixCls,
                disabled = _props.disabled,
                pickerItemStyle = _props.pickerItemStyle,
                indicatorStyle = _props.indicatorStyle;

            var value = this.state.value;
            var childrenTree = (0, _arrayTreeFilter2['default'])(data, function (c, level) {
                return c.value === value[level];
            }).map(function (c) {
                return c.children;
            });
            // in case the users data is async get when select change
            var needPad = cols - childrenTree.length;
            if (needPad > 0) {
                for (var i = 0; i < needPad; i++) {
                    childrenTree.push([]);
                }
            }
            childrenTree.length = cols - 1;
            childrenTree.unshift(data);
            return childrenTree.map(function () {
                var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var level = arguments[1];
                return _react2['default'].createElement(_Picker2['default'], { key: level, prefixCls: pickerPrefixCls, style: { flex: 1 }, disabled: disabled, indicatorStyle: indicatorStyle, pickerItemStyle: pickerItemStyle }, children.map(function (item) {
                    return _react2['default'].createElement(_Picker2['default'].Item, { value: item.value, key: item.value }, item.label);
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                className = props.className,
                rootNativeProps = props.rootNativeProps,
                style = props.style;

            var cols = this.getCols();
            var multiStyle = (0, _extends3['default'])({ flexDirection: 'row', alignItems: 'center' }, style);
            return _react2['default'].createElement(_MultiPicker2['default'], { style: multiStyle, prefixCls: prefixCls, className: className, selectedValue: this.state.value, rootNativeProps: rootNativeProps, onValueChange: this.onValueChange }, cols);
        }
    }]);
    return Cascader;
}(_react2['default'].Component);

Cascader.defaultProps = {
    cols: 3,
    prefixCls: 'rmc-cascader',
    pickerPrefixCls: 'rmc-picker',
    data: [],
    disabled: false
};
exports['default'] = Cascader;
module.exports = exports['default'];

/***/ }),

/***/ "6MiT":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "6TdU":
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__("FNvM");

/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = createRelationalOperation(function(value, other) {
  return value >= other;
});

module.exports = gte;


/***/ }),

/***/ "6lrk":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("hbAh"),
    getMatchData = __webpack_require__("16tV");

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseIsMatch(object, source, getMatchData(source), customizer);
}

module.exports = isMatchWith;


/***/ }),

/***/ "7Qw4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("odTk");
var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var speciesConstructor = __webpack_require__("Xfp1");
var iterate = __webpack_require__("UHV6");
var Set = path.Set;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  difference: function difference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, Set))(set);
    var remover = aFunction(newSet['delete']);
    iterate(iterable, function (value) {
      remover.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "7YkW":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("NGEn");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "7j3q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollBarSize;
var cached;

function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

/***/ }),

/***/ "7y91":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Input = function (_React$Component) {
    (0, _inherits3['default'])(Input, _React$Component);

    function Input(props) {
        (0, _classCallCheck3['default'])(this, Input);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

        _this.onInputBlur = function (e) {
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: false
                });
            }
            var value = e.target.value;
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onInputFocus = function (e) {
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: true
                });
            }
            var value = e.target.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.focus = function () {
            _this.refs.input.focus();
        };
        _this.state = {
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(Input, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('focused' in nextProps) {
                this.setState({
                    focused: nextProps.focused
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if ((this.props.autoFocus || this.state.focused) && navigator.userAgent.indexOf('AlipayClient') > 0) {
                this.refs.input.focus();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.focused) {
                this.refs.input.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var otherProps = (0, _omit2['default'])(this.props, ['onBlur', 'onFocus', 'focused', 'autoFocus']);
            return _react2['default'].createElement('input', (0, _extends3['default'])({ ref: 'input', onBlur: this.onInputBlur, onFocus: this.onInputFocus }, otherProps));
        }
    }]);
    return Input;
}(_react2['default'].Component);

exports['default'] = Input;
module.exports = exports['default'];

/***/ }),

/***/ "8/eq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = __webpack_require__("dliL")('Set', function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, __webpack_require__("V+c1"));


/***/ }),

/***/ "8Lhr":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("5Zxu");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "8o2t":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("pzR0");
var getIterator = __webpack_require__("1nw6");

module.exports = function (it) {
  // eslint-disable-next-line no-undef
  return IS_PURE ? getIterator(it) : Map.prototype.entries.call(it);
};


/***/ }),

/***/ "9+GO":
/***/ (function(module, exports, __webpack_require__) {

// Chrome 38 Symbol has incorrect toString conversion
module.exports = !__webpack_require__("r54x")(function () {
  // eslint-disable-next-line no-undef
  String(Symbol());
});


/***/ }),

/***/ "9UkZ":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    getPrototype = __webpack_require__("vi0E"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "9VpW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");

// `Set.prototype.addAll` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  addAll: function addAll(/* ...elements */) {
    var set = anObject(this);
    var adder = aFunction(set.add);
    for (var k = 0, len = arguments.length; k < len; k++) {
      adder.call(set, arguments[k]);
    }
    return set;
  }
});


/***/ }),

/***/ "9mDF":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("fkET");
var requireObjectCoercible = __webpack_require__("hiy0");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "A2uy":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("9mDF");
var toLength = __webpack_require__("xDUa");
var toAbsoluteIndex = __webpack_require__("40wi");

// `Array.prototype.{ indexOf, includes }` methods implementation
// false -> Array#indexOf
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
// true  -> Array#includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "A7EC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var iterate = __webpack_require__("UHV6");

// `Map.prototype.merge` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  merge: function merge(iterable) {
    var map = anObject(this);
    iterate(iterable, aFunction(map.set), map, true);
    return map;
  }
});


/***/ }),

/***/ "AMIE":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("l/2K");
var toIndexedObject = __webpack_require__("9mDF");
var arrayIndexOf = __webpack_require__("A2uy")(false);
var hiddenKeys = __webpack_require__("Eb96");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "AaNf":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

module.exports = baseIsArrayBuffer;


/***/ }),

/***/ "AyKp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(273);

/***/ }),

/***/ "B1Xl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var iterate = __webpack_require__("UHV6");

// `Map.groupBy` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', stat: true, forced: __webpack_require__("pzR0") }, {
  groupBy: function groupBy(iterable, keyDerivative) {
    var newMap = new this();
    iterate(iterable, function (element) {
      var derivedKey = keyDerivative(element);
      if (!newMap.has(derivedKey)) newMap.set(derivedKey, [element]);
      else newMap.get(derivedKey).push(element);
    });
    return newMap;
  }
});


/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(13);

/***/ }),

/***/ "BGSR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("i9tX");

module.exports = function (COLLECTION) {
  $export({ target: COLLECTION, stat: true }, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "BGpQ":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("pzR0");
var getIterator = __webpack_require__("1nw6");

module.exports = function (it) {
  // eslint-disable-next-line no-undef
  return IS_PURE ? getIterator(it) : Set.prototype.values.call(it);
};


/***/ }),

/***/ "BUS2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2025
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node && process.type != 'renderer';
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__("nErl");
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };

  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };

  var nodeWrap = function (method, is224) {
    var crypto = __webpack_require__(1)
    var Buffer = __webpack_require__(2).Buffer;
    var algorithm = is224 ? 'sha224' : 'sha256';
    var bufferFrom;
    if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) {
      bufferFrom = Buffer.from;
    } else {
      bufferFrom = function (message) {
        return new Buffer(message);
      };
    }
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };

  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else { // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }

  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >>> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >>> 2] |= (0xc0 | (code >>> 6)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >>> 2] |= (0xe0 | (code >>> 12)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | ((code >>> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >>> 2] |= (0xf0 | (code >>> 18)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | ((code >>> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | ((code >>> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >>> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >>> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha256.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;

    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
      t1 = blocks[j - 2];
      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }

    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        ab = a & b;
        maj = ab ^ (a & c) ^ bc;
        ch = (e & f) ^ (~e & g);
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
      da = d & a;
      maj = da ^ (d & b) ^ ab;
      ch = (h & e) ^ (~h & f);
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
      cd = c & d;
      maj = cd ^ (c & a) ^ da;
      ch = (g & h) ^ (~g & e);
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
      bc = b & c;
      maj = bc ^ (b & d) ^ cd;
      ch = (f & g) ^ (~f & h);
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
      this.chromeBugWorkAround = true;
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };

  Sha256.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var hex = HEX_CHARS[(h0 >>> 28) & 0x0F] + HEX_CHARS[(h0 >>> 24) & 0x0F] +
      HEX_CHARS[(h0 >>> 20) & 0x0F] + HEX_CHARS[(h0 >>> 16) & 0x0F] +
      HEX_CHARS[(h0 >>> 12) & 0x0F] + HEX_CHARS[(h0 >>> 8) & 0x0F] +
      HEX_CHARS[(h0 >>> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h1 >>> 28) & 0x0F] + HEX_CHARS[(h1 >>> 24) & 0x0F] +
      HEX_CHARS[(h1 >>> 20) & 0x0F] + HEX_CHARS[(h1 >>> 16) & 0x0F] +
      HEX_CHARS[(h1 >>> 12) & 0x0F] + HEX_CHARS[(h1 >>> 8) & 0x0F] +
      HEX_CHARS[(h1 >>> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h2 >>> 28) & 0x0F] + HEX_CHARS[(h2 >>> 24) & 0x0F] +
      HEX_CHARS[(h2 >>> 20) & 0x0F] + HEX_CHARS[(h2 >>> 16) & 0x0F] +
      HEX_CHARS[(h2 >>> 12) & 0x0F] + HEX_CHARS[(h2 >>> 8) & 0x0F] +
      HEX_CHARS[(h2 >>> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h3 >>> 28) & 0x0F] + HEX_CHARS[(h3 >>> 24) & 0x0F] +
      HEX_CHARS[(h3 >>> 20) & 0x0F] + HEX_CHARS[(h3 >>> 16) & 0x0F] +
      HEX_CHARS[(h3 >>> 12) & 0x0F] + HEX_CHARS[(h3 >>> 8) & 0x0F] +
      HEX_CHARS[(h3 >>> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h4 >>> 28) & 0x0F] + HEX_CHARS[(h4 >>> 24) & 0x0F] +
      HEX_CHARS[(h4 >>> 20) & 0x0F] + HEX_CHARS[(h4 >>> 16) & 0x0F] +
      HEX_CHARS[(h4 >>> 12) & 0x0F] + HEX_CHARS[(h4 >>> 8) & 0x0F] +
      HEX_CHARS[(h4 >>> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
      HEX_CHARS[(h5 >>> 28) & 0x0F] + HEX_CHARS[(h5 >>> 24) & 0x0F] +
      HEX_CHARS[(h5 >>> 20) & 0x0F] + HEX_CHARS[(h5 >>> 16) & 0x0F] +
      HEX_CHARS[(h5 >>> 12) & 0x0F] + HEX_CHARS[(h5 >>> 8) & 0x0F] +
      HEX_CHARS[(h5 >>> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
      HEX_CHARS[(h6 >>> 28) & 0x0F] + HEX_CHARS[(h6 >>> 24) & 0x0F] +
      HEX_CHARS[(h6 >>> 20) & 0x0F] + HEX_CHARS[(h6 >>> 16) & 0x0F] +
      HEX_CHARS[(h6 >>> 12) & 0x0F] + HEX_CHARS[(h6 >>> 8) & 0x0F] +
      HEX_CHARS[(h6 >>> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[(h7 >>> 28) & 0x0F] + HEX_CHARS[(h7 >>> 24) & 0x0F] +
        HEX_CHARS[(h7 >>> 20) & 0x0F] + HEX_CHARS[(h7 >>> 16) & 0x0F] +
        HEX_CHARS[(h7 >>> 12) & 0x0F] + HEX_CHARS[(h7 >>> 8) & 0x0F] +
        HEX_CHARS[(h7 >>> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };

  Sha256.prototype.toString = Sha256.prototype.hex;

  Sha256.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var arr = [
      (h0 >>> 24) & 0xFF, (h0 >>> 16) & 0xFF, (h0 >>> 8) & 0xFF, h0 & 0xFF,
      (h1 >>> 24) & 0xFF, (h1 >>> 16) & 0xFF, (h1 >>> 8) & 0xFF, h1 & 0xFF,
      (h2 >>> 24) & 0xFF, (h2 >>> 16) & 0xFF, (h2 >>> 8) & 0xFF, h2 & 0xFF,
      (h3 >>> 24) & 0xFF, (h3 >>> 16) & 0xFF, (h3 >>> 8) & 0xFF, h3 & 0xFF,
      (h4 >>> 24) & 0xFF, (h4 >>> 16) & 0xFF, (h4 >>> 8) & 0xFF, h4 & 0xFF,
      (h5 >>> 24) & 0xFF, (h5 >>> 16) & 0xFF, (h5 >>> 8) & 0xFF, h5 & 0xFF,
      (h6 >>> 24) & 0xFF, (h6 >>> 16) & 0xFF, (h6 >>> 8) & 0xFF, h6 & 0xFF
    ];
    if (!this.is224) {
      arr.push((h7 >>> 24) & 0xFF, (h7 >>> 16) & 0xFF, (h7 >>> 8) & 0xFF, h7 & 0xFF);
    }
    return arr;
  };

  Sha256.prototype.array = Sha256.prototype.digest;

  Sha256.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };

  function HmacSha256(key, is224, sharedMemory) {
    var i, type = typeof key;
    if (type === 'string') {
      var bytes = [], length = key.length, index = 0, code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >>> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >>> 12));
          bytes[index++] = (0x80 | ((code >>> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >>> 18));
          bytes[index++] = (0x80 | ((code >>> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >>> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }

    if (key.length > 64) {
      key = (new Sha256(is224, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha256.call(this, is224, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();

  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };

  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return exports;
      }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU"), __webpack_require__("DuR2")))

/***/ }),

/***/ "Bbjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_COST; });
/* unused harmony export GET_REFUND_FEE */
/* unused harmony export SUBMIT_CHANGE_APPLY */
/* unused harmony export SUBMIT_VOLCHANGE_APPLY */
/* unused harmony export SUBMIT_REFUND_APPLY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_NAME_PHONE; });
/* unused harmony export CHECK_CODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_REFUND_WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_REFUND_WAY; });
/* unused harmony export GET_VERIFICATION */
/* unused harmony export CHECK_VERIFICATION_CODE */
/* unused harmony export SHOW_EIENTRANCE */
/* unused harmony export GET_REFUND_RULES */
/* unused harmony export CREATE_E2E_CHANGE */
/* unused harmony export CREATE_MU_CHANGE */
/* unused harmony export CREATE_GP_CHANGE */
/* unused harmony export SUMBIT_CHANGE_ADDPSGSINFO */
/* unused harmony export CHECK_ISNEEDPSGINFO */
/* unused harmony export CHECK_PNRDOCS */
/* unused harmony export GET_INSURANCEC_CHANGE */
/* unused harmony export GREEN_FLIGHT_SERVE */
/* unused harmony export IS_GREEN_SWITCHON */
/* unused harmony export GET_PACKAGE_DATE */
/* unused harmony export GET_ENCRYP_FLIGHTS */
/* unused harmony export GET_OVERTIME_B */
/* unused harmony export GET_CIVIL_SWITCH */
/* unused harmony export GET_PHONEAREA_CODE */
/* unused harmony export GET_ALL_SWITCH */
/* unused harmony export GET_AREA_CODE */
/* unused harmony export MU_CONTACT_INFO */
/* harmony export (immutable) */ __webpack_exports__["j"] = createGPChange;
/* harmony export (immutable) */ __webpack_exports__["h"] = clearCost;
/* harmony export (immutable) */ __webpack_exports__["i"] = createE2EChange;
/* harmony export (immutable) */ __webpack_exports__["k"] = createMuChange;
/* harmony export (immutable) */ __webpack_exports__["y"] = submitApply;
/* harmony export (immutable) */ __webpack_exports__["z"] = submitChangeAddPsgsInfoApply;
/* harmony export (immutable) */ __webpack_exports__["g"] = checkIsNeedPsgsInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = checkIsNeedPNRPsgsInfo;
/* unused harmony export submitApplyRefund */
/* unused harmony export getRefundFee */
/* unused harmony export getRefundRules */
/* harmony export (immutable) */ __webpack_exports__["w"] = saveCost;
/* harmony export (immutable) */ __webpack_exports__["q"] = getNameAndPhone;
/* harmony export (immutable) */ __webpack_exports__["t"] = getVerification;
/* unused harmony export checkVerificationCode */
/* unused harmony export saveRefundWay */
/* unused harmony export getRefundWay */
/* harmony export (immutable) */ __webpack_exports__["x"] = showEiEntrance;
/* harmony export (immutable) */ __webpack_exports__["p"] = getInsurancecChange;
/* harmony export (immutable) */ __webpack_exports__["u"] = greenFlightServe;
/* harmony export (immutable) */ __webpack_exports__["v"] = isGreenSwitchOn;
/* harmony export (immutable) */ __webpack_exports__["s"] = getPackageDate;
/* harmony export (immutable) */ __webpack_exports__["o"] = getEncrypFlights;
/* harmony export (immutable) */ __webpack_exports__["r"] = getOverTime_B;
/* harmony export (immutable) */ __webpack_exports__["n"] = getCivilSwitch;
/* unused harmony export getPhoneAreaCode */
/* harmony export (immutable) */ __webpack_exports__["l"] = getAllSwitch;
/* harmony export (immutable) */ __webpack_exports__["m"] = getAreaCodeList;
/* unused harmony export muContactInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var CLEAR_COST = 'CLEAR_COST';
var SAVE_COST = 'SAVE_COST';
var GET_REFUND_FEE = 'GET_REFUND_FEE';
var SUBMIT_CHANGE_APPLY = 'SUBMIT_CHANGE_APPLY';
var SUBMIT_VOLCHANGE_APPLY = 'SUBMIT_VOLCHANGE_APPLY';
var SUBMIT_REFUND_APPLY = 'SUBMIT_REFUND_APPLY';
var GET_NAME_PHONE = 'GET_NAME_PHONE';
var CHECK_CODE = 'CHECK_CODE';
var SAVE_REFUND_WAY = 'SAVE_REFUND_WAY';
var GET_REFUND_WAY = 'GET_REFUND_WAY';
var GET_VERIFICATION = 'GET_VERIFICATION';
var CHECK_VERIFICATION_CODE = 'CHECK_VERIFICATION_CODE';
var SHOW_EIENTRANCE = 'SHOW_EIENTRANCE';
var GET_REFUND_RULES = 'GET_REFUND_RULES';
var CREATE_E2E_CHANGE = 'CREATE_E2E_CHANGE';
var CREATE_MU_CHANGE = 'CREATE_MU_CHANGE';
var CREATE_GP_CHANGE = 'CREATE_GP_CHANGE';
var SUMBIT_CHANGE_ADDPSGSINFO = 'SUMBIT_CHANGE_ADDPSGSINFO';
var CHECK_ISNEEDPSGINFO = 'CHECK_ISNEEDPSGINFO';
var CHECK_PNRDOCS = 'CHECK_PNRDOCS';
var GET_INSURANCEC_CHANGE = 'GET_INSURANCEC_CHANGE';
var GREEN_FLIGHT_SERVE = 'GREEN_FLIGHT_SERVE';
var IS_GREEN_SWITCHON = 'IS_GREEN_SWITCHON';
var GET_PACKAGE_DATE = 'GET_PACKAGE_DATE';
var GET_ENCRYP_FLIGHTS = 'GET_ENCRYP_FLIGHTS';
var GET_OVERTIME_B = 'GET_OVERTIME_B';
var GET_CIVIL_SWITCH = 'GET_CIVIL_SWITCH';
var GET_PHONEAREA_CODE = 'GET_PHONEAREA_CODE';
var GET_ALL_SWITCH = 'GET_ALL_SWITCH';
var GET_AREA_CODE = 'GET_AREA_CODE';
var MU_CONTACT_INFO = 'MU_CONTACT_INFO';
function createGPChange(data) {
  return {
    type: CREATE_GP_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createGPChange,
        method: 'post',
        data: data
      }
    }
  };
}

// 清空联系人和费用详情
function clearCost() {
  return { type: CLEAR_COST };
}

// 创建E2E单
function createE2EChange(data) {
  return {
    type: CREATE_E2E_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createE2EChange,
        method: 'post',
        data: data
      }
    }
  };
}

// 创建东航变更单
function createMuChange(data) {
  return {
    type: CREATE_MU_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createMuChange,
        method: 'post',
        data: data
      }
    }
  };
}

// 提交变更申请
function submitApply(data, load, vol) {
  var artificialFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (artificialFlag) data.changeVO.reissueFlag = artificialFlag;
  return {
    type: SUBMIT_CHANGE_APPLY,
    closeLoading: load,
    payload: {
      request: {
        url: vol ? __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleVolChangeReqPayOK : __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleChangeReqPayOK,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 补充旅客信息提交变更
 */
function submitChangeAddPsgsInfoApply(isArtificial, data) {
  return {
    type: SUMBIT_CHANGE_ADDPSGSINFO,
    closeLoading: true,
    payload: {
      request: {
        url: !isArtificial ? __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleChangeReqPayOK : __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createE2EChange,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 校验国际票是否需要补充旅客信息
 */
function checkIsNeedPsgsInfo(data) {
  return {
    type: CHECK_ISNEEDPSGINFO,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].touchConfirmIntVol,
        method: 'post',
        data: data
      }
    }
  };
}

/**
 * @description 重新录入信息校验
 */
function checkIsNeedPNRPsgsInfo(data) {
  return {
    type: CHECK_PNRDOCS,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].checkPnrDocs,
        method: 'post',
        data: data
      }
    }
  };
}

// 提交退票申请
function submitApplyRefund(data) {
  return {
    type: SUBMIT_REFUND_APPLY,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleRefundApp,
        method: 'post',
        data: data
      }
    }
  };
}

// 获取退票费
function getRefundFee(data) {
  return {
    type: GET_REFUND_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].afterSaleRefundFee,
        method: 'post',
        data: data
      }
    }
  };
}

// 获取退改规则
function getRefundRules(data) {
  return {
    type: GET_REFUND_RULES,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getOriginFlightUseCondition,
        method: 'get',
        params: data
      }
    }
  };
}

// 保存退票信息
function saveCost(data) {
  return { type: SAVE_COST, data: data };
}

// 获取联系信息
function getNameAndPhone(data) {
  var load = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: GET_NAME_PHONE,
    closeLoading: load,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getNameAndPhone,
        method: 'post',
        data: data
      }
    }
  };
}

// 获取短信验证码
function getVerification(data) {
  return {
    type: GET_VERIFICATION,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getVerificationCode + '?type=change',
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'application/json' }
      }
    }
  };
}

// 2018.03.16 获取行程单回收通知
// export function getStrokeNotice (data, cb) {
//   return dispatch => {
//     return api.callApiPost(
//       {
//         url: urlConfig.strokeNotice,
//         querys: data,
//         success: function (result) {
//           cb(result.receiptMsg)
//           return result
//         }
//       },
//       false
//     )
//   }
// }

// 退票前短信验证
function checkVerificationCode(data) {
  return {
    type: CHECK_VERIFICATION_CODE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].checkVerificationCode,
        method: 'post',
        data: data
      }
    }
  };
}

// 保存付款方式
function saveRefundWay(data) {
  return { type: SAVE_REFUND_WAY, data: data };
}

// 获取退款方式
function getRefundWay(data) {
  return {
    type: GET_REFUND_WAY,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getRefundMode,
        method: 'post',
        data: data
      }
    }
  };
}

// 是否展示电子发票
function showEiEntrance(data) {
  return {
    type: SHOW_EIENTRANCE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].showEiEntrance,
        method: 'post',
        data: data
      }
    }
  };
}
// 获取保险产品
function getInsurancecChange(data) {
  return {
    type: GET_INSURANCEC_CHANGE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getInsurancecChange,
        method: 'post',
        data: data
      }
    }
  };
}

// 获取绿色飞行产品
function greenFlightServe(data) {
  return {
    type: GREEN_FLIGHT_SERVE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].greenFlightServe,
        method: 'post',
        data: data
      }
    }
  };
}

function isGreenSwitchOn(data) {
  return {
    type: IS_GREEN_SWITCHON,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].isGreenSwitchOn,
        method: 'post',
        data: data
      }
    }
  };
}

function getPackageDate(data) {
  return {
    type: GET_PACKAGE_DATE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getPackageDate,
        method: 'post',
        data: data
      }
    }
  };
}

function getEncrypFlights(data) {
  return {
    type: GET_ENCRYP_FLIGHTS,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].encrypFlights,
        method: 'post',
        data: data
      }
    }
  };
}

function getOverTime_B() {
  return {
    type: GET_OVERTIME_B,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_LOADTIME'
        }
      }
    }
  };
}
function getCivilSwitch(val) {
  return {
    type: GET_CIVIL_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: val
        }
      }
    }
  };
}

function getPhoneAreaCode() {
  return {
    type: GET_PHONEAREA_CODE,
    payload: {
      request: {
        url: '/public/phoneAreaCode.json',
        method: 'get'
      }
    }
  };
}

function getAllSwitch(val) {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].memberAllSwitch,
        method: 'post',
        data: {
          switchKeys: val
        }
      }
    }
  };
}

function getAreaCodeList(data) {
  return {
    type: GET_AREA_CODE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getAreaCodeList,
        method: 'post',
        data: data
      }
    }
  };
}

function muContactInfo(data) {
  return { type: MU_CONTACT_INFO, data: data };
}

/***/ }),

/***/ "BcSr":
/***/ (function(module, exports, __webpack_require__) {

var baseLt = __webpack_require__("2gEL"),
    createRelationalOperation = __webpack_require__("FNvM");

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

module.exports = lt;


/***/ }),

/***/ "C/Wh":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("hcE8");
var hide = __webpack_require__("wkr2");

module.exports = function (key, value) {
  try {
    hide(global, key, value);
  } catch (e) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "C1ru":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "C9Ci":
/***/ (function(module, exports) {

function arrayTreeFilter(data, filterFn, options) {
  options = options || {};
  options.childrenKeyName = options.childrenKeyName || 'children';
  var children = data || [];
  var result = [];
  var level = 0;
  var foundItem;
  do {
    var foundItem = children.filter(function(item) {
      return filterFn(item, level);
    })[0];
    if (!foundItem) {
      break;
    }
    result.push(foundItem);
    children = foundItem[options.childrenKeyName] || [];
    level += 1;
  } while(children.length > 0);
  return result;
}

module.exports = arrayTreeFilter;


/***/ }),

/***/ "CJFh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CL6c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("r/oT");

__webpack_require__("vlTG");
__webpack_require__("INOt");
__webpack_require__("XszO");
__webpack_require__("B1Xl");
__webpack_require__("uS+O");
__webpack_require__("YeaM");
__webpack_require__("Sh04");
__webpack_require__("A7EC");


/***/ }),

/***/ "DEG1":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ "DP/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/style/css.web.js
var css_web = __webpack_require__("gj9y");
var css_web_default = /*#__PURE__*/__webpack_require__.n(css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/index.web.js
var index_web = __webpack_require__("qZDr");
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// EXTERNAL MODULE: ./src/config/routerConfig.js
var routerConfig = __webpack_require__("a1o4");

// EXTERNAL MODULE: ./src/components/ProgressBar/index.js
var ProgressBar = __webpack_require__("7OyB");

// EXTERNAL MODULE: ./src/components/PopUpLoad/index.js
var PopUpLoad = __webpack_require__("7rGq");

// EXTERNAL MODULE: ./src/components/PopUp/index.js
var PopUp = __webpack_require__("2H8H");

// EXTERNAL MODULE: ./src/components/PopPwd/index.js
var PopPwd = __webpack_require__("01Lf");

// EXTERNAL MODULE: ./src/routes/routes/refundApply/components/BankAuthPopup/index.js
var BankAuthPopup = __webpack_require__("/1Jj");

// EXTERNAL MODULE: ./src/routes/routes/applySubmit/components/Explain/index.js
var Explain = __webpack_require__("HTl8");

// EXTERNAL MODULE: ./src/routes/modules/actions.js
var actions = __webpack_require__("1EI8");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-redux/es/index.js from dll-reference vendor_library
var esfrom_dll_reference_vendor_library = __webpack_require__("RH2O");

// EXTERNAL MODULE: ../emp-helpers/dist/es/index.js + 57 modules
var es = __webpack_require__("mekh");

// EXTERNAL MODULE: ./src/utils/util_recommendCode.js
var util_recommendCode = __webpack_require__("Sf+c");

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__("oFuF");

// EXTERNAL MODULE: ./src/routes/routes/updateDetail/modules/actions.js
var modules_actions = __webpack_require__("xXpn");

// EXTERNAL MODULE: ./src/components/OnlineService/index.js
var OnlineService = __webpack_require__("uWHR");

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/config/commonlang/cn.js
var cn = __webpack_require__("GxNa");

// EXTERNAL MODULE: ./src/config/commonlang/en.js
var en = __webpack_require__("/aCt");

// CONCATENATED MODULE: ./src/routes/containers/AppContainer/index.js


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 全局核心公共组件
 */















var AppContainer_AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer(props) {
    var _this2 = this;

    _classCallCheck(this, AppContainer);

    var _this = _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).call(this, props));

    _this._getUserInfo = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getUserInfo();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this._getConfig = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var _this$props, getSysConf, getAppConf;

      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, getSysConf = _this$props.getSysConf, getAppConf = _this$props.getAppConf;
              _context2.next = 3;
              return [Object(es["i" /* createCode3Widget */])(), getAppConf(), getSysConf()];

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this._getMileageSwitch = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var getMileageSwitch;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getMileageSwitch = _this.props.getMileageSwitch;
              _context3.next = 3;
              return getMileageSwitch();

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));
    _this._getcustomerUrlSwitch = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var getcustomerUrlSwitch, switchData, cs, at, ig;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getcustomerUrlSwitch = _this.props.getcustomerUrlSwitch;
              _context4.next = 3;
              return getcustomerUrlSwitch();

            case 3:
              switchData = _context4.sent;
              cs = 'N', at = 'N', ig = 'N';

              try {
                if (switchData.payload.data.kaiguan && switchData.payload.data.kaiguan.length > 0) {
                  cs = switchData.payload.data.kaiguan.filter(function (i) {
                    return i.business_type === 'S';
                  })[0].is_open === '1' ? 'Y' : 'N';
                  at = switchData.payload.data.kaiguan.filter(function (i) {
                    return i.business_type === 'P';
                  })[0].is_open === '1' ? 'Y' : 'N';
                  ig = switchData.payload.data.kaiguan.filter(function (i) {
                    return i.business_type === 'J';
                  })[0].is_open === '1' ? 'Y' : 'N';
                  window.sessionStorage.setItem('csSwitch', cs);
                  window.sessionStorage.setItem('atSwitch', at);
                  window.sessionStorage.setItem('igSwitch', ig);
                }
              } catch (error) {
                console.log('接口异常');
              }

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));
    return _this;
  }

  _createClass(AppContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.CryptoJS = CryptoJS;
      var _props = this.props,
          selectTabStyle = _props.selectTabStyle,
          location = _props.location,
          getLanguage = _props.getLanguage;

      var lang = location.query.language;
      if (lang) {
        window.sessionStorage.setItem('language', lang);
        if (lang == 'en') {
          getLanguage(en["a" /* default */]);
          document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
        } else {
          getLanguage(cn["a" /* default */]);
        }
      } else {
        if (window.sessionStorage.getItem('language') == 'en') {
          getLanguage(en["a" /* default */]);
        } else {
          getLanguage(cn["a" /* default */]);
        }
      }
      this._getUserInfo();
      if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
        if (js_cookie_default.a.get('TOKEN') === 'TOKEN' || js_cookie_default.a.get('TOKEN') === 'token' || !js_cookie_default.a.get('TOKEN')) {
          if (location.query.token) {
            js_cookie_default.a.remove('TOKEN');
            js_cookie_default.a.remove('cs1246643sso');
            js_cookie_default.a.remove('csmbplogintype');
            js_cookie_default.a.set('TOKEN', location.query.token);
            js_cookie_default.a.set('cs1246643sso', location.query.token);
            // Cookies.set('csmbplogintype', "6")
            js_cookie_default.a.set('wxopenLogintype', 'fastlogin');
          }
        }
      }
      // 刷新，第一次进入程序重置退改列表tab的状态。
      if (location.query.selectTabStyle) {
        selectTabStyle(location.query.selectTabStyle);
      } else {
        selectTabStyle('1');
      }
      this._getConfig();
      this._getMileageSwitch();

      this._getcustomerUrlSwitch();
      window.H5NavigationBack = function () {
        return 'N';
      };
      // let vconsole = document.getElementById('__vconsole');
      // vconsole ? vconsole.style.display = 'none': '';
      // this._getUserInfo();
      // const memberNo = this.props.userInfo.memberNo;
      // if (
      //   [ '118218337593','149459309923'
      //   ].includes(
      //     memberNo
      //   )
      // ) {
      //   vconsole ? vconsole.style.display = 'block': '';
      // }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          location = _props2.location,
          changeNavbarState = _props2.changeNavbarState;
      var channel = location.query.channel;
      // 判断是否是app入口

      if (location.query.t === 'fromClient' || Object(es["C" /* isCsairApp */])() || window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
        changeNavbarState(false);
      }
      // setTimeout(this._getConfig, 2000);
      setTimeout(util_recommendCode["a" /* codeExtLink */], 500);
      // 如果是小程序入口进入，加载微信jsdk
      (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram' || channel === 'wxopen') && Object(util["createWechatSdk"])();
      Object(es["b" /* absoluteLayoutRestPage */])();
      // if (/(ReformProcess)|(ApplySubmit)|(TicketChange)|(selectDate)|(EndorsedApply)|(refundApply)/.test(window.location.href)) {
      //   const container = document.createElement('div');
      //   ReactDOM.render(<CustomerService />, container);
      //   const targetNode = document.getElementById('root');
      //   targetNode.appendChild(container);
      // }
      // window.addEventListener('visibilitychange', function () {
      //   if (window.sessionStorage.getItem('toggel')) {
      //     window.sessionStorage.removeItem('toggel')
      //     window.location.reload()
      //   }
      // });
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _jsx(reactfrom_dll_reference_vendor_library_default.a.Fragment, {}, void 0, children);
    }
  }]);

  return AppContainer;
}(reactfrom_dll_reference_vendor_library["Component"]);

/* harmony default export */ var containers_AppContainer = (Object(esfrom_dll_reference_vendor_library["connect"])(function (state) {
  return {
    userInfo: state.App.userInfo
  };
}, function (dispatch) {
  return {
    selectTabStyle: function selectTabStyle(index) {
      return dispatch(Object(modules_actions["o" /* selectTabStyle */])(index));
    },
    changeNavbarState: function changeNavbarState(bool) {
      return dispatch(Object(actions["l" /* changeNavbarState */])(bool));
    },
    getSysConf: function getSysConf(data) {
      return dispatch(Object(actions["x" /* getSysConf */])(data));
    },
    getAppConf: function getAppConf() {
      return dispatch(Object(actions["q" /* getAppConf */])());
    },
    getMileageSwitch: function getMileageSwitch() {
      return dispatch(Object(actions["u" /* getMileageSwitch */])());
    },
    getUserInfo: function getUserInfo() {
      return dispatch(Object(actions["y" /* getUserInfo */])());
    },
    getLanguage: function getLanguage(data) {
      return dispatch(Object(actions["s" /* getLanguage */])(data));
    },
    getcustomerUrlSwitch: function getcustomerUrlSwitch() {
      return dispatch(Object(actions["z" /* getcustomerUrlSwitch */])());
    }
  };
})(AppContainer_AppContainer));
// EXTERNAL MODULE: ./src/routes/routes/easyLogin/modules/actions.js
var easyLogin_modules_actions = __webpack_require__("otiu");

// EXTERNAL MODULE: ./src/routes/routes/reformProcess/modules/actions.js
var reformProcess_modules_actions = __webpack_require__("2s00");

// EXTERNAL MODULE: ./src/utils/enEXchange.js
var enEXchange = __webpack_require__("D6oK");

// CONCATENATED MODULE: ./src/routes/routes/updateDetail/index.js


function updateDetail__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created by Pactera on 2017/4/14.
 * 列表
 */









/* harmony default export */ var updateDetail = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.updateDetail.key,
    onEnter: function () {
      var _ref = updateDetail__asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2(nextState, replace, callback) {
        var gointo = function () {
          var _ref3 = updateDetail__asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var enterUrl, state, query, q;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    enterUrl = window.location.href;

                    window.sessionStorage.setItem('enterUrl', enterUrl);
                    state = store.getState();
                    query = nextState.location.query;

                    console.log('退改列表页地址：', window.location.href);

                    if (!query.urlParams) {
                      _context.next = 9;
                      break;
                    }

                    q = Object(util["parseLoginUrlParams"])(query.urlParams);
                    _context.next = 9;
                    return store.dispatch(Object(easyLogin_modules_actions["c" /* initloginInfo */])({
                      easylogin: q.mode === 'easy',
                      queryNo: q.account,
                      familyName: q.lastName || ' ',
                      givenName: q.firstName || ' '
                    }));

                  case 9:
                    window.sessionStorage.removeItem('ticketInfoList');
                    window.sessionStorage.removeItem('refundOrderOOReq');
                    window.sessionStorage.removeItem('changeOrderOOreq');
                    window.sessionStorage.removeItem('changeOrderOO_req');
                    window.sessionStorage.removeItem('wrongResaon');
                    window.sessionStorage.removeItem('ticketApplication'); // GN: [ID1678500][2024-11-26]
                    window.sessionStorage.removeItem('orderChannelId');
                    window.sessionStorage.removeItem('orderingSiteCode');
                    window.sessionStorage.removeItem('changeTap');
                    window.sessionStorage.removeItem('pageButtonName');

                    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
                      page_name: '机票退改列表页',
                      tab_type: '可退改',
                      channel_id: query.channel ? query.channel : ''
                    });

                    Object(es["w" /* gspNewVersion */])(['机票退改列表页面', '072-0001-23028-12201'], {
                      1: '页面曝光一次触发一次',
                      2: '国双新版',
                      3: Object(es["C" /* isCsairApp */])() ? 'App' : 'Mobile'
                    });
                    callback();

                  case 22:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function gointo() {
            return _ref3.apply(this, arguments);
          };
        }();

        var channel, _ref2, _ref2$payload$data, openlink, wechatAppLinkSwitch, reslut, _reslut;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Object(enEXchange["a" /* loadStatusCodeMsg */])(['queryOrderTickets', 'moreQuery', 'cancleChangePayIn', 'checkOrderTicket']);
                channel = nextState.location.query.channel;
                _context2.next = 4;
                return store.dispatch(Object(modules_actions["i" /* facecheckmorequerychannel */])(channel === 'cuss'));

              case 4:
                if (!(channel && channel === 'cuss' && !Object(es["C" /* isCsairApp */])() && !(window.__wxjs_environment && window.__wxjs_environment === 'miniprogram'))) {
                  _context2.next = 19;
                  break;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch(Object(reformProcess_modules_actions["k" /* getScheme */])({
                  url: window.location.href
                }));

              case 8:
                _ref2 = _context2.sent;
                _ref2$payload$data = _ref2.payload.data;
                openlink = _ref2$payload$data.openlink;
                wechatAppLinkSwitch = _ref2$payload$data.wechatAppLinkSwitch;

                if (wechatAppLinkSwitch === 'Y') {
                  window.location.href = openlink;
                } else {
                  Object(PopUp["default"])('温馨提示', '您好，因小程序跳转异常，请前往南航APP扫码办理，谢谢。');
                }
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](5);

                Object(PopUp["default"])('温馨提示', '您好，因小程序跳转异常，请前往南航APP扫码办理，谢谢。');

              case 18:
                return _context2.abrupt('return', false);

              case 19:
                if (!(channel && channel === 'cuss')) {
                  _context2.next = 36;
                  break;
                }

                _context2.prev = 20;
                _context2.next = 23;
                return store.dispatch(Object(actions["p" /* getAllSwitch */])(['EXTRA_EMP_MOREQUERY_CUSS_SWITCH']
                // 'EXTRA_EMP_APPEAL_SWITCH',
                // 'EXTRA_EMP_CUSTSERVICE'
                ));

              case 23:
                reslut = _context2.sent;
                _context2.next = 26;
                return store.dispatch(Object(modules_actions["j" /* facecheckmorequeryswitch */])({
                  isOpen: reslut.payload.data.EXTRA_EMP_MOREQUERY_CUSS_SWITCH
                }));

              case 26:
                gointo();
                _context2.next = 34;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t1 = _context2['catch'](20);
                _context2.next = 33;
                return store.dispatch(Object(modules_actions["j" /* facecheckmorequeryswitch */])({ isOpen: 'N' }));

              case 33:
                gointo();

              case 34:
                _context2.next = 50;
                break;

              case 36:
                _context2.prev = 36;
                _context2.next = 39;
                return store.dispatch(Object(actions["p" /* getAllSwitch */])(['EXTRA_EMP_MOREQUERY_SWITCH']));

              case 39:
                _reslut = _context2.sent;
                _context2.next = 42;
                return store.dispatch(Object(modules_actions["j" /* facecheckmorequeryswitch */])({
                  isOpen: _reslut.payload.data.EXTRA_EMP_MOREQUERY_SWITCH
                }));

              case 42:
                gointo();
                _context2.next = 50;
                break;

              case 45:
                _context2.prev = 45;
                _context2.t2 = _context2['catch'](36);
                _context2.next = 49;
                return store.dispatch(Object(modules_actions["j" /* facecheckmorequeryswitch */])({ isOpen: 'N' }));

              case 49:
                gointo();

              case 50:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 15], [20, 29], [36, 45]]);
      }));

      function onEnter(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return onEnter;
    }(),
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(3).then((function (require) {
        var TicketListContainers = __webpack_require__("g9k2").default;
        cb(null, TicketListContainers);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/routes/routes/coupon/modules/actions.js
var coupon_modules_actions = __webpack_require__("Zywo");

// EXTERNAL MODULE: ./src/routes/routes/refundCoupon/modules/actions.js
var refundCoupon_modules_actions = __webpack_require__("iQIy");

// CONCATENATED MODULE: ./src/routes/routes/endorsedApply/index.js
/**
 * Created by Pactera on 2017/4/14.
 * 退改申请页面
 */







/* harmony default export */ var endorsedApply = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.endorsedApply.key,
    onEnter: function onEnter(nextState, replace, callback) {
      Object(enEXchange["a" /* loadStatusCodeMsg */])(['checkOrderTicket', 'checkTicketFlight', 'cancelCheckIn'], {
        cancelCheckIn: []
      });
      window.localStorage.removeItem('routeType');
      window.sessionStorage.removeItem('pageButtonName');
      // gspCollect(
      //   [
      //     '2021-EMP退改-选航段选旅客页面',
      //     '选航段选旅客页面',
      //     '004-000-71001-103',
      //   ],
      //   { 6: '国内' },
      //   process.env.NODE_ENV === 'production'
      // );
      var _nextState$location$q = nextState.location.query,
          ticketChangeType = _nextState$location$q.ticketChangeType,
          channel = _nextState$location$q.channel;


      Object(es["w" /* gspNewVersion */])(ticketChangeType === 'refundTicket' ? ['退票-填写信息页面', '072-0046-23028-12201'] : ['变更-填写信息页面', '072-0017-23028-12201'], {
        1: '页面曝光一次触发一次',
        2: '国双新版',
        3: Object(es["C" /* isCsairApp */])() ? 'App' : 'Mobile'
      });
      var pageName = ticketChangeType === 'refundTicket' ? channel === 'TPWL' ? '机票退改-取消行程选人选航段页' : '机票退改-退票选人选航段页' : '机票退改-变更选人选航段页';
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: pageName,
        channel_id: channel ? channel : ''
      });

      store.dispatch(Object(coupon_modules_actions["g" /* clearCoupon */])());
      store.dispatch(Object(refundCoupon_modules_actions["f" /* clearRefundCoupon */])());
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(6).then((function (require) {
        var EndorsedApply = __webpack_require__("Cyfb").default;
        cb(null, EndorsedApply);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/routes/routes/endorsedApply/modules/actions.js
var endorsedApply_modules_actions = __webpack_require__("jgRS");

// CONCATENATED MODULE: ./src/routes/routes/selectDate/index.js


function selectDate__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created by Pactera on 2017/4/14.
 * 选择日期
 */





/* harmony default export */ var selectDate = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.selectDate.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var gointo = function () {
        var _ref = selectDate__asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          var _store$getState, oldLocation, dates;

          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  Object(enEXchange["a" /* loadStatusCodeMsg */])(['checkFlightDate']);
                  window.sessionStorage.removeItem('pageButtonName');
                  window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
                    page_name: '机票退改-选择变更日期页',
                    channel_id: nextState.location.query.channel ? nextState.location.query.channel : ''
                  });
                  _store$getState = store.getState(), oldLocation = _store$getState.App.oldLocation, dates = _store$getState.selectDate.dates;
                  // history 的前进后退需避开日期页面

                  if (!(oldLocation.pathname === routerConfig["default"].ticket.child.ticketChange.path && !oldLocation.query.changeKey && !nextState.location.query.resetDateKey)) {
                    _context.next = 17;
                    break;
                  }

                  if (!(nextState.location.query.channel == 'AI')) {
                    _context.next = 14;
                    break;
                  }

                  if (!(nextState.location.query.from && nextState.location.query.from === 'assistant' || window.sessionStorage.getItem('isAIComming'))) {
                    _context.next = 11;
                    break;
                  }

                  if (/NHPAASWEBVIEW/i.test(navigator.userAgent) && window.nh && typeof window.nh.navigateBack === 'function') {
                    window.nh.navigateBack(JSON.stringify({ url: '' }));
                  } else {
                    window.parent.postMessage({
                      type: 'NH_AI_HALF_SCREEN_H5',
                      action: 'close',
                      payload: {}
                    }, '*');
                  }
                  return _context.abrupt('return', false);

                case 11:
                  window.ft.miniProgram.navigateBack();
                  return _context.abrupt('return', false);

                case 13:
                  return _context.abrupt('return', false);

                case 14:
                  window.history.go(-1);
                  _context.next = 18;
                  break;

                case 17:
                  if (oldLocation.pathname === routerConfig["default"].ticket.child.endorsedApply.path && dates.length !== 0) {
                    // 乘机人和航段选择页面 -> 航班选择页面
                    window.history.go(1);
                  } else {
                    callback();
                  }

                case 18:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function gointo() {
          return _ref.apply(this, arguments);
        };
      }();

      function messageEvent(event) {
        window.removeEventListener('message', messageEvent);
        // 必须验证来源！
        if (event.origin.indexOf('csair.com') < 0) return;
        // { userId: 123, token: 'abc' }
        window.sessionStorage.setItem('nextStepParams', JSON.stringify(event.data));
        window.localStorage.setItem('routeType', event.data.isDomestic ? '国内' : '国际');
        window.sessionStorage.setItem('isAIComming', true);
        store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(event.data));
        gointo();
      }
      if (nextState.location.query.channel == 'AI' && !nextState.location.query.from) {
        if (window.ft && window.ft.miniProgram) {
          window.ft.getStorage({
            key: 'nextStepParams',
            success: function success(data) {
              window.sessionStorage.setItem('nextStepParams', JSON.stringify(data.data));
              window.localStorage.setItem('routeType', data.data.isDomestic ? '国内' : '国际');
              window.sessionStorage.setItem('isAICommingFT', true);
              store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(data.data));
            },
            fail: function fail(data) {},
            complete: function complete(data) {
              gointo();
            }
          });
        }
      } else if (nextState.location.query.channel == 'AI' && nextState.location.query.from === 'assistant') {
        if (/NHPAASWEBVIEW/i.test(navigator.userAgent) && window.nh && typeof window.nh.getStartupParams === 'function') {
          var data = typeof window.nh.getStartupParams() === 'string' ? JSON.parse(window.nh.getStartupParams()) : {};
          window.sessionStorage.setItem('nextStepParams', JSON.stringify(data));
          window.localStorage.setItem('routeType', data.isDomestic ? '国内' : '国际');
          window.sessionStorage.setItem('isAIComming', true);
          store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(data));
          gointo();
        } else {
          window.addEventListener('message', messageEvent);
        }
      } else {
        gointo();
      }
    },
    onLeave: function onLeave(prevState) {
      window.sessionStorage.removeItem('nextStepParams');
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(20).then((function (require) {
        var SelectDateContainer = __webpack_require__("Rw+w").default;
        cb(null, SelectDateContainer);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/routes/routes/ticketChanges/modules/actions.js
var ticketChanges_modules_actions = __webpack_require__("irwo");

// EXTERNAL MODULE: ./node_modules/lodash/lang.js
var lodash_lang = __webpack_require__("MIb3");
var lang_default = /*#__PURE__*/__webpack_require__.n(lodash_lang);

// CONCATENATED MODULE: ./src/routes/routes/ticketChanges/index.js








/* harmony default export */ var ticketChanges = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.ticketChange.key,
    onEnter: function onEnter(nextState, replace, callback) {
      Object(enEXchange["a" /* loadStatusCodeMsg */])(['afterSaleChangeReqNewFlightDetail']);
      Object(es["w" /* gspNewVersion */])(['变更-选择新航班页面-选择新航班页面', '072-0021-23028-12201'], {
        1: '页面曝光一次触发一次',
        2: '国双新版',
        3: Object(es["C" /* isCsairApp */])() ? 'App' : 'Mobile'
      });
      window.sessionStorage.removeItem('pageButtonName');

      var _store$getState = store.getState(),
          oldLocation = _store$getState.App.oldLocation,
          _store$getState$Edors = _store$getState.EdorsedApply,
          changeProcess = _store$getState$Edors.changeProcess,
          flightList = _store$getState$Edors.flightList,
          psgList = _store$getState$Edors.psgList;

      window.sessionStorage.removeItem('upCharge');
      window.sessionStorage.removeItem('licheng');
      var flightArr = nextState.location.query.flight.split(',').sort(util["compare"]);
      var personArr = nextState.location.query.person.split(',').sort(util["compare"]);

      var originSelectFlight = flightList.filter(function (item, i) {
        return flightArr.indexOf(String(i)) !== -1;
      });
      var originSelectpsg = psgList.filter(function (item, i) {
        return personArr.indexOf(String(i)) !== -1;
      });
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-变更新航班页',
        channel_id: nextState.location.query.channel ? nextState.location.query.channel : '',
        ticket_number: originSelectpsg.map(function (obj) {
          return obj.ticketNo;
        }).join(';'),
        flight_date: originSelectFlight.map(function (obj) {
          return obj.flightDate;
        }).join(';'),
        flight_number: originSelectFlight.map(function (obj) {
          return obj.flightNo;
        }).join(';'),
        origin_location: originSelectFlight.map(function (obj) {
          return obj.depAirportName;
        }).join(';'),
        destination_location: originSelectFlight.map(function (obj) {
          return obj.arrAirportName;
        }).join(';'),
        passenger_type: originSelectpsg.map(function (obj) {
          return obj.psgType === 3 ? '婴儿' : obj.psgType === 1 || obj.psgType === 2 ? '儿童' : '成人';
        }).join(';'),
        ticket_refund_type: changeProcess && changeProcess[0] && changeProcess[0] === 'zybg' ? '自愿变更' : '非自愿变更'
      });

      // 提交页面 -> 选择新航班页面时要返回选择乘机人页面
      if (oldLocation.pathname === routerConfig["default"].ticket.child.applySubmit.path) {
        // window.history.go(-2);
        // return false;
        store.dispatch(Object(ticketChanges_modules_actions["g" /* clearFlight */])());
      }

      // resetDateKey重选功能 选择日期页面 -> 选择新航班页面
      if (!oldLocation.query.resetDateKey) {
        if (!nextState.location.query.changeKey) {
          store.dispatch(Object(ticketChanges_modules_actions["g" /* clearFlight */])());
          if (!Object(lodash_lang["isEqual"])(Array.isArray(changeProcess) ? changeProcess.sort() : [changeProcess], Array.isArray(nextState.location.query.changeProcess) ? nextState.location.query.changeProcess.sort() : [nextState.location.query.changeProcess])) {
            store.dispatch(Object(endorsedApply_modules_actions["v" /* saveChangeProcess */])({
              changeProcess: Array.isArray(nextState.location.query.changeProcess) ? nextState.location.query.changeProcess.sort() : [nextState.location.query.changeProcess]
            }));
          }
        } else {
          store.dispatch(Object(ticketChanges_modules_actions["l" /* restFlight */])(Number(nextState.location.query.changeKey)));
        }
      }

      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(7).then((function (require) {
        var TicketChange = __webpack_require__("mGz8").default;
        cb(null, TicketChange);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/routes/routes/applySubmit/modules/actions.js
var applySubmit_modules_actions = __webpack_require__("Bbjx");

// CONCATENATED MODULE: ./src/routes/routes/applySubmit/index.js
/**
 * Created by Pactera on 2017/4/14.
 * 提交页面
 */




// import { toQueryString } from 'Utils';



/* harmony default export */ var applySubmit = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.applySubmit.key,
    // onEnter(nextState, replace, callback) {
    //   const { orderNo, ticketNo } = nextState.location.query;
    //   const state = store.getState();
    //   if (
    //     state.App.oldLocation.pathname === Routes.ticket.child.endorsedApply.path ||
    //     state.App.oldLocation.pathname === Routes.ticket.child.ticketChange.path
    //   ) {
    //     callback();
    //   }
    // else if (orderNo !== null) {
    //   if (orderNo !== state.EdorsedApply.orderNo) {
    //     replace(
    //       `${Routes.ticket.child.updateDetail.path}?${toQueryString(state.updateDetail.urlQuery)}`,
    //     );
    //   }
    //   callback();
    // } else if (ticketNo !== null) {
    //   if (ticketNo !== state.EdorsedApply.ticketNo) {
    //     replace(
    //       `${Routes.ticket.child.updateDetail.path}?${toQueryString(state.updateDetail.urlQuery)}`,
    //     );
    //   }
    //   callback();
    // }
    // },
    onEnter: function onEnter(nextState, replace, callback) {
      Object(enEXchange["a" /* loadStatusCodeMsg */])(['getNameAndPhone', 'change', 'getVerificationCode']);
      window.sessionStorage.removeItem('pageButtonName');

      var _store$getState = store.getState(),
          oldLocation = _store$getState.App.oldLocation,
          _store$getState$Edors = _store$getState.EdorsedApply,
          changeProcess = _store$getState$Edors.changeProcess,
          flightList = _store$getState$Edors.flightList,
          psgList = _store$getState$Edors.psgList;

      var _nextState$location$q = nextState.location.query,
          channel = _nextState$location$q.channel,
          flight = _nextState$location$q.flight,
          person = _nextState$location$q.person;


      var flightArr = flight.split(',').sort(util["compare"]);
      var personArr = person.split(',').sort(util["compare"]);

      var originSelectFlight = flightList.filter(function (item, i) {
        return flightArr.indexOf(String(i)) !== -1;
      });
      var originSelectpsg = psgList.filter(function (item, i) {
        return personArr.indexOf(String(i)) !== -1;
      });
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-变更提交申请页',
        channel_id: channel ? channel : '',
        ticket_number: originSelectpsg.map(function (obj) {
          return obj.ticketNo;
        }).join(';'),
        flight_date: originSelectFlight.map(function (obj) {
          return obj.flightDate;
        }).join(';'),
        flight_number: originSelectFlight.map(function (obj) {
          return obj.flightNo;
        }).join(';'),
        origin_location: originSelectFlight.map(function (obj) {
          return obj.depAirportName;
        }).join(';'),
        destination_location: originSelectFlight.map(function (obj) {
          return obj.arrAirportName;
        }).join(';'),
        passenger_type: originSelectpsg.map(function (obj) {
          return obj.psgType === 3 ? '婴儿' : obj.psgType === 1 || obj.psgType === 2 ? '儿童' : '成人';
        }).join(';'),
        ticket_refund_type: changeProcess && changeProcess[0] && changeProcess[0] === 'zybg' ? '自愿变更' : '非自愿变更'
      });
      window.sessionStorage.setItem('historyUrl', oldLocation.pathname);
      callback();
    },
    onLeave: function onLeave(prevState) {
      console.log('applysubmit route leave');
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(5).then((function (require) {
        store.dispatch(Object(applySubmit_modules_actions["h" /* clearCost */])());
        var ApplySubmit = __webpack_require__("/QuY").default;
        cb(null, ApplySubmit);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/components/MemberPopup/index.js + 1 modules
var MemberPopup = __webpack_require__("apQ4");

// CONCATENATED MODULE: ./src/routes/routes/reformProcess/index.js


function reformProcess__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created by Pactera on 2017/4/14.
 * 退改后详情页面
 */








/* harmony default export */ var reformProcess = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.reformProcess.key,
    onEnter: function () {
      var _ref = reformProcess__asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee(nextState, replace, callback) {
        var _nextState$location$q, orderType, orderNo, linkType, channel, _ref2, _ref2$payload$data, openlink, wechatAppLinkSwitch, openWithApp, gointo;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                gointo = function gointo() {
                  var wxchannel = '';
                  if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
                    wxchannel = '&channel=wxopen';
                  }
                  var isS_Num = nextState.location.query.orderNo.includes('S');
                  var scene = isS_Num ? '100' : '101';
                  var state = store.getState();
                  var channel = JSON.parse(window.sessionStorage.getItem('emp_channel') ? window.sessionStorage.getItem('emp_channel') : null) ? JSON.parse(window.sessionStorage.getItem('emp_channel')).use_channel : '';
                  if (!navigator.userAgent.toLowerCase().includes('toutiaomicroapp') && channel !== 'YGZQ' && state.App.lang.language !== 'en') {
                    Object(MemberPopup["a" /* default */])({
                      getMemberList: function getMemberList(data) {
                        return store.dispatch(Object(actions["w" /* getPassageMemberLevel */])(data));
                      },
                      crateNps: function crateNps(data) {
                        return store.dispatch(Object(actions["C" /* searchNpsUrl */])(data));
                      },
                      query: nextState.location.query,
                      fdbParmas: {
                        businessId: scene,
                        returnUrl: window.location.href.replace(/(&vipMember=Y)|(vipMember=Y&)/g, ''),
                        channel: Object(util["userAgentType"])(),
                        scene: scene,
                        routeType: window.localStorage.getItem('routeType'),
                        changeNo: isS_Num ? nextState.location.query.orderNo : '',
                        refundNo: isS_Num ? '' : nextState.location.query.orderNo
                      },
                      lang: state.App.lang
                    });
                  }
                  Object(es["w" /* gspNewVersion */])(orderType === 'S' ? ['变更详情页面', '072-0036-23028-12201'] : ['退票详情页面', '072-0058-23028-12201'], {
                    1: '页面曝光一次触发一次',
                    2: '国双新版',
                    3: Object(es["C" /* isCsairApp */])() ? 'App' : 'Mobile'
                  });

                  window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
                    page_name: orderType === 'S' ? '机票退改-变更详情页' : orderNo.includes('TJ') ? '机票退改-取消行程详情页' : '机票退改-退票详情页',
                    channel_id: channel ? channel : '',
                    refund_change_order_id: orderNo
                  });

                  if (Object(util["session"])('emp-mobile') && Object(util["session"])('emp-mobile').fromEmp) {
                    window.sessionStorage.setItem('emp-mobile', JSON.stringify({
                      fromEmp: false
                    }));
                    window.history.go(-1);
                    return false;
                  }
                  if (state.App.oldLocation.pathname !== routerConfig["default"].ticket.child.applySubmit.path) {
                    Object(PopUpLoad["default"])('load', state.App.lang);
                  }
                  callback();
                };

                openWithApp = function openWithApp(scheme_link) {
                  // let toggel = 1;
                  var onloadTimer = null;
                  // 尝试打开 scheme
                  window.location.href = scheme_link;
                  // 设置15秒无操作，进入详情页
                  onloadTimer = setTimeout(function () {
                    // toggel = 0;
                    gointo();
                    clearTimeout(onloadTimer);
                  }, 15000);

                  // window.addEventListener('focus', function() {
                  //   if (toggel === 1) {
                  //     gointo();
                  //     clearTimeout(onloadTimer);
                  //   }
                  // });
                };

                Object(enEXchange["a" /* loadStatusCodeMsg */])(['afterSaleChangeReqDetail', 'cancleChangePayIn', 'afterGetRefundOrderDetail', 'getVerificationCode']);
                _nextState$location$q = nextState.location.query, orderType = _nextState$location$q.orderType, orderNo = _nextState$location$q.orderNo, linkType = _nextState$location$q.linkType, channel = _nextState$location$q.channel;

                if (!(linkType && linkType === 'wechat')) {
                  _context.next = 14;
                  break;
                }

                _context.next = 7;
                return store.dispatch(Object(reformProcess_modules_actions["k" /* getScheme */])({
                  url: window.location.href.replace(/(&linkType=wechat)|(linkType=wechat&)/g, '') + '&channel=wxopen'
                }));

              case 7:
                _ref2 = _context.sent;
                _ref2$payload$data = _ref2.payload.data;
                openlink = _ref2$payload$data.openlink;
                wechatAppLinkSwitch = _ref2$payload$data.wechatAppLinkSwitch;

                if (wechatAppLinkSwitch === 'Y') {
                  openWithApp(openlink);
                } else {
                  gointo();
                }
                _context.next = 15;
                break;

              case 14:
                gointo();

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onEnter(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return onEnter;
    }(),
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(1).then((function (require) {
        var ReformProcess = __webpack_require__("bc/d").default;
        cb(null, ReformProcess);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/addPersonMessage/index.js
/**
 * 补充旅客信息
 */





/* harmony default export */ var addPersonMessage = (function (store) {
  return {
    path: 'AddPersonMessage',
    onEnter: function onEnter(nextState, replace, callback) {
      Object(enEXchange["a" /* loadStatusCodeMsg */])(['getNameAndPhone', 'change', 'getVerificationCode']);
      Object(es["v" /* gspCollect */])(['2021-EMP退改-补充旅客信息页面', '补充旅客信息页面', '018-000-71001-103'], { 6: '国内' }, "production" === 'production');
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(2).then((function (require) {
        var addPersonMessage = __webpack_require__("0V13").default;
        cb(null, addPersonMessage);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/addProductShop/index.js
/**
 * 补充旅客信息
 */




/* harmony default export */ var addProductShop = (function (store) {
  return {
    path: 'addProductShop',
    onEnter: function onEnter(nextState, replace, callback) {
      // gspCollect(
      //   [
      //     '2021-EMP退改-补充旅客信息页面',
      //     '补充旅客信息页面',
      //     '018-000-71001-103',
      //   ],
      //   { 6: '国内' },
      //   process.env.NODE_ENV === 'production'
      // );
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(18).then((function (require) {
        var addProductShop = __webpack_require__("wUTy").default;
        cb(null, addProductShop);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/faceRecognition/index.js
/**
 * 人脸识别
 */



/* harmony default export */ var faceRecognition = (function (store) {
  return {
    path: 'faceRecognition',
    onEnter: function onEnter(nextState, replace, callback) {
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(22).then((function (require) {
        var faceRecognition = __webpack_require__("FqQ6").default;
        cb(null, faceRecognition);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/certificationResults/index.js
/**
 * 人脸识别结果
 */




/* harmony default export */ var certificationResults = (function (store) {
  return {
    path: 'certificationResults',
    onEnter: function onEnter(nextState, replace, callback) {
      Object(enEXchange["a" /* loadStatusCodeMsg */])(['createRefundTa']);
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(17).then((function (require) {
        var certificationResults = __webpack_require__("iEvy").default;
        cb(null, certificationResults);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: delegated ./node_modules/react-router/es/index.js from dll-reference vendor_library
var react_router_esfrom_dll_reference_vendor_library = __webpack_require__("CIox");

// EXTERNAL MODULE: ./src/components/Header/index.js
var Header = __webpack_require__("m5tV");

// EXTERNAL MODULE: ./src/routes/routes/feeQuery/components/FeeQueryContainer/index.less
var FeeQueryContainer = __webpack_require__("wbZz");
var FeeQueryContainer_default = /*#__PURE__*/__webpack_require__.n(FeeQueryContainer);

// CONCATENATED MODULE: ./src/routes/routes/feeQuery/components/FeeQueryContainer/index.js
var FeeQueryContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var FeeQueryContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function FeeQueryContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FeeQueryContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FeeQueryContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FeeQueryContainer_FeeQuery = function (_Component) {
  FeeQueryContainer__inherits(FeeQuery, _Component);

  function FeeQuery() {
    var _ref;

    var _temp, _this, _ret;

    FeeQueryContainer__classCallCheck(this, FeeQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = FeeQueryContainer__possibleConstructorReturn(this, (_ref = FeeQuery.__proto__ || Object.getPrototypeOf(FeeQuery)).call.apply(_ref, [this].concat(args))), _this), _this._navBarLeftClick = function () {
      _this.props.router.goBack();
    }, _temp), FeeQueryContainer__possibleConstructorReturn(_this, _ret);
  }

  FeeQueryContainer__createClass(FeeQuery, [{
    key: 'render',
    value: function render() {
      return FeeQueryContainer__jsx('div', {
        className: 'feeQueryPage'
      }, void 0, FeeQueryContainer__jsx('header', {}, void 0, FeeQueryContainer__jsx(Header["default"], {
        onLeftClick: this._navBarLeftClick,
        title: routerConfig["default"].ticket.child.feeQuery.name
      })), this.props.children);
    }
  }]);

  return FeeQuery;
}(reactfrom_dll_reference_vendor_library["Component"]);

/* harmony default export */ var components_FeeQueryContainer = (Object(react_router_esfrom_dll_reference_vendor_library["withRouter"])(FeeQueryContainer_FeeQuery));
// CONCATENATED MODULE: ./src/routes/routes/feeQuery/index.js
/**
 * 退改计算器结果详情页面
 */


/* harmony default export */ var feeQuery = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.feeQuery.key,
    component: components_FeeQueryContainer,
    getChildRoutes: function getChildRoutes(partialNextState, cb) {
      __webpack_require__.e/* require.ensure */(0).then((function (require) {
        cb(null, [__webpack_require__("e3WW").default(store), __webpack_require__("bfwJ").default(store), __webpack_require__("dgEs").default(store)]);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/changeFlight/index.js

// import { gspCollect } from '@csair/emp-helpers';
/* harmony default export */ var changeFlight = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.changeFlight.key,
    onEnter: function onEnter(nextState, replace, callback) {
      // gspCollect(
      //   [
      //     '2021-EMP退改-退票提交申请页面',
      //     '退票提交申请页面',
      //     '006-000-71001-103',
      //   ],
      //   { 6: '国内' },
      //   process.env.NODE_ENV === 'production'
      // );
      callback();
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(9).then((function (require) {
        var changeFlight = __webpack_require__("p9p0").default;
        cb(null, changeFlight);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/pay/index.js




/* harmony default export */ var pay = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.pay.key,
    onEnter: function onEnter(nextState, replace, callback) {
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-支付成功页',
        channel_id: nextState.location.query.channel ? nextState.location.query.channel : '',
        refund_change_order_id: nextState.location.query.orderNo
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(13).then((function (require) {
        var pay = __webpack_require__("wfVj").default;
        cb(null, pay);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/electronicInvoice/index.js




/* harmony default export */ var electronicInvoice = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.electronicInvoice.key,
    onEnter: function onEnter(nextState, replace, callback) {
      Object(es["v" /* gspCollect */])(['2021-EMP退改-预约电子发票页面', '预约电子发票页面', '013-000-71001-103'], { 6: '国内' }, "production" === 'production');
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(14).then((function (require) {
        var electronicInvoice = __webpack_require__("q+7q").default;
        cb(null, electronicInvoice);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/coupon/index.js





/* harmony default export */ var coupon = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.coupon.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var _nextState$location$q = nextState.location.query,
          channel = _nextState$location$q.channel,
          flight = _nextState$location$q.flight,
          person = _nextState$location$q.person;

      var _store$getState = store.getState(),
          oldLocation = _store$getState.App.oldLocation,
          _store$getState$Edors = _store$getState.EdorsedApply,
          changeProcess = _store$getState$Edors.changeProcess,
          flightList = _store$getState$Edors.flightList,
          psgList = _store$getState$Edors.psgList;

      var flightArr = flight.split(',').sort(util["compare"]);
      var personArr = person.split(',').sort(util["compare"]);

      var originSelectFlight = flightList.filter(function (item, i) {
        return flightArr.indexOf(String(i)) !== -1;
      });
      var originSelectpsg = psgList.filter(function (item, i) {
        return personArr.indexOf(String(i)) !== -1;
      });
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-变更优惠券列表页',
        channel_id: channel ? channel : '',
        ticket_number: originSelectpsg.map(function (obj) {
          return obj.ticketNo;
        }).join(';'),
        flight_date: originSelectFlight.map(function (obj) {
          return obj.flightDate;
        }).join(';'),
        flight_number: originSelectFlight.map(function (obj) {
          return obj.flightNo;
        }).join(';'),
        origin_location: originSelectFlight.map(function (obj) {
          return obj.depAirportName;
        }).join(';'),
        destination_location: originSelectFlight.map(function (obj) {
          return obj.arrAirportName;
        }).join(';'),
        passenger_type: originSelectpsg.map(function (obj) {
          return obj.psgType === 3 ? '婴儿' : obj.psgType === 1 || obj.psgType === 2 ? '儿童' : '成人';
        }).join(';'),
        ticket_refund_type: changeProcess && changeProcess[0] && changeProcess[0] === 'zybg' ? '自愿变更' : '非自愿变更'
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(12).then((function (require) {
        var Container = __webpack_require__("23F0").default;
        cb(null, Container);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/refundCoupon/index.js




/* harmony default export */ var refundCoupon = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.refundCoupon.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var _store$getState = store.getState(),
          _store$getState$Edors = _store$getState.EdorsedApply,
          changeProcess = _store$getState$Edors.changeProcess,
          flightList = _store$getState$Edors.flightList,
          psgList = _store$getState$Edors.psgList;

      var _nextState$location$q = nextState.location.query,
          channel = _nextState$location$q.channel,
          flight = _nextState$location$q.flight,
          person = _nextState$location$q.person;

      var flightArr = flight.split(',').sort(util["compare"]);
      var personArr = person.split(',').sort(util["compare"]);

      var originSelectFlight = flightList.filter(function (item, i) {
        return flightArr.indexOf(String(i)) !== -1;
      });
      var originSelectpsg = psgList.filter(function (item, i) {
        return personArr.indexOf(String(i)) !== -1;
      });
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-退票优惠券列表页',
        channel_id: channel ? channel : '',
        ticket_number: originSelectpsg.map(function (obj) {
          return obj.ticketNo;
        }).join(';'),
        flight_date: originSelectFlight.map(function (obj) {
          return obj.flightDate;
        }).join(';'),
        flight_number: originSelectFlight.map(function (obj) {
          return obj.flightNo;
        }).join(';'),
        origin_location: originSelectFlight.map(function (obj) {
          return obj.depAirportName;
        }).join(';'),
        destination_location: originSelectFlight.map(function (obj) {
          return obj.arrAirportName;
        }).join(';'),
        passenger_type: originSelectpsg.map(function (obj) {
          return obj.psgType === 3 ? '婴儿' : obj.psgType === 1 || obj.psgType === 2 ? '儿童' : '成人';
        }).join(';'),
        ticket_refund_type: originSelectpsg.map(function (obj) {
          return obj.scopeCodes.join(';');
        }).includes('fzytp') ? '非自愿退票' : '自愿退票'
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(11).then((function (require) {
        var Container = __webpack_require__("NTEi").default;
        cb(null, Container);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/easyLogin/index.js



/* harmony default export */ var easyLogin = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.easyLogin.key,
    onEnter: function onEnter(nextState, replace, callback) {
      if (!nextState.location.query.easyMoreQuery) {
        store.dispatch(Object(easyLogin_modules_actions["c" /* initloginInfo */])());
      }
      callback();
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(19).then((function (require) {
        var easyLogin = __webpack_require__("eMEt").default;
        cb(null, easyLogin);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/refundApply/index.js








/* harmony default export */ var refundApply = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.refundApply.key,
    onEnter: function onEnter(nextState, replace, callback) {
      function gointo() {
        window.sessionStorage.removeItem('pageButtonName');
        var _nextState$location$q = nextState.location.query,
            channel = _nextState$location$q.channel,
            flight = _nextState$location$q.flight,
            person = _nextState$location$q.person;

        Object(enEXchange["a" /* loadStatusCodeMsg */])(['getNameAndPhone', 'getVerificationCode', 'createRefund', 'createRefundTa', 'submitFastRefundMultiple', 'getRefundMode']);

        var _store$getState = store.getState(),
            oldLocation = _store$getState.App.oldLocation,
            _store$getState$Edors = _store$getState.EdorsedApply,
            changeProcess = _store$getState$Edors.changeProcess,
            flightList = _store$getState$Edors.flightList,
            psgList = _store$getState$Edors.psgList;

        console.log(store.getState());
        var flightArr = flight.split(',').sort(util["compare"]);
        var personArr = person.split(',').sort(util["compare"]);

        var originSelectFlight = flightList.filter(function (item, i) {
          return flightArr.indexOf(String(i)) !== -1;
        });
        var originSelectpsg = psgList.filter(function (item, i) {
          return personArr.indexOf(String(i)) !== -1;
        });

        window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
          page_name: channel === 'TPWL' ? '机票退改-取消行程提交申请页' : '机票退改-退票提交申请页',
          channel_id: channel ? channel : '',
          ticket_number: originSelectpsg.map(function (obj) {
            return obj.ticketNo;
          }).join(';'),
          flight_date: originSelectFlight.map(function (obj) {
            return obj.flightDate;
          }).join(';'),
          flight_number: originSelectFlight.map(function (obj) {
            return obj.flightNo;
          }).join(';'),
          origin_location: originSelectFlight.map(function (obj) {
            return obj.depAirportName;
          }).join(';'),
          destination_location: originSelectFlight.map(function (obj) {
            return obj.arrAirportName;
          }).join(';'),
          passenger_type: originSelectpsg.map(function (obj) {
            return obj.psgType === 3 ? '婴儿' : obj.psgType === 1 || obj.psgType === 2 ? '儿童' : '成人';
          }).join(';'),
          ticket_refund_type: channel === 'TPWL' ? '自愿退票' : originSelectpsg.map(function (obj) {
            return obj.scopeCodes.join(';');
          }).includes('fzytp') ? '非自愿退票' : '自愿退票'
        });

        window.localStorage.removeItem('creatparmar');
        window.sessionStorage.setItem('historyUrl', oldLocation.pathname);
        callback();
      }
      function messageEvent(event) {
        window.removeEventListener('message', messageEvent);
        // 必须验证来源！
        if (event.origin.indexOf('csair.com') < 0) return;
        // { userId: 123, token: 'abc' }
        window.sessionStorage.setItem('nextStepParams', JSON.stringify(event.data));
        window.localStorage.setItem('routeType', event.data.isDomestic ? '国内' : '国际');
        window.sessionStorage.setItem('isAIComming', true);
        store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(event.data));
        gointo();
      }
      if (nextState.location.query.channel == 'AI' && !nextState.location.query.from) {
        if (window.ft && window.ft.miniProgram) {
          window.ft.getStorage({
            key: 'nextStepParams',
            success: function success(data) {
              window.sessionStorage.setItem('nextStepParams', JSON.stringify(data.data));
              window.localStorage.setItem('routeType', data.data.isDomestic ? '国内' : '国际');
              window.sessionStorage.setItem('isAICommingFT', true);
              store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(data.data));
            },
            fail: function fail(data) {},
            complete: function complete(data) {
              gointo();
            }
          });
        }
      } else if (nextState.location.query.channel == 'AI' && nextState.location.query.from === 'assistant') {
        if (/NHPAASWEBVIEW/i.test(navigator.userAgent) && window.nh && typeof window.nh.getStartupParams === 'function') {
          var data = typeof window.nh.getStartupParams() === 'string' ? JSON.parse(window.nh.getStartupParams()) : {};
          window.sessionStorage.setItem('nextStepParams', JSON.stringify(data));
          window.localStorage.setItem('routeType', data.isDomestic ? '国内' : '国际');
          window.sessionStorage.setItem('isAIComming', true);
          store.dispatch(Object(endorsedApply_modules_actions["u" /* saveAiPramas */])(data));
          gointo();
        } else {
          window.addEventListener('message', messageEvent);
        }
      } else {
        gointo();
      }
    },
    onLeave: function onLeave(prevState) {
      window.sessionStorage.removeItem('nextStepParams');
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(4).then((function (require) {
        var Container = __webpack_require__("cBqU").default;
        cb(null, Container);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/wrongPurchase/index.js




/* harmony default export */ var wrongPurchase = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.wrongPurchase.key,
    onEnter: function onEnter(nextState, replace, callback) {
      // gspNewVersion(['错购申请页面', '072-0060-23028-12201'], {
      //   1: '页面曝光一次触发一次',
      //   2: '国双新版',
      //   3: isCsairApp() ? 'App' : 'Mobile',
      // });
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-错购提交申请页',
        channel_id: ''
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(15).then((function (require) {
        var wrongPurchase = __webpack_require__("FqBf").default;
        cb(null, wrongPurchase);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/viewProgress/index.js


/* harmony default export */ var viewProgress = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.viewProgress.key,
    onEnter: function onEnter(nextState, replace, callback) {
      if (window.sessionStorage.getItem('first')) {
        window.location.reload();
        window.sessionStorage.removeItem('first');
      }
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(10).then((function (require) {
        var ViewProgress = __webpack_require__("83Iu").default;
        cb(null, ViewProgress);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/discountTicketApplication/index.js
// GN: [ID1678500][2024-11-26]




/* harmony default export */ var discountTicketApplication = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.discountTicketApplication.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var channel = nextState.location.query.channel;

      // gspNewVersion(['错购申请页面', '072-0060-23028-12201'], {
      //   1: '页面曝光一次触发一次',
      //   2: '国双新版',
      //   3: isCsairApp() ? 'App' : 'Mobile',
      // });

      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-降价客票申请页',
        channel_id: channel ? channel : ''
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(16).then((function (require) {
        var discountTicketApplication = __webpack_require__("CSz6").default;
        cb(null, discountTicketApplication);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/facemoreQurey/index.js



/* harmony default export */ var facemoreQurey = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.facemoreQurey.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var query = nextState.location.query;

      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-码上改签查询页',
        channel_id: query.channel ? query.channel : ''
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(21).then((function (require) {
        var facemoreQurey = __webpack_require__("lgzb").default;
        cb(null, facemoreQurey);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// EXTERNAL MODULE: ./src/routes/routes/changeRefundExplain/components/FeeQueryContainer/index.less
var changeRefundExplain_components_FeeQueryContainer = __webpack_require__("Flp4");
var components_FeeQueryContainer_default = /*#__PURE__*/__webpack_require__.n(changeRefundExplain_components_FeeQueryContainer);

// EXTERNAL MODULE: ./src/routes/routes/changeRefundExplain/assets/icon2-home.png
var icon2_home = __webpack_require__("tHUL");
var icon2_home_default = /*#__PURE__*/__webpack_require__.n(icon2_home);

// CONCATENATED MODULE: ./src/routes/routes/changeRefundExplain/components/FeeQueryContainer/index.js
var components_FeeQueryContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var components_FeeQueryContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function components_FeeQueryContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function components_FeeQueryContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function components_FeeQueryContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import homeIcon2 from '../../assets/home2.png';

var components_FeeQueryContainer_FeeQuery = function (_Component) {
  components_FeeQueryContainer__inherits(FeeQuery, _Component);

  function FeeQuery() {
    var _ref;

    var _temp, _this, _ret;

    components_FeeQueryContainer__classCallCheck(this, FeeQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = components_FeeQueryContainer__possibleConstructorReturn(this, (_ref = FeeQuery.__proto__ || Object.getPrototypeOf(FeeQuery)).call.apply(_ref, [this].concat(args))), _this), _this._navBarLeftClick = function () {
      window.$sensors.sensors.track('fuction_click', {
        page_name: '机票退改说明页',
        fuction_area: '机票退改说明页-顶部导航栏',
        fuction_title: '机票退改说明页-顶部导航栏:返回'
      });
      _this.props.router.goBack();
    }, _this.goHome = function () {
      window.$sensors.sensors.track('fuction_click', {
        page_name: '机票退改说明页',
        fuction_area: '机票退改说明页-顶部导航栏',
        fuction_title: '机票退改说明页-顶部导航栏:回到首页',
        target_url: 'https://m.csair.com'
      });
      window.location.href = 'https://m.csair.com';
    }, _temp), components_FeeQueryContainer__possibleConstructorReturn(_this, _ret);
  }

  components_FeeQueryContainer__createClass(FeeQuery, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          query = _props.location.query,
          lang = _props.lang;


      return components_FeeQueryContainer__jsx('div', {
        className: 'wrapper feeQueryList'
      }, void 0, components_FeeQueryContainer__jsx('header', {}, void 0, components_FeeQueryContainer__jsx(Header["default"], {
        onLeftClick: this._navBarLeftClick,
        rightContent: [components_FeeQueryContainer__jsx('img', {
          alt: '',
          src: icon2_home_default.a,
          onClick: this.goHome,
          style: {
            width: '0.38rem',
            height: '0.38rem',
            marginRight: '0.2rem'
          }
        }, '1')],
        title: !query.channel ? lang.csair : lang.cancellationInt
      })), this.props.children);
    }
  }]);

  return FeeQuery;
}(reactfrom_dll_reference_vendor_library["Component"]);

/* harmony default export */ var routes_changeRefundExplain_components_FeeQueryContainer = (Object(esfrom_dll_reference_vendor_library["connect"])(function (state) {
  return {
    lang: state.App.lang
  };
}, function (dispatch) {
  return {};
})(Object(react_router_esfrom_dll_reference_vendor_library["withRouter"])(components_FeeQueryContainer_FeeQuery)));
// CONCATENATED MODULE: ./src/routes/routes/changeRefundExplain/index.js
// import Routes from 'Routes';
// import { saveOldLocation } from '../../modules/actions';

// export default store => ({
//   path: Routes.ticket.child.changeRefundExplain.key,
//   onEnter(nextState, replace, callback) {
//     callback();
//   },
//   onLeave(prevState) {
//     store.dispatch(saveOldLocation(prevState.location));
//   },
//   getComponent(nextState, cb) {
//     require.ensure(
//       [],
//       require => {
//         const changeRefundExplain = require('./components/changeRefundExplain')
//           .default;
//         cb(null, changeRefundExplain);
//       },
//       'changeRefundExplain'
//     );
//   },
// });

/**
 * 退改计算器结果详情页面
 */


/* harmony default export */ var changeRefundExplain = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.changeRefundExplain.key,
    component: routes_changeRefundExplain_components_FeeQueryContainer,
    getChildRoutes: function getChildRoutes(partialNextState, cb) {
      __webpack_require__.e/* require.ensure */(0).then((function (require) {
        cb(null, [__webpack_require__("Piik").default(store), __webpack_require__("SHtq").default(store)]);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/routes/cancelLation/index.js




/* harmony default export */ var cancelLation = (function (store) {
  return {
    path: routerConfig["default"].ticket.child.cancelLation.key,
    onEnter: function onEnter(nextState, replace, callback) {
      var channel = nextState.location.query.channel;


      Object(enEXchange["a" /* loadStatusCodeMsg */])(['checkOrderTicket', 'checkTicketFlight']);
      window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
        page_name: '机票退改-取消行程列表页',
        channel_id: channel ? channel : ''
      });
      callback();
    },
    onLeave: function onLeave(prevState) {
      store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
    },
    getComponent: function getComponent(nextState, cb) {
      __webpack_require__.e/* require.ensure */(8).then((function (require) {
        var cancelLation = __webpack_require__("hciJ").default;
        cb(null, cancelLation);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});
// CONCATENATED MODULE: ./src/routes/index.js


/**
 * Created by Pactera on 2017/4/14.
 */





// import PopDisposal from 'PopDisposal';





























/* harmony default export */ var routes = __webpack_exports__["default"] = (function (store) {
  return {
    path: routerConfig["default"].ticket.key,
    component: containers_AppContainer,
    onChange: function onChange(prevState, nextState, replace, callback) {
      // 切换路由，全局功能
      if (prevState.location.pathname !== nextState.location.pathname) {
        ProgressBar["a" /* default */].clear();
        PopUpLoad["default"].clear();
        PopUp["default"].clear();
        PopPwd["a" /* default */].clear();
        // PopDisposal.clear();
        Explain["a" /* default */].clear();
        BankAuthPopup["a" /* default */].clear();
        index_web_default.a.hide();
      }
      callback();
    },
    childRoutes: [updateDetail(store), endorsedApply(store), refundApply(store), ticketChanges(store), applySubmit(store), reformProcess(store), addPersonMessage(store), addProductShop(store), faceRecognition(store), certificationResults(store), {
      path: routerConfig["default"].ticket.child.loginFeeQuery.key,
      indexRoute: {
        onEnter: function onEnter(nextState, replace) {
          var _nextState$location = nextState.location,
              search = _nextState$location.search,
              _nextState$location$q = _nextState$location.query,
              lastName = _nextState$location$q.lastName,
              ticketNo = _nextState$location$q.ticketNo;

          if (lastName && ticketNo) {
            replace('' + routerConfig["default"].ticket.child.feeQuery.childs.list.path + search);
          } else {
            replace('' + routerConfig["default"].ticket.child.feeQuery.childs.login.path + search);
          }
        },
        onLeave: function onLeave(prevState) {
          store.dispatch(Object(actions["B" /* saveOldLocation */])(prevState.location));
        }
      }
    }, feeQuery(store), selectDate(store), changeFlight(store), easyLogin(store), pay(store), electronicInvoice(store), coupon(store), refundCoupon(store), wrongPurchase(store), viewProgress(store), discountTicketApplication(store), facemoreQurey(store), changeRefundExplain(store), cancelLation(store)]
  };
});

/***/ }),

/***/ "DT0+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(5);

/***/ }),

/***/ "Dc0G":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "DwgU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dww5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    getDefaultProps: function getDefaultProps() {
        return {
            prefixCls: 'rmc-multi-picker',
            onValueChange: function onValueChange() {}
        };
    },
    getValue: function getValue() {
        var _props = this.props,
            children = _props.children,
            selectedValue = _props.selectedValue;

        if (selectedValue && selectedValue.length) {
            return selectedValue;
        } else {
            if (!children) {
                return [];
            }
            return _react2['default'].Children.map(children, function (c) {
                var cc = _react2['default'].Children.toArray(c.props.children);
                return cc && cc[0] && cc[0].props.value;
            });
        }
    },
    onValueChange: function onValueChange(i, v) {
        var value = this.getValue().concat();
        value[i] = v;
        this.props.onValueChange(value, i);
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "E7Bb":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("gHOb"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),

/***/ "EHRO":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "EJk4":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("hiy0");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "EV8X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("YK8K");

var _index2 = _interopRequireDefault(_index);

var _getDataAttr = __webpack_require__("M9vV");

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tag = function (_React$Component) {
    (0, _inherits3['default'])(Tag, _React$Component);

    function Tag(props) {
        (0, _classCallCheck3['default'])(this, Tag);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onChange = _this$props.onChange;

            if (disabled) {
                return;
            }
            var isSelect = _this.state.selected;
            _this.setState({
                selected: !isSelect
            }, function () {
                if (onChange) {
                    onChange(!isSelect);
                }
            });
        };
        _this.onTagClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
            _this.setState({
                closed: true
            }, _this.props.afterClose);
        };
        _this.state = {
            selected: props.selected,
            closed: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Tag, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.selected !== nextProps.selected) {
                this.setState({
                    selected: nextProps.selected
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                prefixCls = _props.prefixCls,
                disabled = _props.disabled,
                closable = _props.closable,
                small = _props.small,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-normal', !disabled && (!this.state.selected || small || closable)), (0, _defineProperty3['default'])(_classNames, prefixCls + '-small', small), (0, _defineProperty3['default'])(_classNames, prefixCls + '-active', this.state.selected && !disabled && !small && !closable), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-closable', closable), _classNames));
            var closableDom = closable && !disabled && !small ? _react2['default'].createElement(
                'div',
                { className: prefixCls + '-close', role: 'button', onClick: this.onTagClose, 'aria-label': 'remove tag' },
                _react2['default'].createElement(_index2['default'], { type: 'cross-circle', size: 'xs', 'aria-hidden': 'true' })
            ) : null;
            return !this.state.closed ? _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _getDataAttr2['default'])(this.props), { className: wrapCls, onClick: this.onClick, style: style }),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-text' },
                    children
                ),
                closableDom
            ) : null;
        }
    }]);
    return Tag;
}(_react2['default'].Component);

exports['default'] = Tag;

Tag.defaultProps = {
    prefixCls: 'am-tag',
    disabled: false,
    selected: false,
    closable: false,
    small: false,
    onChange: function onChange() {},
    onClose: function onClose() {},
    afterClose: function afterClose() {}
};
module.exports = exports['default'];

/***/ }),

/***/ "Eb96":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "EcGd":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),

/***/ "EmT1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeyboardItem = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__("zMcl");

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var KeyboardItem = exports.KeyboardItem = function (_React$Component) {
    (0, _inherits3['default'])(KeyboardItem, _React$Component);

    function KeyboardItem() {
        (0, _classCallCheck3['default'])(this, KeyboardItem);
        return (0, _possibleConstructorReturn3['default'])(this, (KeyboardItem.__proto__ || Object.getPrototypeOf(KeyboardItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(KeyboardItem, [{
        key: 'render',
        value: function render() {
            var _wrapCls;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                _onClick = _a.onClick,
                className = _a.className,
                disabled = _a.disabled,
                children = _a.children,
                tdRef = _a.tdRef,
                restProps = __rest(_a, ["prefixCls", "onClick", "className", "disabled", "children", "tdRef"]);
            var value = children;
            if (className === 'keyboard-delete') {
                value = 'delete';
            } else if (className === 'keyboard-hide') {
                value = 'hide';
            } else if (className === 'keyboard-confirm') {
                value = 'confirm';
            }
            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item', true), _wrapCls);
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { activeClassName: prefixCls + '-item-active' },
                _react2['default'].createElement(
                    'td',
                    (0, _extends3['default'])({ ref: tdRef, onClick: function onClick(e) {
                            _onClick(e, value);
                        }, className: (0, _classnames2['default'])(wrapCls) }, restProps),
                    children
                )
            );
        }
    }]);
    return KeyboardItem;
}(_react2['default'].Component);

KeyboardItem.defaultProps = {
    prefixCls: 'am-number-keyboard',
    onClick: function onClick() {},
    disabled: false
};

var CustomKeyboard = function (_React$Component2) {
    (0, _inherits3['default'])(CustomKeyboard, _React$Component2);

    function CustomKeyboard() {
        (0, _classCallCheck3['default'])(this, CustomKeyboard);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (CustomKeyboard.__proto__ || Object.getPrototypeOf(CustomKeyboard)).apply(this, arguments));

        _this2.onKeyboardClick = function (e, value) {
            e.nativeEvent.stopImmediatePropagation();
            if (value === 'confirm' && _this2.confirmDisabled) {
                return null;
            } else {
                if (_this2.linkedInput) {
                    _this2.linkedInput.onKeyboardClick(value);
                }
            }
        };
        _this2.renderKeyboardItem = function (item, index) {
            return _react2['default'].createElement(
                KeyboardItem,
                { onClick: _this2.onKeyboardClick, key: 'item-' + item + '-' + index },
                item
            );
        };
        return _this2;
    }

    (0, _createClass3['default'])(CustomKeyboard, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                confirmLabel = _props.confirmLabel;

            var wrapperCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-hide', true), _classNames));
            return _react2['default'].createElement(
                'div',
                { className: wrapperCls, ref: function ref(el) {
                        return _this3.antmKeyboard = el;
                    } },
                _react2['default'].createElement(
                    'table',
                    null,
                    _react2['default'].createElement(
                        'tbody',
                        null,
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['1', '2', '3'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(KeyboardItem, { className: 'keyboard-delete', rowSpan: 2, onClick: this.onKeyboardClick })
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['4', '5', '6'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            })
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['7', '8', '9'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(
                                KeyboardItem,
                                { className: 'keyboard-confirm', rowSpan: 2, onClick: this.onKeyboardClick, tdRef: function tdRef(el) {
                                        return _this3.confirmKeyboardItem = el;
                                    } },
                                confirmLabel
                            )
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['.', '0'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(KeyboardItem, { className: 'keyboard-hide', onClick: this.onKeyboardClick })
                        )
                    )
                )
            );
        }
    }]);
    return CustomKeyboard;
}(_react2['default'].Component);

CustomKeyboard.defaultProps = {
    prefixCls: 'am-number-keyboard'
};
exports['default'] = CustomKeyboard;

/***/ }),

/***/ "F92V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__("4VPq");

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupCascader = function (_React$Component) {
    (0, _inherits3['default'])(PopupCascader, _React$Component);

    function PopupCascader() {
        (0, _classCallCheck3['default'])(this, PopupCascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PopupCascader.__proto__ || Object.getPrototypeOf(PopupCascader)).apply(this, arguments));

        _this.onOk = function (v) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                onOk = _this$props.onOk;

            if (onChange) {
                onChange(v);
            }
            if (onOk) {
                onOk(v);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(PopupCascader, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_Popup2['default'], (0, _extends3['default'])({ picker: this.props.cascader }, this.props, { onOk: this.onOk }));
        }
    }]);
    return PopupCascader;
}(_react2['default'].Component);

PopupCascader.defaultProps = {
    pickerValueProp: 'value',
    pickerValueChangeProp: 'onChange'
};
exports['default'] = PopupCascader;
module.exports = exports['default'];

/***/ }),

/***/ "FNvM":
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__("kxzG");

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber(value);
      other = toNumber(other);
    }
    return operator(value, other);
  };
}

module.exports = createRelationalOperation;


/***/ }),

/***/ "FhcP":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("7YkW"),
    arraySome = __webpack_require__("2X2u"),
    cacheHas = __webpack_require__("dmQx");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "Fkvj":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "Flp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fp5l":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("bGc4"),
    isObjectLike = __webpack_require__("UnEC");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "Fqf1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),

/***/ "G8ar":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "GB3+":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("1rEs").f;
var has = __webpack_require__("l/2K");
var TO_STRING_TAG = __webpack_require__("jAiL")('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "GDZS":
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__("J009");

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ "GPcm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("rUAC")(true);
var InternalStateModule = __webpack_require__("I1z2");
var defineIterator = __webpack_require__("RxPu");
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = at(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "HAas":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "HC1p":
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__("y9sD"),
    baseUnary = __webpack_require__("S7p9"),
    nodeUtil = __webpack_require__("Dc0G");

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),

/***/ "HLWT":
/***/ (function(module, exports, __webpack_require__) {

var UNSCOPABLES = __webpack_require__("jAiL")('unscopables');
var create = __webpack_require__("43zn");
var hide = __webpack_require__("wkr2");
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) hide(ArrayPrototype, UNSCOPABLES, create(null));

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "HT7L":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "HTl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = explainBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__ = __webpack_require__("h2Na");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__ = __webpack_require__("YK8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__("DwgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var popupQueue = [];

var _ref = _jsx('i', {});

var _ref2 = _jsx('span', {}, void 0, '|');

var _ref3 = _jsx('li', {
  className: 'arrows'
}, void 0, _jsx('span', {}), _jsx('div', {
  className: 'triangle_border_right'
}));

var _ref4 = _jsx('span', {});

var Explain = function (_PureComponent) {
  _inherits(Explain, _PureComponent);

  function Explain(props) {
    _classCallCheck(this, Explain);

    var _this = _possibleConstructorReturn(this, (Explain.__proto__ || Object.getPrototypeOf(Explain)).call(this, props));

    var conditions = _this.props.conditions;

    _this.state = {
      arr: conditions,
      showTextIndex: 0,
      hidden: true
    };
    return _this;
  }
  //点击展开、关闭规则文字


  _createClass(Explain, [{
    key: 'showRlues',
    value: function showRlues(e, index) {
      e.stopPropagation();
      this.setState({ showTextIndex: index });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onClose = _props.onClose,
          lang = _props.lang;
      var _state = this.state,
          arr = _state.arr,
          showTextIndex = _state.showTextIndex;

      var isShowText = [];
      arr.map(function (obj, index) {
        if (index === showTextIndex) {
          return isShowText.push(true);
        } else {
          return isShowText.push(false);
        }
      });
      return _jsx('div', {
        className: 'explain_main_bg',
        role: 'button',
        'aria-label': '\u5173\u95ED',
        onClick: onClose
      }, void 0, _jsx('div', {
        className: 'max_heght_box'
      }, void 0, arr.map(function (obj, index) {
        return _jsx('div', {
          className: 'rules_content changebg_color',
          onClick: function onClick(e) {
            e.stopPropagation();
          }
        }, void 0, arr.length > 1 ? _jsx('div', {
          className: 'border',
          role: 'button',
          onClick: function onClick(e) {
            return _this2.showRlues(e, index);
          }
        }, void 0, _jsx('div', {
          className: 'flight_title'
        }, void 0, _ref, obj.flightNo, '\xA0', _ref2, '\xA0', obj.flightClass), _jsx('ul', {}, void 0, _jsx('li', {
          className: 'voyage'
        }, void 0, _jsx('p', {}, void 0, obj.depTime), _jsx('span', {}, void 0, obj.depAirportName)), _ref3, _jsx('li', {
          className: 'voyage'
        }, void 0, _jsx('p', {}, void 0, obj.arrTime), _jsx('span', {}, void 0, obj.arrAirportName))), _jsx('a', {
          className: 'text_btn'
        }, void 0, isShowText[index] ? '∧' : '∨')) : null, _jsx('div', {
          className: 'showRules_text',
          style: { display: isShowText[index] ? 'block' : 'none' }
        }, void 0, _jsx('div', {
          className: 'rules_title'
        }, void 0, _ref4, lang.TermsOfUse), _jsx('div', {
          className: 'description_rules'
        }, void 0, _jsx('div', {
          className: 'rules1'
        }, void 0, obj.adultInstructions))));
      })));
    }
  }]);

  return Explain;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Explain.defaultProps = {
  conditions: []
};

var _ref5 = _jsx('div', {
  className: 'arrows'
}, void 0, _jsx('span', {}), _jsx('div', {
  className: 'triangle_border_right'
}));

var _ref6 = _jsx('th', {});

var ExplainRules = function (_PureComponent2) {
  _inherits(ExplainRules, _PureComponent2);

  function ExplainRules(props) {
    _classCallCheck(this, ExplainRules);

    var _this3 = _possibleConstructorReturn(this, (ExplainRules.__proto__ || Object.getPrototypeOf(ExplainRules)).call(this, props));

    _this3._handleClickLeft = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var index = _this3.state.index;

      if (index === 0) {
        return false;
      }
      _this3.setState({
        index: index - 1
      });
    };

    _this3._handleClickRight = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var index = _this3.state.index;

      if (index + 1 === _this3.props.conditions.length) {
        return false;
      }
      _this3.setState({
        index: index + 1
      });
    };

    var conditions = _this3.props.conditions;

    _this3.state = {
      arr: conditions,
      index: 0,
      hidden: true
    };
    return _this3;
  }
  //点击展开、关闭规则文字


  _createClass(ExplainRules, [{
    key: 'showRlues',
    value: function showRlues(e, index) {
      e.stopPropagation();
      this.setState({ showTextIndex: index });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onClose = _props2.onClose,
          conditions = _props2.conditions,
          lang = _props2.lang;
      var index = this.state.index;

      var obj = conditions[index];
      var _obj$segmentlabletext = obj.segmentlabletext.changeRefundRule,
          beforeChange = _obj$segmentlabletext.beforeChange,
          afterChange = _obj$segmentlabletext.afterChange,
          beforeRefund = _obj$segmentlabletext.beforeRefund,
          afterRefund = _obj$segmentlabletext.afterRefund;

      return _jsx('div', {
        className: 'explain explain__layoutCenter',
        onClick: onClose
      }, void 0, _jsx('div', {
        className: 'explain__content'
      }, void 0, _jsx('div', {
        className: 'explain__top'
      }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default.a, {
        type: 'left',
        onClick: this._handleClickLeft
      })), _jsx('div', {
        className: 'explain__flightInfo'
      }, void 0, _jsx('div', {}, void 0, obj.flightNo + ' | ' + obj.flightDate), _jsx('div', {
        className: 'flight'
      }, void 0, _jsx('div', {
        className: 'dep'
      }, void 0, _jsx('div', {}, void 0, obj.depTime), _jsx('div', {}, void 0, obj.depCityName)), _ref5, _jsx('div', {
        className: 'arrive'
      }, void 0, _jsx('div', {}, void 0, obj.arrTime), _jsx('div', {}, void 0, obj.arrCityName)))), _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default.a, {
        type: 'right',
        onClick: this._handleClickRight
      }))), _jsx('div', {
        className: 'explain__bottom'
      }, void 0, _jsx('div', {}, void 0, lang.rfInstruction), _jsx('div', {
        className: 'explain__table'
      }, void 0, _jsx('table', {
        cellspacing: '0',
        cellpadding: '0'
      }, void 0, _jsx('tr', {}, void 0, _ref6, _jsx('th', {}, void 0, lang.unused), _jsx('th', {}, void 0, lang.partiallyUsed)), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, lang.updateDetail56), _jsx('td', {}, void 0, beforeChange === 'N' ? lang.noChange : beforeChange), _jsx('td', {}, void 0, afterChange === 'N' ? lang.noChange : afterChange)), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, lang.updateDetail57), _jsx('td', {}, void 0, beforeRefund === 'N' ? lang.noRefund : beforeRefund), _jsx('td', {}, void 0, afterRefund === 'N' ? lang.noRefund : afterRefund)))), _jsx('div', {}, void 0, lang.referenceTip))));
    }
  }]);

  return ExplainRules;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

ExplainRules.defaultProps = {
  conditions: []
};


function explainBox() {
  var data = arguments.length <= 0 ? undefined : arguments[0];
  var isBrandFreight = (arguments.length <= 1 ? undefined : arguments[1]) || false;

  var div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    if (!div) return;
    __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  if (!isBrandFreight) {
    __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(_jsx(Explain, {
      conditions: data,
      onClose: function onClose() {
        close();
      }
    }), div);
  } else {
    __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(_jsx(ExplainRules, {
      conditions: data,
      onClose: function onClose() {
        close();
      }
    }), div);
  }

  popupQueue.push({
    close: close
  });

  return popupQueue[popupQueue.length - 1];
}

explainBox.clear = function () {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(function (progess) {
      progess.close();
    });
    popupQueue = [];
  }
};

/***/ }),

/***/ "HVdB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("r54x")(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "He3V":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("q0qZ");
var propertyIsEnumerableModule = __webpack_require__("NGss");
var createPropertyDescriptor = __webpack_require__("C1ru");
var toIndexedObject = __webpack_require__("9mDF");
var toPrimitive = __webpack_require__("whWw");
var has = __webpack_require__("l/2K");
var IE8_DOM_DEFINE = __webpack_require__("K6eN");
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "HpvJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var bind = __webpack_require__("Xo5R");
var getSetIterator = __webpack_require__("BGpQ");

// `Set.prototype.every` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  every: function every(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var step, value;
    while (!(step = iterator.next()).done) {
      if (!boundFunction(value = step.value, value, set)) return false;
    } return true;
  }
});


/***/ }),

/***/ "Hxdr":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "I1z2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("hcE8");
var nativeFunctionToString = __webpack_require__("0Q51");
var isObject = __webpack_require__("HAas");
var hide = __webpack_require__("wkr2");
var objectHas = __webpack_require__("l/2K");
var sharedKey = __webpack_require__("siPu");
var hiddenKeys = __webpack_require__("Eb96");
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    } return state;
  };
};

if (typeof WeakMap == 'function' && /native code/.test(nativeFunctionToString.call(WeakMap))) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    hide(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "ICSD":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "INOt":
/***/ (function(module, exports, __webpack_require__) {

// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("BGSR")('Map');


/***/ }),

/***/ "J009":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ "JBvZ":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "JDN0":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isArray = __webpack_require__("NGEn"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "K5Hn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("jMIW");

/***/ }),

/***/ "K6eN":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("q0qZ") && !__webpack_require__("r54x")(function () {
  return Object.defineProperty(__webpack_require__("P1fK")('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "KGqH":
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "KKFe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    WrapComponent: 'div',
    transitionName: 'am-slide-up',
    maskTransitionName: 'am-fade'
};
module.exports = exports['default'];

/***/ }),

/***/ "Kbrx":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("jAiL")('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (e) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "L3oL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "L7dY":
/***/ (function(module, exports, __webpack_require__) {

var baseGt = __webpack_require__("SP2x"),
    createRelationalOperation = __webpack_require__("FNvM");

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

module.exports = gt;


/***/ }),

/***/ "L8MQ":
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__("ktnU"),
    keys = __webpack_require__("ktak");

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ "LSBV":
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__("EcGd"),
    baseUnary = __webpack_require__("S7p9"),
    nodeUtil = __webpack_require__("Dc0G");

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),

/***/ "LjUa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("qEBd");

__webpack_require__("qbRp");
__webpack_require__("5d6Q");
__webpack_require__("9VpW");
__webpack_require__("XZwo");
__webpack_require__("HpvJ");
__webpack_require__("7Qw4");
__webpack_require__("RsNe");
__webpack_require__("cjLM");
__webpack_require__("Qun8");
__webpack_require__("Vlko");
__webpack_require__("mt/P");
__webpack_require__("TNZR");
__webpack_require__("Vxs6");
__webpack_require__("lAmK");
__webpack_require__("2S96");


/***/ }),

/***/ "MIb3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'castArray': __webpack_require__("Rhpv"),
  'clone': __webpack_require__("rezj"),
  'cloneDeep': __webpack_require__("kvU2"),
  'cloneDeepWith': __webpack_require__("lQmB"),
  'cloneWith': __webpack_require__("nIBz"),
  'conformsTo': __webpack_require__("cfiI"),
  'eq': __webpack_require__("22B7"),
  'gt': __webpack_require__("L7dY"),
  'gte': __webpack_require__("6TdU"),
  'isArguments': __webpack_require__("1Yb9"),
  'isArray': __webpack_require__("NGEn"),
  'isArrayBuffer': __webpack_require__("ghWY"),
  'isArrayLike': __webpack_require__("bGc4"),
  'isArrayLikeObject': __webpack_require__("Fp5l"),
  'isBoolean': __webpack_require__("DEG1"),
  'isBuffer': __webpack_require__("ggOT"),
  'isDate': __webpack_require__("LSBV"),
  'isElement': __webpack_require__("b+MK"),
  'isEmpty': __webpack_require__("lHK6"),
  'isEqual': __webpack_require__("hygk"),
  'isEqualWith': __webpack_require__("e4xA"),
  'isError': __webpack_require__("Xu6E"),
  'isFinite': __webpack_require__("du7g"),
  'isFunction': __webpack_require__("gGqR"),
  'isInteger': __webpack_require__("8Lhr"),
  'isLength': __webpack_require__("Rh28"),
  'isMap': __webpack_require__("dwsC"),
  'isMatch': __webpack_require__("h012"),
  'isMatchWith': __webpack_require__("6lrk"),
  'isNaN': __webpack_require__("GDZS"),
  'isNative': __webpack_require__("42xy"),
  'isNil': __webpack_require__("q16o"),
  'isNull': __webpack_require__("qtVo"),
  'isNumber': __webpack_require__("J009"),
  'isObject': __webpack_require__("yCNF"),
  'isObjectLike': __webpack_require__("UnEC"),
  'isPlainObject': __webpack_require__("9UkZ"),
  'isRegExp': __webpack_require__("HC1p"),
  'isSafeInteger': __webpack_require__("jVrk"),
  'isSet': __webpack_require__("SGXn"),
  'isString': __webpack_require__("JDN0"),
  'isSymbol': __webpack_require__("6MiT"),
  'isTypedArray': __webpack_require__("YsVG"),
  'isUndefined': __webpack_require__("hz+3"),
  'isWeakMap': __webpack_require__("E7Bb"),
  'isWeakSet': __webpack_require__("w+5H"),
  'lt': __webpack_require__("BcSr"),
  'lte': __webpack_require__("PDII"),
  'toArray': __webpack_require__("nIHh"),
  'toFinite': __webpack_require__("sBat"),
  'toInteger': __webpack_require__("5Zxu"),
  'toLength': __webpack_require__("rNS8"),
  'toNumber': __webpack_require__("kxzG"),
  'toPlainObject': __webpack_require__("TlPD"),
  'toSafeInteger': __webpack_require__("nbNu"),
  'toString': __webpack_require__("ZT2e")
};


/***/ }),

/***/ "MoMe":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "MzAl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("HAas");
var anObject = __webpack_require__("5+O3");

module.exports = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(String(proto) + ": can't set as a prototype!");
};


/***/ }),

/***/ "N5RP":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("hcE8").document;

module.exports = document && document.documentElement;


/***/ }),

/***/ "NGEn":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "NGss":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = nativeGetOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "NkRn":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "OAwv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(259);

/***/ }),

/***/ "OC/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_SELECT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPLEACE_SELECT_DATE; });
/* unused harmony export CHECK_FLIGHT_DATE */
/* harmony export (immutable) */ __webpack_exports__["g"] = saveDate;
/* harmony export (immutable) */ __webpack_exports__["f"] = repleaceDate;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearSelectDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkFlightDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var SAVE_SELECT_DATE = 'SAVE_SELECT_DATE';
var CLEAR_SELECT_DATE = 'CLEAR_SELECT_DATE';
var REPLEACE_SELECT_DATE = 'REPLEACE_SELECT_DATE';
var CHECK_FLIGHT_DATE = 'CHECK_FLIGHT_DATE';

// 选择日期
function saveDate(data) {
  return { type: SAVE_SELECT_DATE, data: data };
}

// 替换日期
function repleaceDate(data, num) {
  return { type: REPLEACE_SELECT_DATE, data: data, num: num };
}

// 清空选择日期数据
function clearSelectDate() {
  return { type: CLEAR_SELECT_DATE };
}

// 校验日期
function checkFlightDate(data) {
  return {
    type: 'CHECK_FLIGHT_DATE',
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].checkFlightDate,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "P1fK":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("HAas");
var document = __webpack_require__("hcE8").document;
// typeof document.createElement is 'object' in old IE
var exist = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return exist ? document.createElement(it) : {};
};


/***/ }),

/***/ "PDII":
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__("FNvM");

/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = createRelationalOperation(function(value, other) {
  return value <= other;
});

module.exports = lte;


/***/ }),

/***/ "PYrI":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("l/2K");
var ownKeys = __webpack_require__("aske");
var getOwnPropertyDescriptorModule = __webpack_require__("He3V");
var definePropertyModule = __webpack_require__("1rEs");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "PedI":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "PfJA":
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "Q3+A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("hcE8");
var definePropertyModule = __webpack_require__("1rEs");
var DESCRIPTORS = __webpack_require__("q0qZ");
var SPECIES = __webpack_require__("jAiL")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) definePropertyModule.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "QOUF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
function hasClass(node, className) {
    if (node.classList) {
        return node.classList.contains(className);
    }
    var originClass = node.className;
    return (' ' + originClass + ' ').indexOf(' ' + className + ' ') > -1;
}
function addClass(node, className) {
    if (node.classList) {
        node.classList.add(className);
    } else {
        if (!hasClass(node, className)) {
            node.className = node.className + ' ' + className;
        }
    }
}
function removeClass(node, className) {
    if (node.classList) {
        node.classList.remove(className);
    } else {
        if (hasClass(node, className)) {
            var originClass = node.className;
            node.className = (' ' + originClass + ' ').replace(' ' + className + ' ', '');
        }
    }
}

/***/ }),

/***/ "QeGx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("K5Hn");

__webpack_require__("qYHz");

/***/ }),

/***/ "Qun8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("odTk");
var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var speciesConstructor = __webpack_require__("Xfp1");
var iterate = __webpack_require__("UHV6");
var Set = path.Set;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  intersection: function intersection(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, Set))();
    var hasCheck = aFunction(set.has);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      if (hasCheck.call(set, value)) adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "Rh28":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "Rhpv":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("NGEn");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "RiGx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RmFE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _createReactClass = __webpack_require__("DT0+");

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _MultiPickerMixin = __webpack_require__("Dww5");

var _MultiPickerMixin2 = _interopRequireDefault(_MultiPickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MultiPicker = (0, _createReactClass2['default'])({
    mixins: [_MultiPickerMixin2['default']],
    render: function render() {
        var _this = this;

        var _props = this.props,
            prefixCls = _props.prefixCls,
            className = _props.className,
            rootNativeProps = _props.rootNativeProps,
            children = _props.children;

        var selectedValue = this.getValue();
        var colElements = _react2['default'].Children.map(children, function (col, i) {
            return _react2['default'].cloneElement(col, {
                selectedValue: selectedValue[i],
                onValueChange: function onValueChange() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return _this.onValueChange.apply(_this, [i].concat(args));
                }
            });
        });
        return _react2['default'].createElement(
            'div',
            (0, _extends3['default'])({}, rootNativeProps, { style: this.props.style, className: (0, _classnames2['default'])(className, prefixCls) }),
            colElements
        );
    }
});
exports['default'] = MultiPicker;
module.exports = exports['default'];

/***/ }),

/***/ "RsNe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var speciesConstructor = __webpack_require__("Xfp1");
var getSetIterator = __webpack_require__("BGpQ");
var Set = __webpack_require__("odTk").Set;

// `Set.prototype.filter` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, Set))();
    var adder = aFunction(newSet.add);
    var step, value;
    while (!(step = iterator.next()).done) {
      if (boundFunction(value = step.value, value, set)) adder.call(newSet, value);
    }
    return newSet;
  }
});


/***/ }),

/***/ "RxPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("i9tX");
var createIteratorConstructor = __webpack_require__("ot7w");
var getPrototypeOf = __webpack_require__("wzd1");
var setPrototypeOf = __webpack_require__("jE8y");
var setToStringTag = __webpack_require__("GB3+");
var hide = __webpack_require__("wkr2");
var redefine = __webpack_require__("+opI");
var IS_PURE = __webpack_require__("pzR0");
var ITERATOR = __webpack_require__("jAiL")('iterator');
var Iterators = __webpack_require__("eZ0g");
var IteratorsCore = __webpack_require__("UFcy");
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          hide(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    hide(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "S7p9":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "SGXn":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "SHWz":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("MoMe");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "SP2x":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),

/***/ "Sh04":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var speciesConstructor = __webpack_require__("Xfp1");
var getMapIterator = __webpack_require__("8o2t");
var Map = __webpack_require__("odTk").Map;

// `Map.prototype.mapValues` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  mapValues: function mapValues(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, Map))();
    var setter = aFunction(newMap.set);
    var step, entry, key;
    while (!(step = iterator.next()).done) {
      entry = step.value;
      setter.call(newMap, key = entry[0], boundFunction(entry[1], key, map));
    }
    return newMap;
  }
});


/***/ }),

/***/ "TNZR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var getSetIterator = __webpack_require__("BGpQ");

// `Set.prototype.reduce` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var accumulator, step, value;
    aFunction(callbackfn);
    if (arguments.length > 1) accumulator = arguments[1];
    else {
      step = iterator.next();
      if (step.done) throw TypeError('Reduce of empty set with no initial value!');
      accumulator = step.value;
    }
    while (!(step = iterator.next()).done) {
      accumulator = callbackfn(accumulator, value = step.value, value, set);
    }
    return accumulator;
  }
});


/***/ }),

/***/ "TQ3y":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "TVUd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__("Fqf1");

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ "TlPD":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    keysIn = __webpack_require__("t8rQ");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "U3tk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__("k2+/");

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),

/***/ "UFcy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("wzd1");
var hide = __webpack_require__("wkr2");
var has = __webpack_require__("l/2K");
var IS_PURE = __webpack_require__("pzR0");
var ITERATOR = __webpack_require__("jAiL")('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "UGHC":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "UHV6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("5+O3");
var isArrayIteratorMethod = __webpack_require__("gado");
var toLength = __webpack_require__("xDUa");
var bind = __webpack_require__("Xo5R");
var getIteratorMethod = __webpack_require__("URKv");
var callWithSafeIterationClosing = __webpack_require__("f1+4");
var BREAK = {};

var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
  var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, step;

  if (ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable!');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
        if (result === BREAK) return;
      } return;
    }
    iterator = iterFn.call(iterable);
  }

  while (!(step = iterator.next()).done) {
    if (callWithSafeIterationClosing(iterator, boundFunction, step.value, ENTRIES) === BREAK) return;
  }
};

exports.BREAK = BREAK;


/***/ }),

/***/ "URKv":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("jgJS");
var ITERATOR = __webpack_require__("jAiL")('iterator');
var Iterators = __webpack_require__("eZ0g");

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "UnEC":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "UtYm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uz1a":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    equalArrays = __webpack_require__("FhcP"),
    equalByTag = __webpack_require__("EHRO"),
    equalObjects = __webpack_require__("SHWz"),
    getTag = __webpack_require__("gHOb"),
    isArray = __webpack_require__("NGEn"),
    isBuffer = __webpack_require__("ggOT"),
    isTypedArray = __webpack_require__("YsVG");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "V+c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("1rEs").f;
var create = __webpack_require__("43zn");
var redefineAll = __webpack_require__("XM+g");
var bind = __webpack_require__("Xo5R");
var anInstance = __webpack_require__("tyBP");
var iterate = __webpack_require__("UHV6");
var defineIterator = __webpack_require__("RxPu");
var setSpecies = __webpack_require__("Q3+A");
var DESCRIPTORS = __webpack_require__("q0qZ");
var fastKey = __webpack_require__("0LGO").fastKey;
var InternalStateModule = __webpack_require__("I1z2");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME);
      setInternalState(that, {
        type: NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, NAME, IS_MAP) {
    var ITERATOR_NAME = NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "VaZJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Vlko":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var getSetIterator = __webpack_require__("BGpQ");

// `Set.prototype.join` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  join: function join(separator) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var sep = separator === undefined ? ',' : String(separator);
    var result = [];
    var step;
    while (!(step = iterator.next()).done) result.push(step.value);
    return result.join(sep);
  }
});


/***/ }),

/***/ "Vxs6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var bind = __webpack_require__("Xo5R");
var getSetIterator = __webpack_require__("BGpQ");

// `Set.prototype.some` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  some: function some(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var step, value;
    while (!(step = iterator.next()).done) {
      if (boundFunction(value = step.value, value, set)) return true;
    } return false;
  }
});


/***/ }),

/***/ "WFiI":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "WIhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = saveRefundAppStore;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRefundAppStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__ = __webpack_require__("mekh");


function removePropertyOfNull(obj) {
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'undefined' || obj[key] === null) delete obj[key];
  });
  return obj;
}

function saveRefundAppStore(state) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["C" /* isCsairApp */])()) return false;
  var EdorsedApply = state.EdorsedApply;

  Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["F" /* saveLocalData */])('EMP_STORE_CHANNEL', JSON.parse(window.sessionStorage.getItem('emp_channel') ? window.sessionStorage.getItem('emp_channel') : null));
  Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["F" /* saveLocalData */])('EMP_STORE_EDORSEDAPPLY', removePropertyOfNull({
    flightList: EdorsedApply.flightList.map(function (item) {
      return removePropertyOfNull(item);
    }),
    psgList: EdorsedApply.psgList.map(function (item) {
      return removePropertyOfNull(item);
    }),
    ticketNo: EdorsedApply.ticketNo,
    orderNo: EdorsedApply.orderNo,
    isDomestic: EdorsedApply.isDomestic,
    refundMethod: EdorsedApply.refundMethod,
    ticketClass: EdorsedApply.ticketClass,
    ticketType: EdorsedApply.ticketType,
    xProduct: {
      flightProductId: '',
      products: [],
      xSoProducts: {}
    }
  }));
}

function getRefundAppStore() {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["C" /* isCsairApp */])()) return false;
  window.sessionStorage.setItem('emp_channel', JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["o" /* getLocalData */])('EMP_STORE_CHANNEL')));
  return Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["o" /* getLocalData */])('EMP_STORE_EDORSEDAPPLY');
}

/***/ }),

/***/ "WvIn":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(String(it) + ' is not a function!');
  return it;
};


/***/ }),

/***/ "WxI4":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "XM+g":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("+opI");

module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "XZwo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");

// `Set.prototype.deleteAll` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  deleteAll: function deleteAll(/* ...elements */) {
    var set = anObject(this);
    var remover = aFunction(set['delete']);
    var result = true;
    for (var k = 0, len = arguments.length; k < len; k++) {
      if (!remover.call(set, arguments[k])) result = false;
    }
    return result;
  }
});


/***/ }),

/***/ "Xfp1":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var SPECIES = __webpack_require__("jAiL")('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "Xo5R":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("WvIn");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "XszO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var speciesConstructor = __webpack_require__("Xfp1");
var getMapIterator = __webpack_require__("8o2t");
var Map = __webpack_require__("odTk").Map;

// `Map.prototype.filter` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, Map))();
    var setter = aFunction(newMap.set);
    var step, entry, key, value;
    while (!(step = iterator.next()).done) {
      entry = step.value;
      if (boundFunction(value = entry[1], key = entry[0], map)) setter.call(newMap, key, value);
    }
    return newMap;
  }
});


/***/ }),

/***/ "Xu6E":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC"),
    isPlainObject = __webpack_require__("9UkZ");

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),

/***/ "YDHx":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("Uz1a"),
    isObjectLike = __webpack_require__("UnEC");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "YeaM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var speciesConstructor = __webpack_require__("Xfp1");
var getMapIterator = __webpack_require__("8o2t");
var Map = __webpack_require__("odTk").Map;

// `Map.prototype.mapKeys` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, Map))();
    var setter = aFunction(newMap.set);
    var step, entry, value;
    while (!(step = iterator.next()).done) {
      entry = step.value;
      setter.call(newMap, boundFunction(value = entry[1], entry[0], map), value);
    }
    return newMap;
  }
});


/***/ }),

/***/ "YsVG":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "YveC":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "ZQx6":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

module.exports = baseConformsTo;


/***/ }),

/***/ "ZT2e":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "Zywo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SELECT_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INIT_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_REFUND_COUPONS; });
/* harmony export (immutable) */ __webpack_exports__["i"] = selectCoupon;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancelCoupon;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCoupons;
/* unused harmony export touchRefundSearchBGQ */
/* harmony export (immutable) */ __webpack_exports__["g"] = clearCoupon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var GET_COUPONS = 'GET_COUPONS';
var SELECT_COUPON = 'SELECT_COUPON';
var CANCEL_COUPON = 'CANCEL_COUPON';
var INIT_COUPON = 'INIT_COUPON';
var GET_REFUND_COUPONS = 'GET_REFUND_COUPONS';

function selectCoupon(code, psgSegmentData, couponData, price) {
  return {
    type: SELECT_COUPON,
    code: code,
    psgSegmentData: psgSegmentData,
    couponData: couponData,
    price: price
  };
}

function cancelCoupon(code) {
  return {
    type: CANCEL_COUPON,
    couponCode: code
  };
}

function getCoupons(data) {
  return {
    type: GET_COUPONS,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getCoupons,
        method: 'post',
        data: data
      }
    }
  };
}

function touchRefundSearchBGQ(data) {
  return {
    type: GET_REFUND_COUPONS,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].touchRefundSearchBGQ,
        method: 'post',
        data: data
      }
    }
  };
}

function clearCoupon() {
  return {
    type: INIT_COUPON
  };
}

/***/ }),

/***/ "a/rO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("9mDF");
var addToUnscopables = __webpack_require__("HLWT");
var Iterators = __webpack_require__("eZ0g");
var InternalStateModule = __webpack_require__("I1z2");
var defineIterator = __webpack_require__("RxPu");
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "aCM0":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "apQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/style/css.web.js
var css_web = __webpack_require__("gj9y");
var css_web_default = /*#__PURE__*/__webpack_require__.n(css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/index.web.js
var index_web = __webpack_require__("qZDr");
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/icon/style/css.web.js
var style_css_web = __webpack_require__("h2Na");
var style_css_web_default = /*#__PURE__*/__webpack_require__.n(style_css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/icon/index.web.js
var icon_index_web = __webpack_require__("YK8K");
var icon_index_web_default = /*#__PURE__*/__webpack_require__.n(icon_index_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/checkbox/style/css.web.js
var checkbox_style_css_web = __webpack_require__("fs/i");
var checkbox_style_css_web_default = /*#__PURE__*/__webpack_require__.n(checkbox_style_css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/checkbox/index.web.js
var checkbox_index_web = __webpack_require__("Bp4u");
var checkbox_index_web_default = /*#__PURE__*/__webpack_require__.n(checkbox_index_web);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./src/components/staticData/tips.js
var tips = __webpack_require__("EjGm");

// EXTERNAL MODULE: ./src/config/urlConfig.js
var urlConfig = __webpack_require__("8oYa");

// EXTERNAL MODULE: delegated ./node_modules/query-string/index.js from dll-reference vendor_library
var query_stringfrom_dll_reference_vendor_library = __webpack_require__("OAwv");
var query_stringfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(query_stringfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./src/components/MemberPopup/index.less
var MemberPopup = __webpack_require__("+Gv0");
var MemberPopup_default = /*#__PURE__*/__webpack_require__.n(MemberPopup);

// EXTERNAL MODULE: ./src/components/Btn/index.js
var Btn = __webpack_require__("yU3I");

// EXTERNAL MODULE: ./src/components/MemberPopup/assets/member.png
var member = __webpack_require__("xtxt");
var member_default = /*#__PURE__*/__webpack_require__.n(member);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/tag/style/css.web.js
var tag_style_css_web = __webpack_require__("sjsj");
var tag_style_css_web_default = /*#__PURE__*/__webpack_require__.n(tag_style_css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/tag/index.web.js
var tag_index_web = __webpack_require__("EV8X");
var tag_index_web_default = /*#__PURE__*/__webpack_require__.n(tag_index_web);

// EXTERNAL MODULE: ./src/components/RatePopup/index.less
var RatePopup = __webpack_require__("UtYm");
var RatePopup_default = /*#__PURE__*/__webpack_require__.n(RatePopup);

// CONCATENATED MODULE: ./src/components/RatePopup/index.js








var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var popPwdQueue = [];

var _ref2 = _jsx('div', {
  className: 'text'
}, void 0, '\u5728\u4F7F\u7528\u65F6\u9047\u5230\u4E86\u95EE\u9898?');

var RatePopup__ref3 = _jsx('div', {
  className: 'text'
}, void 0, '\u63A8\u8350\u7684\u539F\u56E0\u662F?');

var RatePopup__ref4 = _jsx('div', {
  className: 'view'
}, void 0, _jsx('span', {}, void 0, '\u975E\u5E38\u4E0D\u613F\u610F'), _jsx('span', {}, void 0, '\u975E\u5E38\u613F\u610F'));

var RatePopup_RateComponent = function (_Component) {
  _inherits(RateComponent, _Component);

  function RateComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RateComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RateComponent.__proto__ || Object.getPrototypeOf(RateComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rate: '',
      textShow: false,
      tList: {
        dissatisArr: ['退款速度慢', '价格不透明', '系统体验差', '操作卡顿', '其他'],
        satisArr: ['退款速度快', '价格透明', '系统体验好', '操作便捷', '其他']
      },
      sList: {
        satisArr: ['价格透明', '支付安全便捷', '系统体验佳', '其他'],
        dissatisArr: ['价格不透明', '支付不够便捷', '系统体验差', '其他']
      },
      describe: ''
    }, _this.reasonOptions = [], _this.setRate = function (val) {
      var rate = _this.state.rate;

      if (rate > 8 && val < 8 || rate < 7 && val > 7) {
        _this.setState({
          textShow: false
        });
      }

      _this.setState({
        rate: val
      });
    }, _this.rateReason = function (selected, item) {
      if (selected && item === '其他') {
        _this.setState({
          textShow: true
        });
      } else if (!selected && item === '其他') {
        _this.setState({
          textShow: false
        });
      }

      if (selected && item !== '其他') {
        _this.reasonOptions.push(item);
      } else {
        _this.reasonOptions = _this.reasonOptions.filter(function (i) {
          return i !== item;
        });
      }
    }, _this.textInput = function (e) {
      _this.setState({
        describe: e.target.value
      });
    }, _this.renderRateTab = function (orderNo) {
      var _this$state = _this.state,
          rate = _this$state.rate,
          textShow = _this$state.textShow,
          sList = _this$state.sList,
          tList = _this$state.tList;

      var arr = void 0;
      if (orderNo.indexOf('S') !== -1) {
        arr = sList;
      } else {
        arr = tList;
      }
      return _jsx('div', {}, void 0, typeof rate === 'number' && rate <= 6 && _jsx('div', {
        className: 'reasonItem'
      }, void 0, _ref2, _jsx('div', {}, void 0, arr.dissatisArr.map(function (item, index) {
        return _jsx(tag_index_web_default.a, {
          onChange: function onChange(selected) {
            _this.rateReason(selected, item);
          }
        }, void 0, item);
      })), textShow && _jsx('textarea', {
        placeholder: '\u8BF7\u63CF\u8FF0\u60A8\u7684\u95EE\u9898',
        rows: '3',
        onChange: function onChange(e) {
          _this.textInput(e);
        }
      })), rate > 8 && _jsx('div', {
        className: 'reasonItem'
      }, void 0, RatePopup__ref3, _jsx('div', {}, void 0, arr.satisArr.map(function (item, index) {
        return _jsx(tag_index_web_default.a, {
          onChange: function onChange(selected) {
            _this.rateReason(selected, item);
          }
        }, void 0, item);
      })), textShow && _jsx('textarea', {
        placeholder: '\u8BF7\u63CF\u8FF0\u60A8\u7684\u95EE\u9898',
        rows: '3',
        onChange: function onChange(e) {
          _this.textInput(e);
        }
      })));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RateComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onCancel = _props.onCancel,
          onConfirm = _props.onConfirm,
          destroy = _props.destroy,
          toHome = _props.toHome,
          orderNo = _props.orderNo;
      var _state = this.state,
          rate = _state.rate,
          describe = _state.describe;


      return _jsx('section', {
        className: 'pop-pwd rate_pop'
      }, void 0, _jsx('div', {
        className: 'pop-pwd-content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, _jsx('p', {
        className: 'rateTitle'
      }, void 0, '\u60A8\u662F\u5426\u613F\u610F\u5411\u60A8\u7684\u4EB2\u621A\u670B\u53CB\u63A8\u8350\u5728\u7EBF', orderNo.indexOf('S') === -1 ? '\u9000\u7968' : '\u53D8\u66F4', '?'), _jsx(icon_index_web_default.a, {
        type: 'cross',
        onClick: function onClick(e) {
          return onCancel(destroy, toHome);
        },
        role: 'button',
        'aria-label': '\u5173\u95ED'
      }), _jsx('div', {
        className: 'rateList'
      }, void 0, new Array(11).fill('').map(function (item, index) {
        return _jsx('i', {
          className: 'rateNum ' + (rate === index && 'checkedNum'),
          onClick: function onClick() {
            return _this2.setRate(index);
          }
        }, void 0, index);
      })), RatePopup__ref4, _jsx('div', {}, void 0, _jsx('div', {}, void 0, this.renderRateTab(orderNo))), _jsx('div', {
        className: 'rateBtn'
      }, void 0, _jsx(Btn["default"], {
        text: '\u63D0\u4EA4',
        onClick: function onClick(e) {
          return onConfirm(rate, describe, _this2.reasonOptions);
        }
      }), _jsx(Btn["default"], {
        text: '\u8DF3\u8FC7',
        onClick: function onClick(e) {
          return onCancel(destroy, toHome);
        }
      }))));
    }
  }]);

  return RateComponent;
}(reactfrom_dll_reference_vendor_library["Component"]);

RatePopup_RateComponent.props = {
  title: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  destroy: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onConfirm: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onCancel: prop_typesfrom_dll_reference_vendor_library_default.a.func
};
RatePopup_RateComponent.defaultProps = {
  destroy: function destroy() {},
  getList: function getList() {},
  onConfirm: function onConfirm(destroy) {
    // toHome && toHome();
    destroy && destroy();
  },
  onCancel: function onCancel(destroy, toHome) {
    toHome && toHome();
    destroy && destroy();
  }
};


function renderNode(props) {
  var _this3 = this;

  var div = document.createElement('div');
  document.body.appendChild(div);

  var destroy = function destroy() {
    if (!div) return;
    react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  var onConfirm = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee(psg, describe, reasonOptions) {
      var list, _ref6, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!psg && psg !== 0)) {
                _context.next = 3;
                break;
              }

              index_web_default.a.info(tips["default"].rateTip.rateTip, 1);
              return _context.abrupt('return');

            case 3:
              list = {
                type: props.orderNum.indexOf('S') !== -1 ? '4' : '3',
                oddNumbers: props.orderNum,
                score: psg,
                describe: describe,
                reasonOptions: reasonOptions.toString()
              };
              _context.next = 6;
              return props.crateNps(list);

            case 6:
              _ref6 = _context.sent;
              data = _ref6.payload.data;

              if (data.status === 0) {
                index_web_default.a.info(tips["default"].rateTip.rateSuccess, 2);
                props.toHome ? props.toHome() : destroy();
                destroy();
              } else {
                destroy();
              }

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function onConfirm(_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(RatePopup_RateComponent, Object.assign({}, props, {
    destroy: destroy,
    onConfirm: onConfirm,
    toHome: props.toHome,
    orderNo: props.orderNum
  })), div);

  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

function ratePopup(query, crateNps, toHome) {
  renderNode({
    orderNum: query.orderNo,
    crateNps: crateNps,
    toHome: toHome
  });
}

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };
// CONCATENATED MODULE: ./src/components/MemberPopup/index.js








var MemberPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MemberPopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MemberPopup__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function MemberPopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MemberPopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MemberPopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CheckboxItem = checkbox_index_web_default.a.CheckboxItem;

var MemberPopup_popPwdQueue = [];

var MemberPopup__ref2 = MemberPopup__jsx('div', {
  className: 'memberImg'
}, void 0, MemberPopup__jsx('img', {
  src: member_default.a,
  alt: ''
}));

var MemberPopup_MemberComponent = function (_Component) {
  MemberPopup__inherits(MemberComponent, _Component);

  function MemberComponent() {
    var _ref;

    var _temp, _this, _ret;

    MemberPopup__classCallCheck(this, MemberComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MemberPopup__possibleConstructorReturn(this, (_ref = MemberComponent.__proto__ || Object.getPrototypeOf(MemberComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: {},
      checked: false,
      status: '',
      checkItem: [],
      checkedPagName: ''
    }, _this.changeData = function (e, val) {
      if (e.target.checked) {
        _this.setState({
          checkedPagName: val.pagName,
          value: val
        });
      } else {
        _this.setState({
          checkedPagName: '',
          value: ''
        });
      }
    }, _temp), MemberPopup__possibleConstructorReturn(_this, _ret);
  }

  // _arr = [];

  MemberPopup__createClass(MemberComponent, [{
    key: 'render',


    //后续优化 如果要选择多个非会员则对数据进行处理
    // onChange = (e, val) => {
    //   const { memberList } = this.props;
    //   if (e.target.checked) {
    //     this._arr.push(val);
    //   } else {
    //     this._arr = this._arr.filter(item => item.pagName !== val.pagName);
    //   }
    // };

    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onCancel = _props.onCancel,
          onConfirm = _props.onConfirm,
          destroy = _props.destroy,
          memberList = _props.memberList,
          toHome = _props.toHome,
          lang = _props.lang;
      var value = this.state.value;

      return MemberPopup__jsx('section', {
        className: 'pop-pwd'
      }, void 0, MemberPopup__jsx('div', {
        id: 'popD',
        className: 'pop-pwd-content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, MemberPopup__jsx('p', {
        className: 'memberTitle'
      }, void 0, lang.tips), MemberPopup__jsx(icon_index_web_default.a, {
        type: 'cross',
        onClick: function onClick(e) {
          return onCancel(destroy);
        },
        role: 'button',
        'aria-label': '\u5173\u95ED'
      }), MemberPopup__ref2, MemberPopup__jsx('p', {
        className: 'isNotMem'
      }, void 0, lang.memberShip1, ':'), memberList.map(function (item, i) {
        return MemberPopup__jsx('div', {
          className: 'memberlist'
        }, i, MemberPopup__jsx('div', {
          className: 'leftButton'
        }, void 0, MemberPopup__jsx(CheckboxItem, {
          checked: item.pagName === _this2.state.checkedPagName,
          onChange: function onChange(e) {
            return _this2.changeData(e, item);
          }
        }, i, item.pagName)));
      }), MemberPopup__jsx('p', {}, void 0, lang.memberShip2), MemberPopup__jsx('div', {
        className: 'pop-btn'
      }, void 0, MemberPopup__jsx(Btn["default"], {
        text: lang.refCupon33,
        onClick: function onClick(e) {
          return onConfirm(value);
        }
      }), MemberPopup__jsx(Btn["default"], {
        text: lang.skip,
        onClick: function onClick(e) {
          return onCancel(destroy, toHome);
        }
      }))));
    }
  }]);

  return MemberComponent;
}(reactfrom_dll_reference_vendor_library["Component"]);

MemberPopup_MemberComponent.props = {
  title: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  destroy: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onConfirm: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onCancel: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  lang: prop_typesfrom_dll_reference_vendor_library_default.a.object
};
MemberPopup_MemberComponent.defaultProps = {
  destroy: function destroy() {},
  getList: function getList() {},
  onConfirm: function onConfirm(destroy) {
    destroy && destroy();
  },
  onCancel: function onCancel(destroy, toHome) {
    toHome && toHome();
    destroy && destroy();
  }
};


function getSessionMessage(key) {
  var persist = sessionStorage.getItem('persist:emp');
  var _store = persist ? JSON.parse(persist) : {};
  var app = _store.App ? JSON.parse(_store.App) : {};
  return app.memberList ? app.memberList[key] : {};
}

function setSessionMessage(data, key) {
  var persist = sessionStorage.getItem('persist:emp');
  var store_a = JSON.parse(persist);
  var store_b = JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).App);
  store_b.memberList = Object.assign({}, _defineProperty({}, key, data));
  store_a.App = JSON.stringify(store_b);
  sessionStorage.setItem('persist:emp', JSON.stringify(store_a));
}

function MemberPopup_renderNode(props) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('popD');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  var destroy = function destroy() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  var onConfirm = function onConfirm(psg) {
    if (Object.keys(psg).length === 0) {
      index_web_default.a.info(props.lang.changeMember.checkMember, 1);
      return;
    }
    var query = query_stringfrom_dll_reference_vendor_library_default.a.stringify({
      pagName: psg.pagName,
      keyMem: props.cacheKey
    });

    // //当前修改
    // if (psg.length === 0) {
    //   Toast.info(lang.changeMember.checkMember, 1);
    //   return;
    // }
    var url = encodeURIComponent(window.location.href);
    if (window.location.href.indexOf('pagName') === -1) {
      url = encodeURIComponent(window.location.href + '&' + query);
      if (window.location.href.indexOf('?') === -1) {
        url = encodeURIComponent(window.location.href + '?' + query);
      }
    } else {
      url = encodeURIComponent(window.location.href.split('keyMem')[0] + query);
    }

    window.location.href = urlConfig["default"].msky_url + '?lang=zh&enrollmentSourceCode=MOBILE&needMemberNo=true&clientId=RCP&encryptValue=' + psg.encryptValue + '&toPage=' + url;
  };

  react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(MemberPopup_MemberComponent, Object.assign({}, props, {
    destroy: destroy,
    onConfirm: onConfirm,
    toHome: props.toHome
  })), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('popD').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  MemberPopup_popPwdQueue.push(destroy);
  return MemberPopup_popPwdQueue[MemberPopup_popPwdQueue.length - 1];
}

/* harmony default export */ var components_MemberPopup = __webpack_exports__["a"] = ((function () {
  var _ref4 = MemberPopup__asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref3) {
    var getMemberList = _ref3.getMemberList,
        query = _ref3.query,
        crateNps = _ref3.crateNps,
        _toHome = _ref3.toHome,
        fdbParmas = _ref3.fdbParmas,
        lang = _ref3.lang;

    var _ref5, data, memberList, fdbDtat, div, destroy, key, dataCache, no_member, _div2, _destroy2;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(query.vipMember !== 'Y')) {
              _context.next = 3;
              break;
            }

            // ratePopup(toHome);
            _toHome && _toHome();
            return _context.abrupt('return', false);

          case 3:
            _context.next = 5;
            return getMemberList({ orderNo: query.orderNo });

          case 5:
            _ref5 = _context.sent;
            data = _ref5.payload.data;
            memberList = data;

            if (!(!memberList || memberList.status === 500)) {
              _context.next = 11;
              break;
            }

            _toHome && _toHome();
            return _context.abrupt('return', false);

          case 11:
            fdbDtat = '';

            if (query.orderNo.includes('GO')) {
              _context.next = 16;
              break;
            }

            _context.next = 15;
            return crateNps(fdbParmas);

          case 15:
            fdbDtat = _context.sent;

          case 16:
            if (memberList.data) {
              _context.next = 19;
              break;
            }

            if (fdbDtat && fdbDtat.payload.data.code == '0000' && !fdbDtat.payload.data.decryptStr.includes('finish')) {
              window.location.href = fdbDtat.payload.data.decryptStr;
            } else {
              div = document.createElement('div');

              document.body.appendChild(div);

              destroy = function destroy() {
                if (!div) return;
                react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
                document.body.removeChild(div);
                div = null;
              };

              destroy();
              _toHome && _toHome();
            }
            return _context.abrupt('return', false);

          case 19:
            key = query.orderNo;
            dataCache = memberList.data.map(function (item) {
              return {
                pagName: item.pagName,
                encryptValue: item.idCard,
                memberNo: item.hasMember
              };
            });
            no_member = dataCache.filter(function (item) {
              return item.memberNo;
            });
            // 存缓存

            setSessionMessage(no_member, key);
            if (no_member.length !== 0) {
              MemberPopup_renderNode({
                memberList: no_member,
                cacheKey: key,
                toHome: function toHome() {
                  if (fdbDtat && fdbDtat.payload.data.code == '0000' && !fdbDtat.payload.data.decryptStr.includes('finish')) {
                    window.location.href = fdbDtat.payload.data.decryptStr;
                  } else {
                    var _div = document.createElement('div');
                    document.body.appendChild(_div);
                    var _destroy = function _destroy() {
                      if (!_div) return;
                      react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(_div);
                      document.body.removeChild(_div);
                      _div = null;
                    };
                    _destroy();
                    _toHome && _toHome();
                  }
                },
                lang: lang
              });
            } else {
              if (fdbDtat && fdbDtat.payload.data.code == '0000' && !fdbDtat.payload.data.decryptStr.includes('finish')) {
                window.location.href = fdbDtat.payload.data.decryptStr;
              } else {
                _div2 = document.createElement('div');

                document.body.appendChild(_div2);

                _destroy2 = function _destroy2() {
                  if (!_div2) return;
                  react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(_div2);
                  document.body.removeChild(_div2);
                  _div2 = null;
                };

                _destroy2();
                _toHome && _toHome();
              }
            }

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref4.apply(this, arguments);
  };
})());

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };

/***/ }),

/***/ "aske":
/***/ (function(module, exports, __webpack_require__) {

var getOwnPropertyNamesModule = __webpack_require__("gLsf");
var getOwnPropertySymbolsModule = __webpack_require__("fTzd");
var anObject = __webpack_require__("5+O3");
var Reflect = __webpack_require__("hcE8").Reflect;

// all object keys, includes non-enumerable and symbols
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "b+MK":
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__("UnEC"),
    isPlainObject = __webpack_require__("9UkZ");

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

module.exports = isElement;


/***/ }),

/***/ "bGc4":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("gGqR"),
    isLength = __webpack_require__("Rh28");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "bJWQ":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("WxI4"),
    listCacheDelete = __webpack_require__("dFpP"),
    listCacheGet = __webpack_require__("JBvZ"),
    listCacheHas = __webpack_require__("2Hvv"),
    listCacheSet = __webpack_require__("deUO");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "blYT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "bwUP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_ELECT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_INVOICE; });
/* unused harmony export CREATE_INVOICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INIT_ISSUEPSGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SELECT_INVOICETITLE_TYPE; });
/* unused harmony export ADD_INVOICETITLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_STATE; });
/* harmony export (immutable) */ __webpack_exports__["i"] = initInvoice;
/* harmony export (immutable) */ __webpack_exports__["j"] = initIssuePsgs;
/* harmony export (immutable) */ __webpack_exports__["h"] = getInvoice;
/* harmony export (immutable) */ __webpack_exports__["f"] = addInvoiceTitle;
/* harmony export (immutable) */ __webpack_exports__["l"] = selectInvoiceTitleType;
/* harmony export (immutable) */ __webpack_exports__["k"] = saveElectData;
/* harmony export (immutable) */ __webpack_exports__["g"] = createInvoice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__("lmnO");



var SAVE_ELECT_DATA = 'SAVE_ELECT_DATA';
var GET_INVOICE = 'GET_INVOICE';
var CREATE_INVOICE = 'CREATE_INVOICE';
var INIT_ISSUEPSGS = 'INIT_ISSUEPSGS';
var SELECT_INVOICETITLE_TYPE = 'SELECT_INVOICETITLE_TYPE';
var ADD_INVOICETITLE = 'ADD_INVOICETITLE';
var INIT_STATE = 'INIT_STATE';

function initInvoice() {
  return {
    type: INIT_STATE
  };
}

/**
 * @description 初始化可开具旅客数据，如果可开具旅客数据为空，则初始化
 * @param {array} psgNum 已选的旅客序号
 */
function initIssuePsgs(psgNum) {
  return function (dispatch, getState) {
    var _getState = getState(),
        psgList = _getState.EdorsedApply.psgList,
        issuePsgs = _getState.electronicInvoice.issuePsgs;

    if (issuePsgs.length !== 0) {
      return false;
    }
    var psgs = psgList.filter(function (item, i) {
      return psgNum.indexOf(String(i)) !== -1;
    }).map(function (item) {
      var obj = {
        ticketNo: item.ticketNo,
        psgname: item.psgName,
        psgType: item.psgType,
        idtype: item.certificateType,
        idcard: item.certificateId
      };
      return obj;
    });
    dispatch({
      type: INIT_ISSUEPSGS,
      psgs: psgs
    });
  };
}

// 查询电子发票
function getInvoice(data) {
  return {
    type: GET_INVOICE,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getSvcPcInvoiceInfoByIdAndType,
        method: 'post',
        data: data
      }
    }
  };
}

// 新增电子发票抬头
function addInvoiceTitle(data) {
  return {
    type: ADD_INVOICETITLE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].saveSvcPcInvoiceDto,
        method: 'post',
        data: data
      }
    }
  };
}

// 选择发票抬头类型
function selectInvoiceTitleType(n, option) {
  return { type: SELECT_INVOICETITLE_TYPE, n: n, option: option };
}

// 保存发票数据
function saveElectData(i, data) {
  return { type: SAVE_ELECT_DATA, n: i, data: data };
}

// 生成电子发票
function createInvoice() {
  return function (dispatch, getState) {
    var _getState$electronicI = getState().electronicInvoice,
        issuePsgs = _getState$electronicI.issuePsgs,
        reservePsgs = _getState$electronicI.reservePsgs;

    if (reservePsgs.length === 0) return false;
    return Promise.all(issuePsgs.filter(function (item) {
      return reservePsgs.indexOf(item.ticketNo) !== -1;
    }).map(function (item) {
      if (item.ticketNo.indexOf('-') !== -1) {
        item.ticketNo = item.ticketNo.split('-')[0];
      }
      return dispatch({
        type: CREATE_INVOICE,
        payload: {
          request: {
            url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createInvoice + '?' + item.ticketNo,
            method: 'post',
            data: Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* filterProperty */])(item, ['option', 'contactNo', 'address', 'depositBank', 'bankCardNo', 'peerRowPsgs', 'useInvoiceTitle', 'isEditOriginInvoiceTitle', 'psgType'])
          }
        }
      });
    })).then(function (result) {
      dispatch(initInvoice());
    }).catch(function (err) {
      console.log(err);
    });
  };
}

/***/ }),

/***/ "cAao":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfiI":
/***/ (function(module, exports, __webpack_require__) {

var baseConformsTo = __webpack_require__("ZQx6"),
    keys = __webpack_require__("ktak");

/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys(source));
}

module.exports = conformsTo;


/***/ }),

/***/ "cjLM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var bind = __webpack_require__("Xo5R");
var getSetIterator = __webpack_require__("BGpQ");

// `Set.prototype.find` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  find: function find(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var step, value;
    while (!(step = iterator.next()).done) {
      if (boundFunction(value = step.value, value, set)) return value;
    }
  }
});


/***/ }),

/***/ "dFpP":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "dXBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REALNAME_VERIFY */
/* unused harmony export SUBMIT_APPLY_TAORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REAL_NAME_VERIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_REAL_NAME_VERIFY; });
/* unused harmony export GET_BANKCARD_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANKCARD_DATA; });
/* harmony export (immutable) */ __webpack_exports__["e"] = realNameVerify;
/* unused harmony export saveVerify */
/* unused harmony export submitApplyTAOrder */
/* harmony export (immutable) */ __webpack_exports__["d"] = getbankcarddata;
/* unused harmony export savebankcarddata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var REALNAME_VERIFY = 'REALNAME_VERIFY';
var SUBMIT_APPLY_TAORDER = 'SUBMIT_APPLY_TAORDER';
var REAL_NAME_VERIFY = 'REAL_NAME_VERIFY';
var CLEAR_REAL_NAME_VERIFY = 'CLEAR_REAL_NAME_VERIFY';
var GET_BANKCARD_DATA = 'GET_BANKCARD_DATA';
var BANKCARD_DATA = 'BANKCARD_DATA';

function realNameVerify(data) {
  return {
    type: REALNAME_VERIFY,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].identityPayAuthInfo,
        method: 'post',
        data: data
      }
    }
  };
}

function saveVerify(data) {
  return { type: REAL_NAME_VERIFY, realNameVerifyResult: data };
}

// 提交TA单
function submitApplyTAOrder(data) {
  var load = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: SUBMIT_APPLY_TAORDER,
    closeLoading: load,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].createRefundTa,
        method: 'post',
        data: data
      }
    }
  };
}

function getbankcarddata(data) {
  return {
    type: GET_BANKCARD_DATA,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].searchAuthInfo,
        method: 'post',
        data: data
      }
    }
  };
}

function savebankcarddata(data) {
  return { type: BANKCARD_DATA, bankcarddata: data };
}

/***/ }),

/***/ "deUO":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "dliL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("hcE8");
var $export = __webpack_require__("i9tX");
var redefine = __webpack_require__("+opI");
var InternalMetadataModule = __webpack_require__("0LGO");
var iterate = __webpack_require__("UHV6");
var anInstance = __webpack_require__("tyBP");
var isObject = __webpack_require__("HAas");
var fails = __webpack_require__("r54x");
var checkCorrectnessOfIteration = __webpack_require__("Kbrx");
var setToStringTag = __webpack_require__("GB3+");
var inheritIfRequired = __webpack_require__("3Nrx");

module.exports = function (NAME, wrapper, common, IS_MAP, IS_WEAK) {
  var NativeConstructor = global[NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var ADDER = IS_MAP ? 'set' : 'add';
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(a) {
        nativeMethod.call(this, a === 0 ? 0 : a);
        return this;
      } : KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : nativeMethod.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : nativeMethod.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : nativeMethod.call(this, a === 0 ? 0 : a);
      } : function set(a, b) {
        nativeMethod.call(this, a === 0 ? 0 : a, b);
        return this;
      }
    );
  };

  if (typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  }))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (target, iterable) {
        anInstance(target, Constructor, NAME);
        var that = inheritIfRequired(new NativeConstructor(), target, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[NAME] = Constructor;
  $export({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, NAME);

  if (!IS_WEAK) common.setStrong(Constructor, NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "dmQx":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("G8ar");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "du7g":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),

/***/ "dwsC":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "e4xA":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("YDHx");

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),

/***/ "eTT4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("jgJS");
var TO_STRING_TAG = __webpack_require__("jAiL")('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;


/***/ }),

/***/ "eZ0g":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "efk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__("ommR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);
/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */

/**
 * Generic animation class with support for dropped frames both optional easing and duration.
 *
 * Optional duration is useful when the lifetime is defined by another condition than time
 * e.g. speed of an animating object, etc.
 *
 * Dropped frame logic allows to keep using the same updater logic independent from the actual
 * rendering. This eases a lot of cases where it might be pretty complex to break down a state
 * based on the pure time difference.
 */


var desiredFrames = 60;
var millisecondsPerSecond = 1000;
var running = {};
var counter = 1;
var win = typeof window !== 'undefined' ? window : undefined;

if (!win) {
  win = typeof global !== 'undefined' ? global : {};
}

var Animate = {
  /**
   * Stops the given animation.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation was stopped (aka, was running before)
   */
  stop: function stop(id) {
    var cleared = running[id] != null;
    if (cleared) {
      running[id] = null;
    }

    return cleared;
  },

  /**
   * Whether the given animation is still running.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation is still running
   */
  isRunning: function isRunning(id) {
    return running[id] != null;
  },

  /**
   * Start the animation.
   *
   * @param stepCallback {Function} Pointer to function which is executed on every step.
   *   Signature of the method should be `function(percent, now, virtual) { return continueWithAnimation; }`
   * @param verifyCallback {Function} Executed before every animation step.
   *   Signature of the method should be `function() { return continueWithAnimation; }`
   * @param completedCallback {Function}
   *   Signature of the method should be `function(droppedFrames, finishedAnimation) {}`
   * @param duration {Integer} Milliseconds to run the animation
   * @param easingMethod {Function} Pointer to easing function
   *   Signature of the method should be `function(percent) { return modifiedValue; }`
   * @return {Integer} Identifier of animation. Can be used to stop it any time.
   */
  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod) {
    var start = +new Date();
    var lastFrame = start;
    var percent = 0;
    var dropCounter = 0;
    var id = counter++;

    // Compacting running db automatically every few new animations
    if (id % 20 === 0) {
      var newRunning = {};
      for (var usedId in running) {
        newRunning[usedId] = true;
      }
      running = newRunning;
    }

    // This is the internal step method which is called every few milliseconds
    var step = function step(virtual) {
      // Normalize virtual value
      var render = virtual !== true;

      // Get current time
      var now = +new Date();

      // Verification is executed before next animation step
      if (!running[id] || verifyCallback && !verifyCallback(id)) {

        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
        return;
      }

      // For the current rendering to apply let's update omitted steps in memory.
      // This is important to bring internal state variables up-to-date with progress in time.
      if (render) {

        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
          step(true);
          dropCounter++;
        }
      }

      // Compute percent value
      if (duration) {
        percent = (now - start) / duration;
        if (percent > 1) {
          percent = 1;
        }
      }

      // Execute step callback, then...
      var value = easingMethod ? easingMethod(percent) : percent;
      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
      } else if (render) {
        lastFrame = now;
        __WEBPACK_IMPORTED_MODULE_0_raf___default()(step);
      }
    };

    // Mark as running
    running[id] = true;

    // Init first step
    __WEBPACK_IMPORTED_MODULE_0_raf___default()(step);

    // Return unique animation ID
    return id;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ersE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__("TVUd");

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('session');

/***/ }),

/***/ "f1+4":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("5+O3");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "f1jo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_STATE; });
/* unused harmony export QUERY_REFUNDCHANGE_FEE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_QUERYINFO; });
/* unused harmony export QUERY_REFUND_FEE */
/* unused harmony export QUERY_CHANGE_FEE */
/* unused harmony export GET_AD_INFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_STYLE; });
/* harmony export (immutable) */ __webpack_exports__["e"] = init;
/* harmony export (immutable) */ __webpack_exports__["i"] = saveQueryInfo;
/* harmony export (immutable) */ __webpack_exports__["g"] = queryRefundChangeFee;
/* harmony export (immutable) */ __webpack_exports__["j"] = selectTabStyle;
/* harmony export (immutable) */ __webpack_exports__["h"] = queryRefundFee;
/* harmony export (immutable) */ __webpack_exports__["f"] = queryChangeFee;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAdInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");

var INIT_STATE = 'INIT_STATE';
var QUERY_REFUNDCHANGE_FEE = 'QUERY_REFUNDCHANGE_FEE';
var SAVE_QUERYINFO = 'SAVE_QUERYINFO';
var QUERY_REFUND_FEE = 'QUERY_REFUND_FEE';
var QUERY_CHANGE_FEE = 'QUERY_CHANGE_FEE';
var GET_AD_INFO = 'GET_AD_INFO';
var SELECT_STYLE = 'SELECT_STYLE';

function init() {
  return { type: INIT_STATE };
}

function saveQueryInfo(data) {
  return { type: SAVE_QUERYINFO, data: data };
}

function queryRefundChangeFee(data) {
  return {
    type: QUERY_REFUNDCHANGE_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryRefundChangeFee,
        method: 'post',
        data: data
      }
    }
  };
}
function selectTabStyle(data) {
  return { type: SELECT_STYLE, data: data };
}

function queryRefundFee(data) {
  return {
    type: QUERY_REFUND_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryRefundFee,
        method: 'post',
        data: data
      }
    }
  };
}

function queryChangeFee(data) {
  return {
    type: QUERY_CHANGE_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryChangeFee,
        method: 'post',
        data: data
      }
    }
  };
}

function getAdInfo(data) {
  return {
    type: GET_AD_INFO,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getAdInfo,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "f931":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "fTzd":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "fkET":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var classof = __webpack_require__("raVe");
var split = ''.split;
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
};


/***/ }),

/***/ "fu9N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__("DT0+");

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _zscroller = __webpack_require__("zabl");

var _zscroller2 = _interopRequireDefault(_zscroller);

var _PickerMixin = __webpack_require__("0IZF");

var _PickerMixin2 = _interopRequireDefault(_PickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Picker = (0, _createReactClass2['default'])({
    mixins: [_PickerMixin2['default']],
    statics: {
        Item: function Item() {}
    },
    getDefaultProps: function getDefaultProps() {
        return {
            prefixCls: 'rmc-picker'
        };
    },
    getInitialState: function getInitialState() {
        var selectedValueState = void 0;
        var _props = this.props,
            selectedValue = _props.selectedValue,
            defaultSelectedValue = _props.defaultSelectedValue;

        if (selectedValue !== undefined) {
            selectedValueState = selectedValue;
        } else if (defaultSelectedValue !== undefined) {
            selectedValueState = defaultSelectedValue;
        } else {
            var children = _react2['default'].Children.toArray(this.props.children);
            selectedValueState = children && children[0] && children[0].props.value;
        }
        return {
            selectedValue: selectedValueState
        };
    },
    componentDidMount: function componentDidMount() {
        var _refs = this.refs,
            content = _refs.content,
            indicator = _refs.indicator,
            mask = _refs.mask,
            root = _refs.root;

        var rootHeight = root.getBoundingClientRect().height;
        // https://github.com/react-component/m-picker/issues/18
        var itemHeight = this.itemHeight = indicator.getBoundingClientRect().height;
        var num = Math.floor(rootHeight / itemHeight);
        if (num % 2 === 0) {
            num--;
        }
        num--;
        num /= 2;
        content.style.padding = itemHeight * num + 'px 0';
        indicator.style.top = itemHeight * num + 'px';
        mask.style.backgroundSize = '100% ' + itemHeight * num + 'px';
        this.zscroller = new _zscroller2['default'](content, {
            scrollingX: false,
            snapping: true,
            locking: false,
            penetrationDeceleration: .1,
            minVelocityToKeepDecelerating: 0.5,
            scrollingComplete: this.scrollingComplete
        });
        this.zscroller.setDisabled(this.props.disabled);
        this.zscroller.scroller.setSnapSize(0, itemHeight);
        this.select(this.state.selectedValue);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if ('selectedValue' in nextProps) {
            this.setState({
                selectedValue: nextProps.selectedValue
            });
        }
        this.zscroller.setDisabled(nextProps.disabled);
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return this.state.selectedValue !== nextState.selectedValue || this.props.children !== nextProps.children;
    },
    componentDidUpdate: function componentDidUpdate() {
        this.zscroller.reflow();
        this.select(this.state.selectedValue);
    },
    componentWillUnmount: function componentWillUnmount() {
        this.zscroller.destroy();
    },
    scrollTo: function scrollTo(top) {
        this.zscroller.scroller.scrollTo(0, top);
    },
    fireValueChange: function fireValueChange(selectedValue) {
        if (selectedValue !== this.state.selectedValue) {
            if (!('selectedValue' in this.props)) {
                this.setState({
                    selectedValue: selectedValue
                });
            }
            if (this.props.onValueChange) {
                this.props.onValueChange(selectedValue);
            }
        }
    },
    scrollingComplete: function scrollingComplete() {
        var _zscroller$scroller$g = this.zscroller.scroller.getValues(),
            top = _zscroller$scroller$g.top;

        if (top >= 0) {
            this.doScrollingComplete(top);
        }
    },
    getValue: function getValue() {
        if ('selectedValue' in this.props) {
            return this.props.selectedValue;
        }
        var children = _react2['default'].Children.toArray(this.props.children);
        return children && children[0] && children[0].props.value;
    },
    render: function render() {
        var _pickerCls;

        var props = this.props;
        var prefixCls = props.prefixCls,
            itemStyle = props.itemStyle,
            indicatorStyle = props.indicatorStyle,
            _props$indicatorClass = props.indicatorClassName,
            indicatorClassName = _props$indicatorClass === undefined ? '' : _props$indicatorClass,
            children = props.children;
        var selectedValue = this.state.selectedValue;

        var itemClassName = prefixCls + '-item';
        var selectedItemClassName = itemClassName + ' ' + prefixCls + '-item-selected';
        var map = function map(item) {
            var _item$props = item.props,
                _item$props$className = _item$props.className,
                className = _item$props$className === undefined ? '' : _item$props$className,
                style = _item$props.style,
                value = _item$props.value;

            return _react2['default'].createElement(
                'div',
                { style: (0, _extends3['default'])({}, itemStyle, style), className: (selectedValue === value ? selectedItemClassName : itemClassName) + ' ' + className, key: value },
                item.children || item.props.children
            );
        };
        // compatibility for preact
        var items = _react2['default'].Children ? _react2['default'].Children.map(children, map) : [].concat(children).map(map);
        var pickerCls = (_pickerCls = {}, (0, _defineProperty3['default'])(_pickerCls, props.className, !!props.className), (0, _defineProperty3['default'])(_pickerCls, prefixCls, true), _pickerCls);
        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(pickerCls), ref: 'root', style: this.props.style },
            _react2['default'].createElement('div', { className: prefixCls + '-mask', ref: 'mask' }),
            _react2['default'].createElement('div', { className: prefixCls + '-indicator ' + indicatorClassName, ref: 'indicator', style: indicatorStyle }),
            _react2['default'].createElement(
                'div',
                { className: prefixCls + '-content', ref: 'content' },
                items
            )
        );
    }
});
exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),

/***/ "gGqR":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObject = __webpack_require__("yCNF");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "gHOb":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "gLsf":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var internalObjectKeys = __webpack_require__("AMIE");
var hiddenKeys = __webpack_require__("YveC").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "gado":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("eZ0g");
var ITERATOR = __webpack_require__("jAiL")('iterator');
var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "ggOT":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "ghWY":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArrayBuffer = __webpack_require__("AaNf"),
    baseUnary = __webpack_require__("S7p9"),
    nodeUtil = __webpack_require__("Dc0G");

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

module.exports = isArrayBuffer;


/***/ }),

/***/ "h012":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("hbAh"),
    getMatchData = __webpack_require__("16tV");

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),

/***/ "hGXm":
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),

/***/ "hbAh":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    baseIsEqual = __webpack_require__("YDHx");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "hcE8":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();


/***/ }),

/***/ "hiy0":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "hrPF":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "hygk":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("YDHx");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "hz+3":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ "i4ON":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("nw3t"),
    eq = __webpack_require__("22B7");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "i9tX":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("hcE8");
var hide = __webpack_require__("wkr2");
var redefine = __webpack_require__("+opI");
var setGlobal = __webpack_require__("C/Wh");
var copyConstructorProperties = __webpack_require__("PYrI");

/*
  options.target - name of the target object
  options.global - target is the global object
  options.stat   - export as static methods of target
  options.proto  - export as prototype methods of target
  options.real   - real prototype method for the `pure` version
  options.forced - export even if the native feature is available
  options.bind   - bind methods to the target, required for the `pure` version
  options.wrap   - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe - use the simple assignment of property instead of delete + defineProperty
  options.sham   - add a flag to not completely full polyfills
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var target, key, targetProperty, sourceProperty;
  if (options.global) {
    target = global;
  } else if (options.stat) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    targetProperty = target[key];
    sourceProperty = source[key];
    // contained in target
    if (!options.forced && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options.unsafe);
  }
};


/***/ }),

/***/ "iQIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_REFUND_COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECT_REFUND_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_REFUND_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_REFUND_COUPON; });
/* harmony export (immutable) */ __webpack_exports__["h"] = selectCoupon;
/* harmony export (immutable) */ __webpack_exports__["e"] = cancelCoupon;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCoupons;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearRefundCoupon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var GET_REFUND_COUPONS = 'GET_REFUND_COUPONS';
var SELECT_REFUND_COUPON = 'SELECT_REFUND_COUPON';
var CANCEL_REFUND_COUPON = 'CANCEL_REFUND_COUPON';
var INIT_REFUND_COUPON = 'INIT_REFUND_COUPON';

function selectCoupon(code, psgSegmentData, couponData) {
  return {
    type: SELECT_REFUND_COUPON,
    code: code,
    psgSegmentData: psgSegmentData,
    couponData: couponData
  };
}

function cancelCoupon(code) {
  return {
    type: CANCEL_REFUND_COUPON,
    couponCode: code
  };
}

function getCoupons(data, charge, refundWay) {
  return {
    type: GET_REFUND_COUPONS,
    closeLoading: true,
    psgsCharge: charge,
    refundWay: refundWay,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].touchRefundSearchBGQ,
        method: 'post',
        data: data
      }
    }
  };
}

function clearRefundCoupon() {
  return {
    type: INIT_REFUND_COUPON
  };
}

/***/ }),

/***/ "iYj9":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "imBK":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("22B7");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "irwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELECT_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REST_FLIGHT; });
/* unused harmony export CLEAR_LITS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_FLIGHT_LIST; });
/* unused harmony export GET_CHANGE_COST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_WQT_OBJ; });
/* unused harmony export SAVE_FILTER_FLIGHT */
/* unused harmony export GET_FILTER_RULES */
/* unused harmony export GET_PRODUCTSHOW_LIST */
/* harmony export (immutable) */ __webpack_exports__["h"] = findFlightList;
/* harmony export (immutable) */ __webpack_exports__["k"] = initFlight;
/* harmony export (immutable) */ __webpack_exports__["l"] = restFlight;
/* harmony export (immutable) */ __webpack_exports__["n"] = selectFlightData;
/* harmony export (immutable) */ __webpack_exports__["g"] = clearFlight;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveWQT;
/* harmony export (immutable) */ __webpack_exports__["i"] = getFlightRules;
/* harmony export (immutable) */ __webpack_exports__["j"] = getMilageFlightRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var INIT_FLIGHT = 'INIT_FLIGHT';
var SELECT_FLIGHT = 'SELECT_FLIGHT';
var CLEAR_FLIGHT = 'CLEAR_FLIGHT';
var REST_FLIGHT = 'REST_FLIGHT';
var CLEAR_LITS = 'CLEAR_LITS';
var FIND_FLIGHT_LIST = 'FIND_FLIGHT_LIST';
var GET_CHANGE_COST = 'GET_CHANGE_COST';
var SAVE_WQT_OBJ = 'SAVE_WQT_OBJ';
var SAVE_FILTER_FLIGHT = 'SAVE_FILTER_FLIGHT';
var GET_FILTER_RULES = 'GET_FILTER_RULES';
var GET_PRODUCTSHOW_LIST = 'GET_PRODUCTSHOW_LIST';

// 查询新航班(自愿变更)
function findFlightList(data, originFlight) {
  return {
    type: FIND_FLIGHT_LIST,
    originFlight: originFlight,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].changeReqNewFlightDetail,
        method: 'post',
        data: data
      }
    }
  };
}

// 初始化新航班相关数据
function initFlight() {
  return { type: INIT_FLIGHT };
}

// 重新确认选择的航段
function restFlight() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return { type: REST_FLIGHT, key: key };
}

// 选择航段
function selectFlightData(data, flag) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  return { type: SELECT_FLIGHT, data: data, flag: flag, key: key };
}

// 清空选择的航段
function clearFlight() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return { type: CLEAR_FLIGHT, key: key };
}

// 保存湾区通数据
function saveWQT(wqtObj) {
  return { type: SAVE_WQT_OBJ, wqtObj: wqtObj };
}

// 使用条件
function getFlightRules(data) {
  return {
    type: GET_FILTER_RULES,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getFlightRules,
        method: 'post',
        data: data
      }
    }
  };
}

//固定里程使用条件
function getMilageFlightRules(data) {
  return {
    type: GET_FILTER_RULES,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getMilageFlightRules,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "izte":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("hcE8");
var setGlobal = __webpack_require__("C/Wh");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.0.0-beta.3',
  mode: __webpack_require__("pzR0") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "jAiL":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("izte")('wks');
var uid = __webpack_require__("17Rs");
var Symbol = __webpack_require__("hcE8").Symbol;
var USE_SYMBOL = __webpack_require__("9+GO");

module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};


/***/ }),

/***/ "jE8y":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var validateSetPrototypeOfArguments = __webpack_require__("MzAl");

module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () { // eslint-disable-line
  var test = {};
  var correctSetter = true;
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    correctSetter = test instanceof Array;
  } catch (e) { correctSetter = false; }
  return function setPrototypeOf(O, proto) {
    validateSetPrototypeOfArguments(O, proto);
    if (correctSetter) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "jF/i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__("s2vR").enable();
  window.Promise = __webpack_require__("U3tk");
}

// fetch() polyfill for making API calls.
__webpack_require__("rplX");

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__("BEQ0");

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),

/***/ "jMIW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jVrk":
/***/ (function(module, exports, __webpack_require__) {

var isInteger = __webpack_require__("8Lhr");

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
}

module.exports = isSafeInteger;


/***/ }),

/***/ "jgJS":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("raVe");
var TO_STRING_TAG = __webpack_require__("jAiL")('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "jgRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_TICKET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_TICKET_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_CHANGE_PROCESS; });
/* unused harmony export CHECK_FACE_AUTH */
/* unused harmony export CANCEL_CHECKIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REPLACE_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_X_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_PSG_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_MU_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_HU_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_MU_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_HU_FILE; });
/* unused harmony export CREATE_XSO_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_AI_PRAMAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_DOOR_PRODUCTS; });
/* unused harmony export UPLOAD_REFUND_FILE */
/* unused harmony export HU_FLIGHT_PROTECTION */
/* harmony export (immutable) */ __webpack_exports__["v"] = saveChangeProcess;
/* harmony export (immutable) */ __webpack_exports__["p"] = checkTicketFlight;
/* harmony export (immutable) */ __webpack_exports__["q"] = clearCheckData;
/* harmony export (immutable) */ __webpack_exports__["o"] = cancelCheckIn;
/* unused harmony export checkFaceAuth */
/* unused harmony export checkTicket */
/* harmony export (immutable) */ __webpack_exports__["s"] = getTicketInfo;
/* harmony export (immutable) */ __webpack_exports__["t"] = replaceFlight;
/* harmony export (immutable) */ __webpack_exports__["C"] = saveXproducts;
/* harmony export (immutable) */ __webpack_exports__["w"] = saveDoorproducts;
/* harmony export (immutable) */ __webpack_exports__["B"] = savePsgFlight;
/* harmony export (immutable) */ __webpack_exports__["A"] = saveMutype;
/* harmony export (immutable) */ __webpack_exports__["z"] = saveMuFile;
/* harmony export (immutable) */ __webpack_exports__["x"] = saveHuFile;
/* harmony export (immutable) */ __webpack_exports__["y"] = saveHutype;
/* harmony export (immutable) */ __webpack_exports__["u"] = saveAiPramas;
/* harmony export (immutable) */ __webpack_exports__["r"] = createXSOOrder;
/* harmony export (immutable) */ __webpack_exports__["D"] = uploadRefundFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = HuFlightProtection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__csair_emp_helpers__ = __webpack_require__("mekh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_TicPopUp__ = __webpack_require__("2H8H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tips__ = __webpack_require__("EjGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Routes__ = __webpack_require__("a1o4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Utils__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_actions__ = __webpack_require__("1EI8");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var CHECK_TICKET = 'CHECK_TICKET';
var CLEAR_TICKET_INFO = 'CLEAR_TICKET_INFO';
var CHECK_TICKET_FLIGHT = 'CHECK_TICKET_FLIGHT';
var SAVE_CHANGE_PROCESS = 'SAVE_CHANGE_PROCESS';
var CHECK_FACE_AUTH = 'CHECK_FACE_AUTH';
var CANCEL_CHECKIN = 'CANCEL_CHECKIN';
var REPLACE_FLIGHT = 'REPLACE_FLIGHT';
var SAVE_X_PRODUCTS = 'SAVE_X_PRODUCTS';
var SAVE_PSG_FLIGHT = 'SAVE_PSG_FLIGHT';
var SAVE_MU_TYPE = 'SAVE_MU_TYPE';
var SAVE_HU_TYPE = 'SAVE_HU_TYPE';
var SAVE_MU_FILE = 'SAVE_MU_FILE';
var SAVE_HU_FILE = 'SAVE_HU_FILE';

var CREATE_XSO_ORDER = 'CREATE_XSO_ORDER';
var SAVE_AI_PRAMAS = 'SAVE_AI_PRAMAS';
var SAVE_DOOR_PRODUCTS = 'SAVE_DOOR_PRODUCTS';
var UPLOAD_REFUND_FILE = 'UPLOAD_REFUND_FILE';
var HU_FLIGHT_PROTECTION = 'HU_FLIGHT_PROTECTION';

function saveChangeProcess(status) {
  return { type: SAVE_CHANGE_PROCESS, status: status };
}

// 变更、退票航段校验
function checkTicketFlight(data) {
  var urlParams = Object(__WEBPACK_IMPORTED_MODULE_6_query_string__["parse"])(window.location.hash.slice(window.location.hash.indexOf('?')));
  return {
    type: CHECK_TICKET_FLIGHT,
    payload: {
      request: {
        url: urlParams.ticketChangeType === 'refundTicket' ? urlParams.channel === 'TPWL' ? __WEBPACK_IMPORTED_MODULE_1_Url__["default"].checkTicketFlightTPWL : __WEBPACK_IMPORTED_MODULE_1_Url__["default"].checkTicketFlight : __WEBPACK_IMPORTED_MODULE_1_Url__["default"].checkTicketFlight,
        method: 'post',
        data: data
      }
    }
  };
}

// 清空乘机人和航段数据
function clearCheckData() {
  return { type: CLEAR_TICKET_INFO };
}

// 取消值机
function cancelCheckIn(data) {
  return {
    type: CANCEL_CHECKIN,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_1_Url__["default"].cancelCheckIn,
        method: 'post',
        data: data
      }
    }
  };
}

function isNeedGoBack() {
  return window.location.href.indexOf(__WEBPACK_IMPORTED_MODULE_5_Routes__["default"].ticket.child.endorsedApply.path) !== -1;
}

function goback() {
  var _JSON$parse = JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App),
      oldLocation = _JSON$parse.oldLocation;

  if (Object(__WEBPACK_IMPORTED_MODULE_2__csair_emp_helpers__["C" /* isCsairApp */])()) {
    try {
      if (!oldLocation.pathname) {
        window.CSNativeObject.closeWebview();
      } else {
        window.history.back();
      }
    } catch (e) {}
  } else {
    window.history.back();
  }
}

/**
 * @description 校验是否需要人脸识别
 * @param {object} authParams
 * @param {bool} nextTrue，默认false
 * @param {func} callback，成功后的回调函数
 */
function checkFaceAuth(authParams) {
  var nextTrue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var callback = arguments[2];
  var lang = arguments[3];

  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var _ref2, checkCode;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: CHECK_FACE_AUTH,
                payload: {
                  request: {
                    url: __WEBPACK_IMPORTED_MODULE_1_Url__["default"].faceRecognition,
                    method: 'post',
                    data: Object.assign({}, authParams, {
                      nextTrue: nextTrue
                    })
                  }
                }
              });

            case 2:
              _ref2 = _context.sent;
              checkCode = _ref2.payload.data.checkCode;

              if (!(checkCode === '1')) {
                _context.next = 7;
                break;
              }

              callback({
                needFaceAuth: false,
                faceAuthResult: false
              });
              return _context.abrupt('return', false);

            case 7:
              if (!(checkCode === '2')) {
                _context.next = 10;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, '办理退票需进行人脸识别，若涉嫌非法操作，南航有权追究其法律责任。', isNeedGoBack() ? goback : '', '', [{
                text: '确认',
                onPress: function onPress() {
                  dispatch(checkFaceAuth(authParams, true, callback, lang));
                }
              }]);
              return _context.abrupt('return', false);

            case 10:
              if (!(checkCode === '3')) {
                _context.next = 13;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, '您好！该类客票暂不支持自助处理，您可以联系原出票单位退票。', isNeedGoBack() ? goback : '');
              return _context.abrupt('return', false);

            case 13:
              if (!(checkCode === '4')) {
                _context.next = 16;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_2__csair_emp_helpers__["c" /* appFaceAuth */])(function (status) {
                if (status === '0' || status === 0) {
                  Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, '人脸认证失败，请重试。如有疑问，请联系南航客服95539。', isNeedGoBack() ? goback : '');
                  return false;
                }
                if (status === '1' || status === 1) {
                  callback({
                    needFaceAuth: true,
                    faceAuthResult: true
                  });
                  return false;
                }
                if (!status || typeof status === 'undefined') {
                  if (isNeedGoBack()) goback();
                  return false;
                }
              }, function () {
                Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, '您好！请更新至最新版的南航App！', isNeedGoBack() ? goback : '');
              });
              return _context.abrupt('return', false);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}

/**
 * @description 校验获取客票信息
 * @param {string} type 类型
 * @param {object} data 入参
 * @param {object} options
 * @param {object} options.channel 渠道
 * @param {func} callback
 */
function transCabin(name) {
  switch (name) {
    case '经济舱':
      return 'Economy Class';
    case '明珠经济舱':
      return 'Sky Pearl Economy Class';
    case '公务舱':
      return 'Business Class';
    case '头等舱':
      return 'First Class';
    default:
      return name;
      break;
  }
}
function checkTicket(type, data, options, callback, lang) {
  var isEN = window.sessionStorage.getItem('language') == 'en';
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var isNeed, _getState, sysConfig, _getState$EdorsedAppl, ticketNo, orderNo, urlParams, url, _ref4, _ref4$payload$data, checkResult, checkCode, checkMsg, error, ticketFlights, ticketType, invalidCode, gloOrederVo, isCeAirline, airportTransferList, flightList, odList, psgList, odFlag, currency, _ticketType, href;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isNeed = isNeedGoBack();
              _getState = getState(), sysConfig = _getState.App.sysConfig, _getState$EdorsedAppl = _getState.EdorsedApply, ticketNo = _getState$EdorsedAppl.ticketNo, orderNo = _getState$EdorsedAppl.orderNo;
              urlParams = Object(__WEBPACK_IMPORTED_MODULE_6_query_string__["parse"])(window.location.hash.slice(window.location.hash.indexOf('?')));
              url = (urlParams.channel && urlParams.channel === 'TPWL' || options.channel && options.channel === 'TPWL') && (urlParams.ticketChangeType === 'refundTicket' || type === 'r' && options.channel && options.channel === 'TPWL') ? __WEBPACK_IMPORTED_MODULE_1_Url__["default"].checkOrderTicketTPWL : __WEBPACK_IMPORTED_MODULE_1_Url__["default"].checkOrderTicket;

              if (!(ticketNo && ticketNo === data.ticketNo || orderNo && orderNo === data.orderNo)) {
                _context2.next = 7;
                break;
              }

              callback();
              return _context2.abrupt('return', false);

            case 7:
              _context2.prev = 7;
              _context2.next = 10;
              return dispatch({
                type: CHECK_TICKET,
                closeLoading: isNeed,
                payload: {
                  request: {
                    url: url,
                    method: 'post',
                    data: data
                  }
                },
                ticketNo: data.ticketNo,
                orderNo: data.orderNo
              }).then(function (data) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__modules_actions__["y" /* getUserInfo */])());
                return data;
              });

            case 10:
              _ref4 = _context2.sent;
              _ref4$payload$data = _ref4.payload.data;
              checkResult = _ref4$payload$data.checkResult;
              checkCode = _ref4$payload$data.checkCode;
              checkMsg = _ref4$payload$data.checkMsg;
              error = _ref4$payload$data.error;
              ticketFlights = _ref4$payload$data.ticketFlights;
              ticketType = _ref4$payload$data.ticketType;
              invalidCode = _ref4$payload$data.invalidCode;
              gloOrederVo = _ref4$payload$data.gloOrederVo;
              isCeAirline = _ref4$payload$data.isCeAirline;
              airportTransferList = _ref4$payload$data.airportTransferList;

              if (!(checkResult === 'Y' || checkResult === 'S')) {
                _context2.next = 49;
                break;
              }

              if (!ticketFlights) {
                _context2.next = 39;
                break;
              }

              flightList = ticketFlights.flightList, odList = ticketFlights.odList, psgList = ticketFlights.psgList, odFlag = ticketFlights.odFlag, currency = ticketFlights.currency;

              if (!(psgList && psgList.length > 0 && type === 'c')) {
                _context2.next = 30;
                break;
              }

              if (!(options.channel === 'appos' && options.channel !== ticketFlights.psgList[0].orderingSiteCode)) {
                _context2.next = 29;
                break;
              }

              // TicPopUp(lang.title, lang.tipP5);
              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, lang.tipP5, '', '', [{
                text: lang.confirm,
                onPress: function onPress() {
                  window.$sensors.sensors.track('popup_click', {
                    popup_area: '可退改列表页-提示弹窗',
                    popup_type: '提示弹窗',
                    popup_title: lang.title,
                    popup_content: lang.tipP5,
                    click_type: lang.confirm
                    // target_url: process.env.TRC_work_order2 + `channel=web_2&query=dxxzrg&value1=${resUrl}`
                  });
                  window.location.hash.indexOf('#/ticket/updateDetail') > -1 ? '' : goback();
                }
              }]);
              return _context2.abrupt('return', false);

            case 29:
              if (options.channel === 'appos' && options.channel === psgList[0].orderingSiteCode) {
                Object(__WEBPACK_IMPORTED_MODULE_7_Utils__["session"])('orderingSiteCode', 'appos');
              }

            case 30:
              flightList.forEach(function (item) {
                item._flightClass_ = isEN ? transCabin(item.flightClass) : item.flightClass;
              });
              // 国际票

              if (!(psgList[0].domestic === 1 && type === 'c' && sysConfig.supportInterVolChange)) {
                _context2.next = 39;
                break;
              }

              _ticketType = 'd';

              if (ticketFlights.isMileage === 'Y0') {
                // Y0动态里程，按照之前的里程流程逻辑
                _ticketType = 'm';
              }
              if (ticketFlights.isMileage === 'Y1') {
                // 固定里程，新航班按价格的展示
                _ticketType = 'm1';
              } else if (Object(__WEBPACK_IMPORTED_MODULE_7_Utils__["isOfficialTicket"])(ticketFlights.psgList)) {
                _ticketType = 'o';
              } else {
                _ticketType = 'd';
              }
              window.sessionStorage.setItem('emp-mobile', JSON.stringify({
                ticket: {
                  base: {
                    ticketNo: data.ticketNo,
                    orderNo: data.orderNo,
                    odFlag: odFlag,
                    ticketType: _ticketType,
                    ticketClass: ticketType,
                    currency: currency
                  },
                  flightList: odFlag ? odList : flightList,
                  psgList: psgList,
                  gloOrederVo: gloOrederVo,
                  airportTransferList: airportTransferList
                }
              }));
              href =
              // window.location.href = `${
              "https://emp.csair.com/" + 'msite/#/selectSegPsg?' + Object(__WEBPACK_IMPORTED_MODULE_6_query_string__["stringify"])(Object.assign({
                orderNo: data.orderNo || '',
                ticketNo: data.ticketNo || '',
                scopeCodes: data.scopeCodes
              }, data.attribute1 ? { packOrderNo: data.packOrderNo } : {}, options.channel ? { channel: options.channel } : {}));

              if (/(InvalidStudentTicket)|(InvalidLabourTicket)/.test(invalidCode)) {
                Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, checkMsg, goback, '', [{
                  text: type === 'c' ? '继续变更' : '继续退票',
                  onPress: function onPress() {
                    window.location.href = href;
                  }
                }, {
                  text: '取消',
                  onPress: function onPress() {
                    window.location.hash.indexOf('#/ticket/updateDetail') > -1 ? '' : goback();
                  }
                }], '', {}, false);
              } else {
                window.location.href = href;
              }
              return _context2.abrupt('return', false);

            case 39:
              if (!(/(twinCityFly)|(EmployeeareaFlight)|(HapplyFly)|(HapplyFlyPc_LessthantwoNull)|(HapplyFlydataException)|(HapplyFlyPc_Lessthantwo)|(InvalidStudentTicket)|(InvalidLabourTicket)|(NoShowHappyFlyNumVoid)|(NoShowCsairHappyFlyVoid)/.test(checkCode) && isNeed)) {
                _context2.next = 42;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, checkMsg, goback, '', [{
                text: type === 'c' ? '继续变更' : '继续退票',
                onPress: function onPress() {
                  callback();
                }
              }, {
                text: '取消',
                onPress: function onPress() {
                  window.location.hash.indexOf('#/ticket/updateDetail') > -1 ? '' : goback();
                }
              }]);
              return _context2.abrupt('return', false);

            case 42:
              if (!(checkCode === 'specialMsg' && isNeed)) {
                _context2.next = 45;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, checkMsg, goback, '', [{
                text: lang.keepsubmit,
                onPress: function onPress() {
                  callback();
                }
              }]);
              return _context2.abrupt('return', false);

            case 45:

              if (/(HappyFlyNoRefund)|(HappyFlyNoRefundZYTP)|(HappyFlyNoChange)|(HappyFlyNoZYBG)/.test(checkCode) && isNeed) {
                Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, checkMsg ? checkMsg : error ? error.errorMsg : '系统异常', isNeedGoBack() ? goback : '');
              }

              // if (window.location.hash.indexOf('#/ticket/updateDetail') > -1 && isCeAirline === "3" && type === 'c') {
              //   TicPopUp(lang.title, lang.updateDetail.huChangeTip, '', '', [
              //     {
              //       text: '确定',
              //       onPress: () => {
              //         callback();
              //       },
              //     },
              //     {
              //       text: '取消',
              //       onPress: () => {
              //       },
              //     },
              //   ]);
              //   return false;
              // }

              callback();
              _context2.next = 50;
              break;

            case 49:
              Object(__WEBPACK_IMPORTED_MODULE_3_TicPopUp__["default"])(lang.title, checkMsg ? checkMsg : error ? error.errorMsg : '系统异常', isNeedGoBack() ? goback : '');

            case 50:
              _context2.next = 55;
              break;

            case 52:
              _context2.prev = 52;
              _context2.t0 = _context2['catch'](7);

              console.log('接口异常');

            case 55:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[7, 52]]);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/**
 * @description 获取客票
 * @param {string} type r 退票 c 变更
 * @param {object} ticketParams checkOrderTicket api参数
 * @param {object} authParams faceRecognition api参数
 * @param {func} callback 成功回调函数
 * @param {object} options
 * @param {object} options.closeLoad
 * @param {object} options.faceAuthResult 人脸认证结果
 */
function getTicketInfo(type, ticketParams, authParams, callback) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    faceAuthResult: false,
    channel: ''
  };
  var lang = arguments[5];

  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(type === 'r' && Object(__WEBPACK_IMPORTED_MODULE_2__csair_emp_helpers__["C" /* isCsairApp */])() && !options.faceAuthResult && getState().App.sysConfig.faceAuth)) {
                _context3.next = 3;
                break;
              }

              dispatch(checkFaceAuth(authParams, false, function (faceAuth) {
                if (!faceAuth.needFaceAuth || faceAuth.needFaceAuth && faceAuth.faceAuthResult) {
                  dispatch(checkTicket(type, ticketParams, {
                    channel: options.channel
                  }, function () {
                    callback(faceAuth.faceAuthResult);
                  }, lang));
                }
              }, lang));
              return _context3.abrupt('return', false);

            case 3:
              dispatch(checkTicket(type, ticketParams, {
                channel: options.channel
              }, callback, lang));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
}

// 替换指定航段
function replaceFlight(index, flight) {
  return { type: REPLACE_FLIGHT, index: index, flight: flight };
}

// 保存x产品
function saveXproducts(products, soProduct, htProduct, trainPro) {
  return { type: SAVE_X_PRODUCTS, products: products, soProduct: soProduct, htProduct: htProduct, trainPro: trainPro };
}
// 保存door产品
function saveDoorproducts(selectDoorList) {
  return { type: SAVE_DOOR_PRODUCTS, selectDoorList: selectDoorList };
}
// 保存x产品
function savePsgFlight(selectedPsg, selectedFlight) {
  return { type: SAVE_PSG_FLIGHT, selectedPsg: selectedPsg, selectedFlight: selectedFlight };
}
function saveMutype(muRefundType, muRefundReason, qtReason) {
  return { type: SAVE_MU_TYPE, muRefundType: muRefundType, muRefundReason: muRefundReason, qtReason: qtReason };
}

function saveMuFile(muFileList) {
  return { type: SAVE_MU_FILE, muFileList: muFileList };
}
function saveHuFile(huFileList) {
  return { type: SAVE_HU_FILE, huFileList: huFileList };
}
function saveHutype(huRefundType, huRefundReason, beizhu) {
  return { type: SAVE_HU_TYPE, huRefundType: huRefundType, huRefundReason: huRefundReason, beizhu: beizhu };
}
function saveAiPramas(data) {
  return { type: SAVE_AI_PRAMAS, data: data };
}
function createXSOOrder(data) {
  return {
    type: CREATE_XSO_ORDER,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_1_Url__["default"].createXSOOrder,
        method: 'post',
        data: data
      }
    }
  };
}

function uploadRefundFile(data) {
  return {
    type: UPLOAD_REFUND_FILE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_1_Url__["default"].uploadRefundFile,
        method: 'post',
        data: data,
        processData: false,
        contentType: false
      }
    }
  };
}

function HuFlightProtection(data) {
  return {
    type: HU_FLIGHT_PROTECTION,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_1_Url__["default"].HuFlightProtectionCheck,
        method: 'post',
        data: data
      }
    }
  };
}

// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/actions.js

/***/ }),

/***/ "k2+/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__("3Cgm");

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),

/***/ "kGv9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDefaultProps = getDefaultProps;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__("F92V");

var _Popup2 = _interopRequireDefault(_Popup);

var _Cascader = __webpack_require__("6//X");

var _Cascader2 = _interopRequireDefault(_Cascader);

var _MultiPicker = __webpack_require__("RmFE");

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__("fu9N");

var _Picker2 = _interopRequireDefault(_Picker);

var _arrayTreeFilter = __webpack_require__("C9Ci");

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */
function getDefaultProps() {
    var defaultFormat = function defaultFormat(values) {
        return values.join(',');
    };
    return {
        triggerType: 'onClick',
        prefixCls: 'am-picker',
        pickerPrefixCls: 'am-picker-col',
        popupPrefixCls: 'am-picker-popup',
        format: defaultFormat,
        cols: 3,
        cascade: true,
        extra: '请选择',
        okText: '确定',
        dismissText: '取消',
        title: ''
    };
}

var AbstractPicker = function (_React$Component) {
    (0, _inherits3['default'])(AbstractPicker, _React$Component);

    function AbstractPicker() {
        (0, _classCallCheck3['default'])(this, AbstractPicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (AbstractPicker.__proto__ || Object.getPrototypeOf(AbstractPicker)).apply(this, arguments));

        _this.getSel = function () {
            var value = _this.props.value || [];
            var treeChildren = void 0;
            if (_this.props.cascade) {
                treeChildren = (0, _arrayTreeFilter2['default'])(_this.props.data, function (c, level) {
                    return c.value === value[level];
                });
            } else {
                treeChildren = value.map(function (v, i) {
                    return _this.props.data[i].filter(function (d) {
                        return d.value === v;
                    })[0];
                });
            }
            return _this.props.format && _this.props.format(treeChildren.map(function (v) {
                return v.label;
            }));
        };
        _this.getPickerCol = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                pickerPrefixCls = _this$props.pickerPrefixCls,
                itemStyle = _this$props.itemStyle,
                indicatorStyle = _this$props.indicatorStyle;

            return data.map(function (col, index) {
                return _react2['default'].createElement(
                    _Picker2['default'],
                    { key: index, prefixCls: pickerPrefixCls, style: { flex: 1 }, itemStyle: itemStyle, indicatorStyle: indicatorStyle },
                    col.map(function (item) {
                        return _react2['default'].createElement(
                            _Picker2['default'].Item,
                            { key: item.value, value: item.value },
                            item.label
                        );
                    })
                );
            });
        };
        return _this;
    }

    (0, _createClass3['default'])(AbstractPicker, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                _a$value = _a.value,
                value = _a$value === undefined ? [] : _a$value,
                extra = _a.extra,
                okText = _a.okText,
                dismissText = _a.dismissText,
                popupPrefixCls = _a.popupPrefixCls,
                itemStyle = _a.itemStyle,
                indicatorStyle = _a.indicatorStyle,
                cascade = _a.cascade,
                prefixCls = _a.prefixCls,
                pickerPrefixCls = _a.pickerPrefixCls,
                data = _a.data,
                cols = _a.cols,
                onPickerChange = _a.onPickerChange,
                restProps = __rest(_a, ["children", "value", "extra", "okText", "dismissText", "popupPrefixCls", "itemStyle", "indicatorStyle", "cascade", "prefixCls", "pickerPrefixCls", "data", "cols", "onPickerChange"]);
            var cascader = void 0;
            var popupMoreProps = {};
            if (cascade) {
                cascader = _react2['default'].createElement(_Cascader2['default'], { prefixCls: prefixCls, pickerPrefixCls: pickerPrefixCls, data: data, cols: cols, onChange: onPickerChange, pickerItemStyle: itemStyle, indicatorStyle: indicatorStyle });
            } else {
                cascader = _react2['default'].createElement(
                    _MultiPicker2['default'],
                    { style: { flexDirection: 'row', alignItems: 'center' }, prefixCls: prefixCls, pickerItemStyle: itemStyle },
                    this.getPickerCol()
                );
                popupMoreProps = {
                    pickerValueProp: 'selectedValue',
                    pickerValueChangeProp: 'onValueChange'
                };
            }
            return _react2['default'].createElement(
                _Popup2['default'],
                (0, _extends3['default'])({ cascader: cascader }, this.popupProps, restProps, { prefixCls: popupPrefixCls, value: value, dismissText: dismissText, okText: okText }, popupMoreProps),
                children && _react2['default'].cloneElement(children, { extra: this.getSel() || extra })
            );
        }
    }]);
    return AbstractPicker;
}(_react2['default'].Component);

exports['default'] = AbstractPicker;

/***/ }),

/***/ "kJxg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _CustomKeyboard = __webpack_require__("EmT1");

var _CustomKeyboard2 = _interopRequireDefault(_CustomKeyboard);

var _class = __webpack_require__("QOUF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var NumberInput = function (_React$Component) {
    (0, _inherits3['default'])(NumberInput, _React$Component);

    function NumberInput(props) {
        (0, _classCallCheck3['default'])(this, NumberInput);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

        _this.getComponent = function () {
            var _this$props = _this.props,
                keyboardPrefixCls = _this$props.keyboardPrefixCls,
                confirmLabel = _this$props.confirmLabel;

            return _react2['default'].createElement(_CustomKeyboard2['default'], { onClick: _this.onKeyboardClick, preixCls: keyboardPrefixCls, confirmLabel: confirmLabel });
        };
        _this.renderCustomKeyboard = function () {
            var container = document.querySelector('#' + _this.props.keyboardPrefixCls + '-container');
            if (!container) {
                container = document.createElement('div');
                container.setAttribute('id', _this.props.keyboardPrefixCls + '-container');
                document.body.appendChild(container);
                window.antmCustomKeyboard = _reactDom2['default'].unstable_renderSubtreeIntoContainer(_this, _this.getComponent(), container);
            }
        };
        _this._blurEventListener = function (ev) {
            var value = _this.props.value;

            if (ev.target !== _this.refs['input-container']) {
                _this.onInputBlur(value);
            }
        };
        _this.unLinkInput = function () {
            var antmCustomKeyboard = window.antmCustomKeyboard;
            if (antmCustomKeyboard.linkedInput === _this) {
                antmCustomKeyboard.linkedInput = null;
                (0, _class.addClass)(antmCustomKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
            }
        };
        _this.onInputBlur = function (value) {
            var focused = _this.state.focused;

            if (focused) {
                _this.setState({
                    focused: false
                });
                _this.props.onBlur(value);
                setTimeout(function () {
                    _this.unLinkInput();
                }, 50);
            }
        };
        _this.onInputFocus = function (value) {
            _this.props.onFocus(value);
            _this.setState({
                focused: true
            }, function () {
                var antmCustomKeyboard = window.antmCustomKeyboard;
                antmCustomKeyboard.linkedInput = _this;
                (0, _class.removeClass)(antmCustomKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
                antmCustomKeyboard.confirmDisabled = value === '';
                if (value === '') {
                    (0, _class.addClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                } else {
                    (0, _class.removeClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                }
            });
        };
        _this.onKeyboardClick = function (KeyboardItemValue) {
            var _this$props2 = _this.props,
                value = _this$props2.value,
                onChange = _this$props2.onChange,
                maxLength = _this$props2.maxLength;

            var valueAfterChange = void 0;
            // 删除键
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
                // 确认键
            } else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                onChange({ target: { value: valueAfterChange } });
                _this.onInputBlur(value);
                // 收起键
            } else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                _this.onInputBlur(valueAfterChange);
            } else {
                if (maxLength !== undefined && +maxLength >= 0 && (value + KeyboardItemValue).length > maxLength) {
                    valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                    onChange({ target: { value: valueAfterChange } });
                } else {
                    valueAfterChange = value + KeyboardItemValue;
                    onChange({ target: { value: valueAfterChange } });
                }
            }
            var antmCustomKeyboard = window.antmCustomKeyboard;
            antmCustomKeyboard.confirmDisabled = valueAfterChange === '';
            if (valueAfterChange === '') {
                (0, _class.addClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
            } else {
                (0, _class.removeClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
            }
        };
        _this.onFakeInputClick = function () {
            var value = _this.props.value;
            var focused = _this.state.focused;

            if (!focused) {
                _this.onInputFocus(value);
            }
        };
        _this.focus = function () {
            document.removeEventListener('click', _this._blurEventListener, false);
            _this.onFakeInputClick();
            setTimeout(function () {
                document.addEventListener('click', _this._blurEventListener, false);
            }, 50);
        };
        _this.state = {
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(NumberInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if ('focused' in nextProps && nextProps.focused !== this.state.focused) {
                this.debounceFocusTimeout = setTimeout(function () {
                    var _props = _this2.props,
                        disabled = _props.disabled,
                        editable = _props.editable;

                    if (nextProps.focused && !disabled && editable) {
                        _this2.onInputFocus(_this2.props.value);
                    }
                }, 10);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!window.antmCustomKeyboard) {
                this.renderCustomKeyboard();
            }
            var _props2 = this.props,
                autoFocus = _props2.autoFocus,
                focused = _props2.focused,
                value = _props2.value,
                disabled = _props2.disabled,
                editable = _props2.editable;

            if ((autoFocus || focused) && !disabled && editable) {
                this.onInputFocus(value);
            }
            document.addEventListener('click', this._blurEventListener, false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._blurEventListener, false);
            if (this.debounceFocusTimeout) {
                clearTimeout(this.debounceFocusTimeout);
                this.debounceFocusTimeout = null;
            }
            this.unLinkInput();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props3 = this.props,
                placeholder = _props3.placeholder,
                value = _props3.value,
                disabled = _props3.disabled,
                editable = _props3.editable;
            var focused = this.state.focused;

            var preventKeyboard = disabled || !editable;
            var fakeInputCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, 'fake-input', true), (0, _defineProperty3['default'])(_classNames, 'focus', focused), (0, _defineProperty3['default'])(_classNames, 'fake-input-disabled', disabled), _classNames));
            return _react2['default'].createElement(
                'div',
                { className: 'fake-input-container' },
                value === '' && _react2['default'].createElement(
                    'div',
                    { className: 'fake-input-placeholder' },
                    placeholder
                ),
                _react2['default'].createElement(
                    'div',
                    { className: fakeInputCls, ref: 'input-container', onClick: preventKeyboard ? function () {} : this.onFakeInputClick },
                    value
                )
            );
        }
    }]);
    return NumberInput;
}(_react2['default'].Component); /* tslint:disable:jsx-no-multiline-js */


NumberInput.defaultProps = {
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    placeholder: '',
    value: '',
    disabled: false,
    editable: true,
    prefixCls: 'am-input',
    keyboardPrefixCls: 'am-number-keyboard'
};
exports['default'] = NumberInput;
module.exports = exports['default'];

/***/ }),

/***/ "ktak":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "ktnU":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("Hxdr");

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ "kvU2":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("Fkvj");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ "kxzG":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "l/2K":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "lAmK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("odTk");
var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var speciesConstructor = __webpack_require__("Xfp1");
var iterate = __webpack_require__("UHV6");
var Set = path.Set;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  symmetricDifference: function symmetricDifference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, Set))(set);
    var remover = aFunction(newSet['delete']);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      remover.call(newSet, value) || adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "lGoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CHANGE_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_PRODUCTSHOW_LIST; });
/* unused harmony export SAVE_RECOMMEND_AND_COST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_CABIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_CHANGEFARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INIT_FLIGHT; });
/* harmony export (immutable) */ __webpack_exports__["f"] = clearChangeFlight;
/* harmony export (immutable) */ __webpack_exports__["h"] = getChangeCost;
/* harmony export (immutable) */ __webpack_exports__["i"] = getProductShopList;
/* harmony export (immutable) */ __webpack_exports__["g"] = editChangeFare;
/* harmony export (immutable) */ __webpack_exports__["j"] = selectCabin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var GET_CHANGE_COST = 'GET_CHANGE_COST';
var GET_PRODUCTSHOW_LIST = 'GET_PRODUCTSHOW_LIST';
var SAVE_RECOMMEND_AND_COST = 'SAVE_RECOMMEND_AND_COST';
var EDIT_CABIN = 'EDIT_CABIN';
var EDIT_CHANGEFARE = 'EDIT_CHANGEFARE';
var INIT_FLIGHT = 'INIT_FLIGHT';

function clearChangeFlight() {
  return { type: INIT_FLIGHT };
}

// 获取变更费用和升舱推荐
function getChangeCost(data) {
  return {
    type: GET_CHANGE_COST,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryChangeCost,
        method: 'post',
        data: data
      }
    }
  };
}

function getProductShopList(data) {
  return {
    type: GET_PRODUCTSHOW_LIST,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getProductShopList,
        method: 'post',
        data: data
      }
    }
  };
}

// 修改变更手续费
function editChangeFare(arr) {
  var data = [];
  if (Number(arr[0]) > 0) {
    data.push({
      psgType: 0,
      exchangeCost: arr[0]
    });
  }
  if (Number(arr[1]) > 0) {
    data.push({
      psgType: 1,
      exchangeCost: arr[1]
    });
  }
  if (Number(arr[2]) > 0) {
    data.push({
      psgType: 3,
      exchangeCost: arr[2]
    });
  }
  return { type: EDIT_CHANGEFARE, data: data };
}

// 选择推荐的升舱
function selectCabin(n) {
  return { type: EDIT_CABIN, n: n };
}

/***/ }),

/***/ "lHK6":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("/GnY"),
    getTag = __webpack_require__("gHOb"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn"),
    isArrayLike = __webpack_require__("bGc4"),
    isBuffer = __webpack_require__("ggOT"),
    isPrototype = __webpack_require__("HT7L"),
    isTypedArray = __webpack_require__("YsVG");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "lOFV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPicker2 = __webpack_require__("kGv9");

var _AbstractPicker3 = _interopRequireDefault(_AbstractPicker2);

var _popupProps = __webpack_require__("KKFe");

var _popupProps2 = _interopRequireDefault(_popupProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Picker = function (_AbstractPicker) {
    (0, _inherits3['default'])(Picker, _AbstractPicker);

    function Picker() {
        (0, _classCallCheck3['default'])(this, Picker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).apply(this, arguments));

        _this.popupProps = _popupProps2['default'];
        return _this;
    }

    return Picker;
}(_AbstractPicker3['default']);

exports['default'] = Picker;

Picker.defaultProps = (0, _AbstractPicker2.getDefaultProps)();
module.exports = exports['default'];

/***/ }),

/***/ "lQmB":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("Fkvj");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/features/map/index.js
var map = __webpack_require__("CL6c");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/core-js/features/set/index.js
var set = __webpack_require__("LjUa");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./src/config/routerConfig.js
var routerConfig = __webpack_require__("a1o4");

// EXTERNAL MODULE: ../emp-helpers/dist/es/index.js + 57 modules
var es = __webpack_require__("mekh");

// EXTERNAL MODULE: delegated ./node_modules/redux/es/index.js from dll-reference vendor_library
var esfrom_dll_reference_vendor_library = __webpack_require__("2KeS");

// EXTERNAL MODULE: delegated ./node_modules/redux-persist/es/index.js from dll-reference vendor_library
var redux_persist_esfrom_dll_reference_vendor_library = __webpack_require__("AyKp");

// EXTERNAL MODULE: ./node_modules/redux-persist/lib/storage/session.js
var session = __webpack_require__("ersE");
var session_default = /*#__PURE__*/__webpack_require__.n(session);

// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ./src/routes/modules/actions.js
var actions = __webpack_require__("1EI8");

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/js-sha256/src/sha256.js
var sha256 = __webpack_require__("BUS2");
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);

// CONCATENATED MODULE: ./src/routes/modules/app.js




/**
 * userInfo
 *  createTime: 1505145600000 创建日期
 *  easyLoginRequest: false
 *  identifyStatus: null 认证 Y是 N否
 *  loginType 登录类型 6：会员登录；7：非会员登录； 8：直接接入；15：简易登录（20180428新增）；17：扫登机牌登录 99 员工登录（特定）
 *  memberNo 会员号
 *  memberType 会员类型：EM(E行会员）/ FFPM（明珠会员）
 *  mobile
 *  name
 *  upgrading
 */

var app_initialState = {
  navBar: {
    display: true
  },
  lang: {},
  oldLocation: {},
  sysConfig: {
    is_Easy_Login_Turn_On: false,
    is_authenticate_turn_on: false,
    is_recommend_turn_on: false,
    has_luck_draw_movable_switch_bool: false,
    the_flag_fastchange: false
  },
  appConfig: {
    moreQuery: "false" === 'true'
  },
  userInfo: {},
  memberList: {},
  switchMieage: {}
};

function TicketChangesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* CHANGE_NAVBAR_STATE */]:
      return Object.assign({}, state, { navBar: { display: action.state } });
    case actions["h" /* SAVE_OLD_LOCATION */]:
      return Object.assign({}, state, { oldLocation: action.data });
    case actions["f" /* GET_SYS_CONFIG */] + '_SUCCESS':
    case actions["c" /* GET_APP_CONFIG */] + '_SUCCESS':
      return action.payload.data ? Object.assign({}, state, {
        sysConfig: Object.assign({}, state.sysConfig, action.payload.data.map || action.payload.data)
      }) : state;
    case actions["g" /* GET_USER_INFO */] + '_SUCCESS':
      if (action.payload.data) {
        var cookieLoginType = Object(es["m" /* getCookieUserInfo */])();
        if (cookieLoginType === 'OA') {
          action.payload.data.data.info.loginType = '99';
        }
        // let vconsole = document.getElementById('__vconsole');
        // vconsole ? vconsole.style.display = 'none' : '';
        // if (
        //   [
        //     '118218337593','149459309923'
        //   ].includes(action.payload.data.data.memberNo)
        // ) {
        //   vconsole ? vconsole.style.display = 'block' : '';
        // }
        var userID = sha256_default()(action.payload.data.data.memberNo);
        js_cookie_default.a.set('userId', userID);
        window.bonreeJsBridge && window.bonreeJsBridge.setUserID(userID);
        return Object.assign({}, state, {
          userInfo: action.payload.data.data
        });
      }
      return state;
    // case `${GET_PASSAGEMEMBER_LEVEL}_SUCCESS`:
    //   if (action.payload.data) {
    //     return Object.assign({}, state, {
    //       memberList: { memberList: action.payload.data.data },
    //     });
    //   }
    // return state;
    case actions["e" /* GET_MILEAGE_SWITCH */] + '_SUCCESS':
      if (action.payload.data) {
        return Object.assign({}, state, {
          switchMieage: action.payload.data
        });
      }
      return state;
    case actions["d" /* GET_LANGUAGE */]:
      if (action.lang) {
        return Object.assign({}, state, {
          lang: action.lang
        });
      }
      return state;
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/routes/modules/current.js
/**
 * 此reducer用于存放应用临时状态，不会持久化。
 */



var current_initialState = {
  loginParamefeeQuery: false, //记录当前是否是退改费用url带参数查询
  flights: [],
  psgs: []
};

function current_TicketChangesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : current_initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions["b" /* EDIT_LOGINPARAM_FEEQUERY */]:
      return Object.assign({}, state, {
        loginParamefeeQuery: !state.loginParamefeeQuery
      });
    case actions["i" /* SET_PSGS_FLIGHTS */]:
      return Object.assign({}, state, {
        flights: action.flights.length ? action.flights : state.flights,
        psgs: action.psgs.length ? action.psgs : state.psgs
      });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/updateDetail/modules/actions.js
var modules_actions = __webpack_require__("xXpn");

// CONCATENATED MODULE: ./src/routes/routes/updateDetail/modules/updateDetail.js


var updateDetail_initialState = {
  selectStyle: '1', // tab 1 可退改 2 处理中 3 已退改
  ticketType: '', // 请求参数 0-代表处理中  1-代表已退改
  authenticated: 0, // -1未实名认证且不展示 0未实名认证 1实名认证
  urlQuery: {}, // 存储首次进入时所带的参数
  faceCheckSwitch: false,
  faceCheckChannel: false,
  logoList: []
};

function updateDetailReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : updateDetail_initialState;
  var action = arguments[1];

  switch (action.type) {
    case modules_actions["f" /* SELECT_STYLE */]:
      return Object.assign({}, state, {
        selectStyle: action.data,
        ticketType: action.data === '2' ? '0' : action.data === '3' ? '1' : ''
      });
    case modules_actions["a" /* CHANGE_AUTH */]:
      return Object.assign({}, state, {
        authenticated: action.data
      });
    case modules_actions["g" /* WAY */]:
      return Object.assign({}, state, {
        way: action.data
      });
    case modules_actions["e" /* SAVE_QUERY */]:
      var params = Object.assign({}, state.urlQuery, action.data);
      return Object.assign({}, state, {
        urlQuery: params
      });
    case modules_actions["b" /* GET_FACECHECKMOREQUERY_SWITCH */]:
      return Object.assign({}, state, {
        faceCheckSwitch: action.data.isOpen == 'Y'
      });
    case modules_actions["c" /* SAVE_FACECHECKMOREQUERY_CHANNEL */]:
      console.log(action.data);
      return Object.assign({}, state, {
        faceCheckChannel: action.data
      });
    case modules_actions["d" /* SAVE_LGOO */]:
      return Object.assign({}, state, {
        logoList: action.data ? action.data : []
      });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__("oFuF");

// EXTERNAL MODULE: ./src/routes/routes/endorsedApply/modules/actions.js
var endorsedApply_modules_actions = __webpack_require__("jgRS");

// CONCATENATED MODULE: ./src/routes/routes/endorsedApply/modules/edorsedApply.js





var edorsedApply_initialState = {
  orderNo: '', // 订单号
  ticketNo: '', // 票号
  salechannel: '', // 客票销售渠道
  ticketClass: 'default', // 客票类型 Group团体 DK DynamicMileage动态里程 StaticMileage固定里程（价格都按现金展示）MixinsMileage(混合支付里程) Civil公务 BonusPoints 积分票 Mix 混合支付票 DXFULLPKX 大兴全价票 DXAWARDPKX 大兴奖励票 ZDHK-TICK 中段换开客票 Government 政府采购机票
  ticketType: 'd', // o公务票 m里程客票(动态里程) m1固定里程 d普通客票(默认) 废弃请使用ticketClass
  refundMethod: '', // 退票方式 退票：e2e 预约退票：book
  isDomestic: true, // 是否是国内票
  isExchanged: false, // 是否换开
  flightList: [], // 航段
  psgList: [], // 乘机人
  changeProcess: [], // 变更流程类型(每次步骤操作修改变更流程类型，最后会剩下一种类型)
  artificialVerify: '', // 变更是否走人工审核
  flightRules: {}, // 每个航段变更日期限制 eg: { 1: [{ ticketNo, changeFlightDateRule }] }
  // x产品，关联变动判断逻辑请参考 EndorsedApply/index.js/relatedXproducts
  isEpidemicPolicy: false, // 是否疫情政策(zybg符合疫情政策走非自愿屏蔽降舱校验)
  xProduct: {
    flightProductId: '',
    products: [],
    xSoProducts: {},
    trainProduct: [],
    airProductId: '',
    hotelProduct: [],
    trainCoupon: [],
    trainPro: []
  },
  orderSoDetail: {},
  goOrder: '', // GO单号
  // isJXflight:false  // 是否是吉祥航空的客票
  exchangeType: '',
  currency: '',
  b2bFlag: false, //B2B客票
  campaignScriptId: '', //竞价候补
  bankGateWayCode: '', //优惠券参数
  getTicketCoupon: '',
  soProMessage: '',
  isCeAirline: '',
  iataOrderViewRS: {}, //东航数据
  muRefundType: '',
  huRefundType: '',
  muFileList: [],
  muRefundReason: '',
  muTicketFlights: {},
  muChangeNo: '',
  receivableCoupons: [],
  iataOrderViewRSHU: {},
  iataOrderViewRSCA: {}, // 国航数据
  hotelSummary: '',
  airportTransferList: [],
  selectDoorList: [],
  qtReason: '',
  sellerId: '',
  beizhu: '',
  huFileList: [],
  huRefundReason: ''
};
var isEN = window.sessionStorage.getItem('language') == 'en';
function transCabin(name) {
  switch (name) {
    case '经济舱':
      return 'Economy Class';
    case '明珠经济舱':
      return 'Sky Pearl Economy Class';
    case '公务舱':
      return 'Business Class';
    case '头等舱':
      return 'First Class';
    default:
      return name;
      break;
  }
}
function EdorsedApplyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : edorsedApply_initialState;
  var action = arguments[1];

  try {
    switch (action.type) {
      case endorsedApply_modules_actions["a" /* CHECK_TICKET */] + '_SUCCESS':
        var _action$payload$data = action.payload.data,
            ticketFlights = _action$payload$data.ticketFlights,
            ticketType = _action$payload$data.ticketType,
            checkResult = _action$payload$data.checkResult,
            refundType = _action$payload$data.refundType,
            isExchanged = _action$payload$data.isExchanged,
            orderDetailVo = _action$payload$data.orderDetailVo,
            orderSoDetailVO = _action$payload$data.orderSoDetailVO,
            gloOrederVo = _action$payload$data.gloOrederVo,
            bankGateWayCode = _action$payload$data.bankGateWayCode,
            getCoupon = _action$payload$data.getCoupon,
            soMessage = _action$payload$data.soMessage,
            isCeAirline = _action$payload$data.isCeAirline,
            iataOrderViewRS = _action$payload$data.iataOrderViewRS,
            receivableCoupons = _action$payload$data.receivableCoupons,
            iataOrderViewRSCA = _action$payload$data.iataOrderViewRSCA,
            order = _action$payload$data.order,
            hotelSummary = _action$payload$data.hotelSummary,
            airportTransferList = _action$payload$data.airportTransferList,
            dataLists = _action$payload$data.dataLists,
            sellerId = _action$payload$data.sellerId,
            ticketNo = action.meta.previousAction.ticketNo;

        var _ticketType = void 0;

        if ((checkResult === 'Y' || checkResult === 'S') && window.location.href.indexOf(routerConfig["default"].ticket.child.updateDetail.path) === -1) {
          if (ticketFlights.isMileage === 'Y0') {
            // Y0动态里程，按照之前的里程流程逻辑
            _ticketType = 'm';
          } else if (ticketFlights.isMileage === 'Y1') {
            // 固定里程，新航班按价格的展示
            _ticketType = 'm1';
          } else if (Object(util["isOfficialTicket"])(ticketFlights.psgList)) {
            _ticketType = 'o';
          } else {
            _ticketType = 'd';
          }

          var _xProduct2 = {
            flightProductId: '',
            products: [],
            xSoProducts: {},
            trainProduct: [],
            airProductId: '',
            hotelProduct: [],
            trainCoupon: []
          };
          var orderSoDetail = {};

          ticketFlights.psgList = ticketFlights.psgList.map(function (item) {
            item.XNos = [];
            return item;
          });
          if (orderDetailVo && refundType !== 'e2e') {
            var airTicket = orderDetailVo.airTicket,
                xproductVOs = orderDetailVo.xproductVOs;

            _xProduct2.flightProductId = airTicket.productId || '';
            // 关联变动判断逻辑请参考 EndorsedApply/index.js/relatedXproducts
            _xProduct2.products = (xproductVOs || []).map(function (item) {
              return {
                text: item.productZhName,
                type: 'num',
                min: 0, // 最小值，默认0，realSegOrder与航段关联变动
                max: item.max || 0, // 最大值，realSegOrder与航段关联变动
                linkMax: item.max || 0, // 强关联最大值
                linkValue: item.min || 0, // 强关联最小值
                value: item.max || 0, // 当前值，默认最大值
                unit: '张',
                realSegOrder: item.realSegOrder, // 与航段segmentId存在关联关系
                details: item.xproductDetails.map(function (detailItem) {
                  return {
                    productId: detailItem.productId,
                    segOrder: detailItem.segOrder,
                    realSegOrder: detailItem.realSegOrder,
                    highRelevancy: detailItem.highRelevancy,
                    orderNo: detailItem.orderNo,
                    subGoodsId: detailItem.subgoodsid,
                    subGoodsZhName: detailItem.subgoodsZhName,
                    psgObj: detailItem.xpassenger,
                    isSele: detailItem.highRelevancy ? false : true
                  };
                }).sort(function (detailItem) {
                  return detailItem.highRelevancy ? -1 : 1;
                })
              };
            });
            xproductVOs.forEach(function (item) {
              item.xproductDetails.forEach(function (ite) {
                ticketFlights.psgList.forEach(function (iu) {
                  if (iu.psgName == ite.xpassenger.name && iu.certificateIdDis == ite.xpassenger.number && ite.highRelevancy) {
                    iu.XNos.push(ite.orderNo);
                  }
                });
              });
            });

            var arr = [];
            var psgArr = ticketFlights.psgList.map(function (item, i) {
              return item.valid ? i : '';
            }).filter(function (item) {
              return item !== '';
            });
            if (psgArr.length === 1) arr = psgArr;
            arr.forEach(function (item) {
              ticketFlights.psgList[item].XNos.forEach(function (it) {
                _xProduct2.products.forEach(function (io) {
                  io.details.forEach(function (ip) {
                    if (ip.orderNo == it) {
                      ip.isSele = true;
                    }
                  });
                });
              });
            });
            _xProduct2.products.forEach(function (item) {
              var heightNum = item.details.filter(function (iu) {
                return !iu.isSele && iu.highRelevancy;
              }).length;
              var minheightNum = item.details.filter(function (iu) {
                return iu.isSele && iu.highRelevancy;
              }).length;
              item.value = item.details.length - heightNum;
              item.linkValue = minheightNum;
              item.max = item.details.length - heightNum;
              item.min = minheightNum;
              item.show = item.details.every(function (nb) {
                return nb.highRelevancy;
              });
            });
          }

          // so产品
          if (orderSoDetailVO && orderSoDetailVO !== null && refundType !== 'e2e') {
            var xsoProductVOs = orderSoDetailVO.xsoProductVOs,
                xairIronTransportVO = orderSoDetailVO.xairIronTransportVO,
                airTicketProductId = orderSoDetailVO.airTicketProductId,
                orderDetailHT = orderSoDetailVO.orderDetailHT,
                airIronTransportDiscounts = orderSoDetailVO.airIronTransportDiscounts;

            if (xsoProductVOs !== null && xsoProductVOs) {
              _xProduct2.xSoProducts = xsoProductVOs;
            }

            if (xairIronTransportVO !== null && xairIronTransportVO) {
              _xProduct2.airProductId = airTicketProductId;
              _xProduct2.trainProduct = xairIronTransportVO;
            }

            if (airIronTransportDiscounts) {
              _xProduct2.airProductId = airTicketProductId;
              _xProduct2.trainCoupon = airIronTransportDiscounts;
            }

            // 酒店产品
            if (orderDetailHT !== null && orderDetailHT) {
              _xProduct2.hotelProduct = orderDetailHT;
            }

            orderSoDetail = orderSoDetailVO;
          }

          if (ticketType === 'ZDHK-TICK') {
            ticketFlights.psgList.forEach(function (item) {
              item.scopeCodes = ['fzybg'];
            });
          }
          return Object.assign({}, state, {
            ticketType: _ticketType ? _ticketType : 'd',
            ticketClass: ticketType,
            flightList: ticketFlights.flightList.map(function (item) {
              item.flightNo = /[a-z]/i.test(item.flightNo) ? item.flightNo : item.carrier + item.flightNo;
              item.flightClass = isEN ? transCabin(item.flightClass) : item.flightClass;
              return item;
            }),
            psgList: ticketFlights.psgList.map(function (item) {
              item._psgName = Object(es["j" /* filterPsgName */])(item.psgName, item.psgType);
              // item._psgName = filterPsgName(item.psgName, item.psgType);
              item._valid = true;
              return item;
            }),
            salechannel: ticketFlights.salechannel,
            orderNo: ticketFlights.orderNo || '',
            muChangeNo: ticketFlights.changeNo || '',
            refundMethod: refundType,
            isDomestic: ticketFlights.psgList[0].domestic !== 1,
            isExchanged: isExchanged === '1',
            ticketNo: ticketNo || '',
            xProduct: _xProduct2,
            goOrder: gloOrederVo,
            currency: ticketFlights.currency,
            orderSoDetail: orderSoDetail,
            b2bFlag: ticketFlights.b2bFlag,
            campaignScriptId: ticketFlights.campaignScriptId,
            bankGateWayCode: bankGateWayCode,
            getTicketCoupon: getCoupon,
            soProMessage: soMessage,
            isCeAirline: isCeAirline,
            iataOrderViewRS: iataOrderViewRS,
            iataOrderViewRSCA: iataOrderViewRSCA,
            iataOrderViewRSHU: { order: order, dataLists: dataLists },
            muTicketFlights: ticketFlights,
            receivableCoupons: receivableCoupons,
            hotelSummary: hotelSummary,
            airportTransferList: airportTransferList,
            sellerId: sellerId
            // isJXflight:true
          });
        }
        return state;
      case endorsedApply_modules_actions["b" /* CHECK_TICKET_FLIGHT */] + '_SUCCESS':
        var data = action.payload.data;

        if (data.refundType) return Object.assign({}, state, {
          refundMethod: data.refundType
        });
        return state;
      case endorsedApply_modules_actions["c" /* CLEAR_TICKET_INFO */]:
        return edorsedApply_initialState;
      case endorsedApply_modules_actions["g" /* SAVE_CHANGE_PROCESS */]:
        return Object.assign({}, state, action.status);
      case endorsedApply_modules_actions["e" /* REPLACE_FLIGHT */]:
        if (!action.flight) return state;
        state.flightList[action.index] = action.flight;
        return state;
      case endorsedApply_modules_actions["n" /* SAVE_X_PRODUCTS */]:
        var _xProduct = state.xProduct;
        _xProduct.products = [];
        _xProduct.xSoProducts = action.soProduct || {};
        _xProduct.hotelProduct = action.htProduct || [];
        _xProduct.trainPro = action.trainPro || [];
        action.products.forEach(function (productItem) {
          if (productItem.value === 0) return;
          _xProduct.products.push(productItem);
        });
        if (!_xProduct.products || !_xProduct.products.length) _xProduct.flightProductId = '';
        return Object.assign({}, state, {
          xProduct: _xProduct
        });

      case endorsedApply_modules_actions["m" /* SAVE_PSG_FLIGHT */]:
        return Object.assign({}, state, {
          selectPsg: action.selectedPsg,
          selectFlight: action.selectedFlight
        });

      case endorsedApply_modules_actions["l" /* SAVE_MU_TYPE */]:
        return Object.assign({}, state, {
          muRefundType: action.muRefundType,
          muRefundReason: action.muRefundReason,
          qtReason: action.qtReason
        });

      case endorsedApply_modules_actions["k" /* SAVE_MU_FILE */]:
        return Object.assign({}, state, {
          muFileList: action.muFileList
        });

      case endorsedApply_modules_actions["h" /* SAVE_DOOR_PRODUCTS */]:
        return Object.assign({}, state, {
          selectDoorList: action.selectDoorList
        });
      case endorsedApply_modules_actions["j" /* SAVE_HU_TYPE */]:
        return Object.assign({}, state, {
          huRefundType: action.huRefundType,
          huRefundReason: action.huRefundReason,
          beizhu: action.beizhu
        });
      case endorsedApply_modules_actions["i" /* SAVE_HU_FILE */]:
        return Object.assign({}, state, {
          muFileList: action.huFileList
        });
      case endorsedApply_modules_actions["f" /* SAVE_AI_PRAMAS */]:
        return Object.assign({}, state, action.data);
      default:
        return state;
    }
  } catch (error) {
    console.log('接口异常');
    return state;
  }
}

// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/edorsedApply.js
// EXTERNAL MODULE: ./src/routes/routes/ticketChanges/modules/actions.js
var ticketChanges_modules_actions = __webpack_require__("irwo");

// CONCATENATED MODULE: ./src/routes/routes/ticketChanges/modules/ticketChanges.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var ticketChanges_initialState = {
  // 湾区通
  bayArea: {
    // NORMAL 普通变更，默认
    // WQT_KX 湾区通快线
    // WQT_YDHC 湾区通异地换乘
    // WQT_NHKX 南航快线
    // WQT_NCKX 南川快线
    bayAreaType: 'NORMAL',
    message: '',
    discount: 1,
    segmentOptions: [],
    startDate: '',
    endDate: ''
  },
  list: [], // 列表数据
  _list: [], // 新航班接口返参
  wqtObj: {}, // key: 航班号, value: { oldFlight, bayAreaType, startDate, endDate }
  taxs: {}, // 税费
  exchangeMode: '', // 换开方式 1自动，其他都是人工，其中0为客服人工，2为销售单位，3为代理人，4紧急换开
  ticketChannel: '', // 出票渠道（客票类型）
  selectFlight: [], // 选择的新航班数据
  artificialFlag: [], // 选择的新航班是否走人工的标识，0 不走人工，1走人工
  selectNum: [], // 选择的新航班为正常情况true，若处于重选状态，按选择序列，修改为false，当所有元素为true时标识选择完毕
  bayAreaTransferDto: {} //不等于NORMAL就是中转快线
};

function ticketChangesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ticketChanges_initialState;
  var action = arguments[1];

  switch (action.type) {
    case ticketChanges_modules_actions["c" /* INIT_FLIGHT */]:
      return ticketChanges_initialState;
    case ticketChanges_modules_actions["b" /* FIND_FLIGHT_LIST */] + '_SUCCESS':
      var data = action.payload.data;

      if (!data.errorInfo) {
        // 初始化赋予湾区通数据，可能一进来当前的航班已经是属于弯曲通的
        var wqtObj = state.wqtObj || {};
        var flightNo = JSON.parse(action.payload.config.data).flightNo;
        var bayArea = data.bayArea || {};
        var dataArr = JSON.parse(JSON.stringify(data.list));
        // 合并湾区通数据对象，作用于日期范围限制退回旧航班数据，旧航班数据可能不存在，因为没有更换行程
        wqtObj[flightNo] = Object.assign({}, wqtObj[flightNo], {
          bayAreaType: bayArea.bayAreaType,
          discount: bayArea.discount,
          endDate: bayArea.endDate,
          startDate: bayArea.startDate
        });
        return Object.assign({}, state, {
          list: data.list.map(function (item) {
            item.crowdInfo = data.crowdInfo;
            item.tagInfo = data.tagInfo;
            if (item.departTime.indexOf(':') === -1) item.departTime = Object(es["A" /* insertStr */])(item.departTime, 2, ':');
            if (item.arriveTime.indexOf(':') === -1) item.arriveTime = Object(es["A" /* insertStr */])(item.arriveTime, 2, ':');
            if (!item.cabinLists) return item;
            item.cabinListsCopy = JSON.parse(JSON.stringify(item.cabinLists));
            var keys = Object.keys(item.cabinLists);
            var cabinObj = {};
            keys.forEach(function (child, ind) {
              var arr = void 0;
              if (!(action.meta.previousAction.originFlight.carrier === "MU" || action.meta.previousAction.originFlight.carrier === "CA" || action.meta.previousAction.originFlight.carrier === "HU")) {
                item.cabinLists[child] = Object(util["cabinSort"])(item.cabinLists[child]);
              }
              if (action.meta.previousAction.originFlight.carrier === "CA") {
                item.cabinLists[child] = item.cabinLists[child].sort(function (p, l) {
                  return l[Object.keys(l)[0]][0].changeFare - p[Object.keys(p)[0]][0].changeFare;
                })[0][Object.keys(item.cabinLists[child].sort(function (p, l) {
                  return l[Object.keys(l)[0]][0].changeFare - p[Object.keys(p)[0]][0].changeFare;
                })[0])[0]];
              }
              var isPriorityFlight = item.cabinLists[child].some(function (flight) {
                return flight.isPriorityDisplay;
              });
              arr = isPriorityFlight ? item.cabinLists[child].filter(function (i) {
                return i.isPriorityDisplay;
              }) : item.cabinLists[child].filter(function (i) {
                return Object(es["h" /* compareCabin */])(action.meta.previousAction.originFlight.flightCabin, i.cabin) === -1 || Object(es["h" /* compareCabin */])(action.meta.previousAction.originFlight.flightCabin, i.cabin) === 0;
              });

              var cabinArr = [];
              if (arr.length !== 0) {
                var otherCabin = {},
                    sortedObj2 = {};
                arr.forEach(function (v, index) {
                  if (ind == 0) {
                    if (!cabinObj[v.cabinName]) {
                      cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                      cabinObj[v.cabinName].index = index;
                    }
                    if (v.addAmount < cabinObj[v.cabinName].addAmount) {
                      cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                      cabinObj[v.cabinName].index = index;
                    }
                    // if (action.meta.previousAction.originFlight.carrier === "MU" && v.addAmount === cabinObj[v.cabinName].addAmount) {
                    //   cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                    //   cabinObj[v.cabinName].index = key
                    // }
                  } else {
                    for (var jkl in cabinObj) {
                      if (action.meta.previousAction.originFlight.carrier === "MU" || action.meta.previousAction.originFlight.carrier === "CA" || action.meta.previousAction.originFlight.carrier === "HU") {
                        if (cabinObj[jkl].index === index) {
                          otherCabin[jkl] = v;
                        }
                      } else {
                        if (cabinObj[jkl].cabin == v.cabin) {
                          otherCabin[jkl] = v;
                        }
                      }
                    }

                    if (action.meta.previousAction.originFlight.carrier === "MU" || action.meta.previousAction.originFlight.carrier === "CA" || action.meta.previousAction.originFlight.carrier === "HU") {
                      Object.keys(cabinObj).forEach(function (key) {
                        sortedObj2[key] = otherCabin[key]; // 直接赋值，保持原有值和顺序
                      });
                    } else {
                      sortedObj2 = otherCabin;
                    }
                  }
                });

                if (ind == 0) {
                  for (var key in cabinObj) {
                    cabinObj[key]._firstFlight = 'Y';
                    cabinArr.push(cabinObj[key]);
                    if (Object(es["q" /* getPhysicalCabinName */])(action.meta.previousAction.originFlight.flightCabin) !== Object(es["q" /* getPhysicalCabinName */])(cabinObj[key].cabin)) {
                      cabinObj[key]._changeStyle = 'Y';
                    }
                  }
                } else {
                  for (var key in sortedObj2) {
                    sortedObj2[key]._firstFlight = 'Y';
                    cabinArr.push(sortedObj2[key]);
                    if (Object(es["q" /* getPhysicalCabinName */])(action.meta.previousAction.originFlight.flightCabin) !== Object(es["q" /* getPhysicalCabinName */])(sortedObj2[key].cabin)) {
                      sortedObj2[key]._changeStyle = 'Y';
                    }
                  }
                }
              }

              //  新双城套票不展示智能推荐
              if (!data.yTwinCity) {
                item.cabinLists[child] = cabinArr.concat(item.cabinLists[child]);
              }
            });
            return item;
          }),
          bayArea: bayArea,
          wqtObj: wqtObj,
          taxs: data.taxs || {},
          yTwinCity: data.yTwinCity || false,
          bayAreaTransferDto: state.bayAreaTransferDto && Object.keys(state.bayAreaTransferDto).length !== 0 ? state.bayAreaTransferDto : data.bayAreaTransferDto || {}

        });
      }
      return Object.assign({}, state, {
        list: []
      });
    case ticketChanges_modules_actions["f" /* SELECT_FLIGHT */]:
      if (action.key !== '') {
        var _arr = [].concat(_toConsumableArray(state.selectFlight));
        _arr.splice(action.key, 1, action.data);
        var arrFlag = [].concat(_toConsumableArray(state.artificialFlag));
        arrFlag.splice(action.key, 1, action.flag);
        var arrSelect = [].concat(_toConsumableArray(state.selectNum));
        arrSelect[action.key] = true;
        return Object.assign({}, state, {
          list: [],
          selectFlight: _arr,
          artificialFlag: arrFlag,
          selectNum: arrSelect
        });
      } else {
        return Object.assign({}, state, {
          list: [],
          selectFlight: [].concat(_toConsumableArray(state.selectFlight), [action.data]),
          artificialFlag: [].concat(_toConsumableArray(state.artificialFlag), [action.flag]),
          selectNum: [].concat(_toConsumableArray(state.selectNum), [true])
        });
      }
    case ticketChanges_modules_actions["a" /* CLEAR_FLIGHT */]:
      if (action.key !== '') {
        var _arr2 = [].concat(_toConsumableArray(state.selectFlight));

        _arr2.splice(action.key, 1, {});
        return Object.assign({}, state, { selectFlight: _arr2 });
      } else {
        return Object.assign({}, state, {
          selectFlight: [],
          artificialFlag: [].concat(_toConsumableArray(state.artificialFlag)),
          selectNum: []
        });
      }
    case ticketChanges_modules_actions["d" /* REST_FLIGHT */]:
      var arr = [].concat(_toConsumableArray(state.selectNum));
      arr[action.key] = false;
      return Object.assign({}, state, { selectNum: arr });
    case ticketChanges_modules_actions["e" /* SAVE_WQT_OBJ */]:
      return Object.assign({}, state, { wqtObj: action.wqtObj });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/applySubmit/modules/actions.js
var applySubmit_modules_actions = __webpack_require__("Bbjx");

// CONCATENATED MODULE: ./src/routes/routes/applySubmit/modules/applySubmit.js


var applySubmit_initialState = {
  cost: [], // 退票费用
  refundWay: 0, // 0 原流水退款，1 极速退款
  showRefundWay: false, // 是否展示退款方式
  contactInfo: {
    contact: '',
    contactPhone: '',
    encContact: '',
    encContactPhone: '',
    areaCode: '86'
  },
  referral: '', //推荐码
  insuranceList: []
};

function ReformProcessReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : applySubmit_initialState;
  var action = arguments[1];

  switch (action.type) {
    case applySubmit_modules_actions["a" /* CLEAR_COST */]:
      return Object.assign({}, state, {
        cost: [],
        refundWay: 0
      });
    case applySubmit_modules_actions["d" /* SAVE_COST */]:
      return Object.assign({}, state, { cost: action.data.refundRepayInfos });
    case applySubmit_modules_actions["c" /* GET_REFUND_WAY */] + '_SUCCESS':
      {
        var data = action.payload.data;

        // if (data.refundModeRes.existRefundMode) {
        //   return Object.assign({}, state, {
        //     refundWay: 0,
        //     showRefundWay: false,
        //   });
        // }

        return Object.assign({}, state, {
          refundWay: data.refundModeRes.refundMode === '2' ? 1 : 0,
          showRefundWay: data.refundModeRes.existRefundMode
        });
      }
    case applySubmit_modules_actions["e" /* SAVE_REFUND_WAY */]:
      return Object.assign({}, state, {
        refundWay: action.data
      });
    case applySubmit_modules_actions["b" /* GET_NAME_PHONE */] + '_SUCCESS':
      {
        var _data = action.payload.data;

        var contactInfo = {
          contact: _data.nameAndPhoneRes.name || '',
          contactPhone: _data.nameAndPhoneRes.telphone || '',
          // contactPhone: data.nameAndPhoneRes.telphone,
          encContact: _data.nameAndPhoneRes.encriptName || '',
          encContactPhone: _data.nameAndPhoneRes.encriptTel || '',
          areaCode: _data.nameAndPhoneRes.areaCode || '86'
        };
        return Object.assign({}, state, { contactInfo: contactInfo });
      }

    // case MU_CONTACT_INFO:
    //   return Object.assign({}, state, {
    //     contactInfo,
    //   });
    // case `${GET_INSURANCEC_CHANGE}_SUCCESS`: {
    //   const {
    //     payload: { data },
    //   } = action;
    //   console.log(state);
    //   return Object.assign({}, state, { insuranceList: data });
    // }
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/reformProcess/modules/actions.js
var reformProcess_modules_actions = __webpack_require__("2s00");

// CONCATENATED MODULE: ./src/routes/routes/reformProcess/modules/subInfo.js


var subInfo_initialState = {
  status: '',
  base: {}, // 变更单信息
  progressBar: {}, // 变更进度条信息
  changePrice: {}, // 变更费用
  changNo: '', // 变更单号
  psgInfoList: [], // 变更旅客信息
  segInfoList: [], // 变更航段信息
  priceDto: {}, // 变更、退票费用明细
  changeDiscountDtoList: [], // 优惠券
  refundOrderInfo: {}, // 退票信息
  psgTicketList: [], // 混合支付
  inPsgTicketInfos: [], // 退票旅客信息
  segmentInfos: [], // 退票航段信息
  disCountOrderInfos: [], // 退票赠送的优惠券
  eleInfo: [],
  reserveSeatObj: {
    orderNo: '',
    dataSource: [],
    status: '',
    phone: '',
    vname: '',
    isBasicCabin: false // 基础经济舱
  },
  insuranceDetailList: [], //保险信息
  auditCount: 1,
  dongHangStatus: '',
  orderRefID: '',
  totalTtPrice: 0,
  repaystatus: '',
  ticketRefundPriceDtoList: [],
  priceInfoDtos: [],
  gloOrederVo: '',
  hotelSummary: '',
  doorToDoorRefundOrder: ''
};

function SubInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : subInfo_initialState;
  var action = arguments[1];

  switch (action.type) {
    case reformProcess_modules_actions["d" /* SAVE_SUBINFO */]:
      if (Array.isArray(action.data.changeDiscountDtoList)) {
        action.data.changeDiscountDtoList.forEach(function (coupon) {
          if (coupon.psgType === '0' || coupon.psgType === '5' || coupon.psgType === '6') {
            action.data.priceDto.adultPrice.faceValue ? action.data.priceDto.adultPrice.faceValue += coupon.discountValue : action.data.priceDto.adultPrice.faceValue = coupon.discountValue;
            if (action.data.base.changeStyle && action.data.base.changeStyle.includes('退票挽留升舱')) {
              action.data.priceDto.adultPrice.upfaceValue = action.data.priceDto.adultPrice.faceValue;
            }
          }
          if (coupon.psgType === '1' || coupon.psgType === '2') {
            action.data.priceDto.childrenPrice.faceValue ? action.data.priceDto.childrenPrice.faceValue += coupon.discountValue : action.data.priceDto.childrenPrice.faceValue = coupon.discountValue;
            if (action.data.base.changeStyle && action.data.base.changeStyle.includes('退票挽留升舱')) {
              action.data.priceDto.childrenPrice.upfaceValue = action.data.priceDto.childrenPrice.faceValue;
            }
          }
          if (coupon.psgType === '3') {
            action.data.priceDto.infantPrice.faceValue ? action.data.priceDto.infantPrice.faceValue += coupon.discountValue : action.data.priceDto.infantPrice.faceValue = coupon.discountValue;
          }
        });
      }

      return Object.assign({}, state, action.data, {
        refundOrderInfo: {},
        inPsgTicketInfos: [],
        segmentInfos: []
      });
    case reformProcess_modules_actions["b" /* SAVE_REFUNDINFO */]:
      var _action$data = action.data,
          refundOrderInfo = _action$data.refundOrderInfo,
          inPsgTicketInfos = _action$data.inPsgTicketInfos,
          segmentInfos = _action$data.segmentInfos,
          priceDto = _action$data.priceDto,
          changeDiscountDtoList = _action$data.changeDiscountDtoList,
          refundViewDetial = _action$data.refundViewDetial,
          psgTicketList = _action$data.psgTicketList,
          redemptionPredictCancelResponse = _action$data.redemptionPredictCancelResponse,
          redemptionNoPredictCancelResponse = _action$data.redemptionNoPredictCancelResponse,
          disCountOrderInfo = _action$data.disCountOrderInfo,
          auditCount = _action$data.auditCount,
          dongHangStatus = _action$data.dongHangStatus,
          orderRefID = _action$data.orderRefID,
          totalTtPrice = _action$data.totalTtPrice,
          repaystatus = _action$data.repaystatus,
          ticketRefundPriceDtoList = _action$data.ticketRefundPriceDtoList,
          priceInfoDtos = _action$data.priceInfoDtos,
          gloOrederVo = _action$data.gloOrederVo,
          hotelSummary = _action$data.hotelSummary,
          doorToDoorRefundOrder = _action$data.doorToDoorRefundOrder;

      return Object.assign({}, state, {
        status: '',
        base: {},
        changePrice: {},
        changNo: '',
        psgInfoList: [],
        segInfoList: [],
        refundOrderInfo: refundOrderInfo,
        inPsgTicketInfos: inPsgTicketInfos,
        segmentInfos: segmentInfos,
        priceDto: priceDto,
        redemptionPredictCancelResponse: redemptionPredictCancelResponse,
        redemptionNoPredictCancelResponse: redemptionNoPredictCancelResponse,
        changeDiscountDtoList: changeDiscountDtoList,
        refundViewDetial: refundViewDetial || null,
        psgTicketList: psgTicketList || null,
        disCountOrderInfos: disCountOrderInfo || [],
        insuranceDetailList: [],
        auditCount: auditCount || 1,
        dongHangStatus: dongHangStatus,
        orderRefID: orderRefID,
        totalTtPrice: totalTtPrice,
        repaystatus: repaystatus,
        ticketRefundPriceDtoList: ticketRefundPriceDtoList,
        priceInfoDtos: priceInfoDtos,
        gloOrederVo: gloOrederVo,
        hotelSummary: hotelSummary,
        doorToDoorRefundOrder: doorToDoorRefundOrder
      });
    case reformProcess_modules_actions["a" /* GET_ELE_INVOICE */] + '_SUCCESS':
      return Object.assign({}, state, {
        eleInfo: action.payload.data.printableTicketsRsp && action.payload.data.printableTicketsRsp.printableTicketsInfos ? action.payload.data.printableTicketsRsp.printableTicketsInfos : []
      });
    case reformProcess_modules_actions["c" /* SAVE_RESERVE_NEW_SEAT */]:
      var reserveSeatObj = Object.assign({}, state.reserveSeatObj, action.data);
      return Object.assign({}, state, { reserveSeatObj: reserveSeatObj });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/realNameVerify/modules/actions.js
var realNameVerify_modules_actions = __webpack_require__("dXBc");

// CONCATENATED MODULE: ./src/routes/routes/realNameVerify/modules/realNameVerify.js


var realNameVerify_initialState = {};

function RealNameVeriifyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : realNameVerify_initialState;
  var action = arguments[1];

  switch (action.type) {
    case realNameVerify_modules_actions["c" /* REAL_NAME_VERIFY */]:
      return Object.assign({}, state, {
        realNameVerifyResult: action.realNameVerifyResult
      });
    case realNameVerify_modules_actions["b" /* CLEAR_REAL_NAME_VERIFY */]:
      return Object.assign({}, state, { realNameVerifyResult: {} });
    case realNameVerify_modules_actions["a" /* BANKCARD_DATA */]:
      return Object.assign({}, state, {
        bankcarddata: action.bankcarddata
      });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/feeQuery/modules/action.js
var modules_action = __webpack_require__("rENR");

// CONCATENATED MODULE: ./src/routes/routes/feeQuery/modules/feeQuery.js


var feeQuery_initialState = {
  psgName: '',
  ticketNo: '',
  ticketPrice: '',
  taxFee: '',
  refundChangeRule: '',
  rules: [],
  segment: [],
  isTicketNoFlag: '0', // 0 票号 1 证件号
  ticketInfos: [],
  mileageTicket: '',
  volunteer: true // true 自愿 false 非自愿
};

function feeQueryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : feeQuery_initialState;
  var action = arguments[1];

  switch (action.type) {
    case modules_action["a" /* INIT_STATE */]:
      return feeQuery_initialState;
    case modules_action["b" /* SAVE_QUERYINFO */]:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/selectDate/modules/actions.js
var selectDate_modules_actions = __webpack_require__("OC/S");

// CONCATENATED MODULE: ./src/routes/routes/selectDate/modules/selectDate.js
function selectDate__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var selectDate_initialState = {
  dates: []
};

function selectDateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectDate_initialState;
  var action = arguments[1];

  switch (action.type) {
    case selectDate_modules_actions["c" /* SAVE_SELECT_DATE */]:
      return Object.assign({}, state, { dates: [].concat(selectDate__toConsumableArray(state.dates), [action.data]) });
    case selectDate_modules_actions["a" /* CLEAR_SELECT_DATE */]:
      return Object.assign({}, state, { dates: [] });
    case selectDate_modules_actions["b" /* REPLEACE_SELECT_DATE */]:
      var arr = [].concat(selectDate__toConsumableArray(state.dates));
      arr.splice(action.num, 1, action.data);
      return Object.assign({}, state, { dates: arr });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/changeFlight/modules/actions.js
var changeFlight_modules_actions = __webpack_require__("lGoi");

// CONCATENATED MODULE: ./src/routes/routes/changeFlight/modules/changeFlight.js
function changeFlight__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var changeFlight_initialState = {
  epidemicDisease: '', // 0126 新冠疫情 0522 广州疫情
  epidemicPolicy: {},
  selectNum: -1, // -1 为当前选择舱位，> -1 为推荐升舱里面的舱位， 具体数据按序列读取
  changeCost: {}, // 当前所选的舱位信息
  recommended: [], // 推荐升舱
  shopList: []
};

function changeFlightReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : changeFlight_initialState;
  var action = arguments[1];

  switch (action.type) {
    case changeFlight_modules_actions["e" /* INIT_FLIGHT */]:
      return changeFlight_initialState;
    case changeFlight_modules_actions["c" /* GET_CHANGE_COST */] + '_SUCCESS':
      var _action$payload$data = action.payload.data,
          recommended = _action$payload$data.recommended,
          selected = _action$payload$data.selected,
          remark = _action$payload$data.remark,
          charge = _action$payload$data.charge,
          difcost = _action$payload$data.difcost;

      return Object.assign({}, state, {
        recommended: recommended || [],
        changeCost: selected,
        // epidemicDisease: isSpecialDateFree ? isSpecialDateFree : '',
        epidemicPolicy: {
          remark: remark, // 疫情原因标识
          charge: charge, // 手续费比例
          difcost: difcost // 票价差比例
        }
      });
    case changeFlight_modules_actions["a" /* EDIT_CABIN */]:
      return Object.assign({}, state, { selectNum: action.n });
    case changeFlight_modules_actions["b" /* EDIT_CHANGEFARE */]:
      var arr = [].concat(changeFlight__toConsumableArray(state.recommended));
      var obj = state.selectNum === -1 ? state.changeCost : arr[state.selectNum];
      var psgCosts = obj.psgCosts.map(function (item) {
        var fee = action.data.filter(function (child) {
          return item.psgType === child.psgType;
        })[0];
        return Object.assign({}, item, {
          exchangeCost: String(fee.exchangeCost),
          exchangeFee: String(Number(fee.exchangeCost) / item.psgCount),
          psgCost: String(Number(item.priceCost) + Number(fee.exchangeCost))
        });
      });
      var cc = Object.assign({}, obj, {
        psgCosts: psgCosts,
        totalCost: psgCosts.reduce(function (a, b) {
          return Number(a.exchangeCost) + Number(a.priceCost) + Number(b.exchangeCost) + Number(b.priceCost);
        }, {
          exchangeCost: 0,
          priceCost: 0
        })
      });
      if (state.selectNum === -1) {
        return Object.assign({}, state, { changeCost: cc });
      } else {
        arr.splice(state.selectNum, 1, cc);
        return Object.assign({}, state, {
          recommended: arr
        });
      }
    case changeFlight_modules_actions["d" /* GET_PRODUCTSHOW_LIST */] + '_SUCCESS':
      var data = action.payload.data;

      return Object.assign({}, state, {
        shopList: data.data
      });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/easyLogin/modules/actions.js
var easyLogin_modules_actions = __webpack_require__("otiu");

// CONCATENATED MODULE: ./src/routes/routes/easyLogin/modules/easyLogin.js


var easyLogin_initialState = {
  easylogin: false // 简易登录，未统一登录
};

function easyLoginQueryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : easyLogin_initialState;
  var action = arguments[1];

  switch (action.type) {
    case easyLogin_modules_actions["b" /* SAVE_LIGIN_MSG */]:
      return Object.assign({}, state, action.data);
    case easyLogin_modules_actions["a" /* INIT_LOGIN_MSH */]:
      if (action.data) {
        return Object.assign({}, state, action.data);
      } else {
        return Object.assign({}, state, { easylogin: false });
      }
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/electronicInvoice/modules/actions.js
var electronicInvoice_modules_actions = __webpack_require__("c/FB");

// CONCATENATED MODULE: ./src/routes/routes/electronicInvoice/modules/electronicInvoice.js
function electronicInvoice__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var issuePsg = {
  ticketNo: '', // 票号
  ticketType: 'ET', // ET | EMD | TKT
  businessType: '退票手续费',
  mobilePhone: '',
  email: '',
  printTime: '', // 开票日期 yyyy-mm-dd
  buyername: '', // 发票抬头（个人或公司）
  buyertaxno: '', // 纳税人识别号
  buyeraddtel: '', // 地址电话
  buyerbankno: '', // 开户行及账号
  amount: '', // 金额
  comments: '', // 发票栏备注信息
  psgname: '', // 旅客姓名
  idtype: '', // 证件类型
  idcard: '', // 证件号码
  psgType: '', // 旅客类型
  option: '0', // 0 个人 1 企业 2 非营业性(非预约接口的参数)
  contactNo: '', // 公司电话(非预约接口的参数)
  address: '', // 地址(非预约接口的参数)
  depositBank: '', // 开户行(非预约接口的参数)
  bankCardNo: '', // 账号,(非预约接口的参数)
  peerRowPsgs: [], // 关联开具的同行人，存票号(非预约接口的参数)
  useInvoiceTitle: '', // 是否使用发票抬头数据，存invoiceId(非预约接口的参数)
  isEditOriginInvoiceTitle: false // 是否修改了原发票抬头(非预约接口的参数)
};

var electronicInvoice_initialState = {
  invoiceTitleData: [], // 登录者的发票抬头数据
  issuePsgs: [], // 开具旅客信息
  reservePsgs: [] // 已预约旅客，存票号
};

function electronicInvoiceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : electronicInvoice_initialState;
  var action = arguments[1];

  switch (action.type) {
    case electronicInvoice_modules_actions["c" /* INIT_STATE */]:
      return electronicInvoice_initialState;
    case electronicInvoice_modules_actions["b" /* INIT_ISSUEPSGS */]:
      var issuePsgs = action.psgs.map(function (item) {
        return Object.assign({}, issuePsg, item);
      });
      return Object.assign({}, state, {
        issuePsgs: issuePsgs
      });
    case electronicInvoice_modules_actions["d" /* SAVE_ELECT_DATA */]:
      var reservePsgs = [].concat(electronicInvoice__toConsumableArray(state.reservePsgs));
      var psg = state.issuePsgs[action.n];
      var newIssuePsgs = [].concat(electronicInvoice__toConsumableArray(state.issuePsgs));
      if (reservePsgs.indexOf(action.data.ticketNo) === -1) reservePsgs.push(action.data.ticketNo);
      newIssuePsgs.splice(action.n, 1, Object.assign({}, psg, action.data));
      return Object.assign({}, state, { issuePsgs: newIssuePsgs, reservePsgs: reservePsgs });
    case electronicInvoice_modules_actions["a" /* GET_INVOICE */] + '_SUCCESS':
      return Object.assign({}, state, {
        invoiceTitleData: action.payload.data.SvcPcInvoiceRes.svcPcInvoiceDto || []
      });
    case electronicInvoice_modules_actions["e" /* SELECT_INVOICETITLE_TYPE */]:
      state.issuePsgs[action.n].option = action.option;
      return state;
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/coupon/modules/actions.js
var coupon_modules_actions = __webpack_require__("Zywo");

// CONCATENATED MODULE: ./src/routes/routes/coupon/modules/coupon.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function coupon__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var coupon_initialState = {
  couponsData: [],
  selectCouponCodes: [], // 已选的变更优惠券code
  couponsPsgSegment: {}, // 已选的变更优惠券对应使用的乘机人和航段
  couponsMap: {} // 已选的变更优惠券数据
};

function CouponsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : coupon_initialState;
  var action = arguments[1];

  switch (action.type) {
    case coupon_modules_actions["c" /* GET_REFUND_COUPONS */] + '_SUCCESS':
    case coupon_modules_actions["b" /* GET_COUPONS */] + '_SUCCESS':
      var coupon = action.payload.data.result.coupon;

      if (coupon && coupon.length !== 0) {
        var prevUrl = window.sessionStorage.getItem('historyUrl');
        if (prevUrl.includes('TicketChange') && state.selectCouponCodes.length > 0) {
          return Object.assign({}, state, {
            couponsData: coupon,
            selectCouponCodes: [],
            couponsPsgSegment: {},
            couponsMap: {}
          });
        } else {
          return Object.assign({}, state, {
            couponsData: coupon
          });
        }
      } else {
        return {
          couponsData: [],
          selectCouponCodes: [],
          couponsPsgSegment: {},
          couponsMap: {}
        };;
      }
    case coupon_modules_actions["e" /* SELECT_COUPON */]:
      delete action.couponData.originData;
      return Object.assign({}, state, {
        selectCouponCodes: [].concat(coupon__toConsumableArray(state.selectCouponCodes), [action.code]),
        couponsMap: Object.assign({}, state.couponsMap, _defineProperty({}, action.code, Object.assign({}, state.couponsData.filter(function (item) {
          return item.discountcode === action.code;
        })[0], {
          couponData: action.couponData
        }))),
        couponsPsgSegment: Object.assign({}, state.couponsPsgSegment, _defineProperty({}, action.code, action.psgSegmentData))
      });
    case coupon_modules_actions["a" /* CANCEL_COUPON */]:
      var obj = Object.assign({}, state.couponsMap),
          arr = [].concat(coupon__toConsumableArray(state.selectCouponCodes)),
          psg = Object.assign({}, state.couponsPsgSegment);
      delete obj[action.couponCode];
      delete psg[action.couponCode];
      arr.splice(arr.indexOf(action.couponCode), 1);
      return Object.assign({}, state, {
        selectCouponCodes: arr,
        couponsMap: obj,
        couponsPsgSegment: psg
      });
    case coupon_modules_actions["d" /* INIT_COUPON */]:
      return coupon_initialState;
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/refundCoupon/modules/actions.js
var refundCoupon_modules_actions = __webpack_require__("iQIy");

// CONCATENATED MODULE: ./src/routes/routes/refundCoupon/modules/coupon.js
function coupon__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function modules_coupon__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var modules_coupon_initialState = {
  refundWay: 2, // 1 原流水退款 2 极速退款 3 南航账户
  couponsData: [],
  selectCouponCodes: [], // 已选的变更优惠券code
  couponsPsgSegment: {}, // 已选的变更优惠券对应使用的乘机人和航段
  couponsMap: {}, // 已选的变更优惠券数据
  psgsCharge: {}
};

function coupon_CouponsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : modules_coupon_initialState;
  var action = arguments[1];

  switch (action.type) {
    case refundCoupon_modules_actions["c" /* INIT_REFUND_COUPON */]:
      return modules_coupon_initialState;
    case refundCoupon_modules_actions["b" /* GET_REFUND_COUPONS */] + '_SUCCESS':
      var _action$meta$previous = action.meta.previousAction,
          psgsCharge = _action$meta$previous.psgsCharge,
          refundWay = _action$meta$previous.refundWay,
          coupon = action.payload.data.result.coupon;

      if (coupon && coupon.length !== 0) {
        var prevUrl = window.sessionStorage.getItem('historyUrl');
        if (prevUrl.includes('EndorsedApply') && state.selectCouponCodes.length > 0) {
          return Object.assign({}, state, {
            couponsData: coupon,
            psgsCharge: psgsCharge,
            refundWay: refundWay,
            selectCouponCodes: [],
            couponsPsgSegment: {},
            couponsMap: {}
          });
        } else {
          return Object.assign({}, state, {
            couponsData: coupon,
            psgsCharge: psgsCharge,
            refundWay: refundWay
          });
        }
      } else {
        return Object.assign({}, state, {
          selectCouponCodes: [],
          couponsPsgSegment: {},
          couponsMap: {}
        });
      }
    case refundCoupon_modules_actions["d" /* SELECT_REFUND_COUPON */]:
      delete action.couponData.originData;
      return Object.assign({}, state, {
        selectCouponCodes: [].concat(modules_coupon__toConsumableArray(state.selectCouponCodes), [action.code]),
        couponsMap: Object.assign({}, state.couponsMap, coupon__defineProperty({}, action.code, Object.assign({}, state.couponsData.filter(function (item) {
          return item.discountcode === action.code;
        })[0], {
          couponData: action.couponData
        }))),
        couponsPsgSegment: Object.assign({}, state.couponsPsgSegment, coupon__defineProperty({}, action.code, action.psgSegmentData))
      });
    case refundCoupon_modules_actions["a" /* CANCEL_REFUND_COUPON */]:
      var obj = Object.assign({}, state.couponsMap),
          arr = [].concat(modules_coupon__toConsumableArray(state.selectCouponCodes)),
          psg = Object.assign({}, state.couponsPsgSegment);
      delete obj[action.couponCode];
      delete psg[action.couponCode];
      arr.splice(arr.indexOf(action.couponCode), 1);
      return Object.assign({}, state, {
        selectCouponCodes: arr,
        couponsMap: obj,
        couponsPsgSegment: psg
      });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/addProductShop/modules/actions.js
var addProductShop_modules_actions = __webpack_require__("pDHE");

// CONCATENATED MODULE: ./src/routes/routes/addProductShop/modules/addProduct.js
// import {
//   insertStr,
//   compareCabin,
//   getPhysicalCabinName,
// } from '@csair/emp-helpers';


var addProduct_initialState = {
  productObj: {}
};

function productReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : addProduct_initialState;
  var action = arguments[1];

  switch (action.type) {
    case addProductShop_modules_actions["a" /* SAVE_PRODUCT_OBJ */]:
      return Object.assign({}, state, { productObj: action.productObj });
    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/cancelLation/modules/actions.js
var cancelLation_modules_actions = __webpack_require__("xq5a");

// CONCATENATED MODULE: ./src/routes/routes/cancelLation/modules/cancelLation.js


var cancelLation_initialState = {
  selectStyle: '1', // tab 1 可退改 2 处理中 3 已退改
  ticketType: '', // 请求参数 0-代表处理中  1-代表已退改
  authenticated: 0, // -1未实名认证且不展示 0未实名认证 1实名认证
  urlQuery: {} // 存储首次进入时所带的参数
  // faceCheckSwitch: false,
  // faceCheckChannel: false,
};

function cancelLationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cancelLation_initialState;
  var action = arguments[1];

  switch (action.type) {
    case cancelLation_modules_actions["c" /* SELECT_STYLE */]:
      return Object.assign({}, state, {
        selectStyle: action.data,
        ticketType: action.data === '2' ? '1' : ''
      });
    case cancelLation_modules_actions["a" /* CHANGE_AUTH */]:
      return Object.assign({}, state, {
        authenticated: action.data
      });
    case cancelLation_modules_actions["d" /* WAY */]:
      return Object.assign({}, state, {
        way: action.data
      });
    case cancelLation_modules_actions["b" /* SAVE_QUERY */]:
      var params = Object.assign({}, state.urlQuery, action.data);
      return Object.assign({}, state, {
        urlQuery: params
      });

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/routes/routes/changeRefundExplain/modules/actions.js
var changeRefundExplain_modules_actions = __webpack_require__("f1jo");

// CONCATENATED MODULE: ./src/routes/routes/changeRefundExplain/modules/changeRefundExplain.js


var changeRefundExplain_initialState = {
  psgName: '',
  ticketNo: '',
  ticketPrice: '',
  taxFee: '',
  refundChangeRule: '',
  rules: [],
  segment: [],
  isTicketNoFlag: '0', // 0 票号 1 证件号
  ticketInfos: [],
  volunteer: true, // true 自愿 false 非自愿
  chargeFee: '',
  refundFee: '',
  mileageTicket: '',
  selectStyle: '1'
};

function changeRefundExplainReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : changeRefundExplain_initialState;
  var action = arguments[1];

  switch (action.type) {
    case changeRefundExplain_modules_actions["a" /* INIT_STATE */]:
      return changeRefundExplain_initialState;
    case changeRefundExplain_modules_actions["b" /* SAVE_QUERYINFO */]:
      return Object.assign({}, state, action.data);
    case changeRefundExplain_modules_actions["c" /* SELECT_STYLE */]:
      return Object.assign({}, state, {
        selectStyle: action.data
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/store/reducers.js














// import officialTicketReducer from '../routes/routes/officialTicket/modules/officialTicket';






var reducers_makeRootReducer = function makeRootReducer(asyncReducers) {
  return Object(esfrom_dll_reference_vendor_library["combineReducers"])(Object.assign({
    App: TicketChangesReducer,
    current: current_TicketChangesReducer,
    updateDetail: updateDetailReducer,
    EdorsedApply: EdorsedApplyReducer,
    ticketChange: ticketChangesReducer,
    applySubmit: ReformProcessReducer,
    subInfo: SubInfo,
    realNameVerify: RealNameVeriifyReducer,
    feeQuery: feeQueryReducer,
    selectDate: selectDateReducer,
    changeFlight: changeFlightReducer,
    easyLoginQuery: easyLoginQueryReducer,
    electronicInvoice: electronicInvoiceReducer,
    // officialTicket: officialTicketReducer,
    coupons: CouponsReducer,
    refundCoupons: coupon_CouponsReducer,
    addProductShop: productReducer,
    cancelLation: cancelLationReducer,
    changeRefundExplain: changeRefundExplainReducer
  }, asyncReducers));
};

var injectReducer = function injectReducer(store, _ref) {
  var key = _ref.key,
      reducer = _ref.reducer;

  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  store.asyncReducers[key] = reducer;
  store.replaceReducer(reducers_makeRootReducer(store.asyncReducers));
};

/* harmony default export */ var reducers = (reducers_makeRootReducer);
// EXTERNAL MODULE: ./src/store/axiosMiddleware.js + 3 modules
var axiosMiddleware = __webpack_require__("aJUj");

// CONCATENATED MODULE: ./src/store/createStore.js








/* harmony default export */ var createStore = (function () {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // ======================================================
  // Middleware Configuration
  // ======================================================
  var middleware = [redux_thunk_es, axiosMiddleware["b" /* default */]];

  // ======================================================
  // Store Enhancers
  // ======================================================
  var enhancers = [];

  var composeEnhancers = esfrom_dll_reference_vendor_library["compose"];

  if (false) {
    var composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================

  var persistConfig = {
    key: 'emp',
    version: 1,
    storage: session_default.a,
    whitelist: ['App', 'updateDetail', 'EdorsedApply', 'selectDate', 'ticketChange', 'applySubmit',
    // 'addPersonMessage',
    // 'subInfo',
    'addProductShop', 'realNameVerify', 'feeQuery', 'changeFlight', 'easyLoginQuery', 'coupons', 'refundCoupons', 'cancelLation'],
    stateReconciler: function stateReconciler(inboundState, originalState, reducedState) {
      if (window.location.href.indexOf(routerConfig["default"].ticket.child.endorsedApply.path) !== -1) {
        return Object.assign({}, reducedState, {
          _persist: {
            version: 1,
            rehydrated: true
          }
        });
      }
      return inboundState;
    }
  };

  var persistedReducer = Object(redux_persist_esfrom_dll_reference_vendor_library["persistReducer"])(persistConfig, reducers());

  var store = Object(esfrom_dll_reference_vendor_library["createStore"])(persistedReducer, initialState, composeEnhancers.apply(undefined, [esfrom_dll_reference_vendor_library["applyMiddleware"].apply(undefined, middleware)].concat(enhancers)));
  store.asyncReducers = {};

  var persistor = Object(redux_persist_esfrom_dll_reference_vendor_library["persistStore"])(store);

  if (/(loginFeeQuery)|(feeQuery)/.test(window.location.href)) {
    persistor.pause();
  }

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime

  if (false) {
    module.hot.accept('./reducers', function () {
      var reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return {
    store: store,
    persistor: persistor
  };
});
// EXTERNAL MODULE: delegated ./node_modules/react-router/es/index.js from dll-reference vendor_library
var react_router_esfrom_dll_reference_vendor_library = __webpack_require__("CIox");

// EXTERNAL MODULE: delegated ./node_modules/react-redux/es/index.js from dll-reference vendor_library
var react_redux_esfrom_dll_reference_vendor_library = __webpack_require__("RH2O");

// CONCATENATED MODULE: ./node_modules/redux-persist/es/integration/react.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(reactfrom_dll_reference_vendor_library["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};
// CONCATENATED MODULE: ./src/containers/AppContainer.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var AppContainer_AppContainer = function AppContainer(_ref) {
  var store = _ref.store,
      persistor = _ref.persistor,
      routes = _ref.routes;
  return _jsx(react_redux_esfrom_dll_reference_vendor_library["Provider"], {
    store: store
  }, void 0, _jsx(PersistGate, {
    loading: null,
    persistor: persistor
  }, void 0, _jsx(react_router_esfrom_dll_reference_vendor_library["Router"], {
    history: react_router_esfrom_dll_reference_vendor_library["hashHistory"],
    children: routes
  })));
};

/* harmony default export */ var containers_AppContainer = (AppContainer_AppContainer);
// EXTERNAL MODULE: ./src/utils/util_appRefundStore.js
var util_appRefundStore = __webpack_require__("WIhA");

// EXTERNAL MODULE: ./src/styles/index.less
var styles = __webpack_require__("CJFh");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// EXTERNAL MODULE: ./node_modules/sa-sdk-javascript/dist/web/sensorsdata.js
var sensorsdata = __webpack_require__("/rHU");
var sensorsdata_default = /*#__PURE__*/__webpack_require__.n(sensorsdata);

// CONCATENATED MODULE: ./src/index.js
// polyfill












// 关闭ios webview橡皮筋效果
Object(es["B" /* iosWebViewRebound */])(false);

// init state
var src_initialState = window.__INITIAL_STATE__;
if (window.location.href.indexOf(routerConfig["default"].ticket.child.refundApply.path) !== -1 && Object(es["C" /* isCsairApp */])()) {
  var src_state = Object(util_appRefundStore["a" /* getRefundAppStore */])();
  if (src_state) src_initialState = {
    EdorsedApply: src_state
  };
}

var src_store = createStore(src_initialState);

window.errorProcess = function () {
  var _store$store$getState = src_store.store.getState(),
      _store$store$getState2 = _store$store$getState.current,
      flights = _store$store$getState2.flights,
      psgs = _store$store$getState2.psgs,
      _store$store$getState3 = _store$store$getState.EdorsedApply,
      flightList = _store$store$getState3.flightList,
      psgList = _store$store$getState3.psgList;
  // 乘机人：只有一个旅客，就默认传该旅客（不管有无勾选），如果多个，就传勾选旅客
  // 航段：只有一段，默认该段，如果有多个，就传勾选的航段


  window.sessionStorage.setItem('emp-mobile', JSON.stringify({
    ticket: {
      flightList: flightList.length === 1 ? flightList : flightList.filter(function (item, i) {
        return flights.includes(i);
      }),
      psgList: psgList.length === 1 ? psgList : psgList.filter(function (item, i) {
        return psgs.includes(i);
      })
    }
  }));
};

var result = 'Y';
if (window.CSNativeObject && typeof window.CSNativeObject.getAnalyticsSwitch == 'function') {
  // 字符串格式的结果：{"status":"Y/N"}
  var res = typeof window.CSNativeObject.getAnalyticsSwitch() === 'string' ? JSON.parse(window.CSNativeObject.getAnalyticsSwitch()) : window.CSNativeObject.getAnalyticsSwitch();
  result = res.status;
}

var channelP = '';
if (Object(util["userAgentType"])() === 'APP Android') {
  channelP = '安卓';
} else if (Object(util["userAgentType"])() === 'APP IOS') {
  channelP = 'iOS';
} else if (Object(util["userAgentType"])() === '小程序') {
  channelP = '小程序';
} else if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
  channelP = '抖音小程序';
} else if (result === 'Y' && location.href.includes('language=en')) {
  channelP = '谷歌';
} else if (Object(util["userAgentType"])() === 'H5 移动') {
  channelP = '触屏';
}

// 注册公共属性
sensorsdata_default.a.registerPage({
  page_url: location.href,
  $referrer: document.referrer,
  platform_source: channelP,
  Uapp_id: 'EXTWEB',
  Uapp_name: '附加服务前端',
  language: location.href.includes('language=en') ? '英文' : '中文',
  page_name: Object(util["getPageName"])(location.hash),
  refer_page_name: Object(util["getPageName"])(document.referrer),
  product_version: location.href.includes('language=en') ? '海外版' : '标准版',
  track_version: '3.0版本',
  version: '【退改前端】退改接入神策埋点需求+20260611',
  business_unit: '机票退改',
  is_login: true
});

sensorsdata_default.a.init({
  // server_url: 'https://test-gate-mata.csair.com/sa?project=CSAIR_NEW',
  server_url: 'https://gate-mata.csair.com/sa?project=CSAIR_NEW',
  is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default'
  },
  show_log: false
});
sensorsdata_default.a.quick('autoTrack'); //用于采集 $pageview 事件。

if (result === 'Y') {
  window.$sensors = { sensors: sensorsdata_default.a };
} else {
  window.$sensors = {
    sensors: {
      track: function track(q, s) {}
    }
  };
}

// Render Setup
var MOUNT_NODE = document.getElementById('root');
var src_routes = __webpack_require__("DP/h").default(src_store.store);
react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(containers_AppContainer, Object.assign({}, src_store, { routes: src_routes })), MOUNT_NODE);

/***/ }),

/***/ "lbHh":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "ll+c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.getComponentLocale = getComponentLocale;
exports.getLocaleCode = getLocaleCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getComponentLocale(props, context, componentName, getDefaultLocale) {
    var locale = {};
    if (context && context.antLocale && context.antLocale[componentName]) {
        locale = context.antLocale[componentName];
    } else {
        var defaultLocale = getDefaultLocale();
        // TODO: make default lang of antd be English
        // https://github.com/ant-design/ant-design/issues/6334
        locale = defaultLocale['default'] || defaultLocale;
    }
    var result = (0, _extends3['default'])({}, locale);
    if (props.locale) {
        result = (0, _extends3['default'])({}, result, props.locale);
        if (props.locale.lang) {
            result.lang = (0, _extends3['default'])({}, locale.lang, props.locale.lang);
        }
    }
    return result;
}
function getLocaleCode(context) {
    var localeCode = context.antLocale && context.antLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if (context.antLocale && context.antLocale.exist && !localeCode) {
        return 'zh-cn';
    }
    return localeCode;
}

/***/ }),

/***/ "lmnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filterProperty;
/**
 * @description 过滤对应的属性值
 * @param {object} obj
 * @param {array} arr 扩展过滤属性名
 * @returns {object} 返回新的对象
 */
function filterProperty(obj) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0; i < arr.length; i++) {
    delete obj[arr[i]];
  }
  return obj;
}

/***/ }),

/***/ "mWhC":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "mi1p":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ "mt/P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("5+O3");
var aFunction = __webpack_require__("WvIn");
var bind = __webpack_require__("Xo5R");
var speciesConstructor = __webpack_require__("Xfp1");
var getSetIterator = __webpack_require__("BGpQ");
var Set = __webpack_require__("odTk").Set;

// `Set.prototype.map` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Set', proto: true, real: true, forced: __webpack_require__("pzR0") }, {
  map: function map(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, Set))();
    var adder = aFunction(newSet.add);
    var step, value;
    while (!(step = iterator.next()).done) {
      adder.call(newSet, boundFunction(value = step.value, value, set));
    }
    return newSet;
  }
});


/***/ }),

/***/ "nAuI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

var _Input = __webpack_require__("7y91");

var _Input2 = _interopRequireDefault(_Input);

var _CustomInput = __webpack_require__("kJxg");

var _CustomInput2 = _interopRequireDefault(_CustomInput);

var _getLocale = __webpack_require__("ll+c");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {} /* tslint:disable:jsx-no-multiline-js */

function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

var InputItem = function (_React$Component) {
    (0, _inherits3['default'])(InputItem, _React$Component);

    function InputItem(props) {
        (0, _classCallCheck3['default'])(this, InputItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (InputItem.__proto__ || Object.getPrototypeOf(InputItem)).call(this, props));

        _this.onInputChange = function (e) {
            var value = e.target.value;
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                type = _this$props.type;

            switch (type) {
                case 'text':
                    break;
                case 'bankCard':
                    value = value.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ');
                    break;
                case 'phone':
                    value = value.replace(/\D/g, '').substring(0, 11);
                    var valueLen = value.length;
                    if (valueLen > 3 && valueLen < 8) {
                        value = value.substr(0, 3) + ' ' + value.substr(3);
                    } else if (valueLen >= 8) {
                        value = value.substr(0, 3) + ' ' + value.substr(3, 4) + ' ' + value.substr(7);
                    }
                    break;
                case 'number':
                    value = value.replace(/\D/g, '');
                    break;
                case 'password':
                    break;
                default:
                    break;
            }
            if (onChange) {
                onChange(value);
            }
        };
        _this.onInputFocus = function (value) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            _this.setState({
                focus: true
            });
            if (document.activeElement.tagName.toLowerCase() === 'input') {
                _this.scrollIntoViewTimeout = setTimeout(function () {
                    try {
                        document.activeElement.scrollIntoViewIfNeeded();
                    } catch (e) {}
                }, 100);
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.onInputBlur = function (value) {
            _this.debounceTimeout = setTimeout(function () {
                if (document.activeElement !== _this.refs.input.refs.input) {
                    _this.setState({
                        focus: false
                    });
                }
            }, 200);
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onExtraClick = function (e) {
            if (_this.props.onExtraClick) {
                _this.props.onExtraClick(e);
            }
        };
        _this.onErrorClick = function (e) {
            if (_this.props.onErrorClick) {
                _this.props.onErrorClick(e);
            }
        };
        _this.clearInput = function () {
            if (_this.props.type !== 'password' && _this.props.updatePlaceholder) {
                _this.setState({
                    placeholder: _this.props.value
                });
            }
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            _this.focus();
        };
        _this.focus = function () {
            _this.refs.input.focus();
        };
        _this.state = {
            placeholder: props.placeholder
        };
        return _this;
    }

    (0, _createClass3['default'])(InputItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('placeholder' in nextProps && !nextProps.updatePlaceholder) {
                this.setState({
                    placeholder: nextProps.placeholder
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            if (this.scrollIntoViewTimeout) {
                clearTimeout(this.scrollIntoViewTimeout);
                this.scrollIntoViewTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                prefixListCls = _props.prefixListCls,
                type = _props.type,
                value = _props.value,
                defaultValue = _props.defaultValue,
                name = _props.name,
                editable = _props.editable,
                disabled = _props.disabled,
                style = _props.style,
                clear = _props.clear,
                children = _props.children,
                error = _props.error,
                className = _props.className,
                extra = _props.extra,
                labelNumber = _props.labelNumber,
                maxLength = _props.maxLength;
            // note: remove `placeholderTextColor` prop for rn TextInput supports placeholderTextColor

            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'prefixListCls', 'editable', 'style', 'clear', 'children', 'error', 'className', 'extra', 'labelNumber', 'onExtraClick', 'onErrorClick', 'updatePlaceholder', 'placeholderTextColor', 'type', 'locale']);
            var locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'InputItem', function () {
                return __webpack_require__("xDq7");
            });
            var confirmLabel = locale.confirmLabel;
            var _state = this.state,
                placeholder = _state.placeholder,
                focus = _state.focus;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixListCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classNames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classNames, prefixCls + '-android', focus), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            var labelCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-7', labelNumber === 7), _classNames2));
            var controlCls = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-control', true));
            var inputType = 'text';
            if (type === 'bankCard' || type === 'phone') {
                inputType = 'tel';
            } else if (type === 'password') {
                inputType = 'password';
            } else if (type === 'digit') {
                inputType = 'number';
            } else if (type !== 'text' && type !== 'number') {
                inputType = type;
            }
            var valueProps = void 0;
            if ('value' in this.props) {
                valueProps = {
                    value: fixControlledValue(value)
                };
            } else {
                valueProps = {
                    defaultValue: defaultValue
                };
            }
            var patternProps = void 0;
            if (type === 'number') {
                patternProps = {
                    pattern: '[0-9]*'
                };
            }
            var classNameProps = void 0;
            if (type === 'digit') {
                classNameProps = {
                    className: 'h5numInput'
                };
            }
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style },
                children ? _react2['default'].createElement(
                    'div',
                    { className: labelCls },
                    children
                ) : null,
                _react2['default'].createElement(
                    'div',
                    { className: controlCls },
                    type === 'money' ? _react2['default'].createElement(_CustomInput2['default'], (0, _extends3['default'])({ type: type, ref: 'input', maxLength: maxLength, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, disabled: disabled, editable: editable, value: fixControlledValue(value) }, this.props.focused !== undefined ? { focused: this.props.focused } : {}, this.props.autoFocus !== undefined ? { autoFocus: this.props.autoFocus } : {}, { prefixCls: prefixCls, confirmLabel: confirmLabel })) : _react2['default'].createElement(_Input2['default'], (0, _extends3['default'])({}, patternProps, otherProps, valueProps, classNameProps, { ref: 'input', type: inputType, maxLength: maxLength, name: name, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, readOnly: !editable, disabled: disabled }))
                ),
                clear && editable && !disabled && value && value.length > 0 ? _react2['default'].createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput }) : null,
                error ? _react2['default'].createElement('div', { className: prefixCls + '-error-extra', onClick: this.onErrorClick }) : null,
                extra !== '' ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-extra', onClick: this.onExtraClick },
                    extra
                ) : null
            );
        }
    }]);
    return InputItem;
}(_react2['default'].Component);

InputItem.defaultProps = {
    prefixCls: 'am-input',
    prefixListCls: 'am-list',
    type: 'text',
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    extra: '',
    onExtraClick: noop,
    error: false,
    onErrorClick: noop,
    labelNumber: 5,
    updatePlaceholder: false
};
InputItem.contextTypes = {
    antLocale: _propTypes2['default'].object
};
exports['default'] = InputItem;
module.exports = exports['default'];

/***/ }),

/***/ "nErl":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "nIBz":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("Fkvj");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneWith;


/***/ }),

/***/ "nIHh":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    copyArray = __webpack_require__("hrPF"),
    getTag = __webpack_require__("gHOb"),
    isArrayLike = __webpack_require__("bGc4"),
    isString = __webpack_require__("JDN0"),
    iteratorToArray = __webpack_require__("hGXm"),
    mapToArray = __webpack_require__("WFiI"),
    setToArray = __webpack_require__("octw"),
    stringToArray = __webpack_require__("0ghZ"),
    values = __webpack_require__("L8MQ");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),

/***/ "nM34":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nbNu":
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__("mi1p"),
    toInteger = __webpack_require__("5Zxu");

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

module.exports = toSafeInteger;


/***/ }),

/***/ "nw3t":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("p0bc");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "o/tC":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("q0qZ");
var definePropertyModule = __webpack_require__("1rEs");
var anObject = __webpack_require__("5+O3");
var objectKeys = __webpack_require__("/09a");

module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) definePropertyModule.f(O, key = keys[i++], Properties[key]);
  return O;
};


/***/ }),

/***/ "octw":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "odTk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hcE8");


/***/ }),

/***/ "ommR":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("UGHC")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "ot7w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("UFcy").IteratorPrototype;
var create = __webpack_require__("43zn");
var createPropertyDescriptor = __webpack_require__("C1ru");
var setToStringTag = __webpack_require__("GB3+");
var Iterators = __webpack_require__("eZ0g");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "otiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_LIGIN_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_LOGIN_MSH; });
/* harmony export (immutable) */ __webpack_exports__["d"] = saveloginInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = initloginInfo;
var SAVE_LIGIN_MSG = 'SAVE_LIGIN_MSG';
var INIT_LOGIN_MSH = 'INIT_LOGIN_MSH';

function saveloginInfo(data) {
  return { type: SAVE_LIGIN_MSG, data: data };
}

function initloginInfo(data) {
  return { type: INIT_LOGIN_MSH, data: data };
}

/***/ }),

/***/ "p0bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "pDHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_PRODUCT_OBJ; });
/* harmony export (immutable) */ __webpack_exports__["b"] = saveProductObj;
var SAVE_PRODUCT_OBJ = 'SAVE_PRODUCT_OBJ';

// 保存商品数据
function saveProductObj(productObj) {
  return { type: SAVE_PRODUCT_OBJ, productObj: productObj };
}

/***/ }),

/***/ "pNAd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("WcGK");

__webpack_require__("cAao");

/***/ }),

/***/ "pzR0":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "q0qZ":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("r54x")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "q16o":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "qEBd":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("8/eq");
__webpack_require__("vw/H");
__webpack_require__("GPcm");
__webpack_require__("3mz+");

module.exports = __webpack_require__("odTk").Set;


/***/ }),

/***/ "qYHz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbRp":
/***/ (function(module, exports, __webpack_require__) {

// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("/mOS")('Set');


/***/ }),

/***/ "qtVo":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ "r/oT":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("waNl");
__webpack_require__("vw/H");
__webpack_require__("GPcm");
__webpack_require__("3mz+");

module.exports = __webpack_require__("odTk").Map;


/***/ }),

/***/ "r54x":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "rENR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QUERY_REFUNDCHANGE_FEE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_QUERYINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_STATE; });
/* unused harmony export QUERY_REFUND_FEE */
/* unused harmony export QUERY_CHANGE_FEE */
/* unused harmony export QUERY_CALCULATOR_TICKETS */
/* unused harmony export GET_LOGINSESSIONTEMP */
/* harmony export (immutable) */ __webpack_exports__["i"] = saveQueryInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = init;
/* harmony export (immutable) */ __webpack_exports__["g"] = queryRefundChangeFee;
/* harmony export (immutable) */ __webpack_exports__["h"] = queryRefundFee;
/* harmony export (immutable) */ __webpack_exports__["f"] = queryChangeFee;
/* harmony export (immutable) */ __webpack_exports__["e"] = queryCalculatorTickets;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLoginSessionTemp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");


var QUERY_REFUNDCHANGE_FEE = 'QUERY_REFUNDCHANGE_FEE';
var SAVE_QUERYINFO = 'SAVE_QUERYINFO';
var INIT_STATE = 'INIT_STATE';
var QUERY_REFUND_FEE = 'QUERY_REFUND_FEE';
var QUERY_CHANGE_FEE = 'QUERY_CHANGE_FEE';
var QUERY_CALCULATOR_TICKETS = 'QUERY_CALCULATOR_TICKETS';
var GET_LOGINSESSIONTEMP = 'GET_LOGINSESSIONTEMP';

function saveQueryInfo(data) {
  return { type: SAVE_QUERYINFO, data: data };
}

function init() {
  return { type: INIT_STATE };
}

function queryRefundChangeFee(data) {
  return {
    type: QUERY_REFUNDCHANGE_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryRefundChangeFee,
        method: 'post',
        data: data
      }
    }
  };
}

function queryRefundFee(data) {
  return {
    type: QUERY_REFUND_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryRefundFee,
        method: 'post',
        data: data
      }
    }
  };
}

function queryChangeFee(data) {
  return {
    type: QUERY_CHANGE_FEE,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryChangeFee,
        method: 'post',
        data: data
      }
    }
  };
}

function queryCalculatorTickets(data) {
  return {
    type: QUERY_CALCULATOR_TICKETS,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryCalculatorTickets,
        method: 'post',
        data: data
      }
    }
  };
}

// 退改计算器免登
function getLoginSessionTemp() {
  return {
    type: GET_LOGINSESSIONTEMP,
    closeLoading: true,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getLoginSessionTemp,
        method: 'get',
        data: {}
      }
    }
  };
}

/***/ }),

/***/ "rNS8":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "rUAC":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("mWhC");
var requireObjectCoercible = __webpack_require__("hiy0");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var S = String(requireObjectCoercible(that));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xd800 || first > 0xdbff || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xdc00 || second > 0xdfff
        ? TO_STRING ? S.charAt(position) : first
        : TO_STRING ? S.slice(position, position + 2) : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "raVe":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "rezj":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("Fkvj");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "rplX":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "s2vR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__("k2+/");

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),

/***/ "sBat":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "siPu":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("izte")('keys');
var uid = __webpack_require__("17Rs");

module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "sjsj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("h2Na");

__webpack_require__("vTl6");

/***/ }),

/***/ "t8rQ":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "tHUL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABCxJREFUaEPtmU9oFUccx3+/Me95seot9ZaENzsQhF5ib4UgHr3EP1Uo9NRasKKiiFBopfGiqKAign+OCqVqe2lpT0XQm156aHwzszU5JGjwEtteEnB+dR7vhX3zdnd2305MhOzx7byd7+f7nfntb3cR3vMD33P9sA6QleDQ0NDWer2+HRFpcXHxr5mZmYWVSDt4Ao1GYzNj7AAAXASAzW3RC0R0gjF2X0r5b0iQ4ACc80lEPJYQ39H7GhEvSSnPrkmAkZGRLbVa7SQRfZsnkIi+I6IrcRz/EwIkWAJCiEkiSnPe1fmaiC5prYMkURmgqPMuRagkKgNkOE8A8AMAPG4L/wQADjoQQZLoGyDH+WcAcFIp9VtScBRFEwBwDgCi5O9Vk+gbIMP5BcbYRLPZfAQAb5JCx8fHB+bm5sYR8YFToSolURogz3nG2OFms/kwr7pwznch4jUAECGSKA1Q1nkXJnQShQGqOu+ChEqiMEBZ5znnI4jYWiZEJLXWz1diT3gBSjqPjUZjN2PsOADsdFz/wxhzOY7jXyxT51zVJLwAJZxnnPOJ9gb9MGMjvySiI1rrnwHA2DFV90QmQEnnmRDiKBGdAYCtnh5nARG/l1Je7UDY8f0mkQlQxnkhxB4iuuWIXwKAP9swHwFAPQFmIb6UUv5UNYkegEDOW4FfSSntTQuEEHuJ6IYDGCSJHoAAzqcJy1pilZNYBgjofNfSSCwbC5G21ColsQywQs67+zl4Ei0AzvmedpOVnPBZSm9TWEBOJQqVxG6t9a8tgOHh4cFarXbnbf++qz1xWldZamJPKS1sRMZ94ndjzOdxHL9aXkJtCNuvf8wY+9rpKgtPWOI5t5QhifvEI2PMN1a8naurClmIgYGBIa3100Q/X2qiEgB2aGFjbBKzs7NjAPB3R3wPQNrknPNDiHg+pYZnVZuSDC2I1OpERKe11jfzLujthaIoks5jYGrZK6vaGZ+VhFJKdT34uPMUAVjuHFuRIe5PtgAVhSf/3kniXvJHpVSuxtIASqkNySYsOdno6GjdGDNmjBkkIpY8h4iGMTbPGHs6NTVl+6S0g0VR1PUsvRIAqdBCiDEiug4AOzypPEHEw1JKWyh6jiiKuhJ/ZwBRFP0IAPvcypai0Qq8r5T6dK0B2LfOmwruif+UUh+sNQB3s7da6c5BRHuLbM7VXEK5a7eosKLjOmb0U4VS/+Ob2He+I6jouHUAdwP6nPOdX08gq/yFci7UdfrphewLKO9mdy/s3kFdgIL3C1JKdbUk/QC8AICsN22ZOgIBvFRKbcuD9TorhDhLRKcAYGNB1+ywnjY4pS33XW4RES9IKXO/enoB7FNavV4/QkRfAMBggeWkEHFSSnk3qVAI8Zn9nOR+YsroleYR8fbS0tK16enp+UoJ+Gxa7fPeBFZboG/+/wEgq6de7V67OQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "tO4o":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "tmj3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tv3T":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("i4ON"),
    baseAssignValue = __webpack_require__("nw3t");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "tyBP":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError((name ? name + ': i' : 'I') + 'ncorrect invocation!');
  } return it;
};


/***/ }),

/***/ "uS+O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var iterate = __webpack_require__("UHV6");

// `Map.keyBy` method
// https://github.com/tc39/collection-methods
__webpack_require__("i9tX")({ target: 'Map', stat: true, forced: __webpack_require__("pzR0") }, {
  keyBy: function keyBy(iterable, keyDerivative) {
    var newMap = new this();
    iterate(iterable, function (element) {
      newMap.set(keyDerivative(element), element);
    });
    return newMap;
  }
});


/***/ }),

/***/ "uWHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utilsRecommendCode__ = __webpack_require__("Sf+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("nM34");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_kefu_png__ = __webpack_require__("VaZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_kefu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_kefu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_kefu2_png__ = __webpack_require__("L3oL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_kefu2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_kefu2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Url__ = __webpack_require__("8oYa");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _ref = _jsx('img', {
  className: 'img1',
  src: __WEBPACK_IMPORTED_MODULE_3__assets_kefu_png___default.a,
  alt: '\u56FE\u6807'
});

var _ref2 = _jsx('img', {
  className: 'img2',
  src: __WEBPACK_IMPORTED_MODULE_4__assets_kefu2_png___default.a,
  alt: '\u56FE\u6807'
});

var OnlineService = function (_PureComponent) {
  _inherits(OnlineService, _PureComponent);

  function OnlineService(props) {
    _classCallCheck(this, OnlineService);

    var _this = _possibleConstructorReturn(this, (OnlineService.__proto__ || Object.getPrototypeOf(OnlineService)).call(this, props));

    _this.gotoCustomer = function () {
      window.sessionStorage.setItem('htmlFontSize', document.getElementsByTagName('html')[0].style.fontSize);

      // 跳转到人工客服 number 0:App 1:触屏 2: 小程序
      if (Object(__WEBPACK_IMPORTED_MODULE_1_utilsRecommendCode__["d" /* webEntry */])() === 0) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_5_Url__["default"].online_service_app_url;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1_utilsRecommendCode__["d" /* webEntry */])() === 1) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_5_Url__["default"].online_service_web_url;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1_utilsRecommendCode__["d" /* webEntry */])() === 2) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_5_Url__["default"].online_service_wx_url;
      }
    };

    _this.handlerTouchstart = function (e) {
      _this.setState({
        startX: e.touches[0].clientX,
        startY: e.touches[0].clientY,
        startLeft: e.target.parentNode.offsetLeft,
        startTop: e.target.parentNode.offsetTop
      });
    };

    _this.handlerTouchmove = function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          startX = _this$state.startX,
          startY = _this$state.startY,
          startLeft = _this$state.startLeft,
          startTop = _this$state.startTop;

      var actmoveX = e.touches[0].clientX - startX;
      var actmoveY = e.touches[0].clientY - startY;

      e.target.parentNode.style.left = startLeft + actmoveX > window.innerWidth - e.target.parentNode.offsetWidth - 10 ? window.innerWidth - e.target.parentNode.offsetWidth - 10 + 'px' : startLeft + actmoveX - 10 < 0 ? 10 + 'px' : startLeft + actmoveX + 'px';

      e.target.parentNode.style.top = startTop + actmoveY > window.innerHeight - e.target.parentNode.offsetHeight - 35 ? window.innerHeight - e.target.parentNode.offsetHeight - 35 + 'px' : startTop + actmoveY - 10 < 0 ? 10 + 'px' : startTop + actmoveY + 'px';
    };

    _this.handlerTouchend = function (e) {
      // console.log(e);
    };

    _this.state = {
      startX: '',
      startY: '',
      startLeft: '',
      startTop: ''
    };
    return _this;
  }

  _createClass(OnlineService, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.customerService.addEventListener('touchstart', this.handlerTouchstart, {
        passive: false
      });
      this.customerService.addEventListener('touchmove', this.handlerTouchmove, {
        passive: false
      });
      this.customerService.addEventListener('touchend', this.handlerTouchend, {
        passive: false
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.customerService.removeEventListener('touchstart', this.handlerTouchstart);
      this.customerService.removeEventListener('touchmove', this.handlerTouchmove);
      this.customerService.removeEventListener('touchend', this.handlerTouchend);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { referral } = this.state;
      var lang = this.props.lang;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'customerServ',
          ref: function ref(customerService) {
            return _this2.customerService = customerService;
          },
          role: 'button',
          'aria-label': lang.onliveService,
          onClick: function onClick() {
            return _this2.gotoCustomer();
          }
        },
        _ref,
        _ref2
      );
    }
  }]);

  return OnlineService;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (OnlineService);

/***/ }),

/***/ "vTl6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vi0E":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "vlTG":
/***/ (function(module, exports, __webpack_require__) {

// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("/mOS")('Map');


/***/ }),

/***/ "vw/H":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("eTT4");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (toString !== ({}).toString) {
  __webpack_require__("+opI")(Object.prototype, 'toString', toString, true);
}


/***/ }),

/***/ "w+5H":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
}

module.exports = isWeakSet;


/***/ }),

/***/ "waNl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = __webpack_require__("dliL")('Map', function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, __webpack_require__("V+c1"), true);


/***/ }),

/***/ "wbZz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "whWw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("HAas");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "wjiB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("r54x")(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "wkr2":
/***/ (function(module, exports, __webpack_require__) {

var definePropertyModule = __webpack_require__("1rEs");
var createPropertyDescriptor = __webpack_require__("C1ru");

module.exports = __webpack_require__("q0qZ") ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "wzd1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("l/2K");
var toObject = __webpack_require__("EJk4");
var IE_PROTO = __webpack_require__("siPu")('IE_PROTO');
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("HVdB");
var ObjectPrototype = Object.prototype;

module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "xDUa":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("mWhC");
var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "xDq7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    confirmLabel: '确定'
};
module.exports = exports['default'];

/***/ }),

/***/ "xXpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELECT_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_QUERY; });
/* unused harmony export GET_TICKET_LIST */
/* unused harmony export GET_ESAY_TICKET_LIST */
/* unused harmony export GET_MORE_TICKET_LIST */
/* unused harmony export GET_SS_TICKET_LIST */
/* unused harmony export GET_WX_TICKET_LIST */
/* unused harmony export GET_INTREATMENTBACK */
/* unused harmony export GET_USER_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_FACECHECKMOREQUERY_SWITCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_FACECHECKMOREQUERY_CHANNEL; });
/* unused harmony export QUERY_UPPPAY_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_LGOO; });
/* harmony export (immutable) */ __webpack_exports__["o"] = selectTabStyle;
/* harmony export (immutable) */ __webpack_exports__["h"] = changeAuth;
/* harmony export (immutable) */ __webpack_exports__["n"] = saveWay;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveQuery;
/* harmony export (immutable) */ __webpack_exports__["j"] = facecheckmorequeryswitch;
/* harmony export (immutable) */ __webpack_exports__["i"] = facecheckmorequerychannel;
/* unused harmony export saveflightLogo */
/* harmony export (immutable) */ __webpack_exports__["l"] = reqTicketList;
/* harmony export (immutable) */ __webpack_exports__["k"] = reqIntreatmentBack;
/* unused harmony export queryUppPayResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Utils__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lang__ = __webpack_require__("MIb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__("1EI8");





var SELECT_STYLE = 'SELECT_STYLE';
var CHANGE_AUTH = 'CHANGE_AUTH';
var WAY = 'WAY';
var SAVE_QUERY = 'SAVE_QUERY';
var GET_TICKET_LIST = 'GET_TICKET_LIST';
var GET_ESAY_TICKET_LIST = 'GET_ESAY_TICKET_LIST';
var GET_MORE_TICKET_LIST = 'GET_MORE_TICKET_LIST';
var GET_SS_TICKET_LIST = 'GET_SS_TICKET_LIST';
var GET_WX_TICKET_LIST = 'GET_WX_TICKET_LIST';
var GET_INTREATMENTBACK = 'GET_INTREATMENTBACK';
var GET_USER_STATUS = 'GET_USER_STATUS';
var GET_FACECHECKMOREQUERY_SWITCH = 'GET_FACECHECKMOREQUERY_SWITCH';
var SAVE_FACECHECKMOREQUERY_CHANNEL = 'SAVE_FACECHECKMOREQUERY_CHANNEL';
var QUERY_UPPPAY_RESULT = 'QUERY_UPPPAY_RESULT';
var SAVE_LGOO = 'SAVE_LGOO';

function selectTabStyle(data) {
  return { type: SELECT_STYLE, data: data };
}

function changeAuth(data) {
  return { type: CHANGE_AUTH, data: data };
}

function saveWay(data) {
  return { type: WAY, data: data };
}

function saveQuery(data) {
  return { type: SAVE_QUERY, data: data };
}
function facecheckmorequeryswitch(data) {
  return { type: GET_FACECHECKMOREQUERY_SWITCH, data: data };
}
function facecheckmorequerychannel(data) {
  return { type: SAVE_FACECHECKMOREQUERY_CHANNEL, data: data };
}

function saveflightLogo(data) {
  return { type: SAVE_LGOO, data: data };
}

function reqTicketList(data) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState) {
    var _getState = getState(),
        easyLoginQuery = _getState.easyLoginQuery,
        updateDetail = _getState.updateDetail;

    var obj = {
      pageSize: 5,
      startIndex: data.startIndex
    };
    var type = '',
        url = ''; // urlParams.moreQueryParams ? urlParams.moreQueryParams : { ...easyLoginQuery };
    if (urlParams.moreQuery && updateDetail.faceCheckSwitch) {
      // 更多客票查询
      type = GET_MORE_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getMoreTicektList;
      obj = Object.assign({}, obj, easyLoginQuery);
      delete obj.easylogin;
    } else if (urlParams.type === 'B' && urlParams.ticketNo) {
      // 扫登机牌查询
      type = GET_WX_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getWXTicektList;
      obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
      obj.queryNo = urlParams.ticketNo;
      if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
        obj.familyName = urlParams.name.split('/')[0];
        obj.givenName = urlParams.name.split('/')[1];
      } else {
        obj.familyName = urlParams.name;
      }
    } else if (urlParams.channel === 'ss') {
      // ss简易
      type = GET_SS_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getSsTicektList;
      obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
      obj.queryNo = urlParams.ticketNo;
      if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
        obj.familyName = urlParams.name.split('/')[0];
        obj.givenName = urlParams.name.split('/')[1];
      } else {
        obj.familyName = urlParams.name;
      }
    } else if (easyLoginQuery.easylogin) {
      // 简易登录查询
      type = GET_ESAY_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getEasyTicektList;
      obj = Object.assign({}, obj, easyLoginQuery);
      delete obj.easylogin;
    } else {
      // 可退改查询
      type = GET_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getTicektList;
      obj.queryArg = data.queryArg;
    }
    return dispatch({
      type: type,
      payload: {
        request: {
          url: '' + url + (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_lang__["isEmpty"])(urlParams) ? '' : '?' + Object(__WEBPACK_IMPORTED_MODULE_1_Utils__["toQueryString"])(urlParams)),
          method: 'post',
          data: obj
        }
      }
    }).then(function (data) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["y" /* getUserInfo */])());
      return data;
    });
  };
}

// 处理中、已退改
function reqIntreatmentBack(data) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var closeLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return {
    type: GET_INTREATMENTBACK,
    closeLoading: closeLoading,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getIntreatmentBack + '?' + new Date().getTime(),
        method: 'post',
        data: data
      }
    }
  };
}

function queryUppPayResult(data) {
  return {
    type: QUERY_UPPPAY_RESULT,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].queryUppPayResult,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "xq5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_QUERY; });
/* unused harmony export GET_TICKET_LIST */
/* unused harmony export GET_ESAY_TICKET_LIST */
/* unused harmony export GET_MORE_TICKET_LIST */
/* unused harmony export GET_SS_TICKET_LIST */
/* unused harmony export GET_WX_TICKET_LIST */
/* unused harmony export GET_INTREATMENTBACK */
/* unused harmony export GET_USER_STATUS */
/* unused harmony export GET_AD_INFO */
/* harmony export (immutable) */ __webpack_exports__["k"] = selectTabStyle;
/* harmony export (immutable) */ __webpack_exports__["e"] = changeAuth;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveWay;
/* harmony export (immutable) */ __webpack_exports__["i"] = saveQuery;
/* harmony export (immutable) */ __webpack_exports__["h"] = reqTicketList;
/* harmony export (immutable) */ __webpack_exports__["g"] = reqIntreatmentBack;
/* harmony export (immutable) */ __webpack_exports__["f"] = getAdInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Utils__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lang__ = __webpack_require__("MIb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__("1EI8");





var SELECT_STYLE = 'SELECT_STYLE';
var CHANGE_AUTH = 'CHANGE_AUTH';
var WAY = 'WAY';
var SAVE_QUERY = 'SAVE_QUERY';
var GET_TICKET_LIST = 'GET_TICKET_LIST';
var GET_ESAY_TICKET_LIST = 'GET_ESAY_TICKET_LIST';
var GET_MORE_TICKET_LIST = 'GET_MORE_TICKET_LIST';
var GET_SS_TICKET_LIST = 'GET_SS_TICKET_LIST';
var GET_WX_TICKET_LIST = 'GET_WX_TICKET_LIST';
var GET_INTREATMENTBACK = 'GET_INTREATMENTBACK';
var GET_USER_STATUS = 'GET_USER_STATUS';
var GET_AD_INFO = 'GET_AD_INFO';

function selectTabStyle(data) {
  return { type: SELECT_STYLE, data: data };
}

function changeAuth(data) {
  return { type: CHANGE_AUTH, data: data };
}

function saveWay(data) {
  return { type: WAY, data: data };
}

function saveQuery(data) {
  return { type: SAVE_QUERY, data: data };
}

function reqTicketList(data) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState) {
    var _getState = getState(),
        easyLoginQuery = _getState.easyLoginQuery;

    var obj = {
      pageSize: 5,
      startIndex: data.startIndex,
      cancelTrip: true
    };
    var type = '',
        url = ''; // urlParams.moreQueryParams ? urlParams.moreQueryParams : { ...easyLoginQuery };
    // if (urlParams.moreQuery && updateDetail.faceCheckSwitch) {
    //   // 更多客票查询
    //   type = GET_MORE_TICKET_LIST;
    //   url = urlConfig.getMoreTicektList;
    //   obj = Object.assign({}, obj, easyLoginQuery);
    //   delete obj.easylogin;
    // } else if (urlParams.type === 'B' && urlParams.ticketNo) {
    //   // 扫登机牌查询
    //   type = GET_WX_TICKET_LIST;
    //   url = urlConfig.getWXTicektList;
    //   obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
    //   obj.queryNo = urlParams.ticketNo;
    //   if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
    //     obj.familyName = urlParams.name.split('/')[0];
    //     obj.givenName = urlParams.name.split('/')[1];
    //   } else {
    //     obj.familyName = urlParams.name;
    //   }
    // } else if (urlParams.channel === 'ss') {
    //   // ss简易
    //   type = GET_SS_TICKET_LIST;
    //   url = urlConfig.getSsTicektList;
    //   obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
    //   obj.queryNo = urlParams.ticketNo;
    //   if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
    //     obj.familyName = urlParams.name.split('/')[0];
    //     obj.givenName = urlParams.name.split('/')[1];
    //   } else {
    //     obj.familyName = urlParams.name;
    //   }
    // } else
    if (easyLoginQuery.easylogin) {
      // 简易登录查询
      type = GET_ESAY_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getEasyTicektList;
      obj = Object.assign({}, obj, easyLoginQuery);
      delete obj.easylogin;
    } else {
      // 可退改查询
      type = GET_TICKET_LIST;
      url = __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getTicektList;
      obj.queryArg = data.queryArg;
    }
    return dispatch({
      type: type,
      payload: {
        request: {
          url: '' + url + (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_lang__["isEmpty"])(urlParams) ? '' : '?' + Object(__WEBPACK_IMPORTED_MODULE_1_Utils__["toQueryString"])(urlParams)),
          method: 'post',
          data: obj
        }
      }
    }).then(function (data) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["y" /* getUserInfo */])());
      return data;
    });
  };
}

// 处理中、已退改
function reqIntreatmentBack(data) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var closeLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return {
    type: GET_INTREATMENTBACK,
    closeLoading: closeLoading,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getIntreatmentBack + '?' + new Date().getTime(),
        method: 'post',
        data: data
      }
    }
  };
}

function getAdInfo(data) {
  return {
    type: GET_AD_INFO,
    payload: {
      request: {
        url: __WEBPACK_IMPORTED_MODULE_0_Url__["default"].getAdInfo,
        method: 'post',
        data: data
      }
    }
  };
}

/***/ }),

/***/ "xtxt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/member.f6856939.png";

/***/ }),

/***/ "y9sD":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),

/***/ "yCNF":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "zabl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/zscroller/es/Animate.js
var Animate = __webpack_require__("efk0");

// CONCATENATED MODULE: ./node_modules/zscroller/es/Scroller.js
/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */



var Scroller;

var NOOP = function NOOP() {};

/**
 * A pure logic 'component' for 'virtual' scrolling/zooming.
 */
Scroller = function Scroller(callback, options) {

  this.__callback = callback;

  this.options = {

    /** Enable scrolling on x-axis */
    scrollingX: true,

    /** Enable scrolling on y-axis */
    scrollingY: true,

    /** Enable animations for deceleration, snap back, zooming and scrolling */
    animating: true,

    /** duration for animations triggered by scrollTo/zoomTo */
    animationDuration: 250,

    /** Enable bouncing (content can be slowly moved outside and jumps back after releasing) */
    bouncing: true,

    /** Enable locking to the main axis if user moves only slightly on one of them at start */
    locking: true,

    /** Enable pagination mode (switching between full page content panes) */
    paging: false,

    /** Enable snapping of content to a configured pixel grid */
    snapping: false,

    /** Enable zooming of content via API, fingers and mouse wheel */
    zooming: false,

    /** Minimum zoom level */
    minZoom: 0.5,

    /** Maximum zoom level */
    maxZoom: 3,

    /** Multiply or decrease scrolling speed **/
    speedMultiplier: 1,

    /** Callback that is fired on the later of touch end or deceleration end,
     provided that another scrolling action has not begun. Used to know
     when to fade out a scrollbar. */
    scrollingComplete: NOOP,

    /** This configures the amount of change applied to deceleration when reaching boundaries  **/
    penetrationDeceleration: 0.03,

    /** This configures the amount of change applied to acceleration when reaching boundaries  **/
    penetrationAcceleration: 0.08

  };

  for (var key in options) {
    this.options[key] = options[key];
  }
};

// Easing Equations (c) 2003 Robert Penner, all rights reserved.
// Open source under the BSD License.

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeOutCubic = function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
};

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeInOutCubic = function easeInOutCubic(pos) {
  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(pos, 3);
  }

  return 0.5 * (Math.pow(pos - 2, 3) + 2);
};

var members = {

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: STATUS
   ---------------------------------------------------------------------------
   */

  /** {Boolean} Whether only a single finger is used in touch handling */
  __isSingleTouch: false,

  /** {Boolean} Whether a touch event sequence is in progress */
  __isTracking: false,

  /** {Boolean} Whether a deceleration animation went to completion. */
  __didDecelerationComplete: false,

  /**
   * {Boolean} Whether a gesture zoom/rotate event is in progress. Activates when
   * a gesturestart event happens. This has higher priority than dragging.
   */
  __isGesturing: false,

  /**
   * {Boolean} Whether the user has moved by such a distance that we have enabled
   * dragging mode. Hint: It's only enabled after some pixels of movement to
   * not interrupt with clicks etc.
   */
  __isDragging: false,

  /**
   * {Boolean} Not touching and dragging anymore, and smoothly animating the
   * touch sequence using deceleration.
   */
  __isDecelerating: false,

  /**
   * {Boolean} Smoothly animating the currently configured change
   */
  __isAnimating: false,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DIMENSIONS
   ---------------------------------------------------------------------------
   */

  /** {Integer} Available outer left position (from document perspective) */
  __clientLeft: 0,

  /** {Integer} Available outer top position (from document perspective) */
  __clientTop: 0,

  /** {Integer} Available outer width */
  __clientWidth: 0,

  /** {Integer} Available outer height */
  __clientHeight: 0,

  /** {Integer} Outer width of content */
  __contentWidth: 0,

  /** {Integer} Outer height of content */
  __contentHeight: 0,

  /** {Integer} Snapping width for content */
  __snapWidth: 100,

  /** {Integer} Snapping height for content */
  __snapHeight: 100,

  /** {Integer} Height to assign to refresh area */
  __refreshHeight: null,

  /** {Boolean} Whether the refresh process is enabled when the event is released now */
  __refreshActive: false,

  /** {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release */
  __refreshActivate: null,

  /** {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled */
  __refreshDeactivate: null,

  /** {Function} Callback to execute to start the actual refresh. Call {@link #refreshFinish} when done */
  __refreshStart: null,

  /** {Number} Zoom level */
  __zoomLevel: 1,

  /** {Number} Scroll position on x-axis */
  __scrollLeft: 0,

  /** {Number} Scroll position on y-axis */
  __scrollTop: 0,

  /** {Integer} Maximum allowed scroll position on x-axis */
  __maxScrollLeft: 0,

  /** {Integer} Maximum allowed scroll position on y-axis */
  __maxScrollTop: 0,

  /* {Number} Scheduled left position (final position when animating) */
  __scheduledLeft: 0,

  /* {Number} Scheduled top position (final position when animating) */
  __scheduledTop: 0,

  /* {Number} Scheduled zoom level (final scale when animating) */
  __scheduledZoom: 0,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: LAST POSITIONS
   ---------------------------------------------------------------------------
   */

  /** {Number} Left position of finger at start */
  __lastTouchLeft: null,

  /** {Number} Top position of finger at start */
  __lastTouchTop: null,

  /** {Date} Timestamp of last move of finger. Used to limit tracking range for deceleration speed. */
  __lastTouchMove: null,

  /** {Array} List of positions, uses three indexes for each state: left, top, timestamp */
  __positions: null,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DECELERATION SUPPORT
   ---------------------------------------------------------------------------
   */

  /** {Integer} Minimum left scroll position during deceleration */
  __minDecelerationScrollLeft: null,

  /** {Integer} Minimum top scroll position during deceleration */
  __minDecelerationScrollTop: null,

  /** {Integer} Maximum left scroll position during deceleration */
  __maxDecelerationScrollLeft: null,

  /** {Integer} Maximum top scroll position during deceleration */
  __maxDecelerationScrollTop: null,

  /** {Number} Current factor to modify horizontal scroll position with on every step */
  __decelerationVelocityX: null,

  /** {Number} Current factor to modify vertical scroll position with on every step */
  __decelerationVelocityY: null,

  /*
   ---------------------------------------------------------------------------
   PUBLIC API
   ---------------------------------------------------------------------------
   */

  /**
   * Configures the dimensions of the client (outer) and content (inner) elements.
   * Requires the available space for the outer element and the outer size of the inner element.
   * All values which are falsy (null or zero etc.) are ignored and the old value is kept.
   *
   * @param clientWidth {Integer ? null} Inner width of outer element
   * @param clientHeight {Integer ? null} Inner height of outer element
   * @param contentWidth {Integer ? null} Outer width of inner element
   * @param contentHeight {Integer ? null} Outer height of inner element
   */
  setDimensions: function setDimensions(clientWidth, clientHeight, contentWidth, contentHeight) {

    var self = this;

    // Only update values which are defined
    if (clientWidth === +clientWidth) {
      self.__clientWidth = clientWidth;
    }

    if (clientHeight === +clientHeight) {
      self.__clientHeight = clientHeight;
    }

    if (contentWidth === +contentWidth) {
      self.__contentWidth = contentWidth;
    }

    if (contentHeight === +contentHeight) {
      self.__contentHeight = contentHeight;
    }

    // Refresh maximums
    self.__computeScrollMax();

    // Refresh scroll position
    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Sets the client coordinates in relation to the document.
   *
   * @param left {Integer ? 0} Left position of outer element
   * @param top {Integer ? 0} Top position of outer element
   */
  setPosition: function setPosition(left, top) {

    var self = this;

    self.__clientLeft = left || 0;
    self.__clientTop = top || 0;
  },

  /**
   * Configures the snapping (when snapping is active)
   *
   * @param width {Integer} Snapping width
   * @param height {Integer} Snapping height
   */
  setSnapSize: function setSnapSize(width, height) {

    var self = this;

    self.__snapWidth = width;
    self.__snapHeight = height;
  },

  /**
   * Activates pull-to-refresh. A special zone on the top of the list to start a list refresh whenever
   * the user event is released during visibility of this zone. This was introduced by some apps on iOS like
   * the official Twitter client.
   *
   * @param height {Integer} Height of pull-to-refresh zone on top of rendered list
   * @param activateCallback {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release.
   * @param deactivateCallback {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled.
   * @param startCallback {Function} Callback to execute to start the real async refresh action. Call {@link #finishPullToRefresh} after finish of refresh.
   */
  activatePullToRefresh: function activatePullToRefresh(height, activateCallback, deactivateCallback, startCallback) {

    var self = this;

    self.__refreshHeight = height;
    self.__refreshActivate = activateCallback;
    self.__refreshDeactivate = deactivateCallback;
    self.__refreshStart = startCallback;
  },

  /**
   * Starts pull-to-refresh manually.
   */
  triggerPullToRefresh: function triggerPullToRefresh() {
    // Use publish instead of scrollTo to allow scrolling to out of boundary position
    // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
    this.__publish(this.__scrollLeft, -this.__refreshHeight, this.__zoomLevel, true);

    if (this.__refreshStart) {
      this.__refreshStart();
    }
  },

  /**
   * Signalizes that pull-to-refresh is finished.
   */
  finishPullToRefresh: function finishPullToRefresh() {

    var self = this;

    self.__refreshActive = false;
    if (self.__refreshDeactivate) {
      self.__refreshDeactivate();
    }

    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Returns the scroll position and zooming values
   *
   * @return {Map} `left` and `top` scroll position and `zoom` level
   */
  getValues: function getValues() {

    var self = this;

    return {
      left: self.__scrollLeft,
      top: self.__scrollTop,
      zoom: self.__zoomLevel
    };
  },

  /**
   * Returns the maximum scroll values
   *
   * @return {Map} `left` and `top` maximum scroll values
   */
  getScrollMax: function getScrollMax() {

    var self = this;

    return {
      left: self.__maxScrollLeft,
      top: self.__maxScrollTop
    };
  },

  /**
   * Zooms to the given level. Supports optional animation. Zooms
   * the center when no coordinates are given.
   *
   * @param level {Number} Level to zoom to
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? null} Zoom in at given left coordinate
   * @param originTop {Number ? null} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomTo: function zoomTo(level, animate, originLeft, originTop, callback) {

    var self = this;

    if (!self.options.zooming) {
      throw new Error("Zooming is not enabled!");
    }

    // Add callback if exists
    if (callback) {
      self.__zoomComplete = callback;
    }

    // Stop deceleration
    if (self.__isDecelerating) {
      Animate["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    var oldLevel = self.__zoomLevel;

    // Normalize input origin to center of viewport if not defined
    if (originLeft == null) {
      originLeft = self.__clientWidth / 2;
    }

    if (originTop == null) {
      originTop = self.__clientHeight / 2;
    }

    // Limit level according to configuration
    level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

    // Recompute maximum values while temporary tweaking maximum scroll ranges
    self.__computeScrollMax(level);

    // Recompute left and top coordinates based on new zoom level
    var left = (originLeft + self.__scrollLeft) * level / oldLevel - originLeft;
    var top = (originTop + self.__scrollTop) * level / oldLevel - originTop;

    // Limit x-axis
    if (left > self.__maxScrollLeft) {
      left = self.__maxScrollLeft;
    } else if (left < 0) {
      left = 0;
    }

    // Limit y-axis
    if (top > self.__maxScrollTop) {
      top = self.__maxScrollTop;
    } else if (top < 0) {
      top = 0;
    }

    // Push values out
    self.__publish(left, top, level, animate);
  },

  /**
   * Zooms the content by the given factor.
   *
   * @param factor {Number} Zoom by given factor
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? 0} Zoom in at given left coordinate
   * @param originTop {Number ? 0} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomBy: function zoomBy(factor, animate, originLeft, originTop, callback) {

    var self = this;

    self.zoomTo(self.__zoomLevel * factor, animate, originLeft, originTop, callback);
  },

  /**
   * Scrolls to the given position. Respect limitations and snapping automatically.
   *
   * @param left {Number?null} Horizontal scroll position, keeps current if value is <code>null</code>
   * @param top {Number?null} Vertical scroll position, keeps current if value is <code>null</code>
   * @param animate {Boolean?false} Whether the scrolling should happen using an animation
   * @param zoom {Number?null} Zoom level to go to
   */
  scrollTo: function scrollTo(left, top, animate, zoom, callback) {

    var self = this;

    // Stop deceleration
    if (self.__isDecelerating) {
      Animate["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    // Correct coordinates based on new zoom level
    if (zoom != null && zoom !== self.__zoomLevel) {

      if (!self.options.zooming) {
        throw new Error("Zooming is not enabled!");
      }

      left *= zoom;
      top *= zoom;

      // Recompute maximum values while temporary tweaking maximum scroll ranges
      self.__computeScrollMax(zoom);
    } else {

      // Keep zoom when not defined
      zoom = self.__zoomLevel;
    }

    if (!self.options.scrollingX) {

      left = self.__scrollLeft;
    } else {

      if (self.options.paging) {
        left = Math.round(left / self.__clientWidth) * self.__clientWidth;
      } else if (self.options.snapping) {
        left = Math.round(left / self.__snapWidth) * self.__snapWidth;
      }
    }

    if (!self.options.scrollingY) {

      top = self.__scrollTop;
    } else {

      if (self.options.paging) {
        top = Math.round(top / self.__clientHeight) * self.__clientHeight;
      } else if (self.options.snapping) {
        top = Math.round(top / self.__snapHeight) * self.__snapHeight;
      }
    }

    // Limit for allowed ranges
    left = Math.max(Math.min(self.__maxScrollLeft, left), 0);
    top = Math.max(Math.min(self.__maxScrollTop, top), 0);

    // Don't animate when no change detected, still call publish to make sure
    // that rendered position is really in-sync with internal data
    if (left === self.__scrollLeft && top === self.__scrollTop) {
      animate = false;
      if (callback) {
        callback();
      }
    }

    // Publish new values
    if (!self.__isTracking) {
      self.__publish(left, top, zoom, animate);
    }
  },

  /**
   * Scroll by the given offset
   *
   * @param left {Number ? 0} Scroll x-axis by given offset
   * @param top {Number ? 0} Scroll x-axis by given offset
   * @param animate {Boolean ? false} Whether to animate the given change
   */
  scrollBy: function scrollBy(left, top, animate) {

    var self = this;

    var startLeft = self.__isAnimating ? self.__scheduledLeft : self.__scrollLeft;
    var startTop = self.__isAnimating ? self.__scheduledTop : self.__scrollTop;

    self.scrollTo(startLeft + (left || 0), startTop + (top || 0), animate);
  },

  /*
   ---------------------------------------------------------------------------
   EVENT CALLBACKS
   ---------------------------------------------------------------------------
   */

  /**
   * Mouse wheel handler for zooming support
   */
  doMouseZoom: function doMouseZoom(wheelDelta, timeStamp, pageX, pageY) {

    var self = this;
    var change = wheelDelta > 0 ? 0.97 : 1.03;

    return self.zoomTo(self.__zoomLevel * change, false, pageX - self.__clientLeft, pageY - self.__clientTop);
  },

  /**
   * Touch start handler for scrolling support
   */
  doTouchStart: function doTouchStart(touches, timeStamp) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Reset interruptedAnimation flag
    self.__interruptedAnimation = true;

    // Stop deceleration
    if (self.__isDecelerating) {
      Animate["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
      self.__interruptedAnimation = true;
    }

    // Stop animation
    if (self.__isAnimating) {
      Animate["a" /* default */].stop(self.__isAnimating);
      self.__isAnimating = false;
      self.__interruptedAnimation = true;
    }

    // Use center point when dealing with two fingers
    var currentTouchLeft, currentTouchTop;
    var isSingleTouch = touches.length === 1;
    if (isSingleTouch) {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    } else {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    }

    // Store initial positions
    self.__initialTouchLeft = currentTouchLeft;
    self.__initialTouchTop = currentTouchTop;

    // Store current zoom level
    self.__zoomLevelStart = self.__zoomLevel;

    // Store initial touch positions
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;

    // Store initial move time stamp
    self.__lastTouchMove = timeStamp;

    // Reset initial scale
    self.__lastScale = 1;

    // Reset locking flags
    self.__enableScrollX = !isSingleTouch && self.options.scrollingX;
    self.__enableScrollY = !isSingleTouch && self.options.scrollingY;

    // Reset tracking flag
    self.__isTracking = true;

    // Reset deceleration complete flag
    self.__didDecelerationComplete = false;

    // Dragging starts directly with two fingers, otherwise lazy with an offset
    self.__isDragging = !isSingleTouch;

    // Some features are disabled in multi touch scenarios
    self.__isSingleTouch = isSingleTouch;

    // Clearing data structure
    self.__positions = [];
  },

  /**
   * Touch move handler for scrolling support
   */
  doTouchMove: function doTouchMove(touches, timeStamp, scale) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (event might be outside of element)
    if (!self.__isTracking) {
      return;
    }

    var currentTouchLeft, currentTouchTop;

    // Compute move based around of center of fingers
    if (touches.length === 2) {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    } else {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    }

    var positions = self.__positions;

    // Are we already is dragging mode?
    if (self.__isDragging) {

      // Compute move distance
      var moveX = currentTouchLeft - self.__lastTouchLeft;
      var moveY = currentTouchTop - self.__lastTouchTop;

      // Read previous scroll position and zooming
      var scrollLeft = self.__scrollLeft;
      var scrollTop = self.__scrollTop;
      var level = self.__zoomLevel;

      // Work with scaling
      if (scale != null && self.options.zooming) {

        var oldLevel = level;

        // Recompute level based on previous scale and new scale
        level = level / self.__lastScale * scale;

        // Limit level according to configuration
        level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

        // Only do further compution when change happened
        if (oldLevel !== level) {

          // Compute relative event position to container
          var currentTouchLeftRel = currentTouchLeft - self.__clientLeft;
          var currentTouchTopRel = currentTouchTop - self.__clientTop;

          // Recompute left and top coordinates based on new zoom level
          scrollLeft = (currentTouchLeftRel + scrollLeft) * level / oldLevel - currentTouchLeftRel;
          scrollTop = (currentTouchTopRel + scrollTop) * level / oldLevel - currentTouchTopRel;

          // Recompute max scroll values
          self.__computeScrollMax(level);
        }
      }

      if (self.__enableScrollX) {

        scrollLeft -= moveX * this.options.speedMultiplier;
        var maxScrollLeft = self.__maxScrollLeft;

        if (scrollLeft > maxScrollLeft || scrollLeft < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollLeft += moveX / 2 * this.options.speedMultiplier;
          } else if (scrollLeft > maxScrollLeft) {

            scrollLeft = maxScrollLeft;
          } else {

            scrollLeft = 0;
          }
        }
      }

      // Compute new vertical scroll position
      if (self.__enableScrollY) {

        scrollTop -= moveY * this.options.speedMultiplier;
        var maxScrollTop = self.__maxScrollTop;

        if (scrollTop > maxScrollTop || scrollTop < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollTop += moveY / 2 * this.options.speedMultiplier;

            // Support pull-to-refresh (only when only y is scrollable)
            if (!self.__enableScrollX && self.__refreshHeight != null) {

              if (!self.__refreshActive && scrollTop <= -self.__refreshHeight) {

                self.__refreshActive = true;
                if (self.__refreshActivate) {
                  self.__refreshActivate();
                }
              } else if (self.__refreshActive && scrollTop > -self.__refreshHeight) {

                self.__refreshActive = false;
                if (self.__refreshDeactivate) {
                  self.__refreshDeactivate();
                }
              }
            }
          } else if (scrollTop > maxScrollTop) {

            scrollTop = maxScrollTop;
          } else {

            scrollTop = 0;
          }
        }
      }

      // Keep list from growing infinitely (holding min 10, max 20 measure points)
      if (positions.length > 60) {
        positions.splice(0, 30);
      }

      // Track scroll movement for decleration
      positions.push(scrollLeft, scrollTop, timeStamp);

      // Sync scroll position
      self.__publish(scrollLeft, scrollTop, level);

      // Otherwise figure out whether we are switching into dragging mode now.
    } else {

      var minimumTrackingForScroll = 3;
      var minimumTrackingForDrag = 5;

      var distanceX = Math.abs(currentTouchLeft - self.__initialTouchLeft);
      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

      self.__enableScrollX = self.options.scrollingX && distanceX >= minimumTrackingForScroll;
      self.__enableScrollY = self.options.scrollingY && distanceY >= minimumTrackingForScroll;

      var radian = void 0;

      if (self.options.locking && self.__enableScrollY) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian < Math.PI / 4) {
          self.__enableScrollY = false;
        }
      }

      if (self.options.locking && self.__enableScrollX) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian > Math.PI / 4) {
          self.__enableScrollX = false;
        }
      }

      positions.push(self.__scrollLeft, self.__scrollTop, timeStamp);

      self.__isDragging = (self.__enableScrollX || self.__enableScrollY) && (distanceX >= minimumTrackingForDrag || distanceY >= minimumTrackingForDrag);
      if (self.__isDragging) {
        self.__interruptedAnimation = false;
      }
    }

    // Update last touch positions and time stamp for next event
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = scale;
  },

  /**
   * Touch end handler for scrolling support
   */
  doTouchEnd: function doTouchEnd(timeStamp) {

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (no touchstart event on element)
    // This is required as this listener ('touchmove') sits on the document and not on the element itself.
    if (!self.__isTracking) {
      return;
    }

    // Not touching anymore (when two finger hit the screen there are two touch end events)
    self.__isTracking = false;

    // Be sure to reset the dragging flag now. Here we also detect whether
    // the finger has moved fast enough to switch into a deceleration animation.
    if (self.__isDragging) {

      // Reset dragging flag
      self.__isDragging = false;

      // Start deceleration
      // Verify that the last move detected was in some relevant time frame
      if (self.__isSingleTouch && self.options.animating && timeStamp - self.__lastTouchMove <= 100) {

        // Then figure out what the scroll position was about 100ms ago
        var positions = self.__positions;
        var endPos = positions.length - 1;
        var startPos = endPos;

        // Move pointer to position measured 100ms ago
        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 3) {
          startPos = i;
        }

        // If start and stop position is identical in a 100ms timeframe,
        // we cannot compute any useful deceleration.
        if (startPos !== endPos) {

          // Compute relative movement between these two points
          var timeOffset = positions[endPos] - positions[startPos];
          var movedLeft = self.__scrollLeft - positions[startPos - 2];
          var movedTop = self.__scrollTop - positions[startPos - 1];

          // Based on 50ms compute the movement to apply for each render step
          self.__decelerationVelocityX = movedLeft / timeOffset * (1000 / 60);
          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

          // How much velocity is required to start the deceleration
          var minVelocityToStartDeceleration = self.options.paging || self.options.snapping ? 4 : 1;

          // Verify that we have enough velocity to start deceleration
          if (Math.abs(self.__decelerationVelocityX) > minVelocityToStartDeceleration || Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {

            // Deactivate pull-to-refresh when decelerating
            if (!self.__refreshActive) {
              self.__startDeceleration(timeStamp);
            }
          } else {
            self.options.scrollingComplete();
          }
        } else {
          self.options.scrollingComplete();
        }
      } else if (timeStamp - self.__lastTouchMove > 100) {
        self.options.scrollingComplete();
      }
    }

    // If this was a slower move it is per default non decelerated, but this
    // still means that we want snap back to the bounds which is done here.
    // This is placed outside the condition above to improve edge case stability
    // e.g. touchend fired without enabled dragging. This should normally do not
    // have modified the scroll positions or even showed the scrollbars though.
    if (!self.__isDecelerating) {

      if (self.__refreshActive && self.__refreshStart) {

        // Use publish instead of scrollTo to allow scrolling to out of boundary position
        // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
        self.__publish(self.__scrollLeft, -self.__refreshHeight, self.__zoomLevel, true);

        if (self.__refreshStart) {
          self.__refreshStart();
        }
      } else {

        if (self.__interruptedAnimation || self.__isDragging) {
          self.options.scrollingComplete();
        }
        self.scrollTo(self.__scrollLeft, self.__scrollTop, true, self.__zoomLevel);

        // Directly signalize deactivation (nothing todo on refresh?)
        if (self.__refreshActive) {

          self.__refreshActive = false;
          if (self.__refreshDeactivate) {
            self.__refreshDeactivate();
          }
        }
      }
    }

    // Fully cleanup list
    self.__positions.length = 0;
  },

  /*
   ---------------------------------------------------------------------------
   PRIVATE API
   ---------------------------------------------------------------------------
   */

  /**
   * Applies the scroll position to the content element
   *
   * @param left {Number} Left scroll position
   * @param top {Number} Top scroll position
   * @param animate {Boolean?false} Whether animation should be used to move to the new coordinates
   */
  __publish: function __publish(left, top, zoom, animate) {

    var self = this;

    // Remember whether we had an animation, then we try to continue based on the current "drive" of the animation
    var wasAnimating = self.__isAnimating;
    if (wasAnimating) {
      Animate["a" /* default */].stop(wasAnimating);
      self.__isAnimating = false;
    }

    if (animate && self.options.animating) {

      // Keep scheduled positions for scrollBy/zoomBy functionality
      self.__scheduledLeft = left;
      self.__scheduledTop = top;
      self.__scheduledZoom = zoom;

      var oldLeft = self.__scrollLeft;
      var oldTop = self.__scrollTop;
      var oldZoom = self.__zoomLevel;

      var diffLeft = left - oldLeft;
      var diffTop = top - oldTop;
      var diffZoom = zoom - oldZoom;

      var step = function step(percent, now, render) {

        if (render) {

          self.__scrollLeft = oldLeft + diffLeft * percent;
          self.__scrollTop = oldTop + diffTop * percent;
          self.__zoomLevel = oldZoom + diffZoom * percent;

          // Push values out
          if (self.__callback) {
            self.__callback(self.__scrollLeft, self.__scrollTop, self.__zoomLevel);
          }
        }
      };

      var verify = function verify(id) {
        return self.__isAnimating === id;
      };

      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
        if (animationId === self.__isAnimating) {
          self.__isAnimating = false;
        }

        if (self.__didDecelerationComplete || wasFinished) {
          self.options.scrollingComplete();
        }

        if (self.options.zooming) {
          self.__computeScrollMax();
          if (self.__zoomComplete) {
            self.__zoomComplete();
            self.__zoomComplete = null;
          }
        }
      };

      // When continuing based on previous animation we choose an ease-out animation instead of ease-in-out
      self.__isAnimating = Animate["a" /* default */].start(step, verify, completed, self.options.animationDuration, wasAnimating ? easeOutCubic : easeInOutCubic);
    } else {

      self.__scheduledLeft = self.__scrollLeft = left;
      self.__scheduledTop = self.__scrollTop = top;
      self.__scheduledZoom = self.__zoomLevel = zoom;

      // Push values out
      if (self.__callback) {
        self.__callback(left, top, zoom);
      }

      // Fix max scroll ranges
      if (self.options.zooming) {
        self.__computeScrollMax();
        if (self.__zoomComplete) {
          self.__zoomComplete();
          self.__zoomComplete = null;
        }
      }
    }
  },

  /**
   * Recomputes scroll minimum values based on client dimensions and content dimensions.
   */
  __computeScrollMax: function __computeScrollMax(zoomLevel) {

    var self = this;

    if (zoomLevel == null) {
      zoomLevel = self.__zoomLevel;
    }

    self.__maxScrollLeft = Math.max(self.__contentWidth * zoomLevel - self.__clientWidth, 0);
    self.__maxScrollTop = Math.max(self.__contentHeight * zoomLevel - self.__clientHeight, 0);
  },

  /*
   ---------------------------------------------------------------------------
   ANIMATION (DECELERATION) SUPPORT
   ---------------------------------------------------------------------------
   */

  /**
   * Called when a touch sequence end and the speed of the finger was high enough
   * to switch into deceleration mode.
   */
  __startDeceleration: function __startDeceleration(timeStamp) {

    var self = this;

    if (self.options.paging) {

      var scrollLeft = Math.max(Math.min(self.__scrollLeft, self.__maxScrollLeft), 0);
      var scrollTop = Math.max(Math.min(self.__scrollTop, self.__maxScrollTop), 0);
      var clientWidth = self.__clientWidth;
      var clientHeight = self.__clientHeight;

      // We limit deceleration not to the min/max values of the allowed range, but to the size of the visible client area.
      // Each page should have exactly the size of the client area.
      self.__minDecelerationScrollLeft = Math.floor(scrollLeft / clientWidth) * clientWidth;
      self.__minDecelerationScrollTop = Math.floor(scrollTop / clientHeight) * clientHeight;
      self.__maxDecelerationScrollLeft = Math.ceil(scrollLeft / clientWidth) * clientWidth;
      self.__maxDecelerationScrollTop = Math.ceil(scrollTop / clientHeight) * clientHeight;
    } else {

      self.__minDecelerationScrollLeft = 0;
      self.__minDecelerationScrollTop = 0;
      self.__maxDecelerationScrollLeft = self.__maxScrollLeft;
      self.__maxDecelerationScrollTop = self.__maxScrollTop;
    }

    // Wrap class method
    var step = function step(percent, now, render) {
      self.__stepThroughDeceleration(render);
    };

    // How much velocity is required to keep the deceleration running
    // added by yiminghe
    var minVelocityToKeepDecelerating = self.options.minVelocityToKeepDecelerating;

    if (!minVelocityToKeepDecelerating) {
      minVelocityToKeepDecelerating = self.options.snapping ? 4 : 0.001;
    }

    // Detect whether it's still worth to continue animating steps
    // If we are already slow enough to not being user perceivable anymore, we stop the whole process here.
    var verify = function verify() {
      var shouldContinue = Math.abs(self.__decelerationVelocityX) >= minVelocityToKeepDecelerating || Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
      if (!shouldContinue) {
        self.__didDecelerationComplete = true;
      }
      return shouldContinue;
    };

    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
      self.__isDecelerating = false;
      // Animate to grid when snapping is active, otherwise just fix out-of-boundary positions
      // fixed by yiminghe, in case call scrollingComplete twice
      self.scrollTo(self.__scrollLeft, self.__scrollTop, self.options.snapping, null, self.__didDecelerationComplete && self.options.scrollingComplete);
    };

    // Start animation and switch on flag
    self.__isDecelerating = Animate["a" /* default */].start(step, verify, completed);
  },

  /**
   * Called on every step of the animation
   *
   * @param inMemory {Boolean?false} Whether to not render the current step, but keep it in memory only. Used internally only!
   */
  __stepThroughDeceleration: function __stepThroughDeceleration(render) {

    var self = this;

    //
    // COMPUTE NEXT SCROLL POSITION
    //

    // Add deceleration to scroll position
    var scrollLeft = self.__scrollLeft + self.__decelerationVelocityX;
    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

    //
    // HARD LIMIT SCROLL POSITION FOR NON BOUNCING MODE
    //

    if (!self.options.bouncing) {

      var scrollLeftFixed = Math.max(Math.min(self.__maxDecelerationScrollLeft, scrollLeft), self.__minDecelerationScrollLeft);
      if (scrollLeftFixed !== scrollLeft) {
        scrollLeft = scrollLeftFixed;
        self.__decelerationVelocityX = 0;
      }

      var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
      if (scrollTopFixed !== scrollTop) {
        scrollTop = scrollTopFixed;
        self.__decelerationVelocityY = 0;
      }
    }

    //
    // UPDATE SCROLL POSITION
    //

    if (render) {

      self.__publish(scrollLeft, scrollTop, self.__zoomLevel);
    } else {

      self.__scrollLeft = scrollLeft;
      self.__scrollTop = scrollTop;
    }

    //
    // SLOW DOWN
    //

    // Slow down velocity on every iteration
    if (!self.options.paging) {

      // This is the factor applied to every iteration of the animation
      // to slow down the process. This should emulate natural behavior where
      // objects slow down when the initiator of the movement is removed
      var frictionFactor = 0.95;

      self.__decelerationVelocityX *= frictionFactor;
      self.__decelerationVelocityY *= frictionFactor;
    }

    //
    // BOUNCING SUPPORT
    //

    if (self.options.bouncing) {

      var scrollOutsideX = 0;
      var scrollOutsideY = 0;

      // This configures the amount of change applied to deceleration/acceleration when reaching boundaries
      var penetrationDeceleration = self.options.penetrationDeceleration;
      var penetrationAcceleration = self.options.penetrationAcceleration;

      // Check limits
      if (scrollLeft < self.__minDecelerationScrollLeft) {
        scrollOutsideX = self.__minDecelerationScrollLeft - scrollLeft;
      } else if (scrollLeft > self.__maxDecelerationScrollLeft) {
        scrollOutsideX = self.__maxDecelerationScrollLeft - scrollLeft;
      }

      if (scrollTop < self.__minDecelerationScrollTop) {
        scrollOutsideY = self.__minDecelerationScrollTop - scrollTop;
      } else if (scrollTop > self.__maxDecelerationScrollTop) {
        scrollOutsideY = self.__maxDecelerationScrollTop - scrollTop;
      }

      // Slow down until slow enough, then flip back to snap position
      if (scrollOutsideX !== 0) {
        if (scrollOutsideX * self.__decelerationVelocityX <= 0) {
          self.__decelerationVelocityX += scrollOutsideX * penetrationDeceleration;
        } else {
          self.__decelerationVelocityX = scrollOutsideX * penetrationAcceleration;
        }
      }

      if (scrollOutsideY !== 0) {
        if (scrollOutsideY * self.__decelerationVelocityY <= 0) {
          self.__decelerationVelocityY += scrollOutsideY * penetrationDeceleration;
        } else {
          self.__decelerationVelocityY = scrollOutsideY * penetrationAcceleration;
        }
      }
    }
  }
};

// Copy over members to prototype
for (var key in members) {
  Scroller.prototype[key] = members[key];
}

/* harmony default export */ var es_Scroller = (Scroller);
// CONCATENATED MODULE: ./node_modules/zscroller/es/DOMScroller.js



var MIN_INDICATOR_SIZE = 8;

function setTransform(nodeStyle, value) {
  nodeStyle.transform = value;
  nodeStyle.webkitTransform = value;
  nodeStyle.MozTransform = value;
}

function setTransformOrigin(nodeStyle, value) {
  nodeStyle.transformOrigin = value;
  nodeStyle.webkitTransformOrigin = value;
  nodeStyle.MozTransformOrigin = value;
}

function DOMScroller(content) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var scrollbars = void 0;
  var indicators = void 0;
  var indicatorsSize = void 0;
  var scrollbarsSize = void 0;
  var indicatorsPos = void 0;
  var scrollbarsOpacity = void 0;
  var contentSize = void 0;
  var clientSize = void 0;

  this.content = content;
  this.container = content.parentNode;
  this.options = extends_default()({}, options, {
    scrollingComplete: function scrollingComplete() {
      _this.clearScrollbarTimer();
      _this.timer = setTimeout(function () {
        if (_this._destroyed) {
          return;
        }
        if (options.scrollingComplete) {
          options.scrollingComplete();
        }
        if (scrollbars) {
          ['x', 'y'].forEach(function (k) {
            if (scrollbars[k]) {
              _this.setScrollbarOpacity(k, 0);
            }
          });
        }
      }, 0);
    }
  });

  if (this.options.scrollbars) {
    scrollbars = this.scrollbars = {};
    indicators = this.indicators = {};
    indicatorsSize = this.indicatorsSize = {};
    scrollbarsSize = this.scrollbarsSize = {};
    indicatorsPos = this.indicatorsPos = {};
    scrollbarsOpacity = this.scrollbarsOpacity = {};
    contentSize = this.contentSize = {};
    clientSize = this.clientSize = {};

    ['x', 'y'].forEach(function (k) {
      var optionName = k === 'x' ? 'scrollingX' : 'scrollingY';
      if (_this.options[optionName] !== false) {
        scrollbars[k] = document.createElement('div');
        scrollbars[k].className = 'zscroller-scrollbar-' + k;
        indicators[k] = document.createElement('div');
        indicators[k].className = 'zscroller-indicator-' + k;
        scrollbars[k].appendChild(indicators[k]);
        indicatorsSize[k] = -1;
        scrollbarsOpacity[k] = 0;
        indicatorsPos[k] = 0;
        _this.container.appendChild(scrollbars[k]);
      }
    });
  }

  var init = true;
  var contentStyle = content.style;

  // create Scroller instance
  this.scroller = new es_Scroller(function (left, top, zoom) {
    if (!init && options.onScroll) {
      options.onScroll();
    }
    setTransform(contentStyle, 'translate3d(' + -left + 'px,' + -top + 'px,0) scale(' + zoom + ')');
    if (scrollbars) {
      ['x', 'y'].forEach(function (k) {
        if (scrollbars[k]) {
          var pos = k === 'x' ? left : top;
          if (clientSize[k] >= contentSize[k]) {
            _this.setScrollbarOpacity(k, 0);
          } else {
            if (!init) {
              _this.setScrollbarOpacity(k, 1);
            }
            var normalIndicatorSize = clientSize[k] / contentSize[k] * scrollbarsSize[k];
            var size = normalIndicatorSize;
            var indicatorPos = void 0;
            if (pos < 0) {
              size = Math.max(normalIndicatorSize + pos, MIN_INDICATOR_SIZE);
              indicatorPos = 0;
            } else if (pos > contentSize[k] - clientSize[k]) {
              size = Math.max(normalIndicatorSize + contentSize[k] - clientSize[k] - pos, MIN_INDICATOR_SIZE);
              indicatorPos = scrollbarsSize[k] - size;
            } else {
              indicatorPos = pos / contentSize[k] * scrollbarsSize[k];
            }
            _this.setIndicatorSize(k, size);
            _this.setIndicatorPos(k, indicatorPos);
          }
        }
      });
    }
    init = false;
  }, this.options);

  // bind events
  this.bindEvents();

  // the content element needs a correct transform origin for zooming
  setTransformOrigin(content.style, 'left top');

  // reflow for the first time
  this.reflow();
}

DOMScroller.prototype.setDisabled = function setDisabled(disabled) {
  this.disabled = disabled;
};

DOMScroller.prototype.clearScrollbarTimer = function clearScrollbarTimer() {
  if (this.timer) {
    clearTimeout(this.timer);
    this.timer = null;
  }
};

DOMScroller.prototype.setScrollbarOpacity = function setScrollbarOpacity(axis, opacity) {
  if (this.scrollbarsOpacity[axis] !== opacity) {
    this.scrollbars[axis].style.opacity = opacity;
    this.scrollbarsOpacity[axis] = opacity;
  }
};

DOMScroller.prototype.setIndicatorPos = function setIndicatorPos(axis, value) {
  if (this.indicatorsPos[axis] !== value) {
    if (axis === 'x') {
      setTransform(this.indicators[axis].style, 'translate3d(' + value + 'px,0,0)');
    } else {
      setTransform(this.indicators[axis].style, 'translate3d(0, ' + value + 'px,0)');
    }
    this.indicatorsPos[axis] = value;
  }
};

DOMScroller.prototype.setIndicatorSize = function setIndicatorSize(axis, value) {
  if (this.indicatorsSize[axis] !== value) {
    this.indicators[axis].style[axis === 'x' ? 'width' : 'height'] = value + 'px';
    this.indicatorsSize[axis] = value;
  }
};

DOMScroller.prototype.reflow = function reflow() {
  if (this.scrollbars) {
    this.contentSize.x = this.content.offsetWidth;
    this.contentSize.y = this.content.offsetHeight;
    this.clientSize.x = this.container.clientWidth;
    this.clientSize.y = this.container.clientHeight;
    if (this.scrollbars.x) {
      this.scrollbarsSize.x = this.scrollbars.x.offsetWidth;
    }
    if (this.scrollbars.y) {
      this.scrollbarsSize.y = this.scrollbars.y.offsetHeight;
    }
  }
  // set the right scroller dimensions
  this.scroller.setDimensions(this.container.clientWidth, this.container.clientHeight, this.content.offsetWidth, this.content.offsetHeight);

  // refresh the position for zooming purposes
  var rect = this.container.getBoundingClientRect();
  this.scroller.setPosition(rect.x + this.container.clientLeft, rect.y + this.container.clientTop);
};

DOMScroller.prototype.destroy = function destroy() {
  this._destroyed = true;
  window.removeEventListener('resize', this.onResize, false);
  this.container.removeEventListener('touchstart', this.onTouchStart, false);
  this.container.removeEventListener('touchmove', this.onTouchMove, false);
  this.container.removeEventListener('touchend', this.onTouchEnd, false);
  this.container.removeEventListener('touchcancel', this.onTouchCancel, false);
  this.container.removeEventListener('mousedown', this.onMouseDown, false);
  document.removeEventListener('mousemove', this.onMouseMove, false);
  document.removeEventListener('mouseup', this.onMouseUp, false);
  this.container.removeEventListener('mousewheel', this.onMouseWheel, false);
};

DOMScroller.prototype.bindEvents = function bindEvents() {
  var _this2 = this;

  var that = this;

  // reflow handling
  window.addEventListener('resize', this.onResize = function () {
    that.reflow();
  }, false);

  var lockMouse = false;
  var releaseLockTimer = void 0;

  this.container.addEventListener('touchstart', this.onTouchStart = function (e) {
    lockMouse = true;
    if (releaseLockTimer) {
      clearTimeout(releaseLockTimer);
      releaseLockTimer = null;
    }
    // Don't react if initial down happens on a form element
    if (e.touches[0] && e.touches[0].target && e.touches[0].target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
      return;
    }
    _this2.clearScrollbarTimer();
    // reflow since the container may have changed
    that.reflow();
    that.scroller.doTouchStart(e.touches, e.timeStamp);
  }, false);

  this.container.addEventListener('touchmove', this.onTouchMove = function (e) {
    if (_this2.options.preventDefaultOnTouchMove !== false) {
      e.preventDefault();
    }
    that.scroller.doTouchMove(e.touches, e.timeStamp, e.scale);
  }, false);

  this.container.addEventListener('touchend', this.onTouchEnd = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    releaseLockTimer = setTimeout(function () {
      lockMouse = false;
    }, 300);
  }, false);

  this.container.addEventListener('touchcancel', this.onTouchCancel = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    releaseLockTimer = setTimeout(function () {
      lockMouse = false;
    }, 300);
  }, false);

  this.onMouseUp = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    document.removeEventListener('mousemove', _this2.onMouseMove, false);
    document.removeEventListener('mouseup', _this2.onMouseUp, false);
  };

  this.onMouseMove = function (e) {
    that.scroller.doTouchMove([{
      pageX: e.pageX,
      pageY: e.pageY
    }], e.timeStamp);
  };

  this.container.addEventListener('mousedown', this.onMouseDown = function (e) {
    if (lockMouse || e.target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
      return;
    }
    _this2.clearScrollbarTimer();
    that.scroller.doTouchStart([{
      pageX: e.pageX,
      pageY: e.pageY
    }], e.timeStamp);
    // reflow since the container may have changed
    that.reflow();
    e.preventDefault();
    document.addEventListener('mousemove', _this2.onMouseMove, false);
    document.addEventListener('mouseup', _this2.onMouseUp, false);
  }, false);

  this.container.addEventListener('mousewheel', this.onMouseWheel = function (e) {
    if (that.options.zooming) {
      that.scroller.doMouseZoom(e.wheelDelta, e.timeStamp, e.pageX, e.pageY);
      e.preventDefault();
    }
  }, false);
};

/* harmony default export */ var es_DOMScroller = __webpack_exports__["default"] = (DOMScroller);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/index.85d947d3.js